require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/05dbbe5265446336458f423e9192a925/code.js', () => { 

BackendlessUI.Functions.Custom['fn_05dbbe5265446336458f423e9192a925'] = function fn_05dbbe5265446336458f423e9192a925() {
return [({ [`label`]: 'Select Grade',[`value`]: '0' }), ({ [`label`]: 'PreK',[`value`]: 'PreK' }), ({ [`label`]: 'K',[`value`]: 'K' }), ({ [`label`]: '1',[`value`]: '1' }), ({ [`label`]: '2',[`value`]: '2' }), ({ [`label`]: '3',[`value`]: '3' }), ({ [`label`]: '4',[`value`]: '4' }), ({ [`label`]: '5',[`value`]: '5' }), ({ [`label`]: '6',[`value`]: '6' }), ({ [`label`]: '7',[`value`]: '7' }), ({ [`label`]: '8',[`value`]: '8' }), ({ [`label`]: '9',[`value`]: '9' }), ({ [`label`]: '10',[`value`]: '10' }), ({ [`label`]: '11',[`value`]: '11' }), ({ [`label`]: '12',[`value`]: '12' }), ({ [`label`]: 'Other',[`value`]: 'Other' })]
}

})
define('./functions/1a06d341212e70cfc5fa381bd1711dba/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1a06d341212e70cfc5fa381bd1711dba'] = async function fn_1a06d341212e70cfc5fa381bd1711dba(pageData) {
var error, transactionObject, insertedShipmentObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    pageData['error'] = '';
    if (getValueLength((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'selectedRate'))) == 0) {
      pageData['error'] = 'No selected rate to create label from.  shippingCreateTransaction.';
      return ;
    }
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Working.....',[`imageUrl`]: 'https://cdn.meadowfarms.com/images/icons/loading-2.gif?w=300',[`timer`]: 6000 }), null);
    for (var count = 0; count < 2; count++) {
      try {
        transactionObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.goshippo.com/transactions')).set(({ [`Authorization`]: String('ShippoToken ') + String(getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingShippoToken')),[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(({ [`rate`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'selectedRate')),[`label_file_type`]: 'ZPLII',[`async`]: false })));
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail('shippingCreateTransaction2 - Shippo API error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),'This was everything in pageData:',(JSON.stringify(pageData)),' This is the rate we\'re trying to buy: ',(getObjectProperty((getObjectProperty(pageData, 'shipment')), 'selectedRate'))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
    if ((typeof (getObjectProperty(transactionObject, 'status')) === 'undefined') || (getObjectProperty(transactionObject, 'status')) != 'SUCCESS') {
      await Backendless.Messaging.sendEmail('shippingCreateTransaction2 - error creating shippo transaction', new Backendless.Bodyparts({ textmessage: (['This is the transaction object: ',(JSON.stringify(transactionObject)),'This was everything in pageData:',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      if (Array.isArray((getObjectProperty(transactionObject, 'messages')))) {
        pageData['error'] = ([(getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'source')),' ',!(typeof (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'message')) === 'undefined') ? (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'message')) : (!(typeof (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'text')) === 'undefined') ? (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'text')) : 'Unknown error message.')].join(''));
      } else {
        pageData['error'] = 'Could not create Shippo Transaction - Please try again.';
      }
      await (async function() {
      	Swal.close();
      })();
      return ;
    }
    if (!(getObjectProperty(pageData, 'testMode'))) {
      await Backendless.Data.of('Shipments').deepSave( ({ [`AddressToOriginal`]: (getObjectProperty(pageData, 'addressToOriginal')),[`AddressTo`]: (getObjectProperty(pageData, 'addressTo')),[`AddressFrom`]: (getObjectProperty(pageData, 'addressReturn')),[`CompanyId`]: (getObjectProperty(pageData, 'addressReturn.companyId')),[`Rates`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'rawRatesAll')),[`Parcel`]: (getObjectProperty(pageData, 'parcel')),[`Weight`]: (getObjectProperty((getObjectProperty(pageData, 'parcel')), 'weight')),[`SelectedRateObjectId`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'selectedRate')),[`TrackingNumber`]: (getObjectProperty(transactionObject, 'tracking_number')),[`TrackingURL`]: (getObjectProperty(transactionObject, 'tracking_url_provider')),[`LogId`]: (Number((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId')))),[`LabelURL`]: (getObjectProperty(transactionObject, 'label_url')).slice(0, 500),[`OfficeSystemInsert`]: true,[`BoxItemNumber`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'boxLabel')),[`User`]: ({ [`objectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')) }) }) );
    }
    if (getValueLength((getObjectProperty(transactionObject, 'label_url'))) > 0) {
      pageData['lastLabelURL'] = (getObjectProperty(transactionObject, 'label_url'));
      await (async function(fileUrl) {
      	sendFile(fileUrl);
      })((getObjectProperty(transactionObject, 'label_url')));
    } else {
      await Backendless.Messaging.sendEmail('shippingCreateTransaction2 - No label to print error', new Backendless.Bodyparts({ textmessage: (String('This is everything in pageData: ') + String(JSON.stringify(pageData))) }), ensureArray('tim@meadowfarms.com'), undefined);
    }
    console.log(getObjectProperty(pageData, 'error'));
    if (getValueLength((getObjectProperty(pageData, 'error'))) == 0) {
      if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'multipackageShipmentLast')) == true) {
        pageData['multipackageShipment'] = false;
      }
      pageData['lastLogId'] = (getObjectProperty(pageData, 'shipment.logId'));
      await BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'](pageData);
      if ((getObjectProperty(pageData, 'multipackageShipment')) == true) {
        (getObjectProperty(pageData, 'shipment'))['multipackageShipmentCount'] = (((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'multipackageShipmentCount')) == '' ? 0 : (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'multipackageShipmentCount'))) + 1);
        await new Promise(r => setTimeout(r, 400 || 0));
        await (async function() {
        	Swal.close();
        })();
      } else {
        await new Promise(r => setTimeout(r, 400 || 0));
        await (async function() {
        	Swal.close();
        })();
      }
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingCreateTransaction2 - General function error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),'This was everything in pageData:',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

return 
}

})
define('./functions/1c34361e2c6c3575779be479e68770c4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'] = async function fn_1c34361e2c6c3575779be479e68770c4(pageData) {
var error, objectKey, pageDataObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    pageData['error'] = '';
    pageData['weightReturnZero'] = false;
    if ((getObjectProperty(pageData, 'multipackageShipment')) == true) {
      var objectKey_list = (Object.keys((getObjectProperty(pageData, 'parcel'))));
      for (var objectKey_index in objectKey_list) {
        objectKey = objectKey_list[objectKey_index];
        (getObjectProperty(pageData, 'parcel'))[objectKey] = '';
      }
      (getObjectProperty(pageData, 'shipment'))['selectedRate'] = '';
      (getObjectProperty(pageData, 'shipment'))['rates'] = '';
      (getObjectProperty(pageData, 'shipment'))['ratesAll'] = '';
      (getObjectProperty(pageData, 'shipment'))['rawRatesAll'] = '';
      (getObjectProperty(pageData, 'shipment'))['labelURL'] = '';
      (getObjectProperty(pageData, 'shipment'))['shipmentCreated'] = '';
      (getObjectProperty(pageData, 'shipment'))['dimensionsEntered'] = '';
      (getObjectProperty(pageData, 'shipment'))['combinedDimensions'] = '';
      (getObjectProperty(pageData, 'shipment'))['boxItemNumber'] = '';
      (getObjectProperty(pageData, 'shipment'))['boxLabel'] = '';
    } else {
      var pageDataObject_list = (getObjectProperty(pageData, 'objectsToClear'));
      for (var pageDataObject_index in pageDataObject_list) {
        pageDataObject = pageDataObject_list[pageDataObject_index];
        var objectKey_list2 = (Object.keys((getObjectProperty(pageData, pageDataObject))));
        for (var objectKey_index2 in objectKey_list2) {
          objectKey = objectKey_list2[objectKey_index2];
          (getObjectProperty(pageData, pageDataObject))[objectKey] = '';
        }
      }
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingClearPageData function - General error', new Backendless.Bodyparts({ textmessage: (String('This was the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

return 
}

})
define('./functions/20217ef49bece0b76c85d32fa0f1d4a7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_20217ef49bece0b76c85d32fa0f1d4a7'] = function fn_20217ef49bece0b76c85d32fa0f1d4a7(timestamp) {
return ([(new Date(timestamp).getMonth() + 1),'/',(new Date(timestamp).getDate()),'/',(new Date(timestamp).getFullYear())].join(''))
}

})
define('./functions/24dd5a91f97590ae7c08510703b68cc4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'] = function fn_24dd5a91f97590ae7c08510703b68cc4(value, targetObject, targetProperty, pageData) {
var valueList, retrievedAddress, lastKeyPressTime;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(pageData, 'scanCaptureActive')) == true) {
    return ;
  }
  (getObjectProperty(pageData, targetObject))[targetProperty] = value;
  if (targetObject == 'addressTo' && ['phone', 'email', 'name', 'company'].indexOf(targetProperty) + 1 == 0) {
    (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = '';
    (getObjectProperty(pageData, 'shipment'))['smartyIsResidential'] = '';
    (getObjectProperty(pageData, 'shipment'))['notifyOfficeSource'] = 'addressTo';
    (getObjectProperty(pageData, 'shipment'))['smartyAddressChecked'] = false;
  }
  if (targetObject == 'shipment' && targetProperty == 'combinedDimensions') {
    if (value.toLowerCase().split('x').length == 3) {
      (getObjectProperty(pageData, 'shipment'))['dimensionsEntered'] = true;
    }
  }

return 
}

})
define('./functions/26b435995da772dfb95a088a74b54925/code.js', () => { 

BackendlessUI.Functions.Custom['fn_26b435995da772dfb95a088a74b54925'] = async function fn_26b435995da772dfb95a088a74b54925(seller, imageNouser, settingImages) {
var text1, imageItem, userImgURL, text0;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  text0 = (getObjectProperty(seller, 'name'));
  text1 = String('Shop ID: ') + String(getObjectProperty(seller, 'shopId'));
  userImgURL = (getObjectProperty(seller, 'image')) ? (getObjectProperty(seller, 'image')) : imageNouser;
  for (var imageItem_index in settingImages) {
    imageItem = settingImages[imageItem_index];
    await (async function(baseImgURL, text, targetImgClass, userImgURL, options, text1) {
    	const targetElem = document.querySelector('.' + targetImgClass);
    	const url = new URL(baseImgURL);

    	url.searchParams.set('text.0.text', text);
    	url.searchParams.set('text.1.text', text1);
    	url.searchParams.set('watermark', userImgURL);

    	for(key in options) {
    	  url.searchParams.set(key, options[key]);
    	}

    	const imgUrl = url.toString().split('+').join('%20').split('BREAK').join('%0A');

    	const link = document.createElement('a');
    	link.setAttribute('href', imgUrl + '&format=original&dl');
    	link.setAttribute('target', '_blank');

    	const img = document.createElement('img');
    	img.setAttribute('src', imgUrl);
    	img.setAttribute('srcset', imgUrl);
    	img.setAttribute('class', 'Sirv');

    	link.appendChild(img);
    	targetElem.innerText = '';
    	targetElem.appendChild(link);
    })((getObjectProperty(imageItem, 'baseImgURL')), text0, (getObjectProperty(imageItem, 'targetImgClass')), (userImgURL.replace((new RegExp('https:\\/\\/cdn.meadowfarms\\.com', '')), '')), (getObjectProperty(imageItem, 'options')), text1);
  }

}

})
define('./functions/3d77e8460dd39d05db4ae281b2e2489a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3d77e8460dd39d05db4ae281b2e2489a'] = async function fn_3d77e8460dd39d05db4ae281b2e2489a(pageData) {
var shipmentObject, error, rawShippingRates, shippoError, weightLock, tempWeight, combinedDimensionsList, rateResults, rateObject, counter, rate, shippingCarrierList, filteredShippingRates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function processRates() {
  if ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).toUpperCase() != 'ALL') {
    filteredShippingRates = (await asyncListFilter(rawShippingRates, async (item) => {


     return ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).toUpperCase().indexOf((getObjectProperty(item, 'provider')).toUpperCase()) + 1 > 0);
    }));
  } else {
    filteredShippingRates = rawShippingRates;
  }
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'excludeUSPS')) == true) {
    filteredShippingRates = (await asyncListFilter(filteredShippingRates, async (item) => {


     return ((getObjectProperty(item, 'provider')).toUpperCase() != 'USPS');
    }));
  }
  filteredShippingRates = (await asyncListFilter(filteredShippingRates, async (item) => {


   return ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingServiceIgnoreList')).indexOf((getObjectProperty((getObjectProperty(item, 'servicelevel')), 'name')).toUpperCase()) + 1 == 0);
  }));
  shippingCarrierList = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).split(',');
  counter = 0;
  rateResults = [];
  rateResults = (await Promise.all(filteredShippingRates.map(async rate => {; return ({ [`objectId`]: (getObjectProperty(rate, 'object_id')),[`amount`]: (getObjectProperty(rate, 'amount')),[`sortAmount`]: (Number((getObjectProperty(rate, 'amount')))),[`carrier`]: (getObjectProperty(rate, 'provider')),[`service`]: (getObjectProperty((getObjectProperty(rate, 'servicelevel')), 'name')),[`speed`]: (getObjectProperty(rate, 'estimated_days')),[`speedDetails`]: (getObjectProperty(rate, 'duration_terms')) });})));
  (getObjectProperty(pageData, 'shipment'))['ratesAll'] = rateResults;
}


  try {
    (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = true;
    combinedDimensionsList = (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'combinedDimensions')).toLowerCase().split('x');
    (getObjectProperty(pageData, 'parcel'))['length'] = (combinedDimensionsList[0]);
    (getObjectProperty(pageData, 'parcel'))['width'] = (combinedDimensionsList[1]);
    (getObjectProperty(pageData, 'parcel'))['height'] = (combinedDimensionsList[2]);
    (getObjectProperty(pageData, 'parcel'))['distance_unit'] = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'distanceUnit'));
    weightLock = false;
    while (!weightLock) {
      tempWeight = (getObjectProperty(pageData, 'scaleWeight'));
      await new Promise(r => setTimeout(r, 100 || 0));
      if (tempWeight == (getObjectProperty(pageData, 'scaleWeight'))) {
        weightLock = true;
        (getObjectProperty(pageData, 'parcel'))['weight'] = (getObjectProperty(pageData, 'scaleWeight'));
      }
    }
    (getObjectProperty(pageData, 'parcel'))['mass_unit'] = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'massUnit'));
    if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'dimensionsEntered')) != true) {
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      pageData['error'] = 'Shipment data cleared while processing.';
      return ;
    }
    for (var count = 0; count < 3; count++) {
      try {
        shipmentObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.goshippo.com/shipments/')).set(({ [`Authorization`]: String('ShippoToken ') + String(getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingShippoToken')),[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(({ [`address_from`]: ({ [`name`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name')) : (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'company')),[`company`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'company')) : '',[`street1`]: [(getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'address1')),' ',(getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'address2'))].join(''),[`city`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'city')),[`state`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'state')),[`zip`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'phone')),[`email`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')) == null || (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')) == '' ? 'no-reply@mfshipment.com' : (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')),[`metadata`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'companyId')) }),[`address_to`]: ({ [`name`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'name')),[`company`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'company')),[`street1`]: [(getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'address1')),' ',(getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'address2'))].join('').trim(),[`city`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'city')),[`state`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'state')),[`zip`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'phone')),[`email`]: (await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54']((getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'email')))) ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'email')) : 'no-reply@mfshipment.com' }),[`parcels`]: [(getObjectProperty(pageData, 'parcel'))],[`extra`]: ({  }),[`async`]: false })));
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail('shippingCreateShipment function - Shippo API error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),' This is everything in pageData: ',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
    shippoError = '';
    if ((typeof (getObjectProperty(shipmentObject, 'status')) === 'undefined') || (getObjectProperty(shipmentObject, 'status')) != 'SUCCESS') {
      await Backendless.Messaging.sendEmail('shippingCreateShipment function - could not create shipment', new Backendless.Bodyparts({ textmessage: (['This was the shippo shipmentObject',(JSON.stringify(shipmentObject)),' This is everything in pageData: ',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      pageData['error'] = 'Could not create Shippo Shipment';
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      return ;
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'is_complete')) != true) {
      shippoError = 'Ship to address is not complete.';
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_from')), 'is_complete')) != true) {
      shippoError = getValueLength(shippoError) > 0 ? [shippoError,' ','Ship from address is not complete.'].join('') : 'Ship from address is not complete.';
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_return')), 'is_complete')) != true) {
      shippoError = getValueLength(shippoError) > 0 ? [shippoError,' ','Return address is not complete.'].join('') : 'Return address is not complete.';
    }
    if (getValueLength(shippoError) > 0) {
      pageData['error'] = shippoError;
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      return ;
    }
    rawShippingRates = (getObjectProperty(shipmentObject, 'rates'));
    (getObjectProperty(pageData, 'shipment'))['rawRatesAll'] = (getObjectProperty(shipmentObject, 'rates'));
    (getObjectProperty(pageData, 'shipment'))['shipmentCreated'] = true;
    await processRates();
    if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'ratesAll')).length == 0) {
      pageData['error'] = 'Current configuration resulted in no shipping rates available.';
      return ;
    }
    await BackendlessUI.Functions.Custom['fn_c78cc03ac7c6da352c756134165187df'](pageData);

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingCreateShipment function - General function error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' This is everything in pageData: ',(JSON.stringify(pageData)),'Everything from Shippo: ',shipmentObject].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;

return 
}

})
define('./functions/437d4fea018b514cfa2e14139db4f75a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_437d4fea018b514cfa2e14139db4f75a'] = function fn_437d4fea018b514cfa2e14139db4f75a(phone) {
var result, phone4_6, cleanPhone, phone1_3, regExp;


  result = true;
  if (phone != null && phone != '') {
    cleanPhone = (phone.replace((new RegExp('\\D', 'g')), ''));
    if (cleanPhone.length == 11 && cleanPhone.charAt(0) == '1') {
      cleanPhone = cleanPhone.slice(1, 11);
    }
    if (cleanPhone.length != 10) {
      result = false;
    }
    phone1_3 = (Number((cleanPhone.slice(0, 3))));
    if (phone1_3 < 201) {
      result = false;
    }
    phone4_6 = (Number((cleanPhone.slice(3, 6))));
    if (phone4_6 < 201) {
      result = false;
    }
  }

return result
}

})
define('./functions/4435afc15c0863b196012c7dd9f85b62/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4435afc15c0863b196012c7dd9f85b62'] = async function fn_4435afc15c0863b196012c7dd9f85b62(scanString, pageData) {
var barcodeList, barcodeString, packageBarcodeByName, barcodeInt, response, error, shipmentObject, shippingCompany, item, shipmentObjectKey, shipmentList, counter, timer, errorList;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getAddress() {
  response = false;
  shipmentList = [];
  counter = 0;
  timer = ((new Date()).valueOf());
  for (var count = 0; count < 2; count++) {
    counter = (typeof counter == 'number' ? counter : 0) + 1;
    try {
      shipmentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogid?logid=',(getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(pageData, 'settings')), 'APIKey')) })).setEncoding('utf8').send());
      break;

    } catch (error) {
      if ((getObjectProperty(error, 'message')).toUpperCase().indexOf('network error'.toUpperCase()) + 1 > 0) {
        await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Network Issue',[`html`]: 'Confirm CORs browser extension is enabled.',[`icon`]: 'error',[`confirmButtonText`]: 'Close',[`showCancelButton`]: false }), null);
        return ;
      } else if (counter == 2) {
        await Backendless.Messaging.sendEmail((String('shippingScanCapture2 Function - Error getting shipment details from Tim\'s shipping endpoint for logid: ') + String(getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,'We tried this many times so far: ',counter,'This was the path: ',[(getObjectProperty((getObjectProperty(pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogid?logid=',(getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      }
      await new Promise(r => setTimeout(r, (100 * counter) || 0));

    }
  }
  if (shipmentList.length == 0) {
    counter = 0;
    for (var count2 = 0; count2 < 3; count2++) {
      try {
        counter = (typeof counter == 'number' ? counter : 0) + 1;
        shipmentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogidmark?logid=',(getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(pageData, 'settings')), 'APIKey')),[`Content-type`]: 'application/json' })).setEncoding('utf8').send());
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail((String('shippingScanCapture2 Function - Error getting shipment details for logid: ') + String(getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' We tried this many times: ',counter].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
  }
  try {
    if (shipmentList.length == 1) {
      response = true;
      shipmentObject = shipmentList[0];
      var shipmentObjectKey_list = (Object.keys(shipmentObject));
      for (var shipmentObjectKey_index in shipmentObjectKey_list) {
        shipmentObjectKey = shipmentObjectKey_list[shipmentObjectKey_index];
        if ((getObjectProperty(shipmentObject, shipmentObjectKey)) === null) {
          shipmentObject[shipmentObjectKey] = '';
        }
      }
      (getObjectProperty(pageData, 'addressToOriginal'))['name'] = (getValueLength((getObjectProperty(shipmentObject, 'To_Attn')).trim()) > 0 ? (getObjectProperty(shipmentObject, 'To_Attn')).trim() : (getObjectProperty(shipmentObject, 'To_Name')).trim());
      (getObjectProperty(pageData, 'addressTo'))['name'] = (getObjectProperty(pageData, 'addressToOriginal.name'));
      (getObjectProperty(pageData, 'addressToOriginal'))['company'] = (getValueLength((getObjectProperty(shipmentObject, 'To_Attn')).trim()) > 0 ? (getObjectProperty(shipmentObject, 'To_Name')).trim() : ' ');
      (getObjectProperty(pageData, 'addressTo'))['company'] = (getObjectProperty(pageData, 'addressToOriginal.company'));
      (getObjectProperty(pageData, 'addressToOriginal'))['address1'] = ((getObjectProperty(shipmentObject, 'To_Address')).trim());
      (getObjectProperty(pageData, 'addressTo'))['address1'] = (getObjectProperty(pageData, 'addressToOriginal.address1'));
      (getObjectProperty(pageData, 'addressToOriginal'))['address2'] = ' ';
      (getObjectProperty(pageData, 'addressTo'))['address2'] = (getObjectProperty(pageData, 'addressToOriginal.address2'));
      (getObjectProperty(pageData, 'addressToOriginal'))['city'] = ((getObjectProperty(shipmentObject, 'To_City')).trim());
      (getObjectProperty(pageData, 'addressTo'))['city'] = (getObjectProperty(pageData, 'addressToOriginal.city'));
      (getObjectProperty(pageData, 'addressToOriginal'))['state'] = ((getObjectProperty(shipmentObject, 'To_State')).trim());
      (getObjectProperty(pageData, 'addressTo'))['state'] = (getObjectProperty(pageData, 'addressToOriginal.state'));
      (getObjectProperty(pageData, 'addressToOriginal'))['zip'] = ((getObjectProperty(shipmentObject, 'To_Zip')).trim());
      (getObjectProperty(pageData, 'addressTo'))['zip'] = (getObjectProperty(pageData, 'addressToOriginal.zip'));
      (getObjectProperty(pageData, 'addressToOriginal'))['country'] = 'US';
      (getObjectProperty(pageData, 'addressTo'))['country'] = (getObjectProperty(pageData, 'addressToOriginal.country'));
      (getObjectProperty(pageData, 'addressToOriginal'))['phone'] = (((getObjectProperty(shipmentObject, 'To_Phone')).replace((new RegExp('\\D', 'g')), '')).trim());
      (getObjectProperty(pageData, 'addressTo'))['phone'] = (getObjectProperty(pageData, 'addressToOriginal.phone'));
      (getObjectProperty(pageData, 'addressToOriginal'))['email'] = ((getObjectProperty(shipmentObject, 'QVNShipNotf1Email')).trim());
      (getObjectProperty(pageData, 'addressTo'))['email'] = (getObjectProperty(pageData, 'addressToOriginal.email'));
      (getObjectProperty(pageData, 'addressFrom'))['company'] = ((getObjectProperty(shipmentObject, 'From_Name')).trim());
      (getObjectProperty(pageData, 'addressReturn'))['company'] = ((getObjectProperty(shipmentObject, 'From_Name')).trim());
      (getObjectProperty(pageData, 'addressFrom'))['address1'] = '325 Silver St.';
      (getObjectProperty(pageData, 'addressReturn'))['address1'] = ((getObjectProperty(shipmentObject, 'From_Address')).trim());
      (getObjectProperty(pageData, 'addressFrom'))['city'] = 'Agawam';
      (getObjectProperty(pageData, 'addressReturn'))['city'] = ((getObjectProperty(shipmentObject, 'From_City')).trim());
      (getObjectProperty(pageData, 'addressFrom'))['state'] = 'MA';
      (getObjectProperty(pageData, 'addressReturn'))['state'] = ((getObjectProperty(shipmentObject, 'From_State')).trim());
      (getObjectProperty(pageData, 'addressFrom'))['zip'] = '01001';
      (getObjectProperty(pageData, 'addressReturn'))['zip'] = ((getObjectProperty(shipmentObject, 'From_Zip')).trim());
      (getObjectProperty(pageData, 'addressFrom'))['country'] = 'US';
      (getObjectProperty(pageData, 'addressReturn'))['country'] = 'US';
      (getObjectProperty(pageData, 'addressFrom'))['phone'] = (getValueLength((getObjectProperty(shipmentObject, 'From_Phone')).trim()) > 0 ? ((getObjectProperty(shipmentObject, 'From_Phone')).replace((new RegExp('\\D', 'g')), '')).trim() : '8008867895');
      (getObjectProperty(pageData, 'addressReturn'))['phone'] = (getValueLength((getObjectProperty(shipmentObject, 'From_Phone')).trim()) > 0 ? ((getObjectProperty(shipmentObject, 'From_Phone')).replace((new RegExp('\\D', 'g')), '')).trim() : '8008867895');
      (getObjectProperty(pageData, 'addressFrom'))['companyId'] = ((getObjectProperty(shipmentObject, 'CompanyID')).trim());
      (getObjectProperty(pageData, 'addressReturn'))['companyId'] = ((getObjectProperty(shipmentObject, 'CompanyID')).trim());
      shippingCompany = (await asyncListFilter((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCompaniesList')), async (item) => {


       return ((getObjectProperty(shipmentObject, 'CompanyID')) == (getObjectProperty(item, 'CompanyId')));
      }));
      (getObjectProperty(pageData, 'addressReturn'))['email'] = (shippingCompany.length == 1 ? (getObjectProperty((shippingCompany[0]), 'Email')) : '');
      (getObjectProperty(pageData, 'addressReturn'))['logourl'] = (shippingCompany.length == 1 ? (getObjectProperty((shippingCompany[0]), 'LogoURL')) : '');
      (getObjectProperty(pageData, 'parcel'))['metadata'] = ((getObjectProperty(shipmentObject, 'Ref1')).trim());
      (getObjectProperty(pageData, 'shipment'))['companyId'] = ((getObjectProperty(shipmentObject, 'CompanyID')).trim());
    }

  } catch (error) {
    response = false;
    await Backendless.Messaging.sendEmail((String('shippingScanCapture2 Function - getAddress - General error getting address for logid: ') + String(getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (String('This was the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  return response
}


  barcodeInt = 0;
  barcodeString = (scanString.replace((new RegExp('[\\s\\r\\n]+', 'g')), '')).toUpperCase();
  if (getValueLength(barcodeString) == 8) {
    barcodeInt = (barcodeString.replace((new RegExp('\\D', 'g')), ''));
    if (getValueLength(barcodeInt) == 8) {
      if (barcodeInt == (getObjectProperty(pageData, 'shipment.logId')) || barcodeInt == (getObjectProperty(pageData, 'lastLogId'))) {
        return ;
      } else {
      }
      (getObjectProperty(pageData, 'shipment'))['logId'] = barcodeInt;
      if (await getAddress()) {
        await BackendlessUI.Functions.Custom['fn_65f8914503da6a18a29e96f6c91d8511'](pageData, 'scanLogId');
      }
      return ;
    }
  }
  if (!(typeof (getObjectProperty((getObjectProperty(pageData, 'packaging')), barcodeString)) === 'undefined')) {
    if (barcodeString == (getObjectProperty(pageData, 'shipment.packageBarcode'))) {
      return false;
    }
    if (!(getObjectProperty(pageData, 'weightReturnZero'))) {
      return false;
    }
    (getObjectProperty(pageData, 'parcel'))['length'] = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'packaging')), barcodeString)), 'length'));
    (getObjectProperty(pageData, 'parcel'))['width'] = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'packaging')), barcodeString)), 'width'));
    (getObjectProperty(pageData, 'parcel'))['height'] = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'packaging')), barcodeString)), 'height'));
    (getObjectProperty(pageData, 'shipment'))['packageBarcode'] = barcodeString;
    (getObjectProperty(pageData, 'shipment'))['boxLabel'] = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'packaging')), barcodeString)), 'name'));
    (getObjectProperty(pageData, 'shipment'))['dimensionsEntered'] = true;
    await BackendlessUI.Functions.Custom['fn_65f8914503da6a18a29e96f6c91d8511'](pageData, 'scanPackage');
    return ;
  }
  if (barcodeString == 'CLR') {
    pageData['multipackageShipment'] = false;
    await BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'](pageData);
    return ;
  }
  if (barcodeString == 'SP') {
    await BackendlessUI.Functions.Custom['fn_ede16f295a85a3ad700cdb4100b1a097'](pageData);
    return ;
  }
  if (barcodeString == 'MPS') {
    if ((getObjectProperty(pageData, 'multipackageShipment')) == true) {
      if ((getObjectProperty((getObjectProperty(pageData, 'modalVisible')), 'modalScan')) == true) {
        pageData['multipackageShipment'] = false;
      } else {
        (getObjectProperty(pageData, 'shipment'))['multipackageShipmentLast'] = true;
      }
    } else {
      pageData['multipackageShipment'] = true;
    }
    return ;
  }
  if (barcodeString == 'REV') {
    pageData['reviewBeforeTransaction'] = ((getObjectProperty(pageData, 'reviewBeforeTransaction')) ? false : true);
    return ;
  }

return 
}

})
define('./functions/498e95b477d71882ffbc8bde233ec06c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_498e95b477d71882ffbc8bde233ec06c'] = async function fn_498e95b477d71882ffbc8bde233ec06c(pageData) {
var error, textFontFamily, textColor, addressMessage, breakChar, finalErrorLine, errorLine, currentErrorLine, word, addressSourceProperty;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = true;
    addressSourceProperty = 'addressToOriginal';
    await Backendless.Messaging.sendEmailFromTemplate('ShippingAddressNotValidInternal', Backendless.EmailEnvelope.create({ addresses: ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingNoShipEmails')).split(',')), ccAddresses: undefined, bccAddresses: undefined, query: '', uniqueEmails: false }), ({ [`orderNumber`]: (getObjectProperty((getObjectProperty(pageData, 'parcel')), 'metadata')),[`logId`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId')),[`name`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'name')),[`company`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'company')),[`address1`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address1')),[`address2`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address2')),[`city`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'city')),[`state`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'state')),[`zip`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'zip')),[`email`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'email')),[`phone`]: (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'phone')),[`smartyError`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'smartyAddressMessage')).length > 0 ? (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'smartyAddressMessage')).join(',') : 'No Ship',[`addressValidationMatchType`]: (getObjectProperty(pageData, 'addressValidationMatchType')) }), undefined);
    breakChar = '%0A';
    textColor = '000000';
    textFontFamily = 'Poppins';
    addressMessage = 'No Ship';
    if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'smartyAddressMessage')).length > 0) {
      var errorLine_list = (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'smartyAddressMessage'));
      for (var errorLine_index in errorLine_list) {
        errorLine = errorLine_list[errorLine_index];
        currentErrorLine = '';
        finalErrorLine = '';
        for (var word_index in errorLine) {
          word = errorLine[word_index];
          if (getValueLength(currentErrorLine) + getValueLength(word) >= 32) {
            finalErrorLine = String(finalErrorLine) + String(getValueLength(finalErrorLine) > 0 ? String(breakChar) + String(currentErrorLine) : currentErrorLine);
            currentErrorLine = '';
          }
          currentErrorLine = String(currentErrorLine) + String(getValueLength(currentErrorLine) > 0 ? String(' ') + String(errorLine) : errorLine);
        }
        if (getValueLength(currentErrorLine) > 0) {
          finalErrorLine = String(finalErrorLine) + String(String(breakChar) + String(currentErrorLine));
        }
        errorLine = finalErrorLine;
      }
      addressMessage = (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'smartyAddressMessage')).join(breakChar);
    }
    await (async function(fileURL, fileType) {
    	printJS(fileURL, fileType);
    })(([(getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShipppingDoNotShipImage')),[String('?text.0.text=') + String(addressMessage),String('&text.0.position.gravity=') + String('center'),String('&text.0.size=') + String('99%'),String('&text.0.color=') + String(textColor),String('&text.0.font.weight=') + String('700'),String('&text.0.font.family=') + String(textFontFamily)].join(''),[String('&text.1.text=') + String(String('Attempted ship date: ') + String([(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join(''))),String('&text.1.position.gravity=') + String('north'),String('&text.1.size=') + String('90%'),String('&text.1.color=') + String(textColor),String('&text.1.font.weight=') + String('600'),String('&text.1.font.family=') + String(textFontFamily)].join(''),String('&w=') + String(72 * 4)].join('')), 'image');
    pageData['multipackageShipment'] = false;
    await BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'](pageData);
    (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
    (getObjectProperty(pageData, 'modalVisible'))['modalBox'] = false;
    (getObjectProperty(pageData, 'modalVisible'))['modalScan'] = true;

  } catch (error) {
    await Backendless.Messaging.sendEmail('noShip function - General error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' This was in Page Data: ',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

return 
}

})
define('./functions/53345af7489572bf06e8f84a5a147b5c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'] = async function fn_53345af7489572bf06e8f84a5a147b5c(redirect) {
var checkResult;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  checkResult = (await Backendless.UserService.getCurrentUser(false));
  if (checkResult && (getObjectProperty(checkResult, 'objectId'))) {
  } else {
    if (!(redirect === null)) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', ({ [`redirect`]: redirect }));
      return ;
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);
      return ;
    }
  }

return checkResult
}

})
define('./functions/6153cc06151d02ccfc05fce1b6855a44/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44'] = async function fn_6153cc06151d02ccfc05fce1b6855a44(list) {
var errors, item, numRegExp, phoneRegExp, emailRegExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  errors = [];
  for (var item_index in list) {
    item = list[item_index];
    if ((getObjectProperty(item, 'rules')).includes('required')) {
      if ((typeof (getObjectProperty(item, 'value')) === 'undefined') || (getObjectProperty(item, 'value')) == '' || (getObjectProperty(item, 'value')) == null) {
        addItemToList(errors, (getObjectProperty(item, 'field')));
      }
    }
    if ((getObjectProperty(item, 'rules')).includes('requiredArray')) {
      if ((typeof (getObjectProperty(item, 'value')) === 'undefined') || (getObjectProperty(item, 'value')) == null || !(Array.isArray((getObjectProperty(item, 'value')))) || (getObjectProperty(item, 'value')).length == 0) {
        addItemToList(errors, (getObjectProperty(item, 'field')));
      }
    }
    if ((getObjectProperty(item, 'rules')).includes('noZerro')) {
      if ((typeof (getObjectProperty(item, 'value')) === 'undefined') || (getObjectProperty(item, 'value')) == '0' || (getObjectProperty(item, 'value')) == 0) {
        addItemToList(errors, (getObjectProperty(item, 'field')));
      }
    }
    if (((getObjectProperty(item, 'rules')).includes('email')) && !(errors.includes((getObjectProperty(item, 'field'))))) {
      if (!(await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54']((getObjectProperty(item, 'value'))))) {
        addItemToList(errors, (getObjectProperty(item, 'field')));
      }
    }
    if (((getObjectProperty(item, 'rules')).includes('phone')) && !(errors.includes((getObjectProperty(item, 'field'))))) {
      if (!(await BackendlessUI.Functions.Custom['fn_437d4fea018b514cfa2e14139db4f75a']((getObjectProperty(item, 'value'))))) {
        addItemToList(errors, (getObjectProperty(item, 'field')));
      }
    }
    if (((getObjectProperty(item, 'rules')).includes('num')) && !(errors.includes((getObjectProperty(item, 'field'))))) {
      numRegExp = (new RegExp('^[0-9.]*$', ''));
      if (((String(getObjectProperty(item, 'value'))).match(numRegExp)) == null) {
        addItemToList(errors, (getObjectProperty(item, 'field')));
      }
    }
  }

return errors
}

})
define('./functions/641b5ba60261949db365c9611859deca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_641b5ba60261949db365c9611859deca'] = async function fn_641b5ba60261949db365c9611859deca() {
  await (async function() {
  	await BackendlessUI.requireModule('https://cdn.crop.guide/loader/l.js?c=NHKLMH');

  })();

return 
}

})
define('./functions/65f8914503da6a18a29e96f6c91d8511/code.js', () => { 

BackendlessUI.Functions.Custom['fn_65f8914503da6a18a29e96f6c91d8511'] = async function fn_65f8914503da6a18a29e96f6c91d8511(pageData, calledFrom) {
var shipmentObject, error, rawShippingRates, shippoError, weightLockCounter, weightLock, tempWeight, combinedDimensionsList, return2, rateResults, rateObject, counter, rate, shippingCarrierList, filteredShippingRates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function processRates() {
  if ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).toUpperCase() != 'ALL') {
    filteredShippingRates = (await asyncListFilter(rawShippingRates, async (item) => {


     return ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).toUpperCase().indexOf((getObjectProperty(item, 'provider')).toUpperCase()) + 1 > 0);
    }));
  } else {
    filteredShippingRates = rawShippingRates;
  }
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'excludeUSPS')) == true) {
    filteredShippingRates = (await asyncListFilter(filteredShippingRates, async (item) => {


     return ((getObjectProperty(item, 'provider')).toUpperCase() != 'USPS');
    }));
  }
  filteredShippingRates = (await asyncListFilter(filteredShippingRates, async (item) => {


   return ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingServiceIgnoreList')).indexOf((getObjectProperty((getObjectProperty(item, 'servicelevel')), 'name')).toUpperCase()) + 1 == 0);
  }));
  shippingCarrierList = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).split(',');
  counter = 0;
  rateResults = [];
  rateResults = (await Promise.all(filteredShippingRates.map(async rate => {; return ({ [`objectId`]: (getObjectProperty(rate, 'object_id')),[`amount`]: (getObjectProperty(rate, 'amount')),[`sortAmount`]: (Number((getObjectProperty(rate, 'amount')))),[`carrier`]: (getObjectProperty(rate, 'provider')),[`service`]: (getObjectProperty((getObjectProperty(rate, 'servicelevel')), 'name')),[`speed`]: (getObjectProperty(rate, 'estimated_days')),[`speedDetails`]: (getObjectProperty(rate, 'duration_terms')) });})));
  (getObjectProperty(pageData, 'shipment'))['ratesAll'] = rateResults;
}


  if (getObjectProperty(pageData, 'createShipmentRunning')) {
    return false;
  }
  pageData['createShipmentRunning'] = true;
  if (getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'address1'))) == 0) {
    pageData['createShipmentRunning'] = false;
    return false;
  }
  if (getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'address1'))) == 0) {
    pageData['createShipmentRunning'] = false;
    return false;
  }
  if (getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'address1'))) == 0) {
    pageData['createShipmentRunning'] = false;
    return false;
  }
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'shipmentCreated')) == true) {
    pageData['createShipmentRunning'] = false;
    return false;
  }
  if ((getObjectProperty(pageData, 'scaleConnected')) != true) {
    pageData['createShipmentRunning'] = false;
    return false;
  }
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'dimensionsEntered')) != true) {
    pageData['createShipmentRunning'] = false;
    return false;
  }
  if ((getObjectProperty(pageData, 'scaleWeight')) == 0) {
    pageData['createShipmentRunning'] = false;
    return false;
  }
  try {
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Working.....',[`imageUrl`]: 'https://cdn.meadowfarms.com/images/icons/loading-2.gif?w=300' }), null);
    weightLock = false;
    weightLockCounter = 0;
    while (!weightLock) {
      weightLockCounter = (typeof weightLockCounter == 'number' ? weightLockCounter : 0) + 1;
      tempWeight = (getObjectProperty(pageData, 'scaleWeight'));
      await new Promise(r => setTimeout(r, 100 || 0));
      if (tempWeight == (getObjectProperty(pageData, 'scaleWeight')) && (getObjectProperty(pageData, 'scaleWeight')) != 0) {
        weightLock = true;
        (getObjectProperty(pageData, 'parcel'))['weight'] = (getObjectProperty(pageData, 'scaleWeight'));
      }
      if (weightLockCounter > 30) {
        pageData['createShipmentRunning'] = false;
        pageData['error'] = 'Inconsistent weight prevented shipment creation';
        return false;
      }
    }
    (getObjectProperty(pageData, 'parcel'))['mass_unit'] = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'massUnit'));
    (getObjectProperty(pageData, 'parcel'))['distance_unit'] = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'distanceUnit'));
    if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'dimensionsEntered')) != true) {
      await (async function() {
      	Swal.close();
      })();
      pageData['error'] = 'Shipment data cleared while processing.';
      pageData['createShipmentRunning'] = false;
      return false;
    }
    for (var count = 0; count < 2; count++) {
      try {
        shipmentObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.goshippo.com/shipments/')).set(({ [`Authorization`]: String('ShippoToken ') + String(getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingShippoToken')),[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(({ [`address_from`]: ({ [`name`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name')) : (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'company')),[`company`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'company')) : '',[`street1`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'address1')),[`street2`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'address2')),[`city`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'city')),[`state`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'state')),[`zip`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'phone')),[`email`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')) == null || (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')) == '' ? 'no-reply@mfshipment.com' : (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')),[`metadata`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'companyId')) }),[`address_return`]: ({ [`name`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'name')) : (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'company')),[`company`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'company')) : '',[`street1`]: (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'address1')),[`street2`]: (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'address2')),[`city`]: (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'city')),[`state`]: (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'state')),[`zip`]: (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(pageData, 'addressReturn')), 'phone')),[`metadata`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'companyId')) }),[`address_to`]: ({ [`name`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'name')),[`company`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'company')),[`street1`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'address1')).trim(),[`street2`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'address2')).trim(),[`city`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'city')),[`state`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'state')),[`zip`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'phone')),[`email`]: (await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54']((getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'email')))) ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'email')) : '',[`validate`]: true }),[`parcels`]: [(getObjectProperty(pageData, 'parcel'))],[`extra`]: ({  }),[`async`]: false })));
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail('shippingCreateShipment function3 - Shippo API error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),' This is everything in pageData: ',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
    shippoError = '';
    if ((typeof (getObjectProperty(shipmentObject, 'status')) === 'undefined') || (getObjectProperty(shipmentObject, 'status')) != 'SUCCESS') {
      await Backendless.Messaging.sendEmail('shippingCreateShipment3 function - could not create shipment', new Backendless.Bodyparts({ textmessage: (['This was the shippo shipmentObject',(JSON.stringify(shipmentObject)),' This is everything in pageData: ',(JSON.stringify(pageData)),' This is where the function is being called from: ',calledFrom].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      pageData['error'] = 'Could not create Shippo Shipment';
      await (async function() {
      	Swal.close();
      })();
      pageData['createShipmentRunning'] = false;
      return false;
    }
    (getObjectProperty(pageData, 'shipment'))['shipmentCreated'] = true;
    (getObjectProperty(pageData, 'shipment'))['addressValid'] = true;
    if ((getObjectProperty(shipmentObject, 'address_to.validation_results.is_valid')) != true) {
      shippoError = 'Ship To address is not valid.';
      (getObjectProperty(pageData, 'shipment'))['addressValid'] = false;
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_from')), 'is_complete')) != true) {
      shippoError = String(shippoError) + String(String(getValueLength(shippoError) > 0 ? ' ' : '') + String('Ship from address is not complete.'));
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_return')), 'is_complete')) != true) {
      shippoError = String(shippoError) + String(String(getValueLength(shippoError) > 0 ? ' ' : '') + String('Return address is not complete.'));
    }
    if (getValueLength(shippoError) > 0) {
      await (async function() {
      	Swal.close();
      })();
      pageData['error'] = shippoError;
    }
    (getObjectProperty(pageData, 'addressTo'))['name'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'name'));
    (getObjectProperty(pageData, 'addressTo'))['company'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'company'));
    (getObjectProperty(pageData, 'addressTo'))['address1'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'street1'));
    (getObjectProperty(pageData, 'addressTo'))['address2'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'street2'));
    (getObjectProperty(pageData, 'addressTo'))['city'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'city'));
    (getObjectProperty(pageData, 'addressTo'))['state'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'state'));
    (getObjectProperty(pageData, 'addressTo'))['zip'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'zip'));
    (getObjectProperty(pageData, 'addressTo'))['country'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'country'));
    (getObjectProperty(pageData, 'addressTo'))['phone'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'phone'));
    (getObjectProperty(pageData, 'addressTo'))['email'] = (getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'email'));
    if (getObjectProperty(pageData, 'shipment.addressValid')) {
      rawShippingRates = (getObjectProperty(shipmentObject, 'rates'));
      (getObjectProperty(pageData, 'shipment'))['rawRatesAll'] = (getObjectProperty(shipmentObject, 'rates'));
      (getObjectProperty(pageData, 'shipment'))['shipmentCreated'] = true;
      await processRates();
      if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'ratesAll')).length == 0) {
        pageData['error'] = 'Current configuration resulted in no shipping rates available.';
        pageData['createShipmentRunning'] = false;
        return false;
      }
      await BackendlessUI.Functions.Custom['fn_c78cc03ac7c6da352c756134165187df'](pageData);
      if (!(getObjectProperty(pageData, 'reviewBeforeTransaction'))) {
        await BackendlessUI.Functions.Custom['fn_1a06d341212e70cfc5fa381bd1711dba'](pageData);
      }
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingCreateShipment3 function - General function error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' This is everything in pageData: ',(JSON.stringify(pageData)),'Everything from Shippo: ',shipmentObject].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  await (async function() {
  	Swal.close();
  })();
  pageData['createShipmentRunning'] = false;

return 
}

})
define('./functions/70ad3f85585d0f344c6cf1fd74ff4a91/code.js', () => { 

BackendlessUI.Functions.Custom['fn_70ad3f85585d0f344c6cf1fd74ff4a91'] = async function fn_70ad3f85585d0f344c6cf1fd74ff4a91(pageData, fundraiserList) {
return (await (async function(fundraiserList, pageData) {
	// Step 1: Group rows by Id
	const groupedById = fundraiserList.reduce((acc, row) => {
	  if (!acc[row.Id]) acc[row.Id] = [];
	  acc[row.Id].push(row);
	  return acc;
	}, {});
	
	// Step 2: Filter groups based on account name, rep, and season to exclude
	const filteredGroups = Object.values(groupedById).filter(group => {
	  const accountInfo = group[0]; // First row is account information
	
	  // Check if the group matches the account name filter
	  const matchesAccountName = pageData.searchFilterObject.accountName
	    ? accountInfo.AccountName.toLowerCase().includes(pageData.searchFilterObject.accountName.toLowerCase())
	    : true;
	
	  //console.log(pageData.searchFilterObject.repAbbr);
	
	  // Check if the group matches the rep filter
	  const matchesRep = pageData.searchFilterObject.repAbbr
	    ? group.some(row => row.Rep.toLowerCase().includes(pageData.searchFilterObject.repAbbr.toLowerCase()))
	    : true;
	
	  // Only apply the season exclusion filter if lastSeasonFilter is true
	  const excludesLastSeason = pageData.searchFilterObject.lastSeasonFilter
	    ? !group.some(row => row.Season && row.Season.trim().toLowerCase() === pageData.searchFilterObject.lastSeason.trim().toLowerCase())
	    : true;
	
	  return matchesAccountName && matchesRep && excludesLastSeason;
	});
	
	//console.log(pageData.searchFilterObject.repList);
	//console.log(filteredGroups.flat())
	
	// Step 3: Flatten the filtered groups back into an array
	return filteredGroups.flat();
})(fundraiserList, pageData))
}

})
define('./functions/7fecd3653238e53fd8441d77fd1f02cb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb'] = async function fn_7fecd3653238e53fd8441d77fd1f02cb(roleName, AppData) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(AppData, 'userRoles')) == null) {
    AppData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }

return ((getObjectProperty(AppData, 'userRoles')).includes(roleName))
}

})
define('./functions/8a75c255e1b93999c602fe2677f6c2bd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8a75c255e1b93999c602fe2677f6c2bd'] = async function fn_8a75c255e1b93999c602fe2677f6c2bd(key, imageUrl, targetClass, downloadButtonClass) {
var returnSetting;

/**
 * Describe this function...
 */
async function ShareSponsorImage1() {
  return { [`baseImgURL`]: imageUrl,[`targetImgClass`]: targetClass,[`downloadButtonClass`]: downloadButtonClass,[`options`]: ({ [`w`]: '1200',[`h`]: '630',[`scale.option`]: 'ignore',[`text.0.width`]: '65%',[`text.0.color`]: 'FFFFFF',[`text.0.font.family`]: 'Poppins',[`text.0.font.weight`]: '700',[`text.0.outline.width`]: '5',[`text.0.position.x`]: '410',[`text.0.position.y`]: '180',[`text.0.position.gravity`]: 'west',[`text.1.color`]: 'FFFFFF',[`text.1.font.size`]: '30',[`text.1.font.family`]: 'Poppins',[`text.1.font.weight`]: '700',[`text.1.outline.width`]: '5',[`text.1.position.x`]: '410',[`text.1.position.y`]: '235',[`text.1.position.gravity`]: 'west',[`text.2.font.size`]: '32',[`text.2.color`]: 'FFFFFF',[`text.2.font.family`]: 'Poppins',[`text.2.font.weight`]: '700',[`text.2.outline.width`]: '5',[`text.2.position.x`]: '413',[`text.2.position.y`]: '275',[`text.2.position.gravity`]: 'west' }) }
}

/**
 * Describe this function...
 */
async function ShareSponsorImage2() {
  return { [`baseImgURL`]: imageUrl,[`targetImgClass`]: targetClass,[`downloadButtonClass`]: downloadButtonClass,[`options`]: ({ [`w`]: '1200',[`h`]: '630',[`scale.option`]: 'ignore',[`text.0.width`]: '65%',[`text.0.color`]: 'FFFFFF',[`text.0.font.family`]: 'Poppins',[`text.0.font.weight`]: '700',[`text.0.outline.width`]: '5',[`text.0.position.x`]: '410',[`text.0.position.y`]: '180',[`text.0.position.gravity`]: 'west',[`text.1.color`]: 'FFFFFF',[`text.1.font.size`]: '30',[`text.1.font.family`]: 'Poppins',[`text.1.font.weight`]: '700',[`text.1.outline.width`]: '5',[`text.1.position.x`]: '410',[`text.1.position.y`]: '235',[`text.1.position.gravity`]: 'west',[`text.2.font.size`]: '32',[`text.2.color`]: 'FFFFFF',[`text.2.font.family`]: 'Poppins',[`text.2.font.weight`]: '700',[`text.2.outline.width`]: '5',[`text.2.position.x`]: '413',[`text.2.position.y`]: '275',[`text.2.position.gravity`]: 'west' }) }
}

/**
 * Describe this function...
 */
async function ShareSponsorImage3() {
  return { [`baseImgURL`]: imageUrl,[`targetImgClass`]: targetClass,[`downloadButtonClass`]: downloadButtonClass,[`options`]: ({ [`w`]: '1200',[`h`]: '630',[`scale.option`]: 'ignore',[`text.0.width`]: '65%',[`text.0.color`]: 'FFFFFF',[`text.0.font.family`]: 'Poppins',[`text.0.font.weight`]: '700',[`text.0.outline.width`]: '5',[`text.0.position.x`]: '410',[`text.0.position.y`]: '220',[`text.0.position.gravity`]: 'west',[`text.1.color`]: 'FFFFFF',[`text.1.font.size`]: '32',[`text.1.font.family`]: 'Poppins',[`text.1.font.weight`]: '700',[`text.1.outline.width`]: '5',[`text.1.position.x`]: '410',[`text.1.position.y`]: '275',[`text.1.position.gravity`]: 'west' }) }
}


  returnSetting = null;
  if (key == 'ShareSponsorImage1') {
    returnSetting = await ShareSponsorImage1();
  } else if (key == 'ShareSponsorImage2') {
    returnSetting = await ShareSponsorImage2();
  } else if (key == 'ShareSponsorImage3') {
    returnSetting = await ShareSponsorImage3();
  }

return returnSetting
}

})
define('./functions/8cec55bfe1cb2271228cc6a79473903e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8cec55bfe1cb2271228cc6a79473903e'] = async function fn_8cec55bfe1cb2271228cc6a79473903e() {
var response;


  response = true;
  if (!((await Backendless.UserService.getUserRoles()).includes('Sponsor'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerDashboard', undefined);
  }

return response
}

})
define('./functions/95f7fa8277ce6bbbfd7b54d2cf020e22/code.js', () => { 

BackendlessUI.Functions.Custom['fn_95f7fa8277ce6bbbfd7b54d2cf020e22'] = async function fn_95f7fa8277ce6bbbfd7b54d2cf020e22(list) {
var errorList, error, item, nameList, numRegExp, item2, phoneRegExp, emailRegExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  errorList = [];
  try {
    for (var item_index in list) {
      item = list[item_index];
      if ((getObjectProperty(item, 'rules')).includes('required')) {
        if ((typeof (getObjectProperty(item, 'value')) === 'undefined') || (getObjectProperty(item, 'value')) == '' || (getObjectProperty(item, 'value')) == null) {
          addItemToList(errorList, item);
        }
      }
      if ((getObjectProperty(item, 'rules')).includes('requiredArray')) {
        if ((typeof (getObjectProperty(item, 'value')) === 'undefined') || (getObjectProperty(item, 'value')) == null || !(Array.isArray((getObjectProperty(item, 'value')))) || (getObjectProperty(item, 'value')).length == 0) {
          addItemToList(errorList, item);
        }
      }
      if ((getObjectProperty(item, 'rules')).includes('noZero')) {
        if ((typeof (getObjectProperty(item, 'value')) === 'undefined') || (getObjectProperty(item, 'value')) == '0' || (getObjectProperty(item, 'value')) == 0) {
          addItemToList(errorList, item);
        }
      }
      if (((getObjectProperty(item, 'rules')).includes('email')) && (await asyncListFilter(errorList, async (item2) => {


       return ((getObjectProperty(item2, 'field')) == (getObjectProperty(item, 'field')));
      })).length == 0) {
        if (!(await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54']((getObjectProperty(item, 'value'))))) {
          addItemToList(errorList, item);
        }
      }
      if (((getObjectProperty(item, 'rules')).includes('phone')) && (await asyncListFilter(errorList, async (item2) => {


       return ((getObjectProperty(item2, 'field')) == (getObjectProperty(item, 'field')));
      })).length == 0) {
        if (!(await BackendlessUI.Functions.Custom['fn_437d4fea018b514cfa2e14139db4f75a']((getObjectProperty(item, 'value'))))) {
          addItemToList(errorList, item);
        }
      }
      if (((getObjectProperty(item, 'rules')).includes('num')) && (await asyncListFilter(errorList, async (item2) => {


       return ((getObjectProperty(item2, 'field')) == (getObjectProperty(item, 'field')));
      })).length == 0) {
        numRegExp = (new RegExp('^[0-9.]*$', ''));
        if (((String(getObjectProperty(item, 'value'))).match(numRegExp)) == null) {
          addItemToList(errorList, item);
        }
      }
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('formValidation2 function - General error', new Backendless.Bodyparts({ textmessage: (String('This was the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

return errorList
}

})
define('./functions/97599fbe5a68c9d2cd01efd5cd381092/code.js', () => { 

BackendlessUI.Functions.Custom['fn_97599fbe5a68c9d2cd01efd5cd381092'] = async function fn_97599fbe5a68c9d2cd01efd5cd381092(keypress, pageData) {
var barcodeObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (keypress == (getObjectProperty((getObjectProperty(pageData, 'settings')), 'startCharacter'))) {
    pageData['scanCaptureActive'] = true;
    stopSetTimeout('scanCaptureActive');

    ;(function() {
      const callback = async () => {
          pageData['scanCaptureActive'] = false;
      pageData['scanInput'] = '';

      };

      const timerId = 'scanCaptureActive';
      const timerDelay = 400;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    return ;
  }
  if (keypress == (getObjectProperty((getObjectProperty(pageData, 'settings')), 'endCharacter'))) {
    pageData['scanInput'] = ((getObjectProperty(pageData, 'scanInput')).replace((new RegExp('\\D', 'g')), ''));
    pageData['scanCaptureActive'] = false;
    barcodeObject = (getObjectProperty((getObjectProperty(pageData, 'barcodes')), (getObjectProperty(pageData, 'scanInput'))));
    pageData['scanInput'] = '';
    if ((getObjectProperty(barcodeObject, 'command')) == 'B') {
      (getObjectProperty(pageData, 'shipment'))['combinedDimensions'] = (getObjectProperty(barcodeObject, 'input1'));
      (getObjectProperty(pageData, 'shipment'))['boxItemNumber'] = (getObjectProperty(barcodeObject, 'input2'));
      (getObjectProperty(pageData, 'shipment'))['boxLabel'] = (getObjectProperty(barcodeObject, 'label'));
      (getObjectProperty(pageData, 'shipment'))['dimensionsEntered'] = true;
      (getObjectProperty(pageData, 'modalVisible'))['modalBox'] = false;
      if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'shipmentCreated')) == true) {
        (getObjectProperty(pageData, 'shipment'))['shipmentCreated'] = false;
      }
      await BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'](pageData);
    }
    if ((getObjectProperty(barcodeObject, 'command')) == 'CLR') {
      pageData['multipackageShipment'] = false;
      await BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'](pageData);
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      (getObjectProperty(pageData, 'modalVisible'))['modalBox'] = false;
      (getObjectProperty(pageData, 'modalVisible'))['modalScan'] = true;
    }
    if ((getObjectProperty(barcodeObject, 'command')) == 'SP') {
      await BackendlessUI.Functions.Custom['fn_ede16f295a85a3ad700cdb4100b1a097'](pageData);
    }
    if ((getObjectProperty(barcodeObject, 'command')) == 'MPS') {
      if ((getObjectProperty(pageData, 'multipackageShipment')) == true) {
        if ((getObjectProperty((getObjectProperty(pageData, 'modalVisible')), 'modalScan')) == true) {
          pageData['multipackageShipment'] = false;
        } else {
          (getObjectProperty(pageData, 'shipment'))['multipackageShipmentLast'] = true;
        }
      } else {
        pageData['multipackageShipment'] = true;
      }
    }
    if ((getObjectProperty(barcodeObject, 'command')) == 'RD') {
    }
    if ((getObjectProperty(barcodeObject, 'command')) == 'RU') {
    }
    if ((getObjectProperty(barcodeObject, 'command')) == 'REV') {
      pageData['reviewBeforeTransaction'] = ((getObjectProperty(pageData, 'reviewBeforeTransaction')) ? false : true);
    }
    return ;
  }
  if ((getObjectProperty(pageData, 'scanCaptureActive')) == true) {
    pageData['scanInput'] = (String(getObjectProperty(pageData, 'scanInput')) + String(keypress));
  }

return 
}

})
define('./functions/9d167b3f52282c0dbef5bcaf729374cd/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'] = function fn_9d167b3f52282c0dbef5bcaf729374cd(list, value) {
var trimValue, valueItem, valuesList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (typeof value === 'string') {
    valuesList = [value];
  } else if (Array.isArray(value)) {
    valuesList = value;
  }
  if (valuesList) {
    for (var valueItem_index in valuesList) {
      valueItem = valuesList[valueItem_index];
      trimValue = valueItem.trim();
      if (!(list.includes(trimValue))) {
        addItemToList(list, trimValue);
      }
    }
  }

return list
}

})
define('./functions/a31c03f60fef43b7116c77b3b7aa7c3f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a31c03f60fef43b7116c77b3b7aa7c3f'] = async function fn_a31c03f60fef43b7116c77b3b7aa7c3f(pageData) {
var shipmentObject, error, rawShippingRates, shippoError, weightLock, tempWeight, return2, rateResults, rateObject, counter, rate, shippingCarrierList, filteredShippingRates, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function processRates() {
  if ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).toUpperCase() != 'ALL') {
    filteredShippingRates = (await asyncListFilter(rawShippingRates, async (item) => {


     return ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).toUpperCase().indexOf((getObjectProperty(item, 'provider')).toUpperCase()) + 1 > 0);
    }));
  } else {
    filteredShippingRates = rawShippingRates;
  }
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'excludeUSPS')) == true) {
    filteredShippingRates = (await asyncListFilter(filteredShippingRates, async (item) => {


     return ((getObjectProperty(item, 'provider')).toUpperCase() != 'USPS');
    }));
  }
  filteredShippingRates = (await asyncListFilter(filteredShippingRates, async (item) => {


   return ((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingServiceIgnoreList')).indexOf((getObjectProperty((getObjectProperty(item, 'servicelevel')), 'name')).toUpperCase()) + 1 == 0);
  }));
  shippingCarrierList = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingCarriers')).split(',');
  counter = 0;
  rateResults = [];
  rateResults = (await Promise.all(filteredShippingRates.map(async rate => {; return ({ [`objectId`]: (getObjectProperty(rate, 'object_id')),[`amount`]: (getObjectProperty(rate, 'amount')),[`sortAmount`]: (Number((getObjectProperty(rate, 'amount')))),[`carrier`]: (getObjectProperty(rate, 'provider')),[`service`]: (getObjectProperty((getObjectProperty(rate, 'servicelevel')), 'name')),[`speed`]: (getObjectProperty(rate, 'estimated_days')),[`speedDetails`]: (getObjectProperty(rate, 'duration_terms')) });})));
  (getObjectProperty(pageData, 'shipment'))['ratesAll'] = rateResults;
}


  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'shipmentCreated')) == true) {
    return false;
  }
  if ((getObjectProperty(pageData, 'scaleConnected')) != true) {
    return false;
  }
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'dimensionsEntered')) != true) {
    return false;
  }
  if ((getObjectProperty(pageData, 'requireValidAddress')) == true && (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'addressValid')) != true) {
    return false;
  }
  if ((getObjectProperty(pageData, 'scaleWeight')) == 0) {
    return false;
  }
  if (return2) {
    await BackendlessUI.Functions.Custom['fn_3d77e8460dd39d05db4ae281b2e2489a'](pageData);
    if ((getObjectProperty(pageData, 'reviewBeforeTransaction')) == false && (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'addressValid')) == true) {
      await BackendlessUI.Functions.Custom['fn_ede16f295a85a3ad700cdb4100b1a097'](pageData);
    }
  }
  try {
    (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = true;
    (getObjectProperty(pageData, 'parcel'))['distance_unit'] = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'distanceUnit'));
    weightLock = false;
    while (!weightLock) {
      tempWeight = (getObjectProperty(pageData, 'scaleWeight'));
      await new Promise(r => setTimeout(r, 100 || 0));
      if (tempWeight == (getObjectProperty(pageData, 'scaleWeight'))) {
        weightLock = true;
        (getObjectProperty(pageData, 'parcel'))['weight'] = (getObjectProperty(pageData, 'scaleWeight'));
      }
    }
    (getObjectProperty(pageData, 'parcel'))['mass_unit'] = (getObjectProperty((getObjectProperty(pageData, 'settings')), 'massUnit'));
    if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'dimensionsEntered')) != true) {
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      pageData['error'] = 'Shipment data cleared while processing.';
      return false;
    }
    for (var count = 0; count < 2; count++) {
      try {
        shipmentObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.shipengine.com/v1/rates')).set(({ [`API-Key`]: (getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShipEngineAPIKey')),[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(({ [`rate_options`]: ({ [`carrier_ids`]: ['se-243816'] }),[`shipment`]: ({ [`validate_address`]: 'validate_and_clean',[`ship_to`]: ({ [`name`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'name')),[`company_name`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'company')),[`address_line1`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'address1')).trim(),[`address_line2`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'address2')).trim(),[`city_locality`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'city')),[`state_province`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'state')),[`postal_code`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'zip')),[`country_code`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'phone')),[`address_residential_indicator`]: 'no' }),[`return_to`]: ({ [`name`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name')) : (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'company')),[`company`]: getValueLength((getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'name'))) > 0 ? (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'company')) : '',[`street1`]: [(getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'address1')),' ',(getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'address2'))].join(''),[`city`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'city')),[`state`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'state')),[`zip`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'zip')),[`country`]: 'US',[`phone`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'phone')),[`email`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')) == null || (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')) == '' ? 'no-reply@mfshipment.com' : (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'email')),[`metadata`]: (getObjectProperty((getObjectProperty(pageData, 'addressFrom')), 'companyId')) }),[`warehouse_id`]: 'se-118932',[`packages`]: [({ [`weight`]: ({ [`value`]: (getObjectProperty((getObjectProperty(pageData, 'parcel')), 'weight')),[`unit`]: 'pound' }),[`dimensions`]: ({ [`unit`]: 'inch',[`length`]: (getObjectProperty((getObjectProperty(pageData, 'parcel')), 'length')),[`width`]: (getObjectProperty((getObjectProperty(pageData, 'parcel')), 'width')),[`height`]: (getObjectProperty((getObjectProperty(pageData, 'parcel')), 'height')) }) })] }) })));
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail('shippingCreateShipment function - Shippo API error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),' This is everything in pageData: ',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
    shippoError = '';
    if ((typeof (getObjectProperty(shipmentObject, 'status')) === 'undefined') || (getObjectProperty(shipmentObject, 'status')) != 'SUCCESS') {
      await Backendless.Messaging.sendEmail('shippingCreateShipment function - could not create shipment', new Backendless.Bodyparts({ textmessage: (['This was the shippo shipmentObject',(JSON.stringify(shipmentObject)),' This is everything in pageData: ',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      pageData['error'] = 'Could not create Shippo Shipment';
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      return ;
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_to')), 'is_complete')) != true) {
      shippoError = 'Ship to address is not complete.';
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_from')), 'is_complete')) != true) {
      shippoError = getValueLength(shippoError) > 0 ? [shippoError,' ','Ship from address is not complete.'].join('') : 'Ship from address is not complete.';
    }
    if ((getObjectProperty((getObjectProperty(shipmentObject, 'address_return')), 'is_complete')) != true) {
      shippoError = getValueLength(shippoError) > 0 ? [shippoError,' ','Return address is not complete.'].join('') : 'Return address is not complete.';
    }
    if (getValueLength(shippoError) > 0) {
      pageData['error'] = shippoError;
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      return ;
    }
    rawShippingRates = (getObjectProperty(shipmentObject, 'rates'));
    (getObjectProperty(pageData, 'shipment'))['rawRatesAll'] = (getObjectProperty(shipmentObject, 'rates'));
    (getObjectProperty(pageData, 'shipment'))['shipmentCreated'] = true;
    await processRates();
    if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'ratesAll')).length == 0) {
      pageData['error'] = 'Current configuration resulted in no shipping rates available.';
      return ;
    }
    await BackendlessUI.Functions.Custom['fn_c78cc03ac7c6da352c756134165187df'](pageData);

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingCreateShipment function - General function error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' This is everything in pageData: ',(JSON.stringify(pageData)),'Everything from Shippo: ',shipmentObject].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;

return 
}

})
define('./functions/a91e5794f31e9cf940b29d5dc78194c1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a91e5794f31e9cf940b29d5dc78194c1'] = function fn_a91e5794f31e9cf940b29d5dc78194c1(searchResultObject, pageData) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(searchResultObject, 'fundraiserType')) == 'Traditional' || (getObjectProperty(searchResultObject, 'fundraiserType')) == 'TraditionalFrozen') {
    pageData['isShowS2S'] = true;
  }
  if ((getObjectProperty(searchResultObject, 'fundraiserType')) == 'DSH') {
    pageData['isShowAddress'] = true;
    pageData['isShowDSH'] = true;
  }
  pageData['queryOrganizationLS'] = (getObjectProperty(searchResultObject, 'label'));
  pageData['organizationId'] = (getObjectProperty(searchResultObject, 'organizationObjID'));
  pageData['officeOrganizationId'] = (getObjectProperty(searchResultObject, 'officeOrganizationId'));
  pageData['fundraiserId'] = (getObjectProperty(searchResultObject, 'fundraiserObjID'));
  pageData['fundraiserPassiveDate'] = (getObjectProperty(searchResultObject, 'fundraiserPassiveDate'));
  pageData['fundraiserStoreCategoriesFrozen'] = (getObjectProperty(searchResultObject, 'fundraiserStoreCategoriesFrozen'));
  pageData['isReadonlyOrganizationLS'] = true;
  pageData['isShowClearOrganizationLS'] = true;
  pageData['isOpenOrganizationLS'] = false;

}

})
define('./functions/af316a0c15474f44858a3f62b2b7292d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_af316a0c15474f44858a3f62b2b7292d'] = async function fn_af316a0c15474f44858a3f62b2b7292d(selector, link) {
  await (async function(link, selector) {
  	const targetElem = document.querySelector(selector);
  	targetElem.innerText = '';

  	const hrefLink = new URL('https://www.facebook.com/plugins/share_button.php');
  	hrefLink.searchParams.set('href', link);
  	hrefLink.searchParams.set('layout', 'button');
  	hrefLink.searchParams.set('size', 'large');
  	hrefLink.searchParams.set('appId', '4766177493401260');
  	hrefLink.searchParams.set('width', '119');
  	hrefLink.searchParams.set('height', '28');

  	const iframe = document.createElement('iframe');
  	iframe.setAttribute('src', hrefLink);
  	iframe.setAttribute('width', '119');
  	iframe.setAttribute('height', '28');
  	iframe.setAttribute('style', 'border:none;overflow:hidden');
  	iframe.setAttribute('scrolling', 'no');
  	iframe.setAttribute('frameborder', '0');
  	iframe.setAttribute('allowfullscreen', 'true');
  	iframe.setAttribute('allow', 'autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share');


  	targetElem.appendChild(iframe);



  })(link, selector);

}

})
define('./functions/af325e4a22a2b4daac665665a4a282f4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_af325e4a22a2b4daac665665a4a282f4'] = async function fn_af325e4a22a2b4daac665665a4a282f4(pageData, source) {
var error, addressSourceProperty, addressValidationObject, addressValidationList, queryString, checkAddress, results, smartyFootnotes, smartyFootnote, footnote, analysisFootnotesList, i, smartyAnalysis, validAddress, analyzeFootnotes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function addressAnalysis() {
  smartyFootnotes = ({ [`AA`]: 'Street name, city, state, and ZIP are all valid.',[`A1`]: 'Address is invalid.',[`BB`]: 'Entire address is valid.',[`CC`]: 'The submitted secondary information (apt, suite, etc.) was not recognized but not required.',[`C1`]: 'Secondary number (apt, suite, etc.) was not recognized and is required.',[`F1`]: 'Military or diplomatic address.',[`G1`]: 'General delivery address.',[`M1`]: 'Primary number (e.g., house number) is missing.',[`M3`]: 'Primary number (e.g., house number) is invalid.',[`N1`]: 'Address is missing secondary information (apt, suite, etc.) and it is required.',[`PB`]: 'PO Box street style address.',[`P1`]: 'PO, RR, or HC box number is missing.',[`P3`]: ' PO, RR, or HC box number is invalid.',[`RR`]: 'Confirmed address with private mailbox (PMB) info.',[`R1`]: 'Confirmed address without private mailbox (PMB) info.',[`R7`]: ' Confirmed as a valid address that doesn\'t currently receive US Postal Service street delivery.',[`U1`]: 'Address has a "unique" ZIP Code.',[`TA`]: 'Input address primary number matched by dropping trailing alphabetic character, e.g. "123A" => "123"',[`IA`]: 'USPS Informed Address identified.' });
  validAddress = false;
  smartyAnalysis = (getObjectProperty(addressValidationObject, 'analysis'));
  if ((getObjectProperty(smartyAnalysis, 'dpv_match_code')) == 'Y') {
    (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
    (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
    if ((getObjectProperty(smartyAnalysis, 'dpv_footnotes')).indexOf('R7') + 1 > 0) {
      (getObjectProperty(pageData, 'shipment'))['excludeUSPS'] = true;
    }
    analyzeFootnotes = false;
    validAddress = true;
  } else if ((getObjectProperty(smartyAnalysis, 'dpv_match_code')) == 'D') {
    (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
    (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
    analyzeFootnotes = false;
    validAddress = true;
  } else if ((getObjectProperty(smartyAnalysis, 'dpv_match_code')) == 'S') {
    if ((getObjectProperty(smartyAnalysis, 'dpv_footnotes')).indexOf('CC') + 1 > 0) {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
      analyzeFootnotes = false;
      validAddress = true;
    } else if ((getObjectProperty(smartyAnalysis, 'dpv_footnotes')).indexOf('C1') + 1 > 0) {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
      analyzeFootnotes = false;
      validAddress = true;
    } else {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = false;
      analyzeFootnotes = true;
      validAddress = false;
    }
  } else {
    if ((getObjectProperty(smartyAnalysis, 'enhanced_match')).indexOf('none') + 1 > 0) {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = false;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = ['Unknown address.'];
      analyzeFootnotes = false;
      validAddress = false;
    } else if ((getObjectProperty(smartyAnalysis, 'enhanced_match')).indexOf('non-postal-match') + 1 > 0) {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
      analyzeFootnotes = false;
      validAddress = true;
      (getObjectProperty(pageData, 'shipment'))['excludeUSPS'] = true;
    } else if ((getObjectProperty(smartyAnalysis, 'enhanced_match')).indexOf('missing-secondary') + 1 > 0) {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
      analyzeFootnotes = false;
      validAddress = true;
    } else if ((getObjectProperty(smartyAnalysis, 'enhanced_match')).indexOf('unknown-secondary') + 1 > 0) {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
      analyzeFootnotes = false;
      validAddress = true;
    }
  }
  if (analyzeFootnotes) {
    analysisFootnotesList = [];
    results = [];
    var i_end = getValueLength((getObjectProperty(smartyAnalysis, 'dpv_footnotes')));
    var i_inc = 2;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      addItemToList(analysisFootnotesList, ((getObjectProperty(smartyAnalysis, 'dpv_footnotes')).slice((i - 1), i + 2)));
    }
    for (var footnote_index in analysisFootnotesList) {
      footnote = analysisFootnotesList[footnote_index];
      if (!(typeof (getObjectProperty(smartyFootnotes, footnote)) === 'undefined')) {
        addItemToList(results, (getObjectProperty(smartyFootnotes, footnote)));
      }
    }
    (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = results;
  }
  if (!validAddress && (getObjectProperty(pageData, 'reviewBeforeTransaction')) == false) {
    await BackendlessUI.Functions.Custom['fn_498e95b477d71882ffbc8bde233ec06c'](pageData);
  }
}


  try {
    addressSourceProperty = 'addressToOriginal';
    if (source == 'button') {
      addressSourceProperty = 'addressTo';
    }
    if (getValueLength((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address1'))) == 0) {
      pageData['error'] = 'No address to validate';
      return ;
    }
    checkAddress = false;
    if (checkAddress) {
      queryString = [String('?key=') + String(encodeURIComponent((getObjectProperty((getObjectProperty(pageData, 'settings')), 'SmartyAPIKey')))),String('&license=') + String(encodeURIComponent('us-core-enterprise-cloud')),String('&street=') + String(encodeURIComponent((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address1')))),String('&street2=') + String(encodeURIComponent(((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address2')).trim()))),String('&city=') + String(encodeURIComponent((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'city')))),String('&state=') + String(encodeURIComponent((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'state')))),String('&zipcode=') + String(encodeURIComponent((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'zip')))),String('&match=') + String(encodeURIComponent((getObjectProperty(pageData, 'addressValidationMatchType')))),String('&candidates=') + String(encodeURIComponent('1')),String('&address-type=') + String(encodeURIComponent('us-street-components'))].join('');
      addressValidationList = [];
      for (var count = 0; count < 3; count++) {
        try {
          addressValidationList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})((String('https://us-street.api.smartystreets.com/street-address') + String(queryString)))).set(({ [`Content-Type`]: 'application/json' })).setEncoding('utf8').send());
          break;

        } catch (error) {
          await Backendless.Messaging.sendEmail('shippingAddressVerification Function - Smarty API error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),'This was the query string: ',queryString].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
          if (getValueLength((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address1'))) == 0) {
            break;
          }
          await new Promise(r => setTimeout(r, 100 || 0));

        }
      }
      if (getValueLength((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address1'))) == 0) {
        pageData['error'] = 'No address to validate';
        return ;
      }
      if (addressValidationList.length == 0) {
        pageData['error'] = 'No Smarty address found';
        return ;
      }
      (getObjectProperty(pageData, 'shipment'))['smartyAddressChecked'] = true;
      addressValidationObject = addressValidationList[0];
      (getObjectProperty(pageData, 'addressTo'))['name'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'name')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'name')));
      (getObjectProperty(pageData, 'addressTo'))['company'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'company')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'company')));
      (getObjectProperty(pageData, 'addressTo'))['address1'] = (getObjectProperty(addressValidationObject, 'delivery_line_1'));
      (getObjectProperty(pageData, 'addressTo'))['address2'] = ((typeof (getObjectProperty(addressValidationObject, 'delivery_line_2')) === 'undefined') ? '' : (getObjectProperty(addressValidationObject, 'delivery_line_2')));
      (getObjectProperty(pageData, 'addressTo'))['city'] = (getObjectProperty((getObjectProperty(addressValidationObject, 'components')), 'city_name'));
      (getObjectProperty(pageData, 'addressTo'))['state'] = (getObjectProperty((getObjectProperty(addressValidationObject, 'components')), 'state_abbreviation'));
      (getObjectProperty(pageData, 'addressTo'))['zip'] = ([(getObjectProperty((getObjectProperty(addressValidationObject, 'components')), 'zipcode')),'-',(getObjectProperty((getObjectProperty(addressValidationObject, 'components')), 'plus4_code'))].join(''));
      (getObjectProperty(pageData, 'addressTo'))['country'] = (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'country'));
      (getObjectProperty(pageData, 'addressTo'))['phone'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'phone')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'phone')));
      (getObjectProperty(pageData, 'addressTo'))['email'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'email')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'email')));
      if ((getObjectProperty((getObjectProperty(addressValidationObject, 'metadata')), 'rdi')) == 'Residential') {
        (getObjectProperty(pageData, 'shipment'))['smartyIsResidential'] = true;
      }
      if ((getObjectProperty((getObjectProperty(addressValidationObject, 'metadata')), 'rdi')) == 'Commercial') {
        (getObjectProperty(pageData, 'shipment'))['smartyIsResidential'] = false;
      }
      await addressAnalysis();
    } else {
      (getObjectProperty(pageData, 'shipment'))['smartyAddressChecked'] = true;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressValid'] = true;
      (getObjectProperty(pageData, 'shipment'))['smartyAddressMessage'] = [];
      (getObjectProperty(pageData, 'addressTo'))['name'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'name')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'name')));
      (getObjectProperty(pageData, 'addressTo'))['company'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'company')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'company')));
      (getObjectProperty(pageData, 'addressTo'))['address1'] = ((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address1')).trim());
      (getObjectProperty(pageData, 'addressTo'))['address2'] = ((getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'address2')).trim());
      (getObjectProperty(pageData, 'addressTo'))['city'] = (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'city'));
      (getObjectProperty(pageData, 'addressTo'))['state'] = (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'state'));
      (getObjectProperty(pageData, 'addressTo'))['zip'] = (getObjectProperty((getObjectProperty(pageData, addressSourceProperty)), 'zip'));
      (getObjectProperty(pageData, 'addressTo'))['country'] = (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'country'));
      (getObjectProperty(pageData, 'addressTo'))['phone'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'phone')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'phone')));
      (getObjectProperty(pageData, 'addressTo'))['email'] = (source == 'button' ? (getObjectProperty((getObjectProperty(pageData, 'addressTo')), 'email')) : (getObjectProperty((getObjectProperty(pageData, 'addressToOriginal')), 'email')));
      (getObjectProperty(pageData, 'shipment'))['smartyIsResidential'] = false;
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingAddressVerification - General function error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),' This is everything in pageData: ',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

return 
}

})
define('./functions/b6a716fc8f5c1d1f5dc8ae32543a46df/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'] = async function fn_b6a716fc8f5c1d1f5dc8ae32543a46df(settingList, appData) {
var settingResults, key, settingKeys;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(appData, 'settings')) {
    var key_list = (Object.keys((getObjectProperty(appData, 'settings'))));
    for (var key_index in key_list) {
      key = key_list[key_index];
      removeItemInList(settingList, key, '');
    }
  } else {
    appData['settings'] = ({  });
  }
  if (settingList.length > 0) {
    settingKeys = settingList.join(',');
    settingResults = (await Backendless.Request.get(`${Backendless.appPath}/services/utils/utils/get_settings`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'keys': JSON.stringify(settingKeys) }).send());
    var key_list2 = (Object.keys(settingResults));
    for (var key_index2 in key_list2) {
      key = key_list2[key_index2];
      (getObjectProperty(appData, 'settings'))[key] = (getObjectProperty(settingResults, key));
    }
  }

return (getObjectProperty(appData, 'settings'))
}

})
define('./functions/c78cc03ac7c6da352c756134165187df/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c78cc03ac7c6da352c756134165187df'] = async function fn_c78cc03ac7c6da352c756134165187df(pageData) {
var error, rateResults, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    rateResults = [];
    rateResults = (await asyncListSort((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'ratesAll')), 1, async (item) => {


     return (getObjectProperty(item, (getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingRateSortBy'))));
    }));
    rateResults = rateResults.slice(0, Number((getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingRateListLimit'))));
    (getObjectProperty(pageData, 'shipment'))['rates'] = rateResults;
    (getObjectProperty(pageData, 'shipment'))['selectedRate'] = (getObjectProperty((rateResults[0]), 'objectId'));

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingRateSort Function - Error', new Backendless.Bodyparts({ textmessage: (String('This is the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

return 
}

})
define('./functions/d217355c2e971bae9029b53b028c6ee5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d217355c2e971bae9029b53b028c6ee5'] = function fn_d217355c2e971bae9029b53b028c6ee5(allSellersList, selectedSellerIdsList, settings) {
var sellerPathText, sellerOrganizationText, sellerNamesText, sellerPathList, sellerOrganizationsList, lastOrganization, sellerNamesList, lastSellerName, orgItem, sellerItem, settings, settingKeys;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  sellerNamesText = '';
  sellerOrganizationText = '';
  sellerPathText = '';
  sellerNamesList = [];
  sellerOrganizationsList = [];
  sellerPathList = [];
  for (var sellerItem_index in allSellersList) {
    sellerItem = allSellersList[sellerItem_index];
    if (selectedSellerIdsList.includes((getObjectProperty(sellerItem, 'objectId')))) {
      addItemToList(sellerNamesList, (getObjectProperty(sellerItem, 'name')));
      addItemToList(sellerPathList, (String(getObjectProperty(settings, 'StoreBaseURL')) + String(getObjectProperty(sellerItem, 'microstorePath'))));
      var orgItem_list = (getObjectProperty(sellerItem, 'organizations'));
      for (var orgItem_index in orgItem_list) {
        orgItem = orgItem_list[orgItem_index];
        if (!(sellerOrganizationsList.includes(orgItem))) {
          addItemToList(sellerOrganizationsList, orgItem);
        }
      }
    }
  }
  if (sellerNamesList.length > 2) {
    lastSellerName = sellerNamesList.pop();
    sellerNamesText = [sellerNamesList.join(', '),' & ',lastSellerName].join('');
  } else {
    sellerNamesText = sellerNamesList.join(' & ');
  }
  if (sellerOrganizationsList.length > 2) {
    lastOrganization = sellerOrganizationsList.pop();
    sellerOrganizationText = [sellerOrganizationsList.join(', '),' & ',lastOrganization].join('');
  } else {
    sellerOrganizationText = sellerOrganizationsList.join(' & ');
  }
  sellerPathText = sellerPathList.join('<p><br></p>');
  sellerPathText = String(sellerPathText) + String('<p><br></p>');

return ({ [`sellerName`]: sellerNamesText,[`organizationName`]: sellerOrganizationText,[`microstorePath`]: sellerPathText })
}

})
define('./functions/d3332f2d035fe3de875748be5828e2a9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'] = async function fn_d3332f2d035fe3de875748be5828e2a9(mainAlertObj, nextActions) {
  await (async function(mainAlertObj, nextActions) {
  	Swal.fire(mainAlertObj)
  	.then((result) => {
  		nextActions ? nextActions(result) : '';
  	});
  })(mainAlertObj, nextActions);

return 
}

})
define('./functions/d72658826cb28ac7b8c3a149ec378a78/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'] = async function fn_d72658826cb28ac7b8c3a149ec378a78(pageData) {
var createShipment;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  createShipment = true;
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'shipmentCreated')) == true) {
    createShipment = false;
  }
  if ((getObjectProperty(pageData, 'scaleConnected')) != true) {
    createShipment = false;
  }
  if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'dimensionsEntered')) != true) {
    createShipment = false;
  }
  if ((getObjectProperty(pageData, 'requireValidAddress')) == true && (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'smartyAddressValid')) != true) {
    createShipment = false;
  }
  if ((getObjectProperty(pageData, 'scaleWeight')) == 0) {
    createShipment = false;
  }
  console.log(String('shippingCreateShipmentCheck1 elapsed time: ') + String(((new Date()).valueOf()) - (getObjectProperty(pageData, 'shipmentStartTime'))));
  if (createShipment) {
    await BackendlessUI.Functions.Custom['fn_3d77e8460dd39d05db4ae281b2e2489a'](pageData);
    console.log(String('shippingCreateShipmentCheck createShipment elapsed time: ') + String(((new Date()).valueOf()) - (getObjectProperty(pageData, 'shipmentStartTime'))));
    if ((getObjectProperty(pageData, 'reviewBeforeTransaction')) == false && (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'smartyAddressValid')) == true) {
      await BackendlessUI.Functions.Custom['fn_ede16f295a85a3ad700cdb4100b1a097'](pageData);
      console.log(String('shippingCreateShipmentCheck createTransaction elapsed time: ') + String(((new Date()).valueOf()) - (getObjectProperty(pageData, 'shipmentStartTime'))));
    }
  }

return 
}

})
define('./functions/e23ea808a57e516b1a8f2ae45d7c20e3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3'] = function fn_e23ea808a57e516b1a8f2ae45d7c20e3(template, pattern, text) {
var returnText, i, textList, currentPattern, patternList;


  returnText = template;
  patternList = pattern;
  textList = text;
  if (!(Array.isArray(patternList))) {
    patternList = [pattern];
  }
  if (!(Array.isArray(textList))) {
    textList = [text];
  }
  var i_end = patternList.length;
  var i_inc = 1;
  if (1 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    currentPattern = ((patternList[(i - 1)]).replace((new RegExp('\\$', '')), '\\$'));
    returnText = (returnText.replace((new RegExp(currentPattern, 'g')), (textList[(i - 1)])));
  }

return returnText
}

})
define('./functions/e3eacc03c5fe8e08620b920723bcb811/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811'] = async function fn_e3eacc03c5fe8e08620b920723bcb811(key, imageUrl, targetClass) {
var returnSetting;

/**
 * Describe this function...
 */
async function ShareStoryImage() {
  return { 'baseImgURL': imageUrl,'targetImgClass': targetClass,'options': ({ 'w': '1080','h': '1920','scale.option': 'ignore','text.0.width': '85%','text.0.font.family': 'Poppins','text.0.font.weight': '600','text.0.color': 'FFFFFF','text.0.position.gravity': 'south','text.0.position.x': '0','text.0.position.y': '-275','text.1.width': '50%','text.1.font.family': 'Poppins','text.1.font.weight': '600','text.1.color': 'FFFFFF','text.1.position.gravity': 'south','text.1.position.x': '0','text.1.position.y': '-175','watermark.scale.width': '775','watermark.position.x': '-4','watermark.position.y': '126' }) }
}

/**
 * Describe this function...
 */
async function ShareMoreImage1() {
  return { 'baseImgURL': imageUrl,'targetImgClass': targetClass,'options': ({ 'w': '1080','h': '1080','scale.option': 'ignore','text.0.width': '35%','text.0.font.family': 'Poppins','text.0.font.weight': '700','text.0.color': 'FFFFFF','text.0.position.gravity': 'southeast','text.0.position.x': '-10','text.0.position.y': '-500','text.1.width': '30%','text.1.font.family': 'Poppins','text.1.font.weight': '700','text.1.color': 'FFFFFF','text.1.position.gravity': 'southeast','text.1.position.x': '-40','text.1.position.y': '-440','watermark.scale.width': '600','watermark.position.x': '-183','watermark.position.y': '106' }) }
}

/**
 * Describe this function...
 */
async function ShareMoreImage2() {
  return { 'baseImgURL': imageUrl,'targetImgClass': targetClass,'options': ({ 'w': '1200','h': '630','scale.option': 'ignore','text.0.width': '45%','text.0.font.family': 'Poppins','text.0.font.weight': '600','text.0.color': 'FFFFFF','text.0.align': 'left','text.0.position.gravity': 'southwest','text.0.position.x': '30','text.0.position.y': '-165','text.1.width': '30%','text.1.font.family': 'Poppins','text.1.font.weight': '600','text.1.color': 'FFFFFF','text.1.position.x': '60','text.1.position.y': '-110','text.1.position.gravity': 'southwest','watermark.scale.width': '528','watermark.position.x': '291','watermark.position.y': '10' }) }
}


  returnSetting = null;
  if (key == 'ShareStoryImage') {
    returnSetting = await ShareStoryImage();
  } else if (key == 'ShareMoreImage1') {
    returnSetting = await ShareMoreImage1();
  } else if (key == 'ShareMoreImage2') {
    returnSetting = await ShareMoreImage2();
  }

return returnSetting
}

})
define('./functions/e4e126481b31e99806b14d5c842f5702/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e4e126481b31e99806b14d5c842f5702'] = async function fn_e4e126481b31e99806b14d5c842f5702(method, path, query, headers, body) {
var response;


  response = (await (async function(method, path, query, headers, body) {
  	const allowedMethods = ['GET', 'POST', 'PUT', 'DELETE'];
  	if (!allowedMethods.includes(method)) {
  	  return 'Error, Method not supported';
  	}
  	
  	const url = new URL(path);
  	if (typeof query === 'object' && !Array.isArray(query) && query !== null) {
  	  for (let key in query) {
  	    url.searchParams.set(key, query[key]);
  	  }
  	}
  	
  	let sendBody = {};
  	if (typeof body === 'object' && !Array.isArray(body) && body !== null) {
  	  sendBody = body;
  	}
  	
  	const request = new XMLHttpRequest();
  	
  	return new Promise(function (resolve, reject) {
  	  const headerMap = {};
  	  request.open(method, url.href, true);
  	
  	  for (let key in headers) {
  	    request.setRequestHeader(key, headers[key]);
  	  }
  	  if (method !== 'GET') {
  	    request.setRequestHeader('Content-Type', 'application/json');
  	  }
  	
  	  request.onreadystatechange = function () {
  	    if (request.readyState == this.DONE) {
  	      console.log(request.status);
  	      if (request.status >= 200 && request.status < 300) {
  	        resolve({ responseText: request.responseText, headers: headerMap });
  	      } else {
  	        reject('Error, status code = ' + request.status);
  	      }
  	    }
  	
  	    if (this.readyState == this.HEADERS_RECEIVED) {
  	      // Get the raw header string
  	      const headers = request.getAllResponseHeaders();
  	
  	      // Convert the header string into an array
  	      // of individual headers
  	      const arr = headers.trim().split(/[\r\n]+/);
  	
  	      // Create a map of header names to values
  	      arr.forEach(function (line) {
  	        const parts = line.split(': ');
  	        const header = parts.shift();
  	        const value = parts.join(': ');
  	        headerMap[header] = value;
  	      });
  	    }
  	  };
  	
  	  sendBody !== {} ? request.send(JSON.stringify(sendBody)) : request.send();
  	});

  })(method, path, query, headers, body));

return response
}

})
define('./functions/e7989e3f9e3c18d25b5875b25ad82a76/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e7989e3f9e3c18d25b5875b25ad82a76'] = async function fn_e7989e3f9e3c18d25b5875b25ad82a76(pageData) {
var masterTotalObject, fundraiserList, repList, item, repObject, key, counter, seasonObject, masterFundraiserObject, changeObject, seasonName, lostAccounts, fundraiserObject, loopNormalizedAddressZip, seasonFundraiserList, raStatus, thisList, seasonList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  masterTotalObject = ({  });
  masterFundraiserObject = ({  });
  repObject = ({  });
  counter = 0;
  seasonList = (await asyncListSort((getObjectProperty(pageData, 'selectedSeasons')), 1, async (item) => {


   return item;
  }));
  (getObjectProperty(pageData, 'searchFilterObject'))['lastSeason'] = (String(seasonList.slice(-1)[0].charAt(0).toUpperCase()) + String((seasonList.slice(-1)[0]).replace((new RegExp('\\D', 'g')), '')));
  for (var seasonName_index in seasonList) {
    seasonName = seasonList[seasonName_index];
    raStatus = 'true';
    thisList = (await asyncListFilter((getObjectProperty(pageData, 'seasonList')), async (item) => {


     return (seasonName == (getObjectProperty(item, 'dbName')));
    }));
    if (thisList.length == 1) {
      if ((getObjectProperty((thisList[0]), 'StartDate')) > ((new Date()).valueOf())) {
        raStatus = 'false';
      }
    }
    counter = (typeof counter == 'number' ? counter : 0) + 1;
    seasonFundraiserList = (await Backendless.Request.get(`${Backendless.appPath}/services/utils/getFundraisersYoY`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'seasons': JSON.stringify(seasonName),'raStatus': JSON.stringify(raStatus) }).send());
    masterTotalObject[seasonName] = ({ [`TotalAccounts`]: 0,[`NewAccounts`]: 0,[`TotalRetail`]: 0,[`NewRetail`]: 0,[`RetailGrowth`]: 0,[`RetailDecline`]: 0,[`LostAccounts`]: 0,[`LostRetail`]: 0,[`PaperRetail`]: 0,[`WebRetail`]: 0,[`TotalEnrollment`]: 0,[`TotalSellers`]: 0,[`WebSellers`]: 0,[`PaperSellers`]: 0 });
    for (var fundraiserObject_index in seasonFundraiserList) {
      fundraiserObject = seasonFundraiserList[fundraiserObject_index];
      loopNormalizedAddressZip = [(await (async function(address) {
      	// Step 1: Convert to lowercase
      	address = address.toLowerCase();
      	
      	// Step 2: Define a mapping of common abbreviations to standard terms
      	const suffixMapping = {
      	  '\\bst\\.?\\b': 'street',     // "St." or "St" -> "street"
      	  '\\bave\\.?\\b': 'avenue',    // "Ave" or "Ave." -> "avenue"
      	  '\\bblvd\\.?\\b': 'boulevard',// "Blvd" or "Blvd." -> "boulevard"
      	  '\\brd\\.?\\b': 'road',       // "Rd" or "Rd." -> "road"
      	  '\\bdr\\.?\\b': 'drive',      // "Dr" or "Dr." -> "drive"
      	  '\\bln\\.?\\b': 'lane',       // "Ln" or "Ln." -> "lane"
      	  '\\bpkwy\\.?\\b': 'parkway',  // "Pkwy" or "Pkwy." -> "parkway"
      	  '\\bapt\\.?\\b': 'apartment', // "Apt" or "Apt." -> "apartment"
      	  '\\bste\\.?\\b': 'suite'      // "Ste" or "Ste." -> "suite"
      	  // Add more suffix mappings as needed
      	};
      	
      	// Step 3: Replace abbreviations using the mapping
      	for (const [pattern, replacement] of Object.entries(suffixMapping)) {
      	  const regex = new RegExp(pattern, 'gi');
      	  address = address.replace(regex, replacement);
      	}
      	
      	// Step 4: Remove any remaining punctuation or extra spaces
      	address = address.replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
      	
      	return address;
      	

      })((getObjectProperty(fundraiserObject, 'Address')))),' ',(await (async function(zipCode) {
      	if (typeof zipCode === 'string' && /\d{5}/.test(zipCode)) {
      	    return zipCode.match(/\d{5}/)[0];
      	  }
      	  return '0';
      })((getObjectProperty(fundraiserObject, 'Zipcode'))))].join('');
      masterTotalObject[seasonName] = ({ [`TotalAccounts`]: (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'TotalAccounts')) + 1,[`NewAccounts`]: (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'NewAccounts')),[`TotalRetail`]: (Number((getObjectProperty(fundraiserObject, 'TotalRetail')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'TotalRetail')),[`NewRetail`]: (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'NewRetail')),[`LostRetail`]: 0,[`RetailGrowth`]: 0,[`RetailDecline`]: 0,[`LostAccounts`]: 0,[`PaperRetail`]: (Number((getObjectProperty(fundraiserObject, 'PaperRetail')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'PaperRetail')),[`WebRetail`]: (Number((getObjectProperty(fundraiserObject, 'WebRetail')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'WebRetail')),[`TotalEnrollment`]: (Number((getObjectProperty(fundraiserObject, 'Enrollment')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'TotalEnrollment')),[`TotalSellers`]: (Number((getObjectProperty(fundraiserObject, 'TotalSellers')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'TotalSellers')),[`WebSellers`]: (Number((getObjectProperty(fundraiserObject, 'WebSellers')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'WebSellers')),[`PaperSellers`]: (Number((getObjectProperty(fundraiserObject, 'PaperSellers')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'PaperSellers')) });
      if (typeof (getObjectProperty(repObject, (getObjectProperty(fundraiserObject, 'RepAbbr')))) === 'undefined') {
        repObject[(getObjectProperty(fundraiserObject, 'RepAbbr'))] = ({ [`name`]: (getObjectProperty(fundraiserObject, 'RepName')),[`abbr`]: (getObjectProperty(fundraiserObject, 'RepAbbr')) });
      }
      if (typeof (getObjectProperty(masterFundraiserObject, loopNormalizedAddressZip)) === 'undefined') {
        (getObjectProperty(masterTotalObject, seasonName))['NewAccounts'] = ((getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'NewAccounts')) + 1);
        (getObjectProperty(masterTotalObject, seasonName))['NewRetail'] = ((Number((getObjectProperty(fundraiserObject, 'TotalRetail')))) + (getObjectProperty((getObjectProperty(masterTotalObject, seasonName)), 'NewRetail')));
        masterFundraiserObject[loopNormalizedAddressZip] = ({ [`AccountName`]: (getObjectProperty(fundraiserObject, 'School')).trim(),[`Address`]: (getObjectProperty(fundraiserObject, 'Address')).trim(),[`City`]: (getObjectProperty(fundraiserObject, 'City')).trim(),[`State`]: (getObjectProperty(fundraiserObject, 'State')).trim(),[`Zipcode`]: (await (async function(zipCode) {
        	if (typeof zipCode === 'string' && /\d{5}/.test(zipCode)) {
        	    return zipCode.match(/\d{5}/)[0];
        	  }
        	  return '0';
        })((getObjectProperty(fundraiserObject, 'Zipcode')))),[`SeasonCount`]: 1,[`Seasons`]: [fundraiserObject],[`MostRecentSeason`]: textToTitleCase(seasonName) });
      } else {
        (getObjectProperty(masterFundraiserObject, loopNormalizedAddressZip))['AccountName'] = ((getObjectProperty(fundraiserObject, 'School')).trim());
        (getObjectProperty(masterFundraiserObject, loopNormalizedAddressZip))['SeasonCount'] = ((getObjectProperty((getObjectProperty(masterFundraiserObject, loopNormalizedAddressZip)), 'SeasonCount')) + 1);
        addItemToList((getObjectProperty((getObjectProperty(masterFundraiserObject, loopNormalizedAddressZip)), 'Seasons')), fundraiserObject);
      }
    }
    if (counter > 1) {
      lostAccounts = (await (async function(season, accounts) {
      	    // Generate the previous season by subtracting 1 from the year
      	    const yearPart = parseInt(season.slice(4));
      	    const previousSeason = `fall${yearPart - 1}`;

      	    // Filter accounts that meet the conditions
      	    const validAccounts = Object.values(accounts)
      	        .filter(account =>
      	            !account.Seasons.some(s => s.Season === season) && // Ensure the provided season does not exist
      	            account.Seasons.some(s => s.Season === previousSeason) // Ensure the previous season exists
      	        );

      	    // Sum the TotalRetail and count the valid accounts
      	    const sum = validAccounts
      	        .map(account => {
      	            // Find the TotalRetail for the previousSeason
      	            const previousSeasonEntry = account.Seasons.find(s => s.Season === previousSeason);
      	            return previousSeasonEntry ? parseFloat(previousSeasonEntry.TotalRetail) : 0;
      	        })
      	        .reduce((sum, value) => sum + value, 0); // Sum up the TotalRetail values

      	    // Return both the sum and the count of valid accounts
      	    return {
      	        sum: sum,
      	        count: validAccounts.length
      	    };
      })(seasonName, masterFundraiserObject));
      (getObjectProperty(masterTotalObject, seasonName))['LostRetail'] = (getObjectProperty(lostAccounts, 'sum'));
      (getObjectProperty(masterTotalObject, seasonName))['LostAccounts'] = (getObjectProperty(lostAccounts, 'count'));
      changeObject = (await (async function(accounts, currentSeason) {
      	    // Generate the previous season by subtracting 1 from the year
      	    const yearPart = parseInt(currentSeason.slice(4));
      	    const previousSeason = `fall${yearPart - 1}`;

      	    let positiveDifferenceSum = 0;
      	    let negativeDifferenceSum = 0;

      	    // Loop through each account and process
      	    Object.values(accounts).forEach(account => {
      	        // Check if both current and previous season exist
      	        const currentSeasonEntry = account.Seasons.find(s => s.Season === currentSeason);
      	        const previousSeasonEntry = account.Seasons.find(s => s.Season === previousSeason);

      	        // If both seasons are present, calculate the difference
      	        if (currentSeasonEntry && previousSeasonEntry) {
      	            const currentTotalRetail = parseFloat(currentSeasonEntry.TotalRetail);
      	            const previousTotalRetail = parseFloat(previousSeasonEntry.TotalRetail);

      	            // Calculate positive difference if current season retail is higher
      	            if (currentTotalRetail > previousTotalRetail) {
      	                positiveDifferenceSum += currentTotalRetail - previousTotalRetail;
      	            }
      	            // Calculate negative difference if previous season retail is higher
      	            else if (currentTotalRetail < previousTotalRetail) {
      	                negativeDifferenceSum += previousTotalRetail - currentTotalRetail;
      	            }
      	        }
      	    });

      	    // Return the results as an object
      	    return {
      	        positiveDifferenceSum: positiveDifferenceSum,
      	        negativeDifferenceSum: negativeDifferenceSum
      	    };
      })(masterFundraiserObject, seasonName));
      (getObjectProperty(masterTotalObject, seasonName))['RetailDecline'] = (getObjectProperty(changeObject, 'negativeDifferenceSum'));
      (getObjectProperty(masterTotalObject, seasonName))['RetailGrowth'] = (getObjectProperty(changeObject, 'positiveDifferenceSum'));
    }
  }
  fundraiserList = [];
  counter = 0;
  var key_list = (Object.keys(masterFundraiserObject));
  for (var key_index in key_list) {
    key = key_list[key_index];
    counter = (typeof counter == 'number' ? counter : 0) + 1;
    addItemToList(fundraiserList, ({ [`AccountName`]: (getObjectProperty((getObjectProperty(masterFundraiserObject, key)), 'AccountName')),[`Address`]: (getObjectProperty((getObjectProperty(masterFundraiserObject, key)), 'Address')),[`City`]: (getObjectProperty((getObjectProperty(masterFundraiserObject, key)), 'City')),[`State`]: (getObjectProperty((getObjectProperty(masterFundraiserObject, key)), 'State')),[`Zipcode`]: (getObjectProperty((getObjectProperty(masterFundraiserObject, key)), 'Zipcode')),[`Season`]: '--',[`AccountId`]: '',[`Sponsor`]: '',[`SponsorEmail`]: '',[`TotalRetail`]: '--',[`WebRetail`]: '--',[`PaperRetail`]: '--',[`Enrollment`]: '--',[`TotalSellers`]: '--',[`WebSellers`]: '--',[`PaperSellers`]: '--',[`SaleType`]: '--',[`Catalogs`]: '--',[`Rep`]: '--',[`Id`]: counter }));
    var seasonObject_list = (getObjectProperty((getObjectProperty(masterFundraiserObject, key)), 'Seasons'));
    for (var seasonObject_index in seasonObject_list) {
      seasonObject = seasonObject_list[seasonObject_index];
      addItemToList(fundraiserList, ({ [`AccountName`]: '',[`Address`]: '',[`City`]: '',[`State`]: '',[`Zipcode`]: '',[`Season`]: String((getObjectProperty(seasonObject, 'Season')).charAt(0).toUpperCase()) + String((getObjectProperty(seasonObject, 'Season')).replace((new RegExp('\\D', 'g')), '')),[`AccountId`]: (getObjectProperty(seasonObject, 'SchoolId')),[`Sponsor`]: (getObjectProperty(seasonObject, 'Sponsor')),[`SponsorEmail`]: (getObjectProperty(seasonObject, 'SponsorEmail')),[`TotalRetail`]: String('$') + String((await (async function(number) {
      	return number.toLocaleString('en-US');
      })((Number((getObjectProperty(seasonObject, 'TotalRetail'))))))),[`WebRetail`]: String('$') + String((await (async function(number) {
      	return number.toLocaleString('en-US');
      })((Number((getObjectProperty(seasonObject, 'WebRetail'))))))),[`PaperRetail`]: String('$') + String((await (async function(number) {
      	return number.toLocaleString('en-US');
      })((Number((getObjectProperty(seasonObject, 'PaperRetail'))))))),[`Enrollment`]: (getObjectProperty(seasonObject, 'Enrollment')),[`TotalSellers`]: (getObjectProperty(seasonObject, 'TotalSellers')),[`WebSellers`]: (getObjectProperty(seasonObject, 'WebSellers')),[`PaperSellers`]: (getObjectProperty(seasonObject, 'PaperSellers')),[`SaleType`]: (getObjectProperty(seasonObject, 'FundraiserType')).toUpperCase(),[`Catalogs`]: (getObjectProperty(seasonObject, 'Catalogs')),[`Rep`]: (getObjectProperty(seasonObject, 'RepAbbr')),[`Id`]: counter }));
    }
  }
  repList = [];
  var key_list2 = (Object.keys(repObject));
  for (var key_index2 in key_list2) {
    key = key_list2[key_index2];
    addItemToList(repList, ({ [`label`]: [(getObjectProperty((getObjectProperty(repObject, key)), 'name')),' - ',(getObjectProperty((getObjectProperty(repObject, key)), 'abbr'))].join(''),[`value`]: (getObjectProperty((getObjectProperty(repObject, key)), 'abbr')) }));
  }
  repList = (await asyncListSort(repList, 1, async (item) => {


   return (getObjectProperty(item, 'label'));
  }));
  repList = (await (async function(list) {
  	list.unshift({"label":"ALL","value":""});

  	return list;
  })(repList));
  (getObjectProperty(pageData, 'searchFilterObject'))['repList'] = repList;
  pageData['fundraiserList'] = fundraiserList;
  pageData['filteredFundraiserList'] = (await BackendlessUI.Functions.Custom['fn_70ad3f85585d0f344c6cf1fd74ff4a91'](pageData, fundraiserList));

return 
}

})
define('./functions/e89aa51663f454786e1bc72788d3fc54/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54'] = function fn_e89aa51663f454786e1bc72788d3fc54(email) {
var result, regExp;


  result = false;
  if (email != null && email != '') {
    regExp = (new RegExp('^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$', 'g'));
    result = (regExp.test((email.trim())));
  }

return result
}

})
define('./functions/ede16f295a85a3ad700cdb4100b1a097/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ede16f295a85a3ad700cdb4100b1a097'] = async function fn_ede16f295a85a3ad700cdb4100b1a097(pageData) {
var error, transactionObject, insertedShipmentObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}


  try {
    if (getValueLength((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'selectedRate'))) == 0) {
      pageData['error'] = 'No selected rate to create label from.  shippingCreateTransaction.';
      return ;
    }
    (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = true;
    for (var count = 0; count < 2; count++) {
      try {
        transactionObject = (await Backendless.Request['post']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.goshippo.com/transactions')).set(({ [`Authorization`]: String('ShippoToken ') + String(getObjectProperty((getObjectProperty(pageData, 'settings')), 'ShippingShippoToken')),[`Content-Type`]: 'application/json' })).setEncoding('utf8').send(({ [`rate`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'selectedRate')),[`label_file_type`]: 'PDF_4x6',[`async`]: false })));
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail('shippingCreateTransaction - Shippo API error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),'This was everything in pageData:',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
    if ((typeof (getObjectProperty(transactionObject, 'status')) === 'undefined') || (getObjectProperty(transactionObject, 'status')) != 'SUCCESS') {
      await Backendless.Messaging.sendEmail('shippingCreateTransaction - error creating shippo transaction', new Backendless.Bodyparts({ textmessage: (['This is the transaction object: ',(JSON.stringify(transactionObject)),'This was everything in pageData:',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      if (Array.isArray((getObjectProperty(transactionObject, 'messages')))) {
        pageData['error'] = ([(getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'source')),' ',!(typeof (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'message')) === 'undefined') ? (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'message')) : (!(typeof (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'text')) === 'undefined') ? (getObjectProperty(((getObjectProperty(transactionObject, 'messages'))[0]), 'text')) : 'Unknown error message.')].join(''));
      } else {
        pageData['error'] = 'Could not create Shippo Transaction - Please try again.';
      }
      (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
      return ;
    }
    await Backendless.Data.of('Shipments').deepSave( ({ [`AddressToOriginal`]: (getObjectProperty(pageData, 'addressToOriginal')),[`AddressTo`]: (getObjectProperty(pageData, 'addressTo')),[`AddressFrom`]: (getObjectProperty(pageData, 'addressFrom')),[`CompanyId`]: (getObjectProperty(pageData, 'addressFrom.companyId')),[`Rates`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'rawRatesAll')),[`Parcel`]: (getObjectProperty(pageData, 'parcel')),[`SelectedRateObjectId`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'selectedRate')),[`TrackingNumber`]: (getObjectProperty(transactionObject, 'tracking_number')),[`TrackingURL`]: (getObjectProperty(transactionObject, 'tracking_url_provider')),[`LogId`]: (Number((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'logId')))),[`LabelURL`]: (getObjectProperty(transactionObject, 'label_url')).slice(0, 500),[`OfficeSystemInsert`]: true,[`BoxItemNumber`]: (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'boxItemNumber')),[`User`]: ({ [`objectId`]: (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')) }) }) );
    pageData['lastLabelURL'] = (getObjectProperty(transactionObject, 'label_url'));
    if (getValueLength((getObjectProperty(transactionObject, 'label_url'))) > 0) {
      await (async function(fileURL, fileType) {
      	printJS(fileURL, fileType);
      })((getObjectProperty(transactionObject, 'label_url')), 'pdf');
    } else {
      await Backendless.Messaging.sendEmail('shippingCreateTransaction - No label to print error', new Backendless.Bodyparts({ textmessage: (String('This is everything in pageData: ') + String(JSON.stringify(pageData))) }), ensureArray('tim@meadowfarms.com'), undefined);
    }
    if (getValueLength((getObjectProperty(pageData, 'error'))) == 0) {
      if ((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'multipackageShipmentLast')) == true) {
        pageData['multipackageShipment'] = false;
      }
      await BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'](pageData);
      if ((getObjectProperty(pageData, 'multipackageShipment')) == true) {
        (getObjectProperty(pageData, 'shipment'))['multipackageShipmentCount'] = (((getObjectProperty((getObjectProperty(pageData, 'shipment')), 'multipackageShipmentCount')) == '' ? 0 : (getObjectProperty((getObjectProperty(pageData, 'shipment')), 'multipackageShipmentCount'))) + 1);
        await new Promise(r => setTimeout(r, 400 || 0));
        (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
        (getObjectProperty(pageData, 'modalVisible'))['modalBox'] = true;
      } else {
        await new Promise(r => setTimeout(r, 400 || 0));
        (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;
        (getObjectProperty(pageData, 'modalVisible'))['modalScan'] = true;
      }
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('shippingCreateTransaction - General function error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',(JSON.stringify(error)),'This was everything in pageData:',(JSON.stringify(pageData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

return 
}

})
define('./functions/efaca7492b738af69391f126684be2ff/code.js', () => { 

BackendlessUI.Functions.Custom['fn_efaca7492b738af69391f126684be2ff'] = function fn_efaca7492b738af69391f126684be2ff(phone) {
var regexp;


  regexp = (new RegExp('/^[\\+]?[(]?[0-9]{3}[)]?[-\\s\\.]?[0-9]{3}[-\\s\\.]?[0-9]{4,6}$', 'im'));

return (regexp.test(phone))
}

})
define('./functions/f30620e2042fe4e4cc73ad02ed3f3336/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f30620e2042fe4e4cc73ad02ed3f3336'] = async function fn_f30620e2042fe4e4cc73ad02ed3f3336(phone) {
var response, onlyNum;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  response = '';
  if ((await BackendlessUI.Functions.Custom['fn_437d4fea018b514cfa2e14139db4f75a'](phone))) {
    onlyNum = (phone.replace((new RegExp('\\D', 'g')), ''));
    if (getValueLength(onlyNum) == 11 && onlyNum.charAt(0) == '1') {
      onlyNum = onlyNum.slice(1, 11);
    }
    response = [onlyNum.slice(0, 3),'-',onlyNum.slice(3, 6),'-',onlyNum.slice(6, onlyNum.length)].join('');
  }

return response
}

})
define('./functions/feffbd2bb679b69a498a1696230cdfc9/code.js', () => { 

BackendlessUI.Functions.Custom['fn_feffbd2bb679b69a498a1696230cdfc9'] = async function fn_feffbd2bb679b69a498a1696230cdfc9(data, settingImages, noImage) {
var imageItem, text2, text1, text0, nameLen, userImgURL;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  text0 = (getObjectProperty(data, 'name'));
  text1 = String('Group ID: ') + String(getObjectProperty(data, 'OfficeOrganizationId'));
  text2 = ['End Date: ',(new Date((getObjectProperty(data, 'endDate'))).getMonth() + 1),'/',(new Date((getObjectProperty(data, 'endDate'))).getDate())].join('');
  nameLen = getValueLength((getObjectProperty(data, 'name')));
  for (var imageItem_index in settingImages) {
    imageItem = settingImages[imageItem_index];
    if ((getObjectProperty(imageItem, 'targetImgClass')).indexOf('3') + 1 != 0) {
      text2 = '';
    }
    if (nameLen < 30) {
      (getObjectProperty(imageItem, 'options'))['text.0.width'] = (String(Math.floor(nameLen * 1.2) + 10) + String('%'));
    }
    await (async function(baseImgURL, text, targetImgClass, userImgURL, options, text1, text2, downloadButtonClass) {
    	const targetElem = document.querySelector('.' + targetImgClass);
    	const url = new URL(baseImgURL);

    	url.searchParams.set('text.0.text', text);
    	url.searchParams.set('text.1.text', text1);
    	url.searchParams.set('text.2.text', text2);
    	//url.searchParams.set('watermark', userImgURL);

    	for(key in options) {
    	  url.searchParams.set(key, options[key]);
    	}

    	const imgUrl = url.toString().split('+').join('%20').split('BREAK').join('%0A');

    	const link = document.createElement('a');
    	link.setAttribute('href', imgUrl + '&format=original&dl');
    	link.setAttribute('target', '_blank');

    	const img = document.createElement('img');
    	img.setAttribute('src', imgUrl);
    	img.setAttribute('srcset', imgUrl);
    	img.setAttribute('class', 'Sirv');

    	link.appendChild(img);
    	targetElem.innerText = '';
    	targetElem.appendChild(link);

    	const downloadButton = document.querySelector('.' + downloadButtonClass);
    	downloadButton.setAttribute('href', imgUrl + '&dl');
    })((getObjectProperty(imageItem, 'baseImgURL')), text0, (getObjectProperty(imageItem, 'targetImgClass')), '', (getObjectProperty(imageItem, 'options')), text1, text2, (getObjectProperty(imageItem, 'downloadButtonClass')));
  }

}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['user'] = (
      await (async function(userIdentity){
        var userColumns = await Backendless.UserService.describeUserClass()
        var identityColumn = userColumns.find(column => column.identity)
        var whereClause = `${identityColumn.name} = '${userIdentity}'`
        var query = Backendless.DataQueryBuilder.create().setWhereClause(whereClause)
        var users = await Backendless.Data.of(Backendless.User).find(query)

        return users[0]
     })((___arguments.context.pageData['userIdentity']))
  );

  },  
/* handler:onEnter *//* content */
}));

define('./pages/404/components/3665111f5a5b9f8f4b064bbdf6ce7a5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/authForgot/components/page/bundle.js', [], () => ({
  /* content */

  /* handler:onEnter */
  async onEnter(___arguments) {
    var user;


  user = (await Backendless.UserService.getCurrentUser(false));
  if (user) {
    await ( async function (pageName, pageData) { BackendlessUI.goToPage(pageName, pageData) })('sellerDashboard', undefined);
  }
  ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },
  /* handler:onEnter *//* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await (async function() {
  	if (window.location.protocol == 'http:') {
  	    window.location.href =window.location.href.replace( 'http:', 'https:');
  	}
  })();

  },
  /* handler:onBeforeEnter */
  /* content */
}));

define('./pages/authForgot/components/58ecb77e91b7d9dd5c99075111c91c64/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var error, isSend, validation, isProcess, buttonSend;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function rules() {
  return [({ 'field': 'email','value': (getObjectProperty(___arguments.context.dataModel, 'email')),'rules': ['required', 'email'] })]
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function updateButtonSend(isProcess) {
  buttonSend = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d9e1c8c6e4dfcdbc5c1417d277df77dc'));
  if (isProcess) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d9e1c8c6e4dfcdbc5c1417d277df77dc')), 'button-loading');
  } else {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d9e1c8c6e4dfcdbc5c1417d277df77dc')), 'button-loading', '');
  }
  buttonSend['disabled'] = isProcess;
}


  await updateButtonSend(true);
  ___arguments.context.pageData['result'] = '';
  ___arguments.context.pageData['error'] = '';
  validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
  if (validation.length > 0) {
    ___arguments.context.pageData['error'] = 'Please enter a valid email address.';
  } else {
    try {
      isSend = (await Backendless.Request.get(`${Backendless.appPath}/services/user/user/recovery_password`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'email': JSON.stringify((getObjectProperty(___arguments.context.dataModel, 'email'))) }).send());
      if (isSend) {
        ___arguments.context.pageData['result'] = 'An email with a new login password has been sent to your email';
      } else {
        ___arguments.context.pageData['error'] = 'Send error';
      }

    } catch (error) {
      ___arguments.context.pageData['error'] = ((typeof (getObjectProperty(error, 'message')) === 'string') ? (getObjectProperty(error, 'message')) : error);

    }
  }
  await updateButtonSend(false);

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/authForgot/components/9c0e75137e04bad6e50940e30ee54426/bundle.js', [], () => ({
  /* content */

  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['error'] = null;
  ___arguments.context.pageData['result'] = null;

  },  
/* handler:onChange *//* content */
}));

define('./pages/authForgot/components/14eb1c5c23cf9908bcfdb48738c399f3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'error')) == null || (getObjectProperty(___arguments.context.pageData, 'error')) == '') {
    visibility = false;
  } else {
    visibility = true;
  }

  return visibility

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/authForgot/components/c82d496a530b4a531f221d8fd355cf9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'error'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/authForgot/components/66edc25d12a15bad742a141469328024/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var visibility;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'result')) == null || (getObjectProperty(___arguments.context.pageData, 'result')) == '') {
    visibility = false;
  } else {
    visibility = true;
  }

  return visibility

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/authForgot/components/58d3b14531d4e833525c1b1a14ce8927/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'result'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/authLogin/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var redirectPage, user, error, validation, logging, buttonLogin;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function rules() {
  return [({ 'field': 'email','value': (getObjectProperty(___arguments.context.dataModel, 'email')),'rules': ['required', 'email'] }), ({ 'field': 'password','value': (getObjectProperty(___arguments.context.dataModel, 'password')),'rules': ['required'] })]
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function updateButtonLogin(logging) {
  buttonLogin = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  if (logging) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('db5546014b7940ad8771a98d85f83036')), 'button-loading');
  } else {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('db5546014b7940ad8771a98d85f83036')), 'button-loading', '');
  }
  buttonLogin['disabled'] = logging;
}

/**
 * Describe this function...
 */
async function login() {
  try {
    user = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.dataModel, 'email')), (getObjectProperty(___arguments.context.dataModel, 'password')), (getObjectProperty(___arguments.context.dataModel, 'stayLoggedIn'))  ));
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
    localStorage.setItem((encodeURIComponent('email')), JSON.stringify((encodeURIComponent((getObjectProperty(___arguments.context.dataModel, 'email'))))));

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  await updateButtonLogin(true);
  await setError(null);
  validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
  if (validation.length > 0) {
    await setError((new Error('Email and Password must be entered')));
  } else {
    try {
      await login();

    } catch (error) {
      if ((getObjectProperty(error, 'code')) == 3033) {
        await login();
      } else {
        await setError(error);
      }

    }
  }
  await updateButtonLogin(false);
  if (user) {
    redirectPage = 'sellerDashboard';
    if ((await Backendless.UserService.getUserRoles()).includes('Sponsor')) {
      redirectPage = 'sponsorDashboard';
    }
    if ((await Backendless.UserService.getUserRoles()).includes('Staff')) {
      redirectPage = 'staffSellers';
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'redirect')) === 'undefined')) {
      redirectPage = (getObjectProperty(___arguments.context.pageData, 'redirect'));
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectPage, undefined);
  }

  },
  /* handler:onSubmit *//* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(typeof (getObjectProperty(___arguments.context.pageData, 'email')) === 'undefined')) {
    ___arguments.context.dataModel['email'] = (getObjectProperty(___arguments.context.pageData, 'email'));
  } else if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((encodeURIComponent('email')))) {
    ___arguments.context.dataModel['email'] = (decodeURIComponent(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((encodeURIComponent('email'))))));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'messageCode')) == 1001) {
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'icon': 'info','title': 'Welcome Back','html': 'You already have an account with Meadow Farms Fundraising.<br><br>You can login on this page with the email address previously provided.<br><br>If you don\'t remember your password reset it or use a Magic Link.' }), null);
  }

  },
  /* handler:onMounted */
  /* content */
}));

define('./pages/authLogin/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var redirectPage, userRoles, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isDisabledMagicLinkBtn'] = true;
  ___arguments.context.appData['alertRegisterSellers'] = true;
  if (typeof (getObjectProperty(___arguments.context.pageData, 'groupid')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'groupid')))) {
    ___arguments.context.appData['groupid'] = (getObjectProperty(___arguments.context.pageData, 'groupid'));
  }
  currentUser = (await Backendless.UserService.getCurrentUser(false));
  userRoles = (await Backendless.UserService.getUserRoles());
  if (currentUser) {
    redirectPage = 'sellerDashboard';
    if (userRoles.includes('Sponsor')) {
      redirectPage = 'sponsorDashboard';
    }
    if (userRoles.includes('Staff')) {
      redirectPage = 'staffSellers';
    }
    if (!(typeof (getObjectProperty(___arguments.context.pageData, 'redirect')) === 'undefined')) {
      redirectPage = (getObjectProperty(___arguments.context.pageData, 'redirect'));
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectPage, undefined);
  }
  ___arguments.context.pageData['isDisabledMagicLinkBtn'] = false;

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await (async function() {
  	if (window.location.protocol == 'http:') {
  	    window.location.href =window.location.href.replace( 'http:', 'https:');
  	}
  })();

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/authLogin/components/03e2eb5d9ade40fff405b392ab56a635/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var magicLink, settings, item, inventorySyncStatusObject;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email')) && (await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email'))))) {
    ___arguments.context.pageData['isDisabledMagicLinkBtn'] = true;
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('03e2eb5d9ade40fff405b392ab56a635')), 'button-loading');
    magicLink = (await Backendless.Request.get(`${Backendless.appPath}/services/magicLink/MagicLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'baseUrl': JSON.stringify(((function () { return window.location.href })())),'email': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email'))) }).send());
    if (magicLink) {
      await Backendless.Request.post(`${Backendless.appPath}/services/utils/sendemail`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ 'key': undefined,'message': ({ 'from_email': 'customerservice@meadowfarms.com','from_name': 'Meadow Farms','subject': 'Here is your link to sign in to Meadow Farms','to': [({ 'email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email')),'type': 'to' })],'global_merge_vars': [({ 'name': 'magiclink','content': magicLink })],'merge_language': 'mailchimp' }),'template_name': 'Portal-One-Time-Link','template_content': [] })));
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'icon': 'success','title': 'Magic Link Sent','html': 'Check your email for your <b style="color:green;">Magic Link</b> to login!' }), null);
    } else {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'icon': 'warning','title': 'User Not Found','html': 'Sorry, the user with this email was not found. Please register.','confirmButtonText': 'Register Now','showCancelButton': true }), (await (async function(url) {
      	const foo = (result) => {
      	  if (result.isConfirmed) {
      	    window.location = url;
      	  }
      	};

      	return foo;
      })((String(((function () { return window.location.href })()).split('?')[0]) + String('?page=authSignup')))));
    }
    ___arguments.context.pageData['isDisabledMagicLinkBtn'] = false;
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('03e2eb5d9ade40fff405b392ab56a635')), 'button-loading', '');
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email')) {
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'icon': 'error','title': 'Invalid Email','html': 'Please enter a valid email address.' }), null);
  } else {
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'icon': 'error','title': 'Missing Email','html': 'Please provide an email address.' }), null);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledMagicLinkBtn'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/authLogout/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var key, obj;

/**
 * Describe this function...
 */
async function deleteProperties(obj) {
  var key_list = (Object.keys(obj));
  for (var key_index in key_list) {
    key = key_list[key_index];
    delete obj[key];
  }
}


  await deleteProperties(___arguments.context.appData);
  await deleteProperties(___arguments.context.pageData);
  await Backendless.UserService.logout();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/authMagicLink/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var redirectPage, userRoles, currentUser, responseData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9']((await (async function() {
  	return {
  	  title: 'Checking...',
  	  html: 'Please wait a moment, we are checking your magic link.',
  	  iconColor: 'transparent',
  	  iconHtml: '<img src="https://cdn.meadowfarms.com/images/logo/portal-logo.png" alt="MFPortal">',
  	  allowOutsideClick: false,
  	  didOpen: () => {
  	    Swal.showLoading();
  	  }
  	};
  })()), null);
  if (getObjectProperty(___arguments.context.pageData, 'token')) {
    responseData = (await Backendless.Request.post(`${Backendless.appPath}/services/magicLink/checkTokenAndLogin`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.pageData, 'token')))));
    currentUser = (getObjectProperty(responseData, 'user'));
    userRoles = (getObjectProperty(responseData, 'roles'));
    Backendless.Users.setCurrentUser(currentUser, currentUser);
    if (currentUser) {
      redirectPage = 'sellerDashboard';
      if (userRoles.includes('Sponsor')) {
        redirectPage = 'sponsorDashboard';
      }
      if (userRoles.includes('Staff')) {
        redirectPage = 'staffSellers';
      }
      if (!(typeof (getObjectProperty(___arguments.context.pageData, 'redirect')) === 'undefined')) {
        redirectPage = (getObjectProperty(___arguments.context.pageData, 'redirect'));
      }
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })(redirectPage, undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);
    }
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);
  }
  await (async function() {
  	Swal.close();
  })();

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
      await (async function() {
  	if (window.location.protocol == 'http:') {
  	    window.location.href =window.location.href.replace( 'http:', 'https:');
  	}
  })();

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/authSignup/components/85dae34486144e2efa2d934bfdddb172/bundle.js', [], () => ({
  /* content */

  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
    var rulesData, user, error, formError, formFieldError, validation, return2, isProcess, buttonSignUp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function rules() {
  rulesData = [({ 'field': 'email','value': (getObjectProperty(___arguments.context.dataModel, 'email')),'rules': ['required', 'email'] }), ({ 'field': 'password','value': (getObjectProperty(___arguments.context.dataModel, 'password')),'rules': ['required'] })];
  if ((getObjectProperty(___arguments.context.dataModel, 'phone')) && (getObjectProperty(___arguments.context.dataModel, 'phone')) != '') {
    addItemToList(rulesData, ({ 'field': 'phone','value': (getObjectProperty(___arguments.context.dataModel, 'phone')),'rules': ['phone'] }));
  }
  return rulesData
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function updateButtonSignUp(isProcess) {
  buttonSignUp = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('db5546014b7940ad8771a98d85f83036'));
  if (isProcess) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('db5546014b7940ad8771a98d85f83036')), 'button-loading');
  } else {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('db5546014b7940ad8771a98d85f83036')), 'button-loading', '');
  }
  buttonSignUp['disabled'] = isProcess;
}

/**
 * Describe this function...
 */
async function signup() {
  user = '';
  try {
    return2 = (await Backendless.Request.post(`${Backendless.appPath}/services/user/user/add`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ 'email': (getObjectProperty(___arguments.context.dataModel, 'email')),'password': (getObjectProperty(___arguments.context.dataModel, 'password')),'phone': (getObjectProperty(___arguments.context.dataModel, 'phone')) }))));
    if (!(typeof (getObjectProperty(return2, 'body')) === 'undefined')) {
      await setError((new Error((getObjectProperty((getObjectProperty(return2, 'body')), 'message')))));
    } else {
      user = return2;
    }

  } catch (error) {
    await setError(error);

  }
}

/**
 * Describe this function...
 */
async function setError(error) {
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = error;
}


  await updateButtonSignUp(true);
  await setError(null);
  validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
  formError = '';
  if (validation.length > 0) {
    for (var formFieldError_index in validation) {
      formFieldError = validation[formFieldError_index];
      if (formFieldError == 'email') {
        if (formError.length > 0) {
          formError = String(formError) + String('<br>');
        }
        formError = String(formError) + String('A valid email address is required.');
      }
      if (formFieldError == 'phone') {
        if (formError.length > 0) {
          formError = String(formError) + String('<br>');
        }
        formError = String(formError) + String('A valid phone number is required.');
      }
      if (formFieldError == 'password') {
        if (formError.length > 0) {
          formError = String(formError) + String('<br>');
        }
        formError = String(formError) + String('A password is required.');
      }
    }
    await setError(({ 'message': formError }));
  } else {
    try {
      await signup();

    } catch (error) {
      await setError(error);

    }
  }
  if (user !== null && !Array.isArray(user) && (typeof user === 'object')) {
    await Backendless.UserService.login( (getObjectProperty(___arguments.context.dataModel, 'email')), (getObjectProperty(___arguments.context.dataModel, 'password')), true  );
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerAdd', undefined);
  }
  await updateButtonSignUp(false);

  },
  /* handler:onSubmit *//* content */
}));

define('./pages/authSignup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var currentUser;


  ___arguments.context.pageData['error'] = '';
  ___arguments.context.pageData['email'] = '';
  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if (currentUser) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerDashboard', undefined);
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	if (window.location.protocol == 'http:') {
  	    window.location.href =window.location.href.replace( 'http:', 'https:');
  	}
  })();
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('52fc247c7746023a2ee6251ac8ea7af3');
  if (typeof (getObjectProperty(___arguments.context.pageData, 'groupid')) === 'number' && !isNaN((getObjectProperty(___arguments.context.pageData, 'groupid')))) {
    ___arguments.context.appData['groupid'] = (getObjectProperty(___arguments.context.pageData, 'groupid'));
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((encodeURIComponent('email')))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', ({ [`messageCode`]: 1001 }));
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/authSignup/components/927c9caef221532a3a695d8ca4ded5cb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = null;

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email'))))) {
    if (!(typeof (
        await (async function(userIdentity){
          var userColumns = await Backendless.UserService.describeUserClass()
          var identityColumn = userColumns.find(column => column.identity)
          var whereClause = `${identityColumn.name} = '${userIdentity}'`
          var query = Backendless.DataQueryBuilder.create().setWhereClause(whereClause)
          var users = await Backendless.Data.of(Backendless.User).find(query)

          return users[0]
       })((getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email')))
    ) === 'undefined')) {
      ___arguments.context.pageData['error'] = (['An account for the email address ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email')),' already exists.  Please login to your existing account to continue.'].join(''));
      ___arguments.context.pageData['email'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('85dae34486144e2efa2d934bfdddb172'), 'email'));
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('52fc247c7746023a2ee6251ac8ea7af3');
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/authSignup/components/f3a7632ebf5567940ac9fe76a8c39182/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    
  },
  /* handler:onChange */
  /* content */
}))

define('./pages/authSignup/components/b4edd272bd7fb7f6f22eae3525232662/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentDataStoreByUid(componentUid) })('85dae34486144e2efa2d934bfdddb172'))['error'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/authSignup/components/52fc247c7746023a2ee6251ac8ea7af3/bundle.js', [], () => ({
  /* content */
  /* handler:titleLogic */
  ['titleLogic'](___arguments) {
      return 'Welcome Back!'

  },
  /* handler:titleLogic */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'error'))

  },
  /* handler:contentLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', ({ 'email': (getObjectProperty(___arguments.context.pageData, 'email')) }));

  },
  /* handler:onClose */
  /* handler:onSubmit */
  async ['onSubmit'](___arguments) {
      ___arguments.context.pageData['error'] = '';
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).closeModal() })('52fc247c7746023a2ee6251ac8ea7af3');

  },
  /* handler:onSubmit */
  /* handler:submitButtonLogic */
  ['submitButtonLogic'](___arguments) {
      return 'Close'

  },
  /* handler:submitButtonLogic */
  /* handler:closeButtonLabelLogic */
  ['closeButtonLabelLogic'](___arguments) {
      return 'Login to your Account'

  },
  /* handler:closeButtonLabelLogic */
  /* content */
}))

define('./pages/sellerAdd/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var searchOrganizationList, item, sellersData, userCheck, sellersCnt;

/**
 * Describe this function...
 */
async function liveSearch() {
  ___arguments.context.pageData['isOpenLiveSearch'] = false;
  ___arguments.context.pageData['isNoresultLiveSearch'] = false;
  ___arguments.context.pageData['isLoadLiveSearch'] = false;
  ___arguments.context.pageData['readonlyLiveSearch'] = false;
  ___arguments.context.pageData['queryLiveSearch'] = '';
  ___arguments.context.pageData['organizationId'] = '';
  ___arguments.context.pageData['fundraiserId'] = '';
  ___arguments.context.pageData['fundraiserPassiveDate'] = '';
  ___arguments.context.pageData['fundraiserStoreCategoriesFrozen'] = '';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function fieldsDefault() {
  ___arguments.context.pageData['firstName'] = ((getObjectProperty(___arguments.context.pageData, 'currentSeller')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSeller')), 'FirstName')) : '');
  ___arguments.context.pageData['lastName'] = ((getObjectProperty(___arguments.context.pageData, 'currentSeller')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSeller')), 'LastName')) : '');
  ___arguments.context.pageData['teacher'] = '';
  ___arguments.context.pageData['goalItems'] = (getObjectProperty(___arguments.context.pageData, 'settings.GoalSellerItems'));
  ___arguments.context.pageData['message'] = 'Thank you for supporting my fundraiser!';
  ___arguments.context.pageData['photo'] = ((getObjectProperty(___arguments.context.pageData, 'currentSeller')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSeller')), 'Avatar')) : '');
  ___arguments.context.pageData['photoData'] = '';
  ___arguments.context.pageData['photoChanged'] = false;
  ___arguments.context.pageData['address1'] = '';
  ___arguments.context.pageData['address2'] = '';
  ___arguments.context.pageData['city'] = '';
  ___arguments.context.pageData['state'] = '';
  ___arguments.context.pageData['zip'] = '';
  ___arguments.context.pageData['grade'] = ((getObjectProperty(___arguments.context.pageData, 'currentSeller')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSeller')), 'Grade')) : '0');
  ___arguments.context.pageData['checkShip'] = false;
  ___arguments.context.pageData['checkGroup'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'SwitchBetweenSellers'));
  ___arguments.context.pageData['ship2X'] = false;
  ___arguments.context.pageData['isDisableSaveButton'] = true;
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ada2c7795a2f62d329947413f52cdba2', (await BackendlessUI.Functions.Custom['fn_05dbbe5265446336458f423e9192a925']()));
}

/**
 * Describe this function...
 */
async function fieldsError() {
  ___arguments.context.pageData['organizationIdError'] = false;
  ___arguments.context.pageData['fundraiserIdError'] = false;
  ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['gradeError'] = false;
  ___arguments.context.pageData['teacherError'] = false;
  ___arguments.context.pageData['messageError'] = false;
  ___arguments.context.pageData['photoError'] = false;
  ___arguments.context.pageData['address1Error'] = false;
  ___arguments.context.pageData['cityError'] = false;
  ___arguments.context.pageData['stateError'] = false;
  ___arguments.context.pageData['zipError'] = false;
  ___arguments.context.pageData['checkAgreeError'] = false;
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function setShowFields() {
  ___arguments.context.pageData['isShowS2S'] = false;
  ___arguments.context.pageData['isShowDSH'] = false;
  ___arguments.context.pageData['isShowAddress'] = false;
}


  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (userCheck) {
    ___arguments.context.pageData['user'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['cdnURL', 'GoalSellerItems', 'CurrentSeasonDatabase'], ___arguments.context.appData));
    ___arguments.context.pageData['currentSeller'] = null;
    if (getObjectProperty(___arguments.context.pageData, 'sellerId')) {
      if (getObjectProperty(___arguments.context.appData, 'sellersData')) {
        sellersData = (getObjectProperty(___arguments.context.appData, 'sellersData'));
      } else {
        sellersData = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getsellers2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
        ___arguments.context.appData['sellersData'] = sellersData;
      }
      ___arguments.context.pageData['currentSeller'] = ((await asyncListFilter(sellersData, async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'sellerId')));
      }))[0]);
    }
    await fieldsError();
    await liveSearch();
    await fieldsDefault();
    await setShowFields();
    await (async function() {
    	await BackendlessUI.requireModule('https://cdn.crop.guide/loader/l.js?c=NHKLMH');

    })();
    if (typeof (getObjectProperty(___arguments.context.appData, 'groupid')) === 'number' && !isNaN((getObjectProperty(___arguments.context.appData, 'groupid')))) {
      searchOrganizationList = (await Backendless.Request.get(`${Backendless.appPath}/services/organization/organization/live_search`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'query': JSON.stringify((getObjectProperty(___arguments.context.appData, 'groupid'))) }).send());
      if (searchOrganizationList.length > 0) {
        await BackendlessUI.Functions.Custom['fn_a91e5794f31e9cf940b29d5dc78194c1']((searchOrganizationList[0]), ___arguments.context.pageData);
        ___arguments.context.pageData['isDisableSaveButton'] = false;
      }
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sellerAdd/components/3a6b5e5b823f45032e58740228639bcf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['firstName'] = ___arguments.value;
  ___arguments.context.pageData['nameChanged'] = true;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'firstName'))

  },
  /* handler:onValueAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var foundSeller, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.pageData, 'sellerId'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'firstName')) && (getObjectProperty(___arguments.context.pageData, 'lastName'))) {
      if (!(getObjectProperty(___arguments.context.appData, 'sellersData'))) {
        ___arguments.context.appData['sellersData'] = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getsellers2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      }
      foundSeller = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'sellersData')), async (item) => {


       return ((getObjectProperty(item, 'FullName')) == [(getObjectProperty(___arguments.context.pageData, 'firstName')),' ',(getObjectProperty(___arguments.context.pageData, 'lastName'))].join(''));
      }))[0];
      if (foundSeller) {
        ___arguments.context.pageData['isDisableSaveButton'] = true;
        if ((getObjectProperty(foundSeller, 'activeFundraiser')) && (getObjectProperty((getObjectProperty(foundSeller, 'activeFundraiser')), 'objectId'))) {
          await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Whoops!','html': ['You have already registered ',(getObjectProperty(___arguments.context.pageData, 'firstName')),' ',(getObjectProperty(___arguments.context.pageData, 'lastName')),' <br><br>You can edit ',(getObjectProperty(___arguments.context.pageData, 'firstName')),'\'s details from your dashboard.  Go there now?'].join(''),'icon': 'info','confirmButtonText': 'Yes','showCancelButton': true }), (await (async function(url) {
          	const foo = (result) => {
          	  if (result.isConfirmed) {
          	    window.location = url;
          	  }
          	};

          	return foo;
          })((String(((function () { return window.location.href })()).split('?')[0]) + String('?page=sellerDashboard')))));
        } else {
          await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Whoops!','html': ['You have already registered ',(getObjectProperty(___arguments.context.pageData, 'firstName')),' ',(getObjectProperty(___arguments.context.pageData, 'lastName')),'<br><br>Would you like to register ',(getObjectProperty(___arguments.context.pageData, 'firstName')),' for a fundraiser?'].join(''),'icon': 'info','confirmButtonText': 'Yes','showCancelButton': true }), (await (async function(url, sellerId, AppData, PageData) {
          	const foo = (result) => {
          	  if (result.isConfirmed) {
          	    if (PageData.officeOrganizationId) {
          	      AppData.groupid = PageData.officeOrganizationId;
          	    }
          	    window.location = `${url}&sellerId=${sellerId}`;
          	  }
          	};

          	return foo;
          })(((function () { return window.location.href })()), (getObjectProperty(foundSeller, 'objectId')), ___arguments.context.appData, ___arguments.context.pageData)));
        }
      }
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/sellerAdd/components/6dc607acff525ac8fed726d2ffce5028/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['lastName'] = ___arguments.value;
  ___arguments.context.pageData['nameChanged'] = true;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'lastName'))

  },
  /* handler:onValueAssignment */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
    var foundSeller, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.pageData, 'sellerId'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'firstName')) && (getObjectProperty(___arguments.context.pageData, 'lastName'))) {
      if (!(getObjectProperty(___arguments.context.appData, 'sellersData'))) {
        ___arguments.context.appData['sellersData'] = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getsellers2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      }
      foundSeller = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'sellersData')), async (item) => {


       return ((getObjectProperty(item, 'FullName')) == [(getObjectProperty(___arguments.context.pageData, 'firstName')),' ',(getObjectProperty(___arguments.context.pageData, 'lastName'))].join(''));
      }))[0];
      if (foundSeller) {
        ___arguments.context.pageData['isDisableSaveButton'] = true;
        if ((getObjectProperty(foundSeller, 'activeFundraiser')) && (getObjectProperty((getObjectProperty(foundSeller, 'activeFundraiser')), 'objectId'))) {
          await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Whoops!','html': ['You have already registered ',(getObjectProperty(___arguments.context.pageData, 'firstName')),' ',(getObjectProperty(___arguments.context.pageData, 'lastName')),' <br><br>You can edit ',(getObjectProperty(___arguments.context.pageData, 'firstName')),'\'s details from your dashboard.  Go there now?'].join(''),'icon': 'info','confirmButtonText': 'Yes','showCancelButton': true }), (await (async function(url) {
          	const foo = (result) => {
          	  if (result.isConfirmed) {
          	    window.location = url;
          	  }
          	};

          	return foo;
          })((String(((function () { return window.location.href })()).split('?')[0]) + String('?page=sellerDashboard')))));
        } else {
          await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Whoops!','html': ['You have already registered ',(getObjectProperty(___arguments.context.pageData, 'firstName')),' ',(getObjectProperty(___arguments.context.pageData, 'lastName')),'<br><br>Would you like to register ',(getObjectProperty(___arguments.context.pageData, 'firstName')),' for a fundraiser?'].join(''),'icon': 'info','confirmButtonText': 'Yes','showCancelButton': true }), (await (async function(url, sellerId, AppData, PageData) {
          	const foo = (result) => {
          	  if (result.isConfirmed) {
          	    if (PageData.officeOrganizationId) {
          	      AppData.groupid = PageData.officeOrganizationId;
          	    }
          	    window.location = `${url}&sellerId=${sellerId}`;
          	  }
          	};

          	return foo;
          })(((function () { return window.location.href })()), (getObjectProperty(foundSeller, 'objectId')), ___arguments.context.appData, ___arguments.context.pageData)));
        }
      }
    }
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/sellerAdd/components/9b472d252bd46b3851047fa97429f4e5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['teacherError'] = false;
  ___arguments.context.pageData['teacher'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'teacher'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/357482a93a2ba389e625282e7696aa16/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['messageError'] = false;
  ___arguments.context.pageData['message'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'message'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/859b8e62ee8ba751bb91c00d6ab35dfb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['address1'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'address1'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'checkDSH')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/bafb1bfcab19932cfa63d19cb9c786f5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['address2'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'address2'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'checkDSH')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/a9c969e617bc54c6351b4ec8ae24574e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['city'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'city'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'checkDSH')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/81dfd518211b309a94cfe0b29641a0ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['zip'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'zip'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'checkDSH')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/fc283fde6c5f9ff99b944a4f2641a973/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['ship2X'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sellerAdd/components/c6a7a0abb256185410b8f23a00883dfb/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-livesearch__list'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenOrganizationLS')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/9029f3db37e3d0fc4cdc0d7910628e16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('81eda7573f36518a05c634270836d96f'), 'label'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/f76235aafc368a19489f30f2550ce7f7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isShowClearOrganizationLS'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['queryOrganizationLS'] = '';
  ___arguments.context.pageData['organizationId'] = '';
  ___arguments.context.pageData['fundraiserId'] = '';
  ___arguments.context.pageData['isShowClearOrganizationLS'] = false;
  ___arguments.context.pageData['isReadonlyOrganizationLS'] = false;
  ___arguments.context.pageData['isShowS2S'] = false;
  ___arguments.context.pageData['isShowDSH'] = false;
  ___arguments.context.pageData['isShowAddress'] = false;
  ___arguments.context.pageData['isDisableSaveButton'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerAdd/components/3335b7f6e33edbad606d7d57aa7555f6/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-livesearch__noresult'];
  if (getObjectProperty(___arguments.context.pageData, 'isNoresultOrganizationLS')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/1e0f8f5619e4f2cf7b56380594b1dd9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-livesearch__load-wrap'];
  if (getObjectProperty(___arguments.context.pageData, 'isLoadOrganizationLS')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/81eda7573f36518a05c634270836d96f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var allowTypes;


  await BackendlessUI.Functions.Custom['fn_a91e5794f31e9cf940b29d5dc78194c1'](___arguments.context.dataModel, ___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerAdd/components/684aa547ace43eae05c960a896d216af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var formattedFormData, error, saveResult, results, displayErrors, input, validation, rulesList, formData, validatedAddress, counter, smartyAddressMessage, message;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

/**
 * Describe this function...
 */
async function rules() {
  rulesList = [({ [`name`]: 'Fundraiser',[`field`]: 'organizationId',[`value`]: (getObjectProperty(___arguments.context.pageData, 'organizationId')),[`rules`]: ['required'] }), ({ [`name`]: 'First Name',[`field`]: 'firstName',[`value`]: (getObjectProperty(___arguments.context.pageData, 'firstName')),[`rules`]: ['required'] }), ({ [`name`]: 'Last Name',[`field`]: 'lastName',[`value`]: (getObjectProperty(___arguments.context.pageData, 'lastName')),[`rules`]: ['required'] }), ({ [`name`]: 'Grade',[`field`]: 'grade',[`value`]: (getObjectProperty(___arguments.context.pageData, 'grade')),[`rules`]: ['required', 'noZerro'] }), ({ [`name`]: 'Teacher',[`field`]: 'teacher',[`value`]: (getObjectProperty(___arguments.context.pageData, 'teacher')),[`rules`]: ['required'] }), ({ [`name`]: 'Store message',[`field`]: 'message',[`value`]: (getObjectProperty(___arguments.context.pageData, 'message')),[`rules`]: ['required'] })];
  if (getObjectProperty(___arguments.context.pageData, 'checkDSH')) {
    addItemToList(rulesList, ({ [`name`]: 'Address',[`field`]: 'address1',[`value`]: (getObjectProperty(___arguments.context.pageData, 'address1')),[`rules`]: ['required'] }));
    addItemToList(rulesList, ({ [`name`]: 'City',[`field`]: 'city',[`value`]: (getObjectProperty(___arguments.context.pageData, 'city')),[`rules`]: ['required'] }));
    addItemToList(rulesList, ({ [`name`]: 'State',[`field`]: 'state',[`value`]: (getObjectProperty(___arguments.context.pageData, 'state')),[`rules`]: ['required'] }));
    addItemToList(rulesList, ({ [`name`]: 'Zip',[`field`]: 'zip',[`value`]: (getObjectProperty(___arguments.context.pageData, 'zip')),[`rules`]: ['required'] }));
  }
  return rulesList
}

/**
 * Describe this function...
 */
async function getFormData() {
  formData = ({ [`organizationId`]: (getObjectProperty(___arguments.context.pageData, 'organizationId')),[`fundraiserId`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserId')),[`fundraiserPassiveDate`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserPassiveDate')),[`fundraiserStoreCategoriesFrozen`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserStoreCategoriesFrozen')),[`firstName`]: (getObjectProperty(___arguments.context.pageData, 'firstName')),[`lastName`]: (getObjectProperty(___arguments.context.pageData, 'lastName')),[`nameChanged`]: (getObjectProperty(___arguments.context.pageData, 'nameChanged')),[`grade`]: (getObjectProperty(___arguments.context.pageData, 'grade')),[`teacher`]: (getObjectProperty(___arguments.context.pageData, 'teacher')),[`goalItems`]: (getObjectProperty(___arguments.context.pageData, 'goalItems')),[`message`]: (getObjectProperty(___arguments.context.pageData, 'message')),[`photo`]: (getObjectProperty(___arguments.context.pageData, 'photo')),[`photoChanged`]: (getObjectProperty(___arguments.context.pageData, 'photoChanged')),[`ship2X`]: (getObjectProperty(___arguments.context.pageData, 'ship2X')) });
  if (getObjectProperty(___arguments.context.pageData, 'currentSeller')) {
    formData['sellerId'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSeller')), 'objectId'));
    formData['microstorePath'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSeller')), 'MicrostorePath'));
  }
  if (getObjectProperty(___arguments.context.pageData, 'checkDSH')) {
    counter = 0;
    for (var count = 0; count < 2; count++) {
      counter = (typeof counter == 'number' ? counter : 0) + 1;
      try {
        validatedAddress = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/smartyaddressvalidation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`address1`]: (getObjectProperty(___arguments.context.pageData, 'address1')),[`address2`]: (getObjectProperty(___arguments.context.pageData, 'address2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'city')),[`state`]: (getObjectProperty(___arguments.context.pageData, 'state')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'zip')) }))));
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail('sellerAdd - smartyAddressValidation API call', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' We tried this many times: ',counter,' This was returned from the API: ',(JSON.stringify(validatedAddress))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, (100 * counter) || 0));

      }
    }
    try {
      if (getObjectProperty(validatedAddress, 'smartyAddressChecked')) {
        smartyAddressMessage = '';
        ___arguments.context.pageData['continueUpdate'] = false;
        ___arguments.context.pageData['userInteraction'] = false;
        if (typeof (getObjectProperty(validatedAddress, 'smartyAddressMessageList')) === 'undefined') {
          validatedAddress['smartyAddressMessageList'] = [];
        }
        if ((getObjectProperty(validatedAddress, 'smartyAddressMessageList')).length > 0) {
          smartyAddressMessage = '<br><br><b>Address Errors:</b><br>';
          var message_list = (getObjectProperty(validatedAddress, 'smartyAddressMessageList'));
          for (var message_index in message_list) {
            message = message_list[message_index];
            smartyAddressMessage = String(smartyAddressMessage) + String(String(message) + String('<br>'));
          }
          await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Address Verification',[`html`]: ['<p style=\'text-align:left;\'>',['<b>You entered:</b><br>',(getObjectProperty(___arguments.context.pageData, 'address1')),' ',(getObjectProperty(___arguments.context.pageData, 'address2')),'<br>',(getObjectProperty(___arguments.context.pageData, 'city')),', ',(getObjectProperty(___arguments.context.pageData, 'state')),', ',(getObjectProperty(___arguments.context.pageData, 'zip'))].join(''),smartyAddressMessage,'</p>'].join(''),[`icon`]: 'warning',[`confirmButtonText`]: 'Edit Address',[`showDenyButton`]: true,[`denyButtonText`]: 'Keep Current Address',[`timer`]: 9000 }), (await (async function(PageData, recomendedAddress) {
          	const foo = (result) => {
          	  if (result.isConfirmed) {

          	    PageData.continueUpdate = false;
          	    PageData.userInteraction = true;

          	  }

          	  if (result.isDenied) {
          	    PageData.continueUpdate = true;
          	    PageData.userInteraction = true;

          	  }
          	};

          	return foo;
          })(___arguments.context.pageData, (getObjectProperty(validatedAddress, 'recommendedAddress')))));
        } else {
          await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Address Verification',[`html`]: ['<p style=\'text-align:left;\'>',['<b>You entered:</b><br>',(getObjectProperty(___arguments.context.pageData, 'address1')),' ',(getObjectProperty(___arguments.context.pageData, 'address2')),'<br>',(getObjectProperty(___arguments.context.pageData, 'city')),', ',(getObjectProperty(___arguments.context.pageData, 'state')),', ',(getObjectProperty(___arguments.context.pageData, 'zip'))].join(''),['<br><br><b>Recommended address:</b><br>',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'address1')),' ',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'address2')),'<br>',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'city')),', ',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'state')),', ',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'zip'))].join(''),'</p>'].join(''),[`icon`]: 'warning',[`confirmButtonText`]: 'Use Recommended Address',[`showDenyButton`]: true,[`denyButtonText`]: 'Keep Current Address',[`timer`]: 9000 }), (await (async function(PageData, recomendedAddress) {
          	const foo = (result) => {
          	  if (result.isConfirmed) {
          	    PageData.address1 = recomendedAddress.address1;
          	    PageData.address2 = recomendedAddress.address2;
          	    PageData.city = recomendedAddress.city;
          	    PageData.state = recomendedAddress.state;
          	    PageData.zip = recomendedAddress.zip;
          	    PageData.continueUpdate = true;
          	    PageData.userInteraction = true;

          	  }

          	  if (result.isDenied) {
          	    PageData.continueUpdate = true;
          	    PageData.userInteraction = true;
          	  }
          	};

          	return foo;
          })(___arguments.context.pageData, (getObjectProperty(validatedAddress, 'recommendedAddress')))));
        }
        counter = 0;
        while (!(getObjectProperty(___arguments.context.pageData, 'userInteraction'))) {
          counter = (typeof counter == 'number' ? counter : 0) + 50;
          await new Promise(r => setTimeout(r, 50 || 0));
          if (counter > 9000) {
            break;
          }
        }
        if ((getObjectProperty(___arguments.context.pageData, 'continueUpdate')) == false || (getObjectProperty(___arguments.context.pageData, 'userInteraction')) == false) {
          ___arguments.context.pageData['isDisableSaveButton'] = false;
          if (Array.isArray(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('684aa547ace43eae05c960a896d216af')))) {
            removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('684aa547ace43eae05c960a896d216af')), 'button-loading', '');
          }
          return ;
        }
      }

    } catch (error) {
      await Backendless.Messaging.sendEmail('sellerAdd - DSH address logic error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' this is from our Smarty API: ',(JSON.stringify(validatedAddress))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

    } finally {
      formData['smartyAddressChecked'] = ((getObjectProperty(validatedAddress, 'smartyAddressChecked')) ? true : false);
      formData['smartyAddressValid'] = ((getObjectProperty(validatedAddress, 'smartyAddressValid')) ? true : false);
      formData['status'] = ((getObjectProperty(validatedAddress, 'smartyAddressValid')) ? true : false);
      formData['address1'] = (getObjectProperty(___arguments.context.pageData, 'address1'));
      formData['address2'] = (getObjectProperty(___arguments.context.pageData, 'address2'));
      formData['city'] = (getObjectProperty(___arguments.context.pageData, 'city'));
      formData['state'] = (getObjectProperty(___arguments.context.pageData, 'state'));
      formData['zip'] = (getObjectProperty(___arguments.context.pageData, 'zip'));

    }
  }
  return formData
}


  validation = (await BackendlessUI.Functions.Custom['fn_95f7fa8277ce6bbbfd7b54d2cf020e22']((await rules())));
  if (validation.length > 0) {
    displayErrors = '';
    for (var input_index in validation) {
      input = validation[input_index];
      ___arguments.context.pageData[(String(getObjectProperty(input, 'field')) + String('Error'))] = true;
      displayErrors = String(displayErrors) + String([(getObjectProperty(input, 'name')),' is required','<br>'].join(''));
    }
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`icon`]: 'error',[`title`]: 'Required Fields',[`html`]: ['<p style=\'text-align:left;\'>',['<b>Please correct the following errors:</b>','<br>',displayErrors].join(''),'</p>'].join('') }), null);
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('684aa547ace43eae05c960a896d216af')), 'button-loading');
    ___arguments.context.pageData['isDisableSaveButton'] = true;
    try {
      formattedFormData = await getFormData();
      if ((typeof formattedFormData === 'undefined') || !(formattedFormData !== null && !Array.isArray(formattedFormData) && (typeof formattedFormData === 'object'))) {
        ___arguments.context.pageData['isDisableSaveButton'] = false;
        if (Array.isArray(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('684aa547ace43eae05c960a896d216af')))) {
          removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('684aa547ace43eae05c960a896d216af')), 'button-loading', '');
        }
        return ;
      }
      if (getObjectProperty(___arguments.context.pageData, 'photoChanged')) {
        results = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/uploadSirv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'fileName': ([((new Date()).valueOf()),'_',mathRandomInt(1, 1000),'.','png'].join('')),'filePath': (['/images/sellers2/',(getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase')),'/'].join('')),'fileData': (getObjectProperty(___arguments.context.pageData, 'photoData')),'fileURL': '' }));
        if (getObjectProperty(results, 'status')) {
          ___arguments.context.pageData['photo'] = (String(getObjectProperty(___arguments.context.pageData, 'settings.cdnURL')) + String(getObjectProperty(results, 'filePath')));
          formattedFormData['photo'] = (String(getObjectProperty(___arguments.context.pageData, 'settings.cdnURL')) + String(getObjectProperty(results, 'filePath')));
        } else {
          formattedFormData['photoChanged'] = false;
        }
      }
      saveResult = (await Backendless.Request.post(`${Backendless.appPath}/services/sellers/sellers/add`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(formattedFormData)));
      if (saveResult) {
        ___arguments.context.appData['sellersData'] = null;
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerDashboard', undefined);
        return ;
      }
      ___arguments.context.pageData['isDisableSaveButton'] = false;
      if (Array.isArray(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('684aa547ace43eae05c960a896d216af')))) {
        removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('684aa547ace43eae05c960a896d216af')), 'button-loading', '');
      }

    } catch (error) {
      formattedFormData['photoData'] = (getValueLength((getObjectProperty(formattedFormData, 'photoData'))) > 0 ? true : false);
      await Backendless.Messaging.sendEmail('sellerAdd submit button - General error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' This was everything in page data: ',(JSON.stringify(___arguments.context.pageData)),' This was what we tried to pass to addSeller: ',(JSON.stringify(formattedFormData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisableSaveButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/ada2c7795a2f62d329947413f52cdba2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['gradeError'] = false;
  ___arguments.context.pageData['grade'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'grade'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/e42308837c09bbe775b4b373cf6982c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-col'];
  if ((getObjectProperty(___arguments.context.pageData, 'organizationIdError')) || (getObjectProperty(___arguments.context.pageData, 'fundraiserIdError'))) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/339c26bd8f1b7875a73dd1b2d7baba96/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'firstNameError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/415b517adfd9bef6fa9c6f317d67b6c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'lastNameError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/1e2568542765b928ccba1f8f8e63303e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'gradeError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/0dd438a5488b78cab08ee63c20dbccff/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'teacherError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/b63fc774dd776753725835b69f5a496d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'messageError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/d543ed9a205715a46af532a355fe884c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'checkAgreeError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/4bab08dbe2eb697c522877d1bd49228e/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
    var button, sirvAvatarURL, response;

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4bab08dbe2eb697c522877d1bd49228e');
  ___arguments.context.pageData['photo'] = '';
  ___arguments.context.pageData['photoChanged'] = false;
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['isDisableSaveButton'] = false;

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExtension, list, text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  fileExtension = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([((new Date()).valueOf()),'_',mathRandomInt(1, 1000),'.',fileExtension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var styles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  styles = ({  });
  if (getObjectProperty(___arguments.context.pageData, 'photo')) {
    styles = ({ 'backgroundImage': ['url("',(getObjectProperty(___arguments.context.pageData, 'photo')),'?w=200','")'].join('') });
  }

  return styles

  },
  /* handler:onStyleAssignment */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
    
  },
  /* handler:onBeforeUpload */
  /* handler:onSelectFiles */
  async ['onSelectFiles'](___arguments) {
      await (async function(filesString, pageData) {
  	function processFile(file, pageData) {
  	  if (file) {
  	    const reader = new FileReader();

  	    reader.onload = function(e) {
  	      // Display the image
  	      const dataURL = e.target.result;
  	      // update the background image
  	      document.getElementById('SellerAdd__Form-field-photo').style.backgroundImage = `url(${dataURL})`;

  	      // Convert the file to a byte array
  	      const arrayBufferReader = new FileReader();
  	      arrayBufferReader.onloadend = function() {
  	        const arrayBuffer = arrayBufferReader.result;

  	        const byteArray = new Uint8Array(arrayBuffer);

  	        let byteString = '';

  	        // Convert byte array to string

  	        for (let i = 0; i < byteArray.length; i++) {
  	          byteString += String.fromCharCode(byteArray[i]);
  	        }

  	        //** convert to base64
  	        const base64String = btoa(byteString);

  	        // put the string into page Data
  	        pageData.photoData = base64String;
  	      };

  	      arrayBufferReader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
  	    };

  	    reader.readAsDataURL(file); // Read the file as a Data URL to display the image
  	  } else {
  	    console.log('image upload not working');
  	  }
  	}

  	processFile(filesString, pageData);
  })((___arguments.selectedFiles[0]), ___arguments.context.pageData);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('4bab08dbe2eb697c522877d1bd49228e');
  ___arguments.context.pageData['photoChanged'] = true;

  },
  /* handler:onSelectFiles */
  /* content */
}))

define('./pages/sellerAdd/components/c81c434e57198819ffd1f147f9363188/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['state'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'state'))

  },
  /* handler:onValueAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'checkDSH')))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/34d42ab5ebe793ccbc8ca1eed02baeae/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['selleradd__modal-crop'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModalCrop')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/1124ac24eff214dfcffaa439435f69ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var button;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.pageData['isOpenModalCrop'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'uploadedFile')) != '') {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'uploadedFile'))));
    ___arguments.context.pageData['uploadedFile'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'photo')) != '') {
    button = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bab08dbe2eb697c522877d1bd49228e'));
    (getObjectProperty(button, 'style'))['background-image'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'photo')),'")'].join(''));
  }
  await (async function() {
  	const oldCroppie = getObjectProperty(___arguments.context.pageData, 'croppie');
  	if(oldCroppie) {
  	  oldCroppie.croppie('destroy');
  	  ___arguments.context.pageData['croppie'] = '';
  	}
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerAdd/components/8864def5843fab26284bf67f10e8a1c6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var button;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.pageData['isOpenModalCrop'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'uploadedFile')) != '') {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'uploadedFile'))));
    ___arguments.context.pageData['uploadedFile'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'photo')) != '') {
    button = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bab08dbe2eb697c522877d1bd49228e'));
    (getObjectProperty(button, 'style'))['background-image'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'photo')),'")'].join(''));
  }
  await (async function() {
  	const oldCroppie = getObjectProperty(___arguments.context.pageData, 'croppie');
  	if(oldCroppie) {
  	  oldCroppie.croppie('destroy');
  	  ___arguments.context.pageData['croppie'] = '';
  	}
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerAdd/components/a7dd8f1ec573fe5d7109af226e59d569/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var button;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.pageData['isOpenModalCrop'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'uploadedFile')) != '') {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'uploadedFile'))));
    ___arguments.context.pageData['uploadedFile'] = '';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'photo')) != '') {
    button = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4bab08dbe2eb697c522877d1bd49228e'));
    (getObjectProperty(button, 'style'))['background-image'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'photo')),'")'].join(''));
  }
  await (async function() {
  	const oldCroppie = getObjectProperty(___arguments.context.pageData, 'croppie');
  	if(oldCroppie) {
  	  oldCroppie.croppie('destroy');
  	  ___arguments.context.pageData['croppie'] = '';
  	}
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerAdd/components/4122ce08c209851576957b35c1835efe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(croppie) {
  	const apiUrl = Backendless.appPath;
  	const ts = Date.now();
  	const croppedFileUrl = apiUrl + `/files/images/sellers/cropped_${ts}.png`;
  	const uploadedFile = getObjectProperty(
  	  ___arguments.context.pageData,
  	  'uploadedFile',
  	);
  	
  	function getObjectProperty(object, propPath) {
  	  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
  	    return object[propPath];
  	  }
  	
  	  const propsNamesList = propPath.split('.');
  	
  	  let result = object;
  	
  	  for (let i = 0; i < propsNamesList.length; i++) {
  	    if (!result || result[propsNamesList[i]] === undefined) {
  	      return;
  	    }
  	
  	    result = result[propsNamesList[i]];
  	  }
  	
  	  return result;
  	}
  	function encodePath(path) {
  	  if (path.startsWith('http://') || path.startsWith('https://')) {
  	    return path;
  	  }
  	
  	  let decodedPath;
  	  try {
  	    decodedPath = decodeURI(path);
  	  } finally {
  	    return (decodedPath || path).split('/').map(encodeURIComponent).join('/');
  	  }
  	}
  	
  	___arguments.context.pageData['isDisableUploadButton'] = true;
  	
  	croppie
  	  .croppie('result', 'blob')
  	  .then(function (blob) {
  	    return new Promise((resolve, reject) => {
  	      const request = new XMLHttpRequest();
  	
  	      request.open('POST', croppedFileUrl + `?overwrite=false`);
  	
  	      request.onload = function () {
  	        if (request.status === 200) {
  	          resolve(request.response);
  	        } else {
  	          reject(
  	            Error(
  	              "Image didn't load successfully; error code:" +
  	                request.statusText,
  	            ),
  	          );
  	        }
  	      };
  	      request.onerror = function () {
  	        reject(Error('There was a network error.'));
  	      };
  	
  	      var formData = new FormData();
  	      formData.append('file', blob);
  	
  	      // Send
  	      request.send(formData);
  	    });
  	  })
  	  .then((data) => {
  	    const parseData = JSON.parse(data);
  	    if (parseData && parseData.fileURL) {
  	      return new Promise((resolve, reject) => {
  	        resolve(
  	          Backendless.Request.get(
  	            `${apiUrl}/services/utils/utils/upload_sirv_image`,
  	          )
  	            .set(
  	              (function (h) {
  	                if (!h['user-token']) {
  	                  delete h['user-token'];
  	                }
  	                return h;
  	              })({
  	                ...{},
  	                ...{ 'user-token': Backendless.getCurrentUserToken() },
  	              }),
  	            )
  	            .query({ fileUrl: JSON.stringify(parseData.fileURL) })
  	            .send(),
  	        );
  	      });
  	    }
  	  })
  	  .then((data) => {
  	    if (data && data.status && data.status === true) {
  	      const fileUrl = 'https://meadowfarms.sirv.com' + data.fileName;
  	
  	      //const button = document.querySelector('.selleradd__form-button-upload');
  	      //button.style.backgroundImage = `url("${fileUrl}")`;
  	
  	      ___arguments.context.pageData['photo'] = fileUrl;
  	
  	      ___arguments.context.pageData['isOpenModalCrop'] = false;
  	      ___arguments.context.pageData['isDisableUploadButton'] = false;
  	
  	      new Promise((resolve, reject) => {
  	        Backendless.Files.remove(encodePath(uploadedFile));
  	        Backendless.Files.remove(encodePath(croppedFileUrl));
  	      });
  	
  	      ___arguments.context.pageData['uploadedFile'] = '';
  	    }
  	  });

  })((getObjectProperty(___arguments.context.pageData, 'croppie')));

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisableUploadButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/62c3694a05f5f3ee0aafb2225dab943d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isShowS2S'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/62c6cb7b8ef79c1a7dbb0ab664737dc3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isShowCheckGroup'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/06b2800d6016d772f70b7b8cc1b666a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isShowAddress'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/d4742a785fb3b51ca8f7957f7e539f18/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = 'Add Seller';
  if (getObjectProperty(___arguments.context.pageData, 'currentSeller')) {
    content2 = 'Join a Fundraiser';
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/aafeb5756e960a561fc909db861fa1ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['checkDSH'] = ___arguments.value;
  ___arguments.context.pageData['ship2X'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sellerAdd/components/e6c29c23624298791558df46173b4f96/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var searchResult, inputValue;


  ___arguments.context.pageData['isShowAddress'] = false;
  ___arguments.context.pageData['isShowCheckShip'] = false;
  ___arguments.context.pageData['organizationIdError'] = false;
  ___arguments.context.pageData['fundraiserIdError'] = false;
  ___arguments.context.pageData['queryOrganizationLS'] = ___arguments.value;
  ___arguments.context.pageData['isOpenOrganizationLS'] = false;
  ___arguments.context.pageData['isNoresultOrganizationLS'] = false;
  inputValue = (___arguments.value.replace((new RegExp('\\D', 'g')), ''));
  if (inputValue.length == 7) {
    ___arguments.context.pageData['isLoadOrganizationLS'] = true;
    searchResult = (await Backendless.Request.get(`${Backendless.appPath}/services/organization/organization/live_search`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'query': JSON.stringify(inputValue) }).send());
    ___arguments.context.pageData['isLoadOrganizationLS'] = false;
    if (searchResult.length > 0) {
      await BackendlessUI.Functions.Custom['fn_a91e5794f31e9cf940b29d5dc78194c1']((searchResult[0]), ___arguments.context.pageData);
      ___arguments.context.pageData['isDisableSaveButton'] = false;
    } else {
      ___arguments.context.pageData['isNoresultOrganizationLS'] = true;
      ___arguments.context.pageData['isDisableSaveButton'] = false;
    }
  } else {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c6a7a0abb256185410b8f23a00883dfb', []);
    ___arguments.context.pageData['isLoadOrganizationLS'] = false;
    ___arguments.context.pageData['isDisableSaveButton'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'queryOrganizationLS'))

  },
  /* handler:onValueAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isReadonlyOrganizationLS'))

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/3be50adbde3a22dafd7e8781ce247577/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Store message to family and friends (',(getObjectProperty(___arguments.context.pageData, 'message')) ? (getObjectProperty(___arguments.context.pageData, 'message')).length : '0',' of 250)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/2df54bd5bb55e9442c7e51431c25b7a1/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var optionsList, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  optionsList = [];
  for (i = 10; i <= 100; i++) {
    addItemToList(optionsList, ({ [`option`]: i,[`value`]: i }));
  }

  return optionsList

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/sellerAdd/components/3879532a33565d9d81681e6671e785cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Home Delivery Details',[`html`]: ['<p>','Offer your buyers delivery by student for cheaper shipping.','</p>'].join(''),[`icon`]: 'info',[`confirmButtonText`]: 'Close',[`showDenyButton`]: false }), null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var settingResults, key, settingKeys, settingsList, sellersList, item, sellersData, settings, userCheck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function setOrders() {
  ___arguments.context.pageData['isOpenModalOrders'] = false;
  ___arguments.context.pageData['orderShopId'] = '';
  ___arguments.context.pageData['sellersFundraiserObjectId'] = '';
  ___arguments.context.pageData['orderFundraiserName'] = '';
  ___arguments.context.pageData['orderFundraiserStart'] = '';
  ___arguments.context.pageData['orderFundraiserEnd'] = '';
  ___arguments.context.pageData['orderFundraiserNext'] = '';
  ___arguments.context.pageData['isDisabledOrderPrintButton'] = false;
  ___arguments.context.pageData['isDisabledOrderPDFButton'] = false;
}

/**
 * Describe this function...
 */
async function setModalEdit() {
  ___arguments.context.pageData['isOpenModalEdit'] = false;
  ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['sellerId'] = '';
  ___arguments.context.pageData['firstName'] = '';
  ___arguments.context.pageData['lastName'] = '';
  ___arguments.context.pageData['photo'] = '';
  ___arguments.context.pageData['MicrostoreId'] = '';
  ___arguments.context.pageData['MicrostorePath'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['photoData'] = '';
  ___arguments.context.pageData['nameChanged'] = '';
  ___arguments.context.pageData['gradeChanged'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['FundraiserId'] = '';
  ___arguments.context.pageData['AppealMessage'] = '';
  ___arguments.context.pageData['TeacherLastName'] = '';
  ___arguments.context.pageData['Grade'] = '';
  ___arguments.context.pageData['goalItems'] = (Number((getObjectProperty(___arguments.context.pageData, 'settings.GoalSellerItems'))));
  ___arguments.context.pageData['Ship2X'] = false;
}


  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (userCheck) {
    settings = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['GoalSellerItems', 'StoreBaseURL', 'cdnURL', 'CurrentSeasonDatabase'], ___arguments.context.appData));
    ___arguments.context.pageData['settings'] = settings;
    await (async function() {
    	await BackendlessUI.requireModule('https://cdn.crop.guide/loader/l.js?c=NHKLMH');
    })();
    await (async function() {
    	await BackendlessUI.requireModule('https://printjs-4de6.kxcdn.com/print.min.js');
    })();
    await setOrders();
    await setModalEdit();
    ___arguments.context.pageData['gradeOptions'] = (await BackendlessUI.Functions.Custom['fn_05dbbe5265446336458f423e9192a925']());
    ___arguments.context.pageData['isNoresults'] = false;
    ___arguments.context.pageData['isLoader'] = true;
    sellersList = [];
    ___arguments.context.pageData['shareButtonsList'] = [({ [`class`]: 'mail',[`type`]: 'email' }), ({ [`class`]: 'cell',[`type`]: 'cell' }), ({ [`class`]: 'people',[`type`]: 'soc' })];
    if (getObjectProperty(___arguments.context.appData, 'sellersData')) {
      sellersData = (getObjectProperty(___arguments.context.appData, 'sellersData'));
    } else {
      sellersData = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getsellers2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      ___arguments.context.appData['sellersData'] = sellersData;
    }
    ___arguments.context.pageData['sellersData'] = sellersData;
    ___arguments.context.pageData['isLoader'] = false;
    if (sellersData.length > 0) {
      sellersList = (getObjectProperty(___arguments.context.pageData, 'sellersData'));
      if ((getObjectProperty(___arguments.context.appData, 'alertRegisterSellers')) == true) {
        ___arguments.context.appData['alertRegisterSellers'] = false;
        if ((await asyncListFilter(sellersData, async (item) => {


         return ((Object.keys((getObjectProperty(item, 'activeFundraiser')))).length > 0);
        })).length == 0) {
          await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`icon`]: 'info',[`title`]: 'Register Your Sellers',[`html`]: 'Register existing sellers for a fundraiser by clicking the "Join a Fundraiser" button under their name.  You can also add additional Sellers if you need.' }), null);
        }
      }
    } else {
      ___arguments.context.pageData['isNoresults'] = true;
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc08b7b7a426964edfe1e90f812f940b')) {
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cc08b7b7a426964edfe1e90f812f940b', sellersList);
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sellerDashboard/components/5d8f324b8bc74fe68c94606123f19d88/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerAdd', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/c81d636bf6f6b1b9d26bb5cc67ccc153/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__noresults'];
  if (getObjectProperty(___arguments.context.pageData, 'isNoresults')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/6f72b42171cb5983c9144d4290f533e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__loader'];
  if (getObjectProperty(___arguments.context.pageData, 'isLoader')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/4584103bdb47682f780c598e78c670bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function clearForm() {
  ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['sellerId'] = '';
  ___arguments.context.pageData['firstName'] = '';
  ___arguments.context.pageData['lastName'] = '';
  ___arguments.context.pageData['photo'] = '';
  ___arguments.context.pageData['MicrostoreId'] = '';
  ___arguments.context.pageData['MicrostorePath'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['nameChanged'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['FundraiserId'] = '';
  ___arguments.context.pageData['AppealMessage'] = '';
  ___arguments.context.pageData['TeacherLastName'] = '';
  ___arguments.context.pageData['Grade'] = '';
  ___arguments.context.pageData['Ship2X'] = false;
}


  ___arguments.context.pageData['isOpenModalEdit'] = false;
  if (getObjectProperty(___arguments.context.pageData, 'uploadedFile')) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'uploadedFile'))));
  }
  await clearForm();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/b6cc3ac5558d4b01036c6d08aa4d21bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function clearForm() {
  ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['sellersObjectId'] = '';
  ___arguments.context.pageData['firstName'] = '';
  ___arguments.context.pageData['lastName'] = '';
  ___arguments.context.pageData['photo'] = '';
  ___arguments.context.pageData['MicrostoreId'] = '';
  ___arguments.context.pageData['MicrostorePath'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['nameChanged'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['SellersFundraisersObjectId'] = '';
  ___arguments.context.pageData['AppealMessage'] = '';
  ___arguments.context.pageData['TeacherLastName'] = '';
  ___arguments.context.pageData['Grade'] = '';
  ___arguments.context.pageData['Ship2X'] = false;
  ___arguments.context.pageData['ship2XChanged'] = false;
  ___arguments.context.pageData['Type'] = undefined;
  ___arguments.context.pageData['OrgName'] = undefined;
  ___arguments.context.pageData['Formatted2StartDate'] = undefined;
  ___arguments.context.pageData['Formatted2EndDate'] = undefined;
  ___arguments.context.pageData['OrgName'] = undefined;
  ___arguments.context.pageData['Address1'] = undefined;
  ___arguments.context.pageData['Address2'] = undefined;
  ___arguments.context.pageData['City'] = undefined;
  ___arguments.context.pageData['StateCode'] = undefined;
  ___arguments.context.pageData['ZipCode'] = undefined;
}


  ___arguments.context.pageData['isOpenModalEdit'] = false;
  if (getObjectProperty(___arguments.context.pageData, 'uploadedFile')) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'uploadedFile'))));
  }
  await clearForm();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/131527acb76bf42887465ba38c1c76cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function clearForm() {
  ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['sellersObjectId'] = '';
  ___arguments.context.pageData['firstName'] = '';
  ___arguments.context.pageData['lastName'] = '';
  ___arguments.context.pageData['photo'] = '';
  ___arguments.context.pageData['MicrostoreId'] = '';
  ___arguments.context.pageData['MicrostorePath'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['nameChanged'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['SellersFundraisersObjectId'] = '';
  ___arguments.context.pageData['AppealMessage'] = '';
  ___arguments.context.pageData['TeacherLastName'] = '';
  ___arguments.context.pageData['Grade'] = '';
  ___arguments.context.pageData['Ship2X'] = false;
  ___arguments.context.pageData['ship2XChanged'] = false;
  ___arguments.context.pageData['Type'] = undefined;
  ___arguments.context.pageData['OrgName'] = undefined;
  ___arguments.context.pageData['Formatted2StartDate'] = undefined;
  ___arguments.context.pageData['Formatted2EndDate'] = undefined;
  ___arguments.context.pageData['OrgName'] = undefined;
  ___arguments.context.pageData['Address1'] = undefined;
  ___arguments.context.pageData['Address2'] = undefined;
  ___arguments.context.pageData['City'] = undefined;
  ___arguments.context.pageData['StateCode'] = undefined;
  ___arguments.context.pageData['ZipCode'] = undefined;
}


  ___arguments.context.pageData['isOpenModalEdit'] = false;
  if (getObjectProperty(___arguments.context.pageData, 'uploadedFile')) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'uploadedFile'))));
  }
  await clearForm();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/1cba8d73d854f89ae0127fc5d9b2c92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, button;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__modal-selleredit'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModalEdit')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/1779f1f97e6f0afee9bf746d6533d4c8/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'firstName'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['firstName'] = ___arguments.value;
  ___arguments.context.pageData['nameChanged'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sellerDashboard/components/c05eb8cc0c8b1f39fae29d1be87e382e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['lastName'] = ___arguments.value;
  ___arguments.context.pageData['nameChanged'] = true;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'lastName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/296380c66e13f026a5c2f87a851d4fc7/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  ['onUploadSuccess'](___arguments) {
    var sirvAvatarURL, response;

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
    
  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExtension;

  },
  /* handler:onFileNameAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var styles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  styles = ({  });
  if ((getObjectProperty(___arguments.context.pageData, 'photo')) != '' && !((getObjectProperty(___arguments.context.pageData, 'photo')) === null)) {
    styles['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'photo')),'?w=200','")'].join(''));
  } else {
    styles['backgroundImage'] = (['url("','https://cdn.meadowfarms.com/images/icons/upload_photo.png','?w=200','")'].join(''));
  }

  return styles

  },
  /* handler:onStyleAssignment */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
    
  },
  /* handler:onBeforeUpload */
  /* handler:onSelectFiles */
  async ['onSelectFiles'](___arguments) {
      await (async function(filesString, pageData) {
  	function processFile(file, pageData) {
  	  if (file) {
  	    const reader = new FileReader();

  	    reader.onload = function(e) {
  	      // Display the image
  	      const dataURL = e.target.result;
  	      // update the background image
  	      document.getElementById('SellerDashboard__Modal-sellerEdit__Form-button-upload').style.backgroundImage = `url(${dataURL})`;

  	      // Convert the file to a byte array
  	      const arrayBufferReader = new FileReader();
  	      arrayBufferReader.onloadend = function() {
  	        const arrayBuffer = arrayBufferReader.result;

  	        const byteArray = new Uint8Array(arrayBuffer);

  	        let byteString = '';

  	        // Convert byte array to string

  	        for (let i = 0; i < byteArray.length; i++) {
  	          byteString += String.fromCharCode(byteArray[i]);
  	        }

  	        //** convert to base64
  	        const base64String = btoa(byteString);

  	        // put the string into page Data
  	        pageData.photoData = base64String;
  	      };

  	      arrayBufferReader.readAsArrayBuffer(file); // Read the file as an ArrayBuffer
  	    };

  	    reader.readAsDataURL(file); // Read the file as a Data URL to display the image
  	  } else {
  	    console.log('image upload not working');
  	  }
  	}

  	processFile(filesString, pageData);
  })((___arguments.selectedFiles[0]), ___arguments.context.pageData);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('296380c66e13f026a5c2f87a851d4fc7');
  ___arguments.context.pageData['photoChanged'] = true;

  },
  /* handler:onSelectFiles */
  /* content */
}))

define('./pages/sellerDashboard/components/136a5bd1a0c9100c466d6937a68c665d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__modal-selleredit__form-field-photo-wrap'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenCrop')) {
    addItemToList(classes, 'hide');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/9582355c54e455e6fadfd939c09b2213/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__modal-selleredit__form-croppie-wrap'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenCrop')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/add4244862db631cb8a12cc4b961c497/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/198d0029afe7a73d7b0a4aef1a15e411/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisableUploadButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/1af1192da1a10e4380eef919bdf5baa6/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__modal-selleredit__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'firstNameError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/025cf067b5557c1ad6aa4a0d21587c55/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__modal-selleredit__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'lastNameError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/20d3cb83e0effb212d750ce8595643ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var sellersData, item, updateResult, formData, results, validatedAddress, error, counter, smartyAddressMessage, message, displayErrors, input, validation, rulesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}

/**
 * Describe this function...
 */
async function clearForm() {
  ___arguments.context.pageData['firstNameError'] = false;
  ___arguments.context.pageData['lastNameError'] = false;
  ___arguments.context.pageData['sellersObjectId'] = '';
  ___arguments.context.pageData['firstName'] = '';
  ___arguments.context.pageData['lastName'] = '';
  ___arguments.context.pageData['photo'] = '';
  ___arguments.context.pageData['MicrostoreId'] = '';
  ___arguments.context.pageData['MicrostorePath'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['nameChanged'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['photoData'] = '';
  ___arguments.context.pageData['SellersFundraisersObjectId'] = '';
  ___arguments.context.pageData['AppealMessage'] = '';
  ___arguments.context.pageData['TeacherLastName'] = '';
  ___arguments.context.pageData['goalItems'] = (getObjectProperty(___arguments.context.pageData, 'settings.GoalSellerItems'));
  ___arguments.context.pageData['Grade'] = '';
  ___arguments.context.pageData['Ship2X'] = false;
  ___arguments.context.pageData['ship2XChanged'] = false;
  ___arguments.context.pageData['Type'] = undefined;
  ___arguments.context.pageData['fundraiserStoreCategoriesFrozen'] = undefined;
  ___arguments.context.pageData['fundraiserPassiveDate'] = undefined;
  ___arguments.context.pageData['OrgName'] = undefined;
  ___arguments.context.pageData['Formatted2StartDate'] = undefined;
  ___arguments.context.pageData['Formatted2EndDate'] = undefined;
  ___arguments.context.pageData['OrgName'] = undefined;
  ___arguments.context.pageData['Address1'] = undefined;
  ___arguments.context.pageData['Address2'] = undefined;
  ___arguments.context.pageData['City'] = undefined;
  ___arguments.context.pageData['StateCode'] = undefined;
  ___arguments.context.pageData['ZipCode'] = undefined;
  ___arguments.context.pageData['addressChanged'] = false;
}

/**
 * Describe this function...
 */
async function rules() {
  rulesList = [({ [`name`]: 'First Name',[`field`]: 'firstName',[`value`]: (getObjectProperty(___arguments.context.pageData, 'firstName')),[`rules`]: ['required'] }), ({ [`name`]: 'Last Name',[`field`]: 'lastName',[`value`]: (getObjectProperty(___arguments.context.pageData, 'lastName')),[`rules`]: ['required'] })];
  if ((getObjectProperty(___arguments.context.pageData, 'Ship2X')) == true && (getObjectProperty(___arguments.context.pageData, 'Type')) == 'DSH') {
    addItemToList(rulesList, ({ [`name`]: 'Address',[`field`]: 'Address1',[`value`]: (getObjectProperty(___arguments.context.pageData, 'Address1')),[`rules`]: ['required'] }));
    addItemToList(rulesList, ({ [`name`]: 'City',[`field`]: 'City',[`value`]: (getObjectProperty(___arguments.context.pageData, 'City')),[`rules`]: ['required'] }));
    addItemToList(rulesList, ({ [`name`]: 'State',[`field`]: 'StateCode',[`value`]: (getObjectProperty(___arguments.context.pageData, 'StateCode')),[`rules`]: ['required'] }));
    addItemToList(rulesList, ({ [`name`]: 'Zip Code',[`field`]: 'ZipCode',[`value`]: (getObjectProperty(___arguments.context.pageData, 'ZipCode')),[`rules`]: ['required'] }));
  }
  return rulesList
}


  validation = (await BackendlessUI.Functions.Custom['fn_95f7fa8277ce6bbbfd7b54d2cf020e22']((await rules())));
  if (validation.length > 0) {
    displayErrors = '';
    for (var input_index in validation) {
      input = validation[input_index];
      ___arguments.context.pageData[(String(getObjectProperty(input, 'field')) + String('Error'))] = true;
      displayErrors = String(displayErrors) + String([(getObjectProperty(input, 'name')),' is required','<br>'].join(''));
    }
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`icon`]: 'error',[`title`]: 'Required Fields',[`html`]: ['<p style=\'text-align:left;\'>',['<b>Please correct the following errors:</b>','<br>',displayErrors].join(''),'</p>'].join('') }), null);
  } else {
    ___arguments.context.pageData['isDisableSaveButton'] = true;
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('20d3cb83e0effb212d750ce8595643ac')), 'button-loading');
    formData = ({ [`microstoreId`]: (getObjectProperty(___arguments.context.pageData, 'MicrostoreId')),[`microstorePath`]: (getObjectProperty(___arguments.context.pageData, 'MicrostorePath')),[`objectId`]: (getObjectProperty(___arguments.context.pageData, 'sellersObjectId')),[`firstName`]: (getObjectProperty(___arguments.context.pageData, 'firstName')),[`lastName`]: (getObjectProperty(___arguments.context.pageData, 'lastName')),[`nameChanged`]: (getObjectProperty(___arguments.context.pageData, 'nameChanged')),[`photoChanged`]: (getObjectProperty(___arguments.context.pageData, 'photoChanged')),[`ship2XChanged`]: (getObjectProperty(___arguments.context.pageData, 'ship2XChanged')),[`gradeChanged`]: (getObjectProperty(___arguments.context.pageData, 'gradeChanged')),[`Grade`]: (getObjectProperty(___arguments.context.pageData, 'Grade')),[`activeFundraiser`]: ({ [`AppealMessage`]: (getObjectProperty(___arguments.context.pageData, 'AppealMessage')),[`SellersFundraisersObjectId`]: (getObjectProperty(___arguments.context.pageData, 'SellersFundraisersObjectId')),[`Ship2X`]: (getObjectProperty(___arguments.context.pageData, 'Ship2X')),[`TeacherLastName`]: (getObjectProperty(___arguments.context.pageData, 'TeacherLastName')),[`Type`]: (getObjectProperty(___arguments.context.pageData, 'Type')),[`fundraiserStoreCategoriesFrozen`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserStoreCategoriesFrozen')),[`fundraiserPassiveDate`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserPassiveDate')),[`GoalItems`]: (getObjectProperty(___arguments.context.pageData, 'goalItems')) }) });
    if ((getObjectProperty(___arguments.context.pageData, 'addressChanged')) == true && (getObjectProperty(___arguments.context.pageData, 'Ship2X')) == true) {
      try {
        validatedAddress = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/smartyaddressvalidation`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`address1`]: (getObjectProperty(___arguments.context.pageData, 'Address1')),[`address2`]: (getObjectProperty(___arguments.context.pageData, 'Address2')),[`city`]: (getObjectProperty(___arguments.context.pageData, 'City')),[`state`]: (getObjectProperty(___arguments.context.pageData, 'StateCode')),[`zip`]: (getObjectProperty(___arguments.context.pageData, 'ZipCode')) }))));
        if (getObjectProperty(validatedAddress, 'smartyAddressChecked')) {
          ___arguments.context.pageData['continueUpdate'] = false;
          ___arguments.context.pageData['userInteraction'] = false;
          smartyAddressMessage = '';
          if ((getObjectProperty(validatedAddress, 'smartyAddressMessageList')).length > 0) {
            smartyAddressMessage = '<br><br><b>Address Errors:</b><br>';
            var message_list = (getObjectProperty(validatedAddress, 'smartyAddressMessageList'));
            for (var message_index in message_list) {
              message = message_list[message_index];
              smartyAddressMessage = String(smartyAddressMessage) + String(String(message) + String('<br>'));
            }
            await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Address Verification',[`html`]: ['<p style=\'text-align:left;\'>',['<b>You entered:</b><br>',(getObjectProperty(___arguments.context.pageData, 'Address1')),' ',(getObjectProperty(___arguments.context.pageData, 'Address2')),'<br>',(getObjectProperty(___arguments.context.pageData, 'City')),', ',(getObjectProperty(___arguments.context.pageData, 'StateCode')),', ',(getObjectProperty(___arguments.context.pageData, 'ZipCode'))].join(''),smartyAddressMessage,'</p>'].join(''),[`icon`]: 'warning',[`confirmButtonText`]: 'Edit Address',[`showDenyButton`]: true,[`denyButtonText`]: 'Keep Current Address',[`timer`]: 11000 }), (await (async function(PageData, recomendedAddress) {
            	const foo = (result) => {
            	  if (result.isConfirmed) {

            	    PageData.continueUpdate = false;
            	    PageData.userInteraction = true;
            	  }

            	  if (result.isDenied) {
            	    PageData.continueUpdate = true;
            	    PageData.userInteraction = true;

            	  }

            	};

            	return foo;
            })(___arguments.context.pageData, (getObjectProperty(validatedAddress, 'recommendedAddress')))));
          } else {
            await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Address Verification',[`html`]: ['<p style=\'text-align:left;\'>',['<b>You entered:</b><br>',(getObjectProperty(___arguments.context.pageData, 'Address1')),' ',(getObjectProperty(___arguments.context.pageData, 'Address2')),'<br>',(getObjectProperty(___arguments.context.pageData, 'City')),', ',(getObjectProperty(___arguments.context.pageData, 'StateCode')),', ',(getObjectProperty(___arguments.context.pageData, 'ZipCode'))].join(''),['<br><br><b>Recommended address:</b><br>',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'address1')),' ',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'address2')),'<br>',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'city')),', ',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'state')),', ',(getObjectProperty((getObjectProperty(validatedAddress, 'recommendedAddress')), 'zip'))].join(''),'</p>'].join(''),[`icon`]: 'warning',[`confirmButtonText`]: 'Use Recommended Address',[`showDenyButton`]: true,[`denyButtonText`]: 'Keep Current Address',[`timer`]: 11000 }), (await (async function(PageData, recomendedAddress) {
            	const foo = (result) => {
            	  if (result.isConfirmed) {
            	    PageData.Address1 = recomendedAddress.address1;
            	    PageData.Address2 = recomendedAddress.address2;
            	    PageData.City = recomendedAddress.city;
            	    PageData.StateCode = recomendedAddress.state;
            	    PageData.ZipCode = recomendedAddress.zip;
            	    PageData.continueUpdate = true;
            	    PageData.userInteraction = true;

            	  }

            	  if (result.isDenied) {
            	    PageData.continueUpdate = true;
            	    PageData.userInteraction = true;

            	  }

            	};

            	return foo;
            })(___arguments.context.pageData, (getObjectProperty(validatedAddress, 'recommendedAddress')))));
          }
          counter = 0;
          while (!(getObjectProperty(___arguments.context.pageData, 'userInteraction'))) {
            counter = (typeof counter == 'number' ? counter : 0) + 50;
            await new Promise(r => setTimeout(r, 50 || 0));
            if (counter > 11000) {
              break;
            }
          }
          if ((getObjectProperty(___arguments.context.pageData, 'continueUpdate')) == false || (getObjectProperty(___arguments.context.pageData, 'userInteraction')) == false) {
            ___arguments.context.pageData['isDisableSaveButton'] = false;
            removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('20d3cb83e0effb212d750ce8595643ac')), 'button-loading', '');
            return ;
          }
        }

      } catch (error) {
        await Backendless.Messaging.sendEmail('Seller Dashboard - Seller Edit - Address validation error', new Backendless.Bodyparts({ textmessage: (String('This was the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

      } finally {
        formData['status'] = ((getObjectProperty(validatedAddress, 'smartyAddressChecked')) ? true : false);
        (getObjectProperty(formData, 'activeFundraiser'))['Address1'] = (getObjectProperty(___arguments.context.pageData, 'Address1'));
        (getObjectProperty(formData, 'activeFundraiser'))['Address2'] = (getObjectProperty(___arguments.context.pageData, 'Address2'));
        (getObjectProperty(formData, 'activeFundraiser'))['City'] = (getObjectProperty(___arguments.context.pageData, 'City'));
        (getObjectProperty(formData, 'activeFundraiser'))['StateCode'] = (getObjectProperty(___arguments.context.pageData, 'StateCode'));
        (getObjectProperty(formData, 'activeFundraiser'))['ZipCode'] = (getObjectProperty(___arguments.context.pageData, 'ZipCode'));

      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'photoChanged')) {
      results = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/uploadSirv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'fileName': ([((new Date()).valueOf()),'_',mathRandomInt(1, 1000),'.','png'].join('')),'filePath': (['/images/sellers2/',(getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase')),'/'].join('')),'fileData': (getObjectProperty(___arguments.context.pageData, 'photoData')),'fileURL': '' }));
      if (getObjectProperty(results, 'status')) {
        ___arguments.context.pageData['photo'] = (String(getObjectProperty(___arguments.context.pageData, 'settings.cdnURL')) + String(getObjectProperty(results, 'filePath')));
        formData['photo'] = (String(getObjectProperty(___arguments.context.pageData, 'settings.cdnURL')) + String(getObjectProperty(results, 'filePath')));
      } else {
        formData['photoChanged'] = false;
      }
    }
    updateResult = (await Backendless.Request.put(`${Backendless.appPath}/services/sellers/update_seller`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(formData)));
    if (updateResult) {
      ___arguments.context.pageData['isOpenModalEdit'] = false;
      sellersData = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'sellersData')).map(async item => {  if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'sellersObjectId'))) {
          item['FirstName'] = (getObjectProperty(___arguments.context.pageData, 'firstName'));
          item['LastName'] = (getObjectProperty(___arguments.context.pageData, 'lastName'));
          item['FullName'] = ([(getObjectProperty(___arguments.context.pageData, 'firstName')),' ',(getObjectProperty(___arguments.context.pageData, 'lastName'))].join(''));
          item['Avatar'] = (getObjectProperty(___arguments.context.pageData, 'photo'));
          if (!(typeof (getObjectProperty((getObjectProperty(updateResult, 'seller')), 'MicrostorePath')) === 'undefined')) {
            item['MicrostorePath'] = (getObjectProperty((getObjectProperty(updateResult, 'seller')), 'MicrostorePath'));
          }
          if (!(typeof (getObjectProperty((getObjectProperty(updateResult, 'seller')), 'Grade')) === 'undefined')) {
            item['Grade'] = (getObjectProperty((getObjectProperty(updateResult, 'seller')), 'Grade'));
          }
          (getObjectProperty(item, 'activeFundraiser'))['Address1'] = (getObjectProperty(___arguments.context.pageData, 'Address1'));
          (getObjectProperty(item, 'activeFundraiser'))['Address2'] = (getObjectProperty(___arguments.context.pageData, 'Address2'));
          (getObjectProperty(item, 'activeFundraiser'))['AppealMessage'] = (getObjectProperty(___arguments.context.pageData, 'AppealMessage'));
          (getObjectProperty(item, 'activeFundraiser'))['City'] = (getObjectProperty(___arguments.context.pageData, 'City'));
          (getObjectProperty(item, 'activeFundraiser'))['Ship2X'] = (getObjectProperty(___arguments.context.pageData, 'Ship2X'));
          (getObjectProperty(item, 'activeFundraiser'))['StateCode'] = (getObjectProperty(___arguments.context.pageData, 'StateCode'));
          (getObjectProperty(item, 'activeFundraiser'))['TeacherLastName'] = (getObjectProperty(___arguments.context.pageData, 'TeacherLastName'));
          (getObjectProperty(item, 'activeFundraiser'))['ZipCode'] = (getObjectProperty(___arguments.context.pageData, 'ZipCode'));
          (getObjectProperty(item, 'activeFundraiser'))['GoalItems'] = (getObjectProperty(___arguments.context.pageData, 'goalItems'));
        }
      ; return item;})));
      ___arguments.context.pageData['sellersData'] = sellersData;
      (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cc08b7b7a426964edfe1e90f812f940b', sellersData);
      await clearForm();
    }
    ___arguments.context.pageData['isDisableSaveButton'] = false;
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('20d3cb83e0effb212d750ce8595643ac')), 'button-loading', '');
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisableSaveButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/04aa39399a67d7943b2b454f805820f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalOrders'] = false;
  ___arguments.context.pageData['orderObject'] = '';
  ___arguments.context.pageData['deliveryObject'] = '';
  ___arguments.context.pageData['seller'] = '';
  ___arguments.context.pageData['fundraiser'] = '';
  ___arguments.context.pageData['fundraiserStatus'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/4266883fa389ac8e5fb2e3e57973809b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalOrders'] = false;
  ___arguments.context.pageData['orderObject'] = '';
  ___arguments.context.pageData['deliveryObject'] = '';
  ___arguments.context.pageData['seller'] = '';
  ___arguments.context.pageData['fundraiser'] = '';
  ___arguments.context.pageData['fundraiserStatus'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/de44a687178d2a4956cbc7042f730c0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerdashboard__modal-orders'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModalOrders')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/15715e4fd21af43dec35d22b36b209a1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var fundraiser, content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'fundraiser')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName')) : null)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/d784a23870ecef44d5f2e32af8b74516/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var response, objectToUse, subTitleType;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  response = '';
  subTitleType = '';
  if (getObjectProperty(___arguments.context.pageData, 'orderObject')) {
    objectToUse = (getObjectProperty(___arguments.context.pageData, 'orderObject'));
    subTitleType = 'orders';
  } else if (getObjectProperty(___arguments.context.pageData, 'deliveryObject')) {
    objectToUse = (getObjectProperty(___arguments.context.pageData, 'deliveryObject'));
    subTitleType = 'deliveries';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'seller')) && objectToUse && (getObjectProperty(___arguments.context.pageData, 'fundraiser')) && (getObjectProperty(objectToUse, 'itemCount'))) {
    if (subTitleType == 'orders') {
      response = ['Fundraiser dates: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'Formatted2StartDate')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'Formatted2EndDate')),'<br>',['You have sold ',(getObjectProperty(objectToUse, 'itemCount')),' items in ',(getObjectProperty(objectToUse, 'orderCount')),' orders for a total of $',(getObjectProperty(objectToUse, 'total'))].join(''),'<br>','<span style=\'font-size: 12px; color: red;\'>','** Orders are updated once a day Monday-Friday','</span>'].join('');
    } else if (subTitleType == 'deliveries') {
      response = ['Fundraiser dates: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'Formatted2StartDate')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'Formatted2EndDate')),'<br>',['You are responsible for delivering the ',(getObjectProperty(objectToUse, 'itemCount')),' items to the customers listed below.'].join(''),'<br>','<span style=\'font-size: 12px; color: red;\'>','** It may take up to 24 hours for orders to display','</span>'].join('');
    }
  }

  return response

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/52446f884aec5acb96ce919e93623dde/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var options;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  options = [];
  if ((Array.isArray((getObjectProperty(___arguments.context.pageData, 'gradeOptions')))) && (getObjectProperty(___arguments.context.pageData, 'gradeOptions')).length > 0) {
    options = (getObjectProperty(___arguments.context.pageData, 'gradeOptions'));
  }

  return options

  },
  /* handler:onOptionsAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Grade'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Grade'] = ___arguments.value;
  ___arguments.context.pageData['gradeChanged'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sellerDashboard/components/ef5547424de2ac3610435922be084628/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['AppealMessage'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'AppealMessage'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/2a027901722ced9e789bff174c928e9b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['TeacherLastName'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'TeacherLastName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/5e11539c4c6da1dc3ede42db67c60fe7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Ship2X'] = ___arguments.value;
  ___arguments.context.pageData['ship2XChanged'] = true;
  if (___arguments.value == false) {
    ___arguments.context.pageData['Address1'] = '';
    ___arguments.context.pageData['Address2'] = '';
    ___arguments.context.pageData['City'] = '';
    ___arguments.context.pageData['StateCode'] = '';
    ___arguments.context.pageData['ZipCode'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Ship2X'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/1575a4f84689e6a2612e2f57402ebc08/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var allowedSaleTypes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'Type')) == 'DSH')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/97113c7e3bc528e1c6b1a7d7b2a74bbc/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var image, nameArr, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  nameArr = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'FullName')).split(' ');
  image = ['https://ui-avatars.com/api/?rounded=true&bold=true&size=250&background=random&name=',nameArr[0].slice(0, 1),'+',nameArr.slice(-1)[0].slice(0, 1)].join('');
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'Avatar')) {
    image = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'Avatar'));
  }

  return image

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/8a91239889a7b6ce683796360293f7b7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'FullName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/d1acc79ee4e61d06802ee65c5bf1fd02/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostoreID'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/c84c670640add49522b139a1369ce88f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'Grade'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/332626cd912c5f3cef8c06cad654c87d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var fundraiser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModalEdit'] = true;
  ___arguments.context.pageData['sellersObjectId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'SellersObjectId'));
  ___arguments.context.pageData['firstName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'FirstName'));
  ___arguments.context.pageData['lastName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'LastName'));
  ___arguments.context.pageData['photo'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'Avatar'));
  ___arguments.context.pageData['MicrostoreId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostoreID'));
  ___arguments.context.pageData['MicrostorePath'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostorePath'));
  ___arguments.context.pageData['Grade'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'Grade'));
  ___arguments.context.pageData['addressChanged'] = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Type'))) {
    ___arguments.context.pageData['SellersFundraisersObjectId'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'SellersFundraisersObjectId'));
    ___arguments.context.pageData['AppealMessage'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'AppealMessage'));
    ___arguments.context.pageData['TeacherLastName'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'TeacherLastName'));
    ___arguments.context.pageData['goalItems'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'GoalItems'));
    ___arguments.context.pageData['Ship2X'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Ship2X'));
    ___arguments.context.pageData['Type'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Type'));
    ___arguments.context.pageData['fundraiserStoreCategoriesFrozen'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'fundraiserStoreCategoriesFrozen'));
    ___arguments.context.pageData['fundraiserPassiveDate'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'fundraiserPassiveDate'));
    ___arguments.context.pageData['OrgName'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'OrgName'));
    ___arguments.context.pageData['Formatted2StartDate'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Formatted2StartDate'));
    ___arguments.context.pageData['Formatted2EndDate'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Formatted2EndDate'));
    ___arguments.context.pageData['OrgName'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'OrgName'));
    ___arguments.context.pageData['Address1'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Address1'));
    ___arguments.context.pageData['Address2'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Address2'));
    ___arguments.context.pageData['City'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'City'));
    ___arguments.context.pageData['StateCode'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'StateCode'));
    ___arguments.context.pageData['ZipCode'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'ZipCode'));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Type')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/a405dc5da89326f3d72f4992689d0523/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')) || !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'objectId')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/0dcc80f2964f18611f84264544fe43d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostorePath'))), true, undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Type')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/8bc99df7cf7dc18cad4158180ebebbcc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(toCopy) {
  	navigator.clipboard.writeText(toCopy);
  })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostorePath'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/be3288cf60c19fbc2173977bdc839a54/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostorePath')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostorePath'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/c017dc0747d8ed5a2d74bcdfb1ae15f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerAdd', ({ 'sellerId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/cabe0c33b988791391fb00d4fc0eaa17/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Formatted2StartDate')),' to ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Formatted2EndDate'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/97b1224839fbf22b86a67038127c9fb2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Formatted2StartDate')),' to ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Formatted2EndDate'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/b2238a1e7bbcaa67dbd7a59b68f2bf44/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerShare', ({ 'type': 'email','sellerId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/40abd4f79ee7f5ad73a94154f06583dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerShare', ({ 'type': 'cell','sellerId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/b797a4697d8e7923e906121c20344b54/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerShare', ({ 'type': 'soc','sellerId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/54c37d094443b1db3b460d835d7e6ccf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Type')) == 'Traditional' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Type')) == 'TraditionalFrozen') && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Ship2X')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/d19326eeb67732dea6cc4ba69d9c3d8b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Type')) == 'Traditional' || (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Type')) == 'TraditionalFrozen') && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Ship2X')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/678fc5b3c7b12cb730bba6532d8b0d9b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Type')) == 'DSH' && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Ship2X')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/4f216fd1e3410414904aaa5abfef9f0d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Type')) == 'DSH' && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Ship2X')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/6dbcd3ae3dc9d7225fcea7394ba6d9fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Address1')) === null) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser'))['Address1'] = '';
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Address2')) === null) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser'))['Address2'] = '';
  }

  return (String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Address1')) + String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Address2')).length > 0 ? String(' ') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'Address2')) : ''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/a638f48e667f287256ade457e171742a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Address1')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'Address2')),','].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/f544c73f793b9db2a6f42b78d9bd39b5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'City')) === null) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser'))['City'] = '';
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'StateCode')) === null) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser'))['StateCode'] = '';
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'ZipCode')) === null) {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser'))['ZipCode'] = '';
  }

  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'City')),', ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'StateCode')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'ZipCode'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/220380e2b31c59a5d44183e5f37734a2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'City')),', ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'StateCode')),' ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'ZipCode'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/1adc5f6e3607b05ba6e5e4c4ea78cf9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModalOrders'] = true;
  ___arguments.context.pageData['orderObject'] = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getorders`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'microstoreId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostoreID')),'officeOrganizationId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'OfficeOrganizationId')),'delivery': false }).send());
  ___arguments.context.pageData['seller'] = ___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119');
  ___arguments.context.pageData['fundraiser'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser'));
  ___arguments.context.pageData['fundraiserStatus'] = 'activeFundraiser';

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (!(typeof (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'orderCount')) === 'undefined') && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'orderCount')) > 0) {
    isDisabled = false;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/6448cd87e1d28e6e60dddf3ed7981c57/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModalOrders'] = true;
  ___arguments.context.pageData['orderObject'] = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getorders`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'microstoreId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostoreID')),'officeOrganizationId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'OfficeOrganizationId')),'delivery': false }).send());
  ___arguments.context.pageData['seller'] = ___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119');
  ___arguments.context.pageData['fundraiser'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser'));
  ___arguments.context.pageData['fundraiserStatus'] = 'completedFundraiser';

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (!(typeof (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'orderCount')) === 'undefined') && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'orderCount')) > 0) {
    isDisabled = false;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/5a2f23ffb01e30c171fd754d79b9e5df/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    var response;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'orderObject')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'orderObject')), 'orders')) : ((getObjectProperty(___arguments.context.pageData, 'deliveryObject')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'deliveryObject')), 'orderItems')) : []))

  },
  /* handler:rowsDataLogic */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
    var forDelivery, forOrder;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  forOrder = [({ 'headerName': 'Order','field': 'order','flex': 1,'filter': false,'sortable': true }), ({ 'headerName': 'Customer','field': 'name','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'date','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'items','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'total','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'yourDelivery','flex': 1,'filter': false,'sortable': true })];
  forDelivery = [({ 'headerName': 'Customer','field': 'name','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'description','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'itemNumber','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'frozen','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'quantity','flex': 1,'filter': false,'sortable': true }), ({ 'field': 'order','flex': 1,'filter': false,'sortable': true })];

  return ((getObjectProperty(___arguments.context.pageData, 'orderObject')) ? forOrder : ((getObjectProperty(___arguments.context.pageData, 'deliveryObject')) ? forDelivery : []))

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/sellerDashboard/components/78646066ccfd846766c5427fbdf92187/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModalOrders'] = true;
  ___arguments.context.pageData['deliveryObject'] = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getorders`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'microstoreId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostoreID')),'officeOrganizationId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'OfficeOrganizationId')),'delivery': true }).send());
  ___arguments.context.pageData['seller'] = ___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119');
  ___arguments.context.pageData['fundraiser'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser'));
  ___arguments.context.pageData['fundraiserStatus'] = 'activeFundraiser';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/a69744bb0ae4b8723f167ff67b5c37fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModalOrders'] = true;
  ___arguments.context.pageData['deliveryObject'] = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getorders`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'microstoreId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'MicrostoreID')),'officeOrganizationId': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'OfficeOrganizationId')),'delivery': true }).send());
  ___arguments.context.pageData['seller'] = ___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119');
  ___arguments.context.pageData['fundraiser'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser'));
  ___arguments.context.pageData['fundraiserStatus'] = 'completedFundraiser';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerDashboard/components/0be31f4e98456677b46b9b12980602fb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'Type')) == 'DSH')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/ce76c6ca7f966ac154c5c828be654d6b/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Address1'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Address1'] = ___arguments.value;
  ___arguments.context.pageData['addressChanged'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sellerDashboard/components/bfb30b7f24d4bed6ea74f7d338126eeb/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Address2'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Address2'] = ___arguments.value;
  ___arguments.context.pageData['addressChanged'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sellerDashboard/components/1e6c935397bd16e607ea88efb4ae374f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['City'] = ___arguments.value;
  ___arguments.context.pageData['addressChanged'] = true;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'City'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/eade9c179cde3dab3668256c92c2a9f9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['StateCode'] = ___arguments.value;
  ___arguments.context.pageData['addressChanged'] = true;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'StateCode'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/f1fd121f848144fcb06d6ceb22ad8c97/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'ZipCode'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['ZipCode'] = ___arguments.value;
  ___arguments.context.pageData['addressChanged'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sellerDashboard/components/8edf8bc6d6a459f96f119321c42d3655/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'ItemCount')) == 0 ? 0.1 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'ItemCount')))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/sellerDashboard/components/3f2769ac6fc30706b12d274a53e2015b/bundle.js', [], () => ({
  /* content */
  /* handler:progressLogic */
  ['progressLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'ItemCount')) == 0 ? 0.1 : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'completedFundraiser')), 'ItemCount')))

  },
  /* handler:progressLogic */
  /* content */
}))

define('./pages/sellerDashboard/components/5d36b79ba0f7ad727d0f5df24509e80a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pdfURL, response, fundraiserStatus, dateNow;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledOrderPrintButton'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5d36b79ba0f7ad727d0f5df24509e80a')), 'button-loading');
  ___arguments.context.pageData['isDisabledOrderPDFButton'] = true;
  dateNow = (new Intl.DateTimeFormat(undefined, ({ 'timeZone': 'America/New_York','timeStyle': 'long','dateStyle': 'short' })).format((new Date())));
  pdfURL = '';
  fundraiserStatus = (getObjectProperty(___arguments.context.pageData, 'fundraiserStatus'));
  if (getObjectProperty(___arguments.context.pageData, 'orderObject')) {
    if (!(typeof (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'orderPDF')) === 'undefined')) {
      pdfURL = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'orderPDF'));
    } else {
      response = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/generatepdf`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'inputList': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'orderObject')), 'orders')),'configuration': ({ 'title': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join(''),'subtitle': String('Online orders as of: ') + String(dateNow.slice(0, dateNow.length - 3)),'headerList': ['Order', 'Customer Name', 'Date', 'Items', 'Total', 'Your Delivery'],'dataSource': 'sellerDashboardOrders','folder': 'sellerOrderpdfs','fileName': [((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')).replace((new RegExp(' ', 'g')), '-')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'MicrostoreID')),'-',[(new Date(dateNow).getMonth() + 1),'-',(new Date(dateNow).getDate()),'-',(new Date(dateNow).getFullYear()),'-',(new Date(dateNow).getHours()),'-',(new Date(dateNow).getMinutes()),'-',String(new Date(dateNow).getSeconds()).length == 1 ? String('0') + String(new Date(dateNow).getSeconds()) : (new Date(dateNow).getSeconds())].join(''),'.pdf'].join(''),'fileTitle': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' Online Orders - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join('') }) }));
      if ((getObjectProperty(response, 'errorCode')) == 0) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus))['orderPDF'] = (getObjectProperty(response, 'pdfURL'));
        pdfURL = (getObjectProperty(response, 'pdfURL'));
      }
    }
  } else if (getObjectProperty(___arguments.context.pageData, 'deliveryObject')) {
    if (!(typeof (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'deliveryPDF')) === 'undefined')) {
      pdfURL = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'deliveryPDF'));
    } else {
      response = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/generatepdf`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'inputList': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'deliveryObject')), 'orderItems')),'configuration': ({ 'title': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join(''),'subtitle': String('Online order items for delivery as of: ') + String(dateNow.slice(0, dateNow.length - 3)),'headerList': ['Customer Name', 'Item Description', 'Item #', 'Frozen', 'Quantity', 'Order'],'dataSource': 'sellerDashboardDeliveries','folder': 'sellerDeliveriespdfs','fileName': [((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')).replace((new RegExp(' ', 'g')), '-')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'MicrostoreID')),'-',[(new Date(dateNow).getMonth() + 1),'-',(new Date(dateNow).getDate()),'-',(new Date(dateNow).getFullYear()),'-',(new Date(dateNow).getHours()),'-',(new Date(dateNow).getMinutes()),'-',String(new Date(dateNow).getSeconds()).length == 1 ? String('0') + String(new Date(dateNow).getSeconds()) : (new Date(dateNow).getSeconds())].join(''),'.pdf'].join(''),'fileTitle': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' Delivery Order Items - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join('') }) }));
      if ((getObjectProperty(response, 'errorCode')) == 0) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus))['deliveryPDF'] = (getObjectProperty(response, 'pdfURL'));
        pdfURL = (getObjectProperty(response, 'pdfURL'));
      }
    }
  }
  if (pdfURL != '') {
    await (async function(fileURL, fileType) {
    	printJS(fileURL, fileType);
    })(pdfURL, 'pdf');
    await new Promise(r => setTimeout(r, 400 || 0));
  }
  ___arguments.context.pageData['isDisabledOrderPrintButton'] = false;
  ___arguments.context.pageData['isDisabledOrderPDFButton'] = false;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5d36b79ba0f7ad727d0f5df24509e80a')), 'button-loading', '');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledOrderPrintButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/9af549c5322afb69d86cd69edba4907d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var pdfURL, response, fundraiserStatus, dateNow;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledOrderPDFButton'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9af549c5322afb69d86cd69edba4907d')), 'button-loading');
  ___arguments.context.pageData['isDisabledOrderPrintButton'] = true;
  dateNow = (new Intl.DateTimeFormat(undefined, ({ 'timeZone': 'America/New_York','timeStyle': 'long','dateStyle': 'short' })).format((new Date())));
  pdfURL = '';
  fundraiserStatus = (getObjectProperty(___arguments.context.pageData, 'fundraiserStatus'));
  if (getObjectProperty(___arguments.context.pageData, 'orderObject')) {
    if (!(typeof (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'orderPDF')) === 'undefined')) {
      pdfURL = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'orderPDF'));
    } else {
      response = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/generatepdf`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'inputList': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'orderObject')), 'orders')),'configuration': ({ 'title': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join(''),'subtitle': String('Online orders as of: ') + String(dateNow.slice(0, dateNow.length - 3)),'headerList': ['Order', 'Customer Name', 'Date', 'Items', 'Total', 'Your Delivery'],'dataSource': 'sellerDashboardOrders','folder': 'sellerOrderpdfs','fileName': [((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')).replace((new RegExp(' ', 'g')), '-')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'MicrostoreID')),'-',[(new Date(dateNow).getMonth() + 1),'-',(new Date(dateNow).getDate()),'-',(new Date(dateNow).getFullYear()),'-',(new Date(dateNow).getHours()),'-',(new Date(dateNow).getMinutes()),'-',String(new Date(dateNow).getSeconds()).length == 1 ? String('0') + String(new Date(dateNow).getSeconds()) : (new Date(dateNow).getSeconds())].join(''),'.pdf'].join(''),'fileTitle': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' Online Orders - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join('') }) }));
      if ((getObjectProperty(response, 'errorCode')) == 0) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus))['orderPDF'] = (getObjectProperty(response, 'pdfURL'));
        pdfURL = (getObjectProperty(response, 'pdfURL'));
      }
    }
  } else if (getObjectProperty(___arguments.context.pageData, 'deliveryObject')) {
    if (!(typeof (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'deliveryPDF')) === 'undefined')) {
      pdfURL = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus)), 'deliveryPDF'));
    } else {
      response = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/generatepdf`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'inputList': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'deliveryObject')), 'orderItems')),'configuration': ({ 'title': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join(''),'subtitle': String('Online order items for delivery as of: ') + String(dateNow.slice(0, dateNow.length - 3)),'headerList': ['Customer Name', 'Item Description', 'Item #', 'Frozen', 'Quantity', 'Order'],'dataSource': 'sellerDashboardDeliveries','folder': 'sellerDeliveriespdfs','fileName': [((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')).replace((new RegExp(' ', 'g')), '-')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'MicrostoreID')),'-',[(new Date(dateNow).getMonth() + 1),'-',(new Date(dateNow).getDate()),'-',(new Date(dateNow).getFullYear()),'-',(new Date(dateNow).getHours()),'-',(new Date(dateNow).getMinutes()),'-',String(new Date(dateNow).getSeconds()).length == 1 ? String('0') + String(new Date(dateNow).getSeconds()) : (new Date(dateNow).getSeconds())].join(''),'.pdf'].join(''),'fileTitle': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), 'FullName')),' Delivery Order Items - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'fundraiser')), 'OrgName'))].join('') }) }));
      if ((getObjectProperty(response, 'errorCode')) == 0) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'seller')), fundraiserStatus))['deliveryPDF'] = (getObjectProperty(response, 'pdfURL'));
        pdfURL = (getObjectProperty(response, 'pdfURL'));
      }
    }
  }
  if (pdfURL != '') {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(pdfURL, true, undefined);
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9af549c5322afb69d86cd69edba4907d')), 'button-loading', '');
  ___arguments.context.pageData['isDisabledOrderPDFButton'] = false;
  ___arguments.context.pageData['isDisabledOrderPrintButton'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledOrderPDFButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/6717285872cf685eff9e8c56c35a665b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Store message to friends and family (',(getObjectProperty(___arguments.context.pageData, 'AppealMessage')) ? (getObjectProperty(___arguments.context.pageData, 'AppealMessage')).length : '0',' of 250)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/0abc3e4e13ee18c90fe957aea9a5c553/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'Type')) == 'Traditional' || (getObjectProperty(___arguments.context.pageData, 'Type')) == 'TraditionalFrozen')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/8f2ebcccfd46786d2dc27e16790236f7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['Ship2X'] = ___arguments.value;
  ___arguments.context.pageData['ship2XChanged'] = true;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'Ship2X'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/bfc9e3cc72a8239a1ac971777dcd8501/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(typeof (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('7e88deeb96c928e22135350d5c4ed119'), 'activeFundraiser')), 'objectId')) === 'undefined'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sellerDashboard/components/7b6b2a3dad76b622923a4dcacd3faa13/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var i, optionsList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  optionsList = [];
  for (i = 10; i <= 100; i++) {
    addItemToList(optionsList, ({ [`option`]: i,[`value`]: i }));
  }

  return optionsList

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/sellerShare/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var typesList, settings, checkUser, sellersList, endDate, sellerItem, organizations, fundraisers, fundraiserItem, sellersData, item, activeSellers, currentSeller, parseSellerTexts, settingKeys;

/**
 * Describe this function...
 */
async function fieldsError() {
  ___arguments.context.pageData['formEmailSellersError'] = false;
  ___arguments.context.pageData['formEmailToError'] = false;
  ___arguments.context.pageData['formEmailSubjectError'] = false;
  ___arguments.context.pageData['formEmailMessageError'] = false;
  ___arguments.context.pageData['formCellSellersError'] = false;
  ___arguments.context.pageData['formCellToError'] = false;
  ___arguments.context.pageData['formCellMessageError'] = false;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function fieldsDefault() {
  ___arguments.context.pageData['fieldEmails'] = '';
  ___arguments.context.pageData['fieldPhones'] = '';
  ___arguments.context.pageData['formEmailSellers'] = [];
  ___arguments.context.pageData['formEmailFundraisers'] = [];
  ___arguments.context.pageData['formEmailTo'] = [];
  ___arguments.context.pageData['formEmailSubject'] = '';
  ___arguments.context.pageData['formEmailMessage'] = '';
  ___arguments.context.pageData['formEmailReminders'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'AutoReminderEmails'));
  ___arguments.context.pageData['formCellSellers'] = [];
  ___arguments.context.pageData['formCellFundraisers'] = [];
  ___arguments.context.pageData['formCellTo'] = [];
  ___arguments.context.pageData['formCellMessage'] = '';
  ___arguments.context.pageData['formCellReminders'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'AutoReminderTexts'));
  ___arguments.context.pageData['formSocSeller'] = '';
}

/**
 * Describe this function...
 */
async function setTypes() {
  ___arguments.context.pageData['activeType'] = ((getObjectProperty(___arguments.context.pageData, 'type')) && (['email', 'cell', 'soc'].includes((getObjectProperty(___arguments.context.pageData, 'type')))) ? (getObjectProperty(___arguments.context.pageData, 'type')) : 'email');
  typesList = [({ [`label`]: 'Email',[`id`]: 'email' }), ({ [`label`]: 'Text',[`id`]: 'cell' }), ({ [`label`]: 'Social Media',[`id`]: 'soc' })];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c1ef98f4bcd945820f9e49b57a522fa3', typesList);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function setSellers() {
  ___arguments.context.pageData['nouserImage'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'SellerAvatarDefault'));
  ___arguments.context.pageData['isDisableSendEmail'] = false;
  ___arguments.context.pageData['isDisableSendCell'] = false;
  ___arguments.context.pageData['isSuccessSendEmail'] = false;
  ___arguments.context.pageData['isSuccessSendCell'] = false;
  ___arguments.context.pageData['isLoader'] = true;
  ___arguments.context.pageData['NoSellers'] = false;
  ___arguments.context.pageData['sellersSocLink'] = '';
  ___arguments.context.pageData['sellersSocShopID'] = '';
  if (getObjectProperty(___arguments.context.appData, 'sellersData')) {
    sellersData = (getObjectProperty(___arguments.context.appData, 'sellersData'));
  } else {
    sellersData = (await Backendless.Request.get(`${Backendless.appPath}/services/sellers/getsellers2`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    ___arguments.context.appData['sellersData'] = sellersData;
  }
  sellersList = [];
  if (sellersData.length > 0) {
    activeSellers = (await asyncListFilter(sellersData, async (item) => {


     return (!(typeof (getObjectProperty((getObjectProperty(item, 'activeFundraiser')), 'Status')) === 'undefined'));
    }));
    sellersList = (await Promise.all(activeSellers.map(async item => {; return ({ [`objectId`]: (getObjectProperty(item, 'objectId')),[`fundraisers`]: [(getObjectProperty((getObjectProperty(item, 'activeFundraiser')), 'objectId'))],[`organizations`]: [(getObjectProperty((getObjectProperty(item, 'activeFundraiser')), 'OrgName'))],[`name`]: (getObjectProperty(item, 'FullName')),[`image`]: (getObjectProperty(item, 'Avatar')),[`shopId`]: (getObjectProperty(item, 'MicrostoreID')),[`microstorePath`]: (getObjectProperty(item, 'MicrostorePath')),[`endDate`]: (getObjectProperty((getObjectProperty(item, 'activeFundraiser')), 'EndDate')) });})));
  } else {
    ___arguments.context.pageData['NoSellers'] = true;
  }
  ___arguments.context.pageData['sellersList'] = sellersList;
  ___arguments.context.pageData['isLoader'] = false;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9735c91b1ae51eeb1d75856b0422c354', sellersList);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('933cac16a4aa6337b5017f1dcdcced4c', sellersList);
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('b50ebaac16bffe1aca2aac3a680f4497', sellersList);
}

/**
 * Describe this function...
 */
async function setMessagesByType() {
  if ((getObjectProperty(___arguments.context.pageData, 'sellerId')) != '' && !(typeof (getObjectProperty(___arguments.context.pageData, 'sellerId')) === 'undefined')) {
    parseSellerTexts = (await BackendlessUI.Functions.Custom['fn_d217355c2e971bae9029b53b028c6ee5']((getObjectProperty(___arguments.context.pageData, 'sellersList')), [(getObjectProperty(___arguments.context.pageData, 'sellerId'))], (getObjectProperty(___arguments.context.pageData, 'settings'))));
    if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'email') {
      ___arguments.context.pageData['formEmailSellers'] = [(getObjectProperty(___arguments.context.pageData, 'sellerId'))];
      ___arguments.context.pageData['formEmailSubject'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSellerEmailSubject')), '$SellerName', (getObjectProperty(parseSellerTexts, 'sellerName'))));
      ___arguments.context.pageData['formEmailMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), ((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')).length > 1 ? 'ShareSellerEmailBodyMultiple' : 'ShareSellerEmailBody'))), ['$SellerName', '$OrganizationName', '$MicrostorePath'], [(getObjectProperty(parseSellerTexts, 'sellerName')), (getObjectProperty(parseSellerTexts, 'organizationName')), (getObjectProperty(parseSellerTexts, 'microstorePath'))]));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'cell') {
      ___arguments.context.pageData['formCellSellers'] = [(getObjectProperty(___arguments.context.pageData, 'sellerId'))];
      ___arguments.context.pageData['formCellMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSellerTextBody')), ['$SellerName', '$OrganizationName', '$MicrostorePath'], [(getObjectProperty(parseSellerTexts, 'sellerName')), (getObjectProperty(parseSellerTexts, 'organizationName')), ((getObjectProperty(parseSellerTexts, 'microstorePath')).replace((new RegExp('<\\/?[^>]+(>|$)', 'g')), ''))]));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'soc') {
      currentSeller = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'sellersList')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'sellerId')));
      }))[0];
      ___arguments.context.pageData['formSocSeller'] = (getObjectProperty(___arguments.context.pageData, 'sellerId'));
      ___arguments.context.pageData['sellersSocShopID'] = (getObjectProperty(currentSeller, 'shopId'));
      ___arguments.context.pageData['sellersSocLink'] = (getObjectProperty(parseSellerTexts, 'microstorePath'));
      await BackendlessUI.Functions.Custom['fn_af316a0c15474f44858a3f62b2b7292d']('.sellershare_soc-form_fb-button', (getObjectProperty(parseSellerTexts, 'microstorePath')));
      await BackendlessUI.Functions.Custom['fn_26b435995da772dfb95a088a74b54925'](currentSeller, (getObjectProperty(___arguments.context.pageData, 'sellerId')), (await settingImages()));
    }
  }
}

/**
 * Describe this function...
 */
async function settingImages() {
  return [(await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareStoryImage', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareStoryImage')), 'sellershare_soc-form_story-image')), (await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareMoreImage1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareMoreImage1')), 'sellershare_soc-form_more-image1')), (await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareMoreImage2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareMoreImage2')), 'sellershare_soc-form_more-image2'))]
}


  checkUser = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (checkUser) {
    settings = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['StoreBaseURL', 'TinyMCEAPIKey', 'ShareSellerEmailSubject', 'ShareSellerEmailBody', 'ShareSellerEmailBodyMultiple', 'ShareSellerTextBody', 'ShareSellerTextBodyMulitple', 'ShareStoryImage', 'ShareMoreImage1', 'ShareMoreImage2', 'cdnURL', 'SellerAvatarDefault'], ___arguments.context.appData));
    ___arguments.context.pageData['settings'] = settings;
    ___arguments.context.pageData['user'] = (await Backendless.UserService.getCurrentUser(false));
    await setTypes();
    await setSellers();
    await fieldsDefault();
    await fieldsError();
    ___arguments.context.pageData['contacts'] = (await Backendless.Request.get(`${Backendless.appPath}/services/user/user/get_contacts`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    await (async function() {
    	/*await new Promise(resolve => {
    	  const script = document.createElement('script');
    	
    	  script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v14.0&appId=4766177493401260&autoLogAppEvents=1';
    	  script.type ='text/javascript';
    	  script.async = true;
    	  script.defer = true;
    	  script.setAttribute('id', 'facebook-jssdk');
    	  script.setAttribute('crossorigin', 'anonymous');
    	  script.setAttribute('nonce', 'Ggaxq90n');
    	  
    	  script.onload = () => resolve();
    	  script.onerror = () => reject();
    	  
    	  document.head.appendChild(script);
    	});*/
    	/*
    	(function(d, s, id) {
    	var js, fjs = d.getElementsByTagName(s)[0];
    	if (d.getElementById(id)) return;
    	js = d.createElement(s); js.id = id;
    	js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
    	fjs.parentNode.insertBefore(js, fjs);
    	}(document, 'script', 'facebook-jssdk'));*/
    })();
    await (async function() {
    	const emailField = document.querySelector('.sellershare_email-form_to_field textarea:first-child');
    	const cellField = document.querySelector('.sellershare_cell-form_to_field textarea:first-child');

    	emailField.addEventListener("keypress", function onEvent(event) {
    	    if (event.key === "Enter") {
    	      ___arguments.context.pageData['fieldEmailsSubmit'] = true;
    	    }
    	});
    	emailField.addEventListener("blur", function onEvent(event) {
    	    ___arguments.context.pageData['fieldEmailsSubmit'] = true;
    	});
    	cellField.addEventListener("keypress", function onEvent(event) {
    	    if (event.key === "Enter") {
    	      ___arguments.context.pageData['fieldPhonesSubmit'] = true;
    	    }
    	});
    	cellField.addEventListener("blur", function onEvent(event) {
    	    ___arguments.context.pageData['fieldPhonesSubmit'] = true;
    	});
    })();
    await setMessagesByType();
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sellerShare/components/78d84ff45a4c7b88faa75827a8cbf2e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var firstSeller, sellersSocLink;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settingImages() {
  return [(await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareStoryImage', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareStoryImage')), 'sellershare_soc-form_story-image')), (await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareMoreImage1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareMoreImage1')), 'sellershare_soc-form_more-image1')), (await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareMoreImage2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareMoreImage2')), 'sellershare_soc-form_more-image2'))]
}


  if (___arguments.value == 'soc' && (getObjectProperty(___arguments.context.pageData, 'formSocSeller')) == '' && (getObjectProperty(___arguments.context.pageData, 'sellersList')).length > 0) {
    firstSeller = (getObjectProperty(___arguments.context.pageData, 'sellersList'))[0];
    sellersSocLink = String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(firstSeller, 'microstorePath'));
    ___arguments.context.pageData['formSocSeller'] = (getObjectProperty(firstSeller, 'objectId'));
    ___arguments.context.pageData['sellersSocShopID'] = (getObjectProperty(firstSeller, 'shopId'));
    ___arguments.context.pageData['sellersSocLink'] = sellersSocLink;
    await BackendlessUI.Functions.Custom['fn_af316a0c15474f44858a3f62b2b7292d']('.sellershare_soc-form_fb-button', sellersSocLink);
    await BackendlessUI.Functions.Custom['fn_26b435995da772dfb95a088a74b54925'](firstSeller, (getObjectProperty(___arguments.context.pageData, 'nouserImage')), (await settingImages()));
  }
  ___arguments.context.pageData['activeType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'id'));

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'label'))

  },
  /* handler:onLabelAssignment */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'id'))

  },
  /* handler:onValueAssignment */
  /* handler:onCheckedValueAssignment */
  onCheckedValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'activeType'))

  },
  /* handler:onCheckedValueAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ['sellershare_type-radio', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'id'))]

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/4593ab1d341398fc79046bd9b4cd5cb3/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_email-form'];
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'email') {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/7c850a43d3bfa15fc361b06293f7a86f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_cell-form'];
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'cell') {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/ae4a96f3ad35d86ed758eedaf047c3ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_soc-form'];
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'soc') {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/4eaf9b994901e3bb6be3a308eec83e74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, messageTemplate, parseSellersTexts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function setSubject() {
  await clearFields();
  if ((getObjectProperty(___arguments.context.pageData, 'sellersList')) && (getObjectProperty(___arguments.context.pageData, 'settings')) && (getObjectProperty(___arguments.context.pageData, 'formEmailSellers')) && (getObjectProperty(___arguments.context.pageData, 'formEmailSellers')).length > 0) {
    parseSellersTexts = (await BackendlessUI.Functions.Custom['fn_d217355c2e971bae9029b53b028c6ee5']((getObjectProperty(___arguments.context.pageData, 'sellersList')), (getObjectProperty(___arguments.context.pageData, 'formEmailSellers')), (getObjectProperty(___arguments.context.pageData, 'settings'))));
    ___arguments.context.pageData['formEmailSubject'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSellerEmailSubject')), '$SellerName', (getObjectProperty(parseSellersTexts, 'sellerName'))));
    ___arguments.context.pageData['isDisableSendEmail'] = false;
    ___arguments.context.pageData['formEmailMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), ((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')).length > 1 ? 'ShareSellerEmailBodyMultiple' : 'ShareSellerEmailBody'))), ['$SellerName', '$OrganizationName', '$MicrostorePath'], [(getObjectProperty(parseSellersTexts, 'sellerName')), (getObjectProperty(parseSellersTexts, 'organizationName')), (getObjectProperty(parseSellersTexts, 'microstorePath'))]));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')).length == 0) {
    ___arguments.context.pageData['isDisableSendEmail'] = true;
  }
}

/**
 * Describe this function...
 */
async function clearFields() {
  ___arguments.context.pageData['formEmailSubjectError'] = false;
  ___arguments.context.pageData['formEmailSubject'] = '';
  ___arguments.context.pageData['formEmailMessageError'] = false;
  ___arguments.context.pageData['formEmailMessage'] = '';
}


  ___arguments.context.pageData['formEmailSellersError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')) && ((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')).includes((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'objectId'))))) {
    ___arguments.context.pageData['formEmailSellers'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'objectId')));
    }));
    ___arguments.context.pageData['formEmailFundraisers'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formEmailFundraisers')), async (item) => {


     return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'fundraisers')).includes(item)));
    }));
  } else {
    ___arguments.context.pageData['formEmailSellers'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'objectId'))));
    ___arguments.context.pageData['formEmailFundraisers'] = ((getObjectProperty(___arguments.context.pageData, 'formEmailFundraisers')).concat((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'fundraisers'))));
  }
  await setSubject();

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'name'))

  },
  /* handler:onLabelAssignment */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var isChecked;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isChecked = false;
  if (getObjectProperty(___arguments.context.pageData, 'formEmailSellers')) {
    isChecked = ((getObjectProperty(___arguments.context.pageData, 'formEmailSellers')).includes((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'objectId'))));
  }

  return isChecked

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellerShare/components/52e5b4344b398854e91695db58c7ec87/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var url;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  url = (getObjectProperty(___arguments.context.pageData, 'nouserImage'));
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), 'image')) {
    url = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), 'image'));
  }

  return ([url,'?',['scale.option=fill', 'scale.width=35', 'scale.height=35'].join('&')].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/sellerShare/components/b47fd19dba194b656a71e94439e1b091/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var url;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  url = (getObjectProperty(___arguments.context.pageData, 'nouserImage'));
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'image')) {
    url = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'image'));
  }

  return ([url,'?',['scale.option=fill', 'scale.width=35', 'scale.height=35'].join('&')].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/sellerShare/components/b8b987c96746b34e7e25cf88b49881c2/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var delimiter, url;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'image')) {
    url = String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'image')) + String('?w=35');
  } else {
    url = ['https://ui-avatars.com/api/?rounded=true&bold=true&size=250&background=random&name=',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'name')).slice(0, 1),'+',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'name')).charAt((((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2d6cee47153cb1ba756c395fb14918cb'), 'name')).indexOf(' ') + 1 + 1) - 1))].join('');
  }

  return url

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/sellerShare/components/124128ad4dcda1b5671fa1b103c3d62a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, parseSellersTexts;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function setTemplate() {
  await clearFields();
  if ((getObjectProperty(___arguments.context.pageData, 'sellersList')) && (getObjectProperty(___arguments.context.pageData, 'settings')) && (getObjectProperty(___arguments.context.pageData, 'formCellSellers')) && (getObjectProperty(___arguments.context.pageData, 'formCellSellers')).length > 0) {
    parseSellersTexts = (await BackendlessUI.Functions.Custom['fn_d217355c2e971bae9029b53b028c6ee5']((getObjectProperty(___arguments.context.pageData, 'sellersList')), (getObjectProperty(___arguments.context.pageData, 'formCellSellers')), (getObjectProperty(___arguments.context.pageData, 'settings'))));
    ___arguments.context.pageData['formCellMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), ((getObjectProperty(___arguments.context.pageData, 'formCellSellers')).length > 1 ? 'ShareSellerTextBodyMulitple' : 'ShareSellerTextBody'))), ['$SellerName', '$OrganizationName', '$MicrostorePath'], [(getObjectProperty(parseSellersTexts, 'sellerName')), (getObjectProperty(parseSellersTexts, 'organizationName')), (((getObjectProperty(parseSellersTexts, 'microstorePath')).replace((new RegExp('<\\/?[^>]+(>|$)', 'g')), '')).replace((new RegExp('(?!^)https:\\/\\/', 'g')), ' https://')).trim()]));
  }
}

/**
 * Describe this function...
 */
async function clearFields() {
  ___arguments.context.pageData['formCellMessageError'] = false;
  ___arguments.context.pageData['formCellMessage'] = '';
}


  ___arguments.context.pageData['formCellSellersError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'formCellSellers')) && ((getObjectProperty(___arguments.context.pageData, 'formCellSellers')).includes((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'objectId'))))) {
    ___arguments.context.pageData['formCellSellers'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formCellSellers')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'objectId')));
    }));
    ___arguments.context.pageData['formCellFundraisers'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formCellFundraisers')), async (item) => {


     return (!((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'fundraisers')).includes(item)));
    }));
  } else {
    ___arguments.context.pageData['formCellSellers'] = (addItemToList((getObjectProperty(___arguments.context.pageData, 'formCellSellers')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'objectId'))));
    ___arguments.context.pageData['formCellFundraisers'] = ((getObjectProperty(___arguments.context.pageData, 'formCellFundraisers')).concat((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'fundraisers'))));
  }
  await setTemplate();

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'name'))

  },
  /* handler:onLabelAssignment */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    var isChecked, messageTemplate, sellerPathText, sellerOrganizationText, sellerNamesText, sellerOrganizationsList, sellerPathList, lastOrganization, sellerNamesList, lastSellerName, orgItem, sellerItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isChecked = false;
  if (getObjectProperty(___arguments.context.pageData, 'formCellSellers')) {
    isChecked = ((getObjectProperty(___arguments.context.pageData, 'formCellSellers')).includes((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dec8b6562931d4ec5e2f9c48957af2d2'), 'objectId'))));
  }

  return isChecked

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellerShare/components/a839d5d243d3423697f9f8b2c4a30b65/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sellersSocLink;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function settingImages() {
  return [(await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareStoryImage', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareStoryImage')), 'sellershare_soc-form_story-image')), (await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareMoreImage1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareMoreImage1')), 'sellershare_soc-form_more-image1')), (await BackendlessUI.Functions.Custom['fn_e3eacc03c5fe8e08620b920723bcb811']('ShareMoreImage2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareMoreImage2')), 'sellershare_soc-form_more-image2'))]
}


  sellersSocLink = String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), 'microstorePath'));
  ___arguments.context.pageData['formSocSeller'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), 'objectId'));
  ___arguments.context.pageData['sellersSocLink'] = sellersSocLink;
  ___arguments.context.pageData['sellersSocShopID'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), 'shopId'));
  await BackendlessUI.Functions.Custom['fn_af316a0c15474f44858a3f62b2b7292d']('.sellershare_soc-form_fb-button', sellersSocLink);
  await BackendlessUI.Functions.Custom['fn_26b435995da772dfb95a088a74b54925'](___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), (getObjectProperty(___arguments.context.pageData, 'nouserImage')), (await settingImages()));

  },
  /* handler:onChange */
  /* handler:onCheckedValueAssignment */
  onCheckedValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formSocSeller'))

  },
  /* handler:onCheckedValueAssignment */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), 'name'))

  },
  /* handler:onLabelAssignment */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('26b5e59268fefbb5383f3ac9e7d7f848'), 'objectId'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerShare/components/b8823b3710199eb9e1e3804b2cf622c4/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sellersSocLink'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerShare/components/50cdd0717c59e988b42e1ac90ea8de9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await (async function() {
  	
  	const button = ___arguments.event.target;
  	const input = button.parentElement.parentElement.querySelector('input');
  	input.select();
  	document.execCommand("copy");
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerShare/components/ee4c94ea1dd34e05dd6312efa2e6096a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Shop ID: ') + String(getObjectProperty(___arguments.context.pageData, 'sellersSocShopID')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sellerShare/components/bc92aa482aa8bb1d4debf55d72554b0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_email-form_sellers-noresult'];
  if (getObjectProperty(___arguments.context.pageData, 'NoSellers')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/7a29a8e5ae7c03a21aae402f2d6e2fb5/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_email-form_sellers-loader'];
  if (getObjectProperty(___arguments.context.pageData, 'isLoader')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/b5e68fd42885df3aa275a50fe3fdb9fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_cell-form_sellers-noresult'];
  if (getObjectProperty(___arguments.context.pageData, 'NoSellers')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/e8c6f4b45b48313b35a6f4622257d5a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_cell-form_sellers-loader'];
  if (getObjectProperty(___arguments.context.pageData, 'isLoader')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/b7c9adf3bf64ef394ead7729cb3c9d3c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_soc-form_sellers-noresult'];
  if (getObjectProperty(___arguments.context.pageData, 'NoSellers')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/d41994d94613bf2f8976e41d64ac93fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_soc-form_sellers-loader'];
  if (getObjectProperty(___arguments.context.pageData, 'isLoader')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/7b414c72d0be277e55fd443d0b216daf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NoSellers')) || (getObjectProperty(___arguments.context.pageData, 'isDisableSendEmail')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, apiResult, formData, field, validation, contactsReturn, formEmailItem, formEmailTo, contactItem, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function rules() {
  return [({ [`field`]: 'formEmailSellers',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formEmailSellers')),[`rules`]: ['requiredArray'] }), ({ [`field`]: 'formEmailTo',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formEmailTo')),[`rules`]: ['requiredArray'] }), ({ [`field`]: 'formEmailSubject',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formEmailSubject')),[`rules`]: ['required'] }), ({ [`field`]: 'formEmailMessage',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formEmailMessage')),[`rules`]: ['required'] })]
}

/**
 * Describe this function...
 */
async function creanForm() {
  ___arguments.context.pageData['formEmailSellers'] = [];
  ___arguments.context.pageData['formEmailTo'] = [];
  ___arguments.context.pageData['formEmailSubject'] = '';
  ___arguments.context.pageData['formEmailMessage'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', []);
  ___arguments.context.pageData['contacts'] = (await Backendless.Request.get(`${Backendless.appPath}/services/user/user/get_contacts`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function parseContacts() {
  contactsReturn = [];
  formEmailTo = (getObjectProperty(___arguments.context.pageData, 'formEmailTo'));
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'emails')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'emails')).length > 0) {
    var contactItem_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'emails'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      if (formEmailTo.includes((getObjectProperty(contactItem, 'value')))) {
        addItemToList(contactsReturn, contactItem);
        formEmailTo = (await asyncListFilter(formEmailTo, async (item) => {


         return (item != (getObjectProperty(contactItem, 'value')));
        }));
      }
    }
  }
  if (formEmailTo.length > 0) {
    for (var formEmailItem_index in formEmailTo) {
      formEmailItem = formEmailTo[formEmailItem_index];
      addItemToList(contactsReturn, ({ [`id`]: '',[`value`]: formEmailItem }));
    }
  }
  return contactsReturn
}


  try {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf')), 'button-loading');
    ___arguments.context.pageData['formEmailMessageError'] = false;
    validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
    if (validation.length > 0) {
      for (var field_index in validation) {
        field = validation[field_index];
        ___arguments.context.pageData[(String(field) + String('Error'))] = true;
      }
    } else {
      ___arguments.context.pageData['isDisableSendEmail'] = true;
      formData = ({ [`sellers`]: (getObjectProperty(___arguments.context.pageData, 'formEmailSellers')),[`fundraisers`]: (getObjectProperty(___arguments.context.pageData, 'formEmailFundraisers')),[`to`]: await parseContacts(),[`subject`]: (getObjectProperty(___arguments.context.pageData, 'formEmailSubject')),[`message`]: (await (async function(htmlString) {
      	const updatedHtmlString = htmlString.replace(/style="([^"]*)"/g, (match, p1) => {
      	  return `style="${p1}; margin: 0;"`;
      	});

      	return updatedHtmlString;
      })((getObjectProperty(___arguments.context.pageData, 'formEmailMessage')))),[`reminders`]: (getObjectProperty(___arguments.context.pageData, 'formEmailReminders')),[`type`]: 'Email' });
      for (var count = 0; count < 2; count++) {
        try {
          apiResult = (await Backendless.Request.post(`${Backendless.appPath}/services/messages/messages/set`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(formData)));
          break;

        } catch (error) {
          await Backendless.Messaging.sendEmail('sellerShare - Email send button - setMessage call error', new Backendless.Bodyparts({ textmessage: (['This is the error: ',error,' This is the formData object: ',(JSON.stringify(formData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

        }
      }
      if (getObjectProperty(apiResult, 'status')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerDashboard', ({ [`message`]: 'email' }));
      }
      ___arguments.context.pageData['isDisableSendEmail'] = false;
    }
    if (Array.isArray(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf')))) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf')), 'button-loading', '');
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('sellerShare - Email send button logic error', new Backendless.Bodyparts({ textmessage: (String('This is the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'isSuccessSendEmail')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf')), 'success');
  }

  return ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf'))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/1e3885a63981a42496d68fee1a399f29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isDisableSendCell')) || (getObjectProperty(___arguments.context.pageData, 'NoSellers')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var apiResult, contactItem, contactsReturn, counter, error, field, formCellItem, formCellTo, formData, item, validation;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function rules() {
  return [({ [`field`]: 'formCellSellers',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formCellSellers')),[`rules`]: ['requiredArray'] }), ({ [`field`]: 'formCellTo',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formCellTo')),[`rules`]: ['requiredArray'] }), ({ [`field`]: 'formCellMessage',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formCellMessage')),[`rules`]: ['required'] })]
}

/**
 * Describe this function...
 */
async function cleanForm() {
  ___arguments.context.pageData['formCellSellers'] = [];
  ___arguments.context.pageData['formCellTo'] = [];
  ___arguments.context.pageData['formCellMessage'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', []);
  ___arguments.context.pageData['contacts'] = (await Backendless.Request.get(`${Backendless.appPath}/services/user/user/get_contacts`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function parseContacts() {
  contactsReturn = [];
  formCellTo = (getObjectProperty(___arguments.context.pageData, 'formCellTo'));
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'phones')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'phones')).length > 0) {
    var contactItem_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'phones'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      if (formCellTo.includes((getObjectProperty(contactItem, 'value')))) {
        addItemToList(contactsReturn, contactItem);
        formCellTo = (await asyncListFilter(formCellTo, async (item) => {


         return (item != (getObjectProperty(contactItem, 'value')));
        }));
      }
    }
  }
  if (formCellTo.length > 0) {
    for (var formCellItem_index in formCellTo) {
      formCellItem = formCellTo[formCellItem_index];
      addItemToList(contactsReturn, ({ [`id`]: '',[`value`]: formCellItem }));
    }
  }
  return contactsReturn
}


  try {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29')), 'button-loading');
    validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
    if (validation.length > 0) {
      for (var field_index in validation) {
        field = validation[field_index];
        ___arguments.context.pageData[(String(field) + String('Error'))] = true;
      }
    } else {
      ___arguments.context.pageData['isDisableSendCell'] = true;
      formData = ({ [`sellers`]: (getObjectProperty(___arguments.context.pageData, 'formCellSellers')),[`fundraisers`]: (getObjectProperty(___arguments.context.pageData, 'formCellFundraisers')),[`to`]: await parseContacts(),[`message`]: (getObjectProperty(___arguments.context.pageData, 'formCellMessage')),[`reminders`]: (getObjectProperty(___arguments.context.pageData, 'formCellReminders')),[`type`]: 'Text' });
      counter = 0;
      for (var count = 0; count < 3; count++) {
        counter = (typeof counter == 'number' ? counter : 0) + 1;
        try {
          apiResult = (await Backendless.Request.post(`${Backendless.appPath}/services/messages/messages/set`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(formData)));
          break;

        } catch (error) {
          await Backendless.Messaging.sendEmail('sellerShare - setMessage API call error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' We\'ve tried this many times: ',counter,' This is the formData: ',(JSON.stringify(formData))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
          await new Promise(r => setTimeout(r, (100 * counter) || 0));

        }
      }
      if (getObjectProperty(apiResult, 'status')) {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerDashboard', ({ [`message`]: 'text' }));
      }
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('sellerShare - text message submit button error', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' This is the API counter: ',counter,' This is the formData: ',(JSON.stringify(formData)),' This is the setMessage API response: ',(JSON.stringify(apiResult))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  ___arguments.context.pageData['isDisableSendCell'] = false;
  if (Array.isArray(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29')))) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29')), 'button-loading', '');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'isSuccessSendCell')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29')), 'success');
  }

  return ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29'))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/0b88cd89868c429f28f6e0ea8515824f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (getObjectProperty(___arguments.context.pageData, 'contacts')) {
    isDisabled = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'emails')).length == 0;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var formEmailTo, contactItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formEmailToError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'emails')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'emails')).length > 0) {
    formEmailTo = (getObjectProperty(___arguments.context.pageData, 'formEmailTo'));
    var contactItem_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'emails'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      formEmailTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formEmailTo, (getObjectProperty(contactItem, 'value'))));
    }
    ___arguments.context.pageData['formEmailTo'] = formEmailTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', formEmailTo);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerShare/components/87ab5762a9ef9ff3f59b3adb584a7c52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (getObjectProperty(___arguments.context.pageData, 'contacts')) {
    isDisabled = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'phones')).length == 0;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var formCellTo, contactItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formCellToError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'phones')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'phones')).length > 0) {
    formCellTo = (getObjectProperty(___arguments.context.pageData, 'formCellTo'));
    var contactItem_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'phones'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      formCellTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formCellTo, (getObjectProperty(contactItem, 'value'))));
    }
    ___arguments.context.pageData['formCellTo'] = formCellTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', formCellTo);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellerShare/components/531f645354216075b4592a2d5189a3f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_email-form_to'];
  if (getObjectProperty(___arguments.context.pageData, 'formEmailToError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/332420aaa1238f2b3ada5928d9125a0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_email-form_subject'];
  if (getObjectProperty(___arguments.context.pageData, 'formEmailSubjectError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/12798471e42e79c646a54532c3e84a69/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_email-form_message'];
  if (getObjectProperty(___arguments.context.pageData, 'formEmailMessageError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/7fe431477239782e68c1ea63edeef882/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_cell-form_to'];
  if (getObjectProperty(___arguments.context.pageData, 'formCellToError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/f0ac94f445d537f49c4a2fe770b7ab2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_cell-form_message'];
  if (getObjectProperty(___arguments.context.pageData, 'formCellMessageError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/e65a9542500b007f1e44661174e4fc44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['formEmailToError'] = false;
  ___arguments.context.pageData['fieldEmails'] = ___arguments.value;
  if (___arguments.value != '' && ((___arguments.value.indexOf(',') !== -1) || (___arguments.value.indexOf(' ') !== -1))) {
    ___arguments.context.pageData['fieldEmailsSubmit'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'fieldEmails'))

  },
  /* handler:onValueAssignment */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var formEmailTo, valueItem, valuesList, value, fieldEmails;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'fieldEmailsSubmit')) {
    ___arguments.context.pageData['fieldEmailsSubmit'] = false;
    valuesList = [];
    formEmailTo = (getObjectProperty(___arguments.context.pageData, 'formEmailTo'));
    fieldEmails = (getObjectProperty(___arguments.context.pageData, 'fieldEmails'));
    value = fieldEmails.trim();
    valuesList = ((value.split(',')).concat((value.split(' '))));
    if (valuesList.length > 0) {
      for (var valueItem_index in valuesList) {
        valueItem = valuesList[valueItem_index];
        if (await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54'](valueItem)) {
          formEmailTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formEmailTo, valueItem));
        }
      }
      ___arguments.context.pageData['fieldEmails'] = '';
    }
    ___arguments.context.pageData['formEmailTo'] = formEmailTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', formEmailTo);
  }

  return ['sellershare_email-form_to_field']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/7d777ffcd77bd1a70c7e426bd645b97e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return ___arguments.context.dataModel

  },
  /* handler:onLabelAssignment */
  /* handler:onDelete */
  async onDelete(___arguments) {
    var formEmailTo, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  formEmailTo = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formEmailTo')), async (item) => {


   return (item != ___arguments.context.dataModel);
  }));
  ___arguments.context.pageData['formEmailTo'] = formEmailTo;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', formEmailTo);

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/sellerShare/components/5952aac50b11b501f254982addee25c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async onDelete(___arguments) {
    var formCellTo, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  formCellTo = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formCellTo')), async (item) => {


   return (item != ___arguments.context.dataModel);
  }));
  ___arguments.context.pageData['formCellTo'] = formCellTo;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', formCellTo);

  },
  /* handler:onDelete */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return ___arguments.context.dataModel

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/sellerShare/components/cb59721e3f41c58f8f96fc44b32b9c9e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['formCellToError'] = false;
  ___arguments.context.pageData['fieldPhones'] = ___arguments.value;
  if (___arguments.value != '' && ((___arguments.value.indexOf(',') !== -1) || (___arguments.value.indexOf(' ') !== -1))) {
    ___arguments.context.pageData['fieldPhonesSubmit'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'fieldPhones'))

  },
  /* handler:onValueAssignment */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var formCellTo, formatPhone, valueItem, valueList, value, fieldPhones;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'fieldPhonesSubmit')) {
    ___arguments.context.pageData['fieldPhonesSubmit'] = false;
    valueList = [];
    formCellTo = (getObjectProperty(___arguments.context.pageData, 'formCellTo'));
    fieldPhones = (getObjectProperty(___arguments.context.pageData, 'fieldPhones'));
    value = fieldPhones.trim();
    valueList = ((value.split(',')).concat((value.split(' '))));
    if (valueList.length > 0) {
      for (var valueItem_index in valueList) {
        valueItem = valueList[valueItem_index];
        formatPhone = (await BackendlessUI.Functions.Custom['fn_f30620e2042fe4e4cc73ad02ed3f3336'](valueItem));
        if (formatPhone != '') {
          formCellTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formCellTo, formatPhone));
        }
      }
      ___arguments.context.pageData['fieldPhones'] = '';
    }
    ___arguments.context.pageData['formCellTo'] = formCellTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', formCellTo);
  }

  return ['sellershare_cell-form_to_field']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/a1ef9cae3bbf6a6adfcd989f0f21c3ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formCellMessageError'] = false;
  ___arguments.context.pageData['formCellMessage'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formCellMessage'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerShare/components/8bfd450fb1c84d17098fcb83bb1ca542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formEmailReminders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formEmailReminders'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellerShare/components/d9e71c933aeb4396cce6bc6bc79b8c14/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formEmailSubjectError'] = false;
  ___arguments.context.pageData['formEmailSubject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    var formEmailSubject, lastSellerName, list, sellerItem, sellerNamesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formEmailSubject'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellerShare/components/e04e1a0b87f176b104a67a553a7aee2a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formCellReminders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formCellReminders'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellerShare/components/9735c91b1ae51eeb1d75856b0422c354/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_email-form_sellers-list'];
  if (getObjectProperty(___arguments.context.pageData, 'formEmailSellersError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/933cac16a4aa6337b5017f1dcdcced4c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellershare_cell-form_sellers-list'];
  if (getObjectProperty(___arguments.context.pageData, 'formCellSellersError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellerShare/components/e50250a145349f6803bc50c558084cbe/bundle.js', [], () => ({
  /* content */
  /* handler:onTextChange */
  ['onTextChange'](___arguments) {
      ___arguments.context.pageData['formEmailMessageError'] = false;

  },
  /* handler:onTextChange */
  /* content */
}))

define('./pages/sellersSettings/components/434d501690556efba28b50d4bf16350d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['firstName'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'firstName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/2bbdce9f6a21d808c9edd1bfe9673345/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['lastName'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'lastName'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/388282f6d0a9031be1528e19c28975df/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['phoneError'] = false;
  ___arguments.context.pageData['phone'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'phone'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/9c51b4b3b715e1cdfa258985287c3bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['emailError'] = false;
  ___arguments.context.pageData['email'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'email'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/2d1519c5be4e38887cc681ca89ebefba/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['switch'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'switch'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/eb5c8af7d6d7ba2f17d4be4c38c66d0f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['sendEmails'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sendEmails'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/351c8a6dd73e8841d6568ab79234c87d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['sendText'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sendText'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/e923a05b6512d1396727f4ff8d072758/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['receiveEmails'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'receiveEmails'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/72954f581cf73fa11478083af785635f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['receiveText'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'receiveText'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/df4aae51fe139acc85e6b03e061f0e74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['currentPwdError'] = false;
  ___arguments.context.pageData['currentPwd'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentPwd'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/2217cb7da3f664a44a63d2ccca127e4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['newPwdError'] = false;
  ___arguments.context.pageData['newPwd'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'newPwd'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/9865f37e93dbcacbe7b5bed889eaeef6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['confirmPwdError'] = false;
  ___arguments.context.pageData['confirmPwd'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'confirmPwd'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/0462506ce0a84191fe2277ed179aab66/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'emailError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/4d9fadfad5f18f79f34d3907488b4bd3/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'phoneError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/760ca40cc21295a91e8958a9ee17783c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'currentPwdError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/2cedf73af64d5ec8a8898bee0bb58d67/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'newPwdError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/411e52e3ef56ed29b675ff6336d32a73/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'confirmPwdError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var user, checkUser, userData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setDefaultFields(userData) {
  ___arguments.context.pageData['firstName'] = (getObjectProperty(userData, 'FirstName'));
  ___arguments.context.pageData['lastName'] = (getObjectProperty(userData, 'LastName'));
  ___arguments.context.pageData['phone'] = (getObjectProperty(userData, 'Phone'));
  ___arguments.context.pageData['email'] = (getObjectProperty(userData, 'email'));
  ___arguments.context.pageData['switch'] = (getObjectProperty(userData, 'SwitchBetweenSellers'));
  ___arguments.context.pageData['sendEmails'] = (getObjectProperty(userData, 'AutoReminderEmails'));
  ___arguments.context.pageData['sendText'] = (getObjectProperty(userData, 'AutoReminderText'));
  ___arguments.context.pageData['receiveEmails'] = (getObjectProperty(userData, 'ReceiveEmails'));
  ___arguments.context.pageData['receiveText'] = (getObjectProperty(userData, 'ReceiveTexts'));
  ___arguments.context.pageData['currentPwd'] = '';
  ___arguments.context.pageData['newPwd'] = '';
  ___arguments.context.pageData['confirmPwd'] = '';
}

/**
 * Describe this function...
 */
async function setErrorFields() {
  ___arguments.context.pageData['phoneError'] = false;
  ___arguments.context.pageData['emailError'] = false;
  ___arguments.context.pageData['currentPwdError'] = false;
  ___arguments.context.pageData['newPwdError'] = false;
  ___arguments.context.pageData['confirmPwdError'] = false;
}

/**
 * Describe this function...
 */
async function setButtonsState() {
  ___arguments.context.pageData['isBtnProfileDisabled'] = false;
  ___arguments.context.pageData['isBtnGeneralDisabled'] = false;
  ___arguments.context.pageData['isBtnNotificationDisabled'] = false;
  ___arguments.context.pageData['isBtnPasswordDisabled'] = false;
  ___arguments.context.pageData['isBtnProfileSuccess'] = false;
  ___arguments.context.pageData['isBtnGeneralSuccess'] = false;
  ___arguments.context.pageData['isBtnNotificationSuccess'] = false;
  ___arguments.context.pageData['isBtnPasswordSuccess'] = false;
}


  checkUser = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (checkUser) {
    await setErrorFields();
    await setButtonsState();
    user = (await Backendless.Request.get(`${Backendless.appPath}/services/user/user/get`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    await setDefaultFields(user);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sellersSettings/components/a63cfaaf87ec1d6c254d603ca9eec2fc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var data, field, saveResponse, validation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function rules() {
  return [({ 'field': 'phone','value': (getObjectProperty(___arguments.context.pageData, 'phone')),'rules': ['phone'] }), ({ 'field': 'email','value': (getObjectProperty(___arguments.context.pageData, 'email')),'rules': ['required', 'email'] })]
}


  validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
  if (validation.length > 0) {
    for (var field_index in validation) {
      field = validation[field_index];
      ___arguments.context.pageData[(String(field) + String('Error'))] = true;
    }
  } else {
    ___arguments.context.pageData['isBtnProfileDisabled'] = true;
    data = ({ 'firstName': (getObjectProperty(___arguments.context.pageData, 'firstName')),'lastName': (getObjectProperty(___arguments.context.pageData, 'lastName')),'phone': (getObjectProperty(___arguments.context.pageData, 'phone')),'email': (getObjectProperty(___arguments.context.pageData, 'email')) });
    saveResponse = (await Backendless.Request.put(`${Backendless.appPath}/services/user/user/update`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(data)));
    if (getObjectProperty(saveResponse, 'status')) {
      ___arguments.context.pageData['isBtnProfileSuccess'] = true;

      ;(function() {
        const callback = async () => {
            ___arguments.context.pageData['isBtnProfileSuccess'] = false;

        };

        const timerId = '';
        const timerDelay = 2000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else if ((getObjectProperty(saveResponse, 'errorFields')).length > 0) {
      var field_list = (getObjectProperty(saveResponse, 'errorFields'));
      for (var field_index2 in field_list) {
        field = field_list[field_index2];
        ___arguments.context.pageData[(String(field) + String('Error'))] = true;
      }
    }
    ___arguments.context.pageData['isBtnProfileDisabled'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBtnProfileDisabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-button'];
  if (getObjectProperty(___arguments.context.pageData, 'isBtnProfileSuccess')) {
    addItemToList(classes, 'success');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sellersSettings/components/b9433278fa62f15d423c3171e6037353/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBtnGeneralDisabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-button'];
  if (getObjectProperty(___arguments.context.pageData, 'isBtnGeneralSuccess')) {
    addItemToList(classes, 'success');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var field, saveResponse, data, validation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.pageData['isBtnGeneralDisabled'] = true;
  data = ({ 'switch': (getObjectProperty(___arguments.context.pageData, 'switch')),'sendEmails': (getObjectProperty(___arguments.context.pageData, 'sendEmails')),'sendText': (getObjectProperty(___arguments.context.pageData, 'sendText')) });
  saveResponse = (await Backendless.Request.put(`${Backendless.appPath}/services/user/user/update`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(data)));
  if (getObjectProperty(saveResponse, 'status')) {
    ___arguments.context.pageData['isBtnGeneralSuccess'] = true;

    ;(function() {
      const callback = async () => {
          ___arguments.context.pageData['isBtnGeneralSuccess'] = false;

      };

      const timerId = '';
      const timerDelay = 2000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }
  ___arguments.context.pageData['isBtnGeneralDisabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellersSettings/components/520b9c210a6b2b85a63bf932913a99b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBtnNotificationDisabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-button'];
  if (getObjectProperty(___arguments.context.pageData, 'isBtnNotificationSuccess')) {
    addItemToList(classes, 'success');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var field, saveResponse, data, validation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.pageData['isBtnNotificationDisabled'] = true;
  data = ({ 'receiveEmails': (getObjectProperty(___arguments.context.pageData, 'receiveEmails')),'receiveText': (getObjectProperty(___arguments.context.pageData, 'receiveText')) });
  saveResponse = (await Backendless.Request.put(`${Backendless.appPath}/services/user/user/update`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(data)));
  if (getObjectProperty(saveResponse, 'status')) {
    ___arguments.context.pageData['isBtnNotificationSuccess'] = true;

    ;(function() {
      const callback = async () => {
          ___arguments.context.pageData['isBtnNotificationSuccess'] = false;

      };

      const timerId = '';
      const timerDelay = 2000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }
  ___arguments.context.pageData['isBtnNotificationDisabled'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sellersSettings/components/177c494540a258e53ec76f8602f1e1e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isBtnPasswordDisabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sellerssettings_form-button'];
  if (getObjectProperty(___arguments.context.pageData, 'isBtnPasswordSuccess')) {
    addItemToList(classes, 'success');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var field, saveResponse, data, validation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function rules() {
  return [({ 'field': 'currentPwd','value': (getObjectProperty(___arguments.context.pageData, 'currentPwd')),'rules': ['required'] }), ({ 'field': 'newPwd','value': (getObjectProperty(___arguments.context.pageData, 'newPwd')),'rules': ['required'] }), ({ 'field': 'confirmPwd','value': (getObjectProperty(___arguments.context.pageData, 'confirmPwd')),'rules': ['required'] })]
}


  validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
  if (validation.length > 0) {
    for (var field_index in validation) {
      field = validation[field_index];
      ___arguments.context.pageData[(String(field) + String('Error'))] = true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'newPwd')) != (getObjectProperty(___arguments.context.pageData, 'confirmPwd'))) {
    ___arguments.context.pageData[(String('newPwd') + String('Error'))] = true;
    ___arguments.context.pageData[(String('confirmPwd') + String('Error'))] = true;
  } else {
    ___arguments.context.pageData['isBtnPasswordDisabled'] = true;
    data = ({ 'currentPwd': (getObjectProperty(___arguments.context.pageData, 'currentPwd')),'newPwd': (getObjectProperty(___arguments.context.pageData, 'newPwd')) });
    saveResponse = (await Backendless.Request.put(`${Backendless.appPath}/services/user/user/update`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(data)));
    if (getObjectProperty(saveResponse, 'status')) {
      ___arguments.context.pageData['isBtnPasswordSuccess'] = true;

      ;(function() {
        const callback = async () => {
            ___arguments.context.pageData['isBtnPasswordSuccess'] = false;

        };

        const timerId = '';
        const timerDelay = 2000;

        runSetTimeout(timerId, callback, timerDelay)
      })()
    } else if ((getObjectProperty(saveResponse, 'errorFields')).length > 0) {
      var field_list = (getObjectProperty(saveResponse, 'errorFields'));
      for (var field_index2 in field_list) {
        field = field_list[field_index2];
        ___arguments.context.pageData[(String(field) + String('Error'))] = true;
      }
    }
    ___arguments.context.pageData['isBtnPasswordDisabled'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var userCheck, item, shippingBarcodeObject, shippingBarcodeList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function testMode() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'tim@meadowfarms.com') {
    console.log('logged in at Tim test mode');
    ___arguments.context.pageData['testMode'] = true;
    (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingShippoToken'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingShippoTestToken'));
    ___arguments.context.pageData['scaleConnected'] = true;
    (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScale'] = false;
  }
}

/**
 * Describe this function...
 */
async function pageDataObjects() {
  ___arguments.context.pageData['requireValidAddress'] = true;
  ___arguments.context.pageData['reviewBeforeTransaction'] = true;
  ___arguments.context.pageData['multipackageShipment'] = false;
  ___arguments.context.pageData['addressValidationMatchType'] = 'invalid';
  ___arguments.context.pageData['scaleConnected'] = false;
  ___arguments.context.pageData['testMode'] = false;
  ___arguments.context.pageData['createShipmentSpinnerVisible'] = false;
  ___arguments.context.pageData['addressToOriginalSpinnerVisible'] = false;
  ___arguments.context.pageData['scanInputTime'] = ((new Date()).valueOf());
  ___arguments.context.pageData['scanCaptureActive'] = false;
  ___arguments.context.pageData['scanCaptureElement'] = '';
  ___arguments.context.pageData['createShipmentTime'] = ((new Date()).valueOf());
  ___arguments.context.pageData['shipmentStartTime'] = ((new Date()).valueOf());
  ___arguments.context.pageData['createShipmentRunning'] = false;
  ___arguments.context.pageData['scanInput'] = '';
  ___arguments.context.pageData['error'] = '';
  ___arguments.context.pageData['scaleWeight'] = '';
  ___arguments.context.pageData['scaleName'] = '';
  ___arguments.context.pageData['lastLabelURL'] = '';
  ___arguments.context.pageData['loggedInUser'] = (((await Backendless.UserService.getCurrentUser(false)) === null) ? '' : (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'FirstName')));
  ___arguments.context.pageData['modalVisible'] = ({ [`modalScan`]: false,[`modalScale`]: true,[`modalBox`]: false,[`modalError`]: false,[`modalProcessing`]: false });
  ___arguments.context.pageData['objectsToClear'] = ['addressToOriginal', 'addressTo', 'addressFrom', 'parcel', 'shipment'];
}

/**
 * Describe this function...
 */
async function pageDataShipmentObjects() {
  ___arguments.context.pageData['shipment'] = ({ [`selectedRate`]: '',[`rates`]: '',[`ratesAll`]: '',[`rawRatesAll`]: '',[`logId`]: '',[`labelURL`]: '',[`shipmentCreated`]: '',[`dimensionsEntered`]: '',[`combinedDimensions`]: '',[`boxItemNumber`]: '',[`boxLabel`]: '',[`smartyAddressChecked`]: '',[`smartyAddressValid`]: '',[`smartyAddressMessage`]: '',[`smartyIsResidential`]: '',[`notifyOfficeSource`]: '',[`reference1`]: '',[`companyId`]: '',[`excludeUSPS`]: '',[`multipackageShipmentCount`]: '',[`multipackageShipmentLast`]: '',[`overweightAlert`]: '' });
  ___arguments.context.pageData['addressToOriginal'] = ({ [`name`]: '',[`company`]: '',[`address1`]: '',[`address2`]: '',[`city`]: '',[`state`]: '',[`zip`]: '',[`country`]: '',[`phone`]: '',[`email`]: '' });
  ___arguments.context.pageData['addressTo'] = ({ [`name`]: '',[`company`]: '',[`address1`]: '',[`address2`]: '',[`city`]: '',[`state`]: '',[`zip`]: '',[`country`]: '',[`phone`]: '',[`email`]: '' });
  ___arguments.context.pageData['addressFrom'] = ({ [`name`]: '',[`company`]: '',[`address1`]: '',[`address2`]: '',[`city`]: '',[`state`]: '',[`zip`]: '',[`country`]: '',[`phone`]: '',[`email`]: '',[`companyId`]: '' });
  ___arguments.context.pageData['parcel'] = ({ [`length`]: '',[`width`]: '',[`height`]: '',[`distance_unit`]: '',[`weight`]: '',[`mass_unit`]: '',[`metadata`]: '' });
}

/**
 * Describe this function...
 */
async function pageDataSettings() {
  ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['OfficeAPIBaseURL', 'CurrentSeasonDatabase', 'APIKey', 'ShippingShippoToken', 'ShippingShippoTestToken', 'SmartyAPIKey', 'ShipppingDoNotShipImage', 'ShippingServiceIgnoreList', 'ShippingRateListLimit', 'ShippingCarriers', 'ShippingRateSortBy', 'ShippingAddressMatchType', 'ShippingNoShipEmails', 'ShippingOutsideCompaniesList', 'ShippingCompaniesList'], ___arguments.context.appData));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingServiceIgnoreList'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingServiceIgnoreList')).toUpperCase().split(','));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingOutsideCompaniesList'] = (await Promise.all(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingOutsideCompaniesList')).split('|')).map(async item => {; return (JSON.parse(item));})));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingCompaniesList'] = (await Promise.all(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingCompaniesList')).split('|')).map(async item => {; return (JSON.parse(item));})));
  ___arguments.context.pageData['addressValidationMatchType'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingAddressMatchType'));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['startCharacter'] = '^';
  (getObjectProperty(___arguments.context.pageData, 'settings'))['endCharacter'] = '~';
  (getObjectProperty(___arguments.context.pageData, 'settings'))['scanInputMaxTime'] = '400';
  (getObjectProperty(___arguments.context.pageData, 'settings'))['distanceUnit'] = 'in';
  (getObjectProperty(___arguments.context.pageData, 'settings'))['massUnit'] = 'lb';
}

/**
 * Describe this function...
 */
async function pageDataBarcodes() {
  ___arguments.context.pageData['barcodes'] = ({  });
  shippingBarcodeList = (await Backendless.Data.of('ShippingBarcodes').find(Backendless.DataQueryBuilder.create().setProperties(['ID', 'Command', 'Input1', 'Input2', 'Label']).setPageSize(100)));
  for (var shippingBarcodeObject_index in shippingBarcodeList) {
    shippingBarcodeObject = shippingBarcodeList[shippingBarcodeObject_index];
    (getObjectProperty(___arguments.context.pageData, 'barcodes'))[(getObjectProperty(shippingBarcodeObject, 'ID'))] = ({ [`command`]: (getObjectProperty(shippingBarcodeObject, 'Command')),[`input1`]: (getObjectProperty(shippingBarcodeObject, 'Input1')),[`input2`]: (getObjectProperty(shippingBarcodeObject, 'Input2')),[`label`]: (getObjectProperty(shippingBarcodeObject, 'Label')) });
  }
}


  ___arguments.context.pageData['pageReady'] = false;
  await pageDataObjects();
  await pageDataShipmentObjects();
  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c']('shippingMain'));
  if (typeof userCheck === 'undefined') {
    return ;
  }
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    await pageDataSettings();
    await pageDataBarcodes();
    await testMode();
    await (async function() {
    	await BackendlessUI.requireModule('https://printjs-4de6.kxcdn.com/print.min.js');
    })();
    await (async function(pageData) {
    	    document.addEventListener("keydown", function(event){
    	        //var x = event.which || event.keyCode;
    	        //pageData.keypress = event.which || event.keyCode;
    	      //var key = event.which || event.keyCode;
    	      //document.getElementById("demo").innerHTML = "The Unicode value is: " + x;
    	      //console.log(String.fromCharCode(parseInt(pageData.keypress)));
    	      //var keypress = String.fromCharCode(parseInt(key));
    	      //console.log('before page load - JS keypress - ' + event.key)
    	      //let element = document.activeElement
    	      //console.log(document.activeElement);
    	      BackendlessUI.Functions.call('shippingScanCapture', event.key, pageData) // the function id is: "97599fbe5a68c9d2cd01efd5cd381092"
    	    });
    })(___arguments.context.pageData);
    ___arguments.context.pageData['pageReady'] = true;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerDashboard', undefined);
  }

  },
  /* handler:onBeforeEnter */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var shippingBarcodeObject, shippingBarcodeList, userCheck;

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/shippingMain/components/c50abee980a554d14ba6f64556017e32/bundle.js', [], () => ({
  /* content */
  /* handler:titleLogic */
  ['titleLogic'](___arguments) {
      return 'Connect Scale'

  },
  /* handler:titleLogic */
  /* handler:onClose */
  async ['onClose'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(pageData) {
  	let connectedDevices = [];
  	let selectedDevice = null;
  	
  	const connectDevice = () => {
  	  navigator.hid.requestDevice({filters:[]}).then(devices => {
  	    if (devices.length == 0)
  	      return;
  	
  	    for (let device of devices)
  	      addDevice(device);
  	  });
  	};
  	
  	// Adds |device| to |connectedDevices|. Selects the device if there was no prior
  	// selection.
  	const addDevice = device => {
  	  if (connectedDevices.includes(device)) {
  	    //console.log('device already in connectedDevices');
  	  } else {
  	    connectedDevices.push(device);
  	    //console.log('device connected: ' + device.productName);
  	  }
  	  
  	  //let scaleText = document.querySelector(".scaleText");
  	  //console.log(scaleText);
  	  if (device !== null) {
  	    pageData.scaleName = device.productName;
  	    device.oninputreport = handleInputReport;
  	    
  	    if (!device.opened) 
  	      device.open();
  	   
  	  }
  	  
  	
  	  /*
  	  if (selectedDevice === null)
  	    selectDevice(device);
  	  updateDeviceMenu();
  	  */
  	};
  	
  	// Removes |device| from |connectedDevices|.
  	const removeDevice = device => {
  	  if (device === selectedDevice)
  	    selectedDevice = null;
  	  for (let i = connectedDevices.length - 1; i >= 0; --i) {
  	    if (connectedDevices[i] === device) {
  	      connectedDevices.splice(i, 1);
  	      console.log('device disconnected: ' + device.productName);
  	      updateDeviceMenu();
  	    }
  	  }
  	};
  	
  	const handleInputReport = event => {
  		//const inputReportTextView = document.querySelector(".scaleValue");
  	  //if (!inputReportTextView)
  	  //	return;
  	
  	  const reportData = new Uint8Array(event.data.buffer); //** original
  	
  		//inputReportTextView.innerHTML = (reportData[3] + (256 * reportData[4])) * 0.01;
  		pageData.scaleWeight = Math.round(((reportData[3] + (256 * reportData[4])) * 0.01) * 10) / 10;
  	}
  	
  	connectDevice();
  })(___arguments.context.pageData);
  while (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalScale')) {
    if ((getObjectProperty(___arguments.context.pageData, 'scaleName')).trim() == 'PS60') {
      ___arguments.context.pageData['scaleConnected'] = true;
      (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScale'] = false;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'scaleName')).trim().slice(0, 7) == 'BCA-222') {
      ___arguments.context.pageData['scaleName'] = ((getObjectProperty(___arguments.context.pageData, 'scaleName')).trim().slice(0, 7));
      ___arguments.context.pageData['scaleConnected'] = true;
      (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScale'] = false;
    }
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = true;

  },
  /* handler:onClose */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalScale'))

  },
  /* handler:onDisplayAssignment */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
      return 'Click "Connect" and select PS60 or BCA-222- from list of devices'

  },
  /* handler:contentLogic */
  /* content */
}))

define('./pages/shippingMain/components/8a4366d416b762b7db4ad6caf3880bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['multipackageShipment'] = false;
  await BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'](___arguments.context.pageData);
  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/263de7fccddddcca5127adeb04848b76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/e843cfe3408355afcac782a42cbc42d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/e10d423ed644f62c0c79d9f6783ba031/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    classesList = ['modal'];
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalScan')) {
      addItemToList(classesList, 'open');
    }
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onVisibilityChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageReady')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalScan')) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/13d91b64ee28be62d688356a677d67ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedAddress, changedValue, element, response, error, shipmentObject, shippingCompany, item, shipmentObjectKey, shipmentList, counter, timer;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getShipmetnDetails2() {
  response = false;
  shipmentList = [];
  counter = 0;
  timer = ((new Date()).valueOf());
  for (var count = 0; count < 3; count++) {
    counter = (typeof counter == 'number' ? counter : 0) + 1;
    try {
      shipmentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogid?logid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'APIKey')) })).setEncoding('utf8').send());
      break;

    } catch (error) {
      if (counter > 1) {
        await Backendless.Messaging.sendEmail((String('modalScanInput Function - Error getting shipment details from Tim\'s shipping endpoint for logid: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,'We tried this many times so far: ',counter,'This was the path: ',[(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogid?logid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      }
      await new Promise(r => setTimeout(r, (100 * counter) || 0));

    }
  }
  if (shipmentList.length == 0) {
    counter = 0;
    for (var count2 = 0; count2 < 3; count2++) {
      try {
        counter = (typeof counter == 'number' ? counter : 0) + 1;
        shipmentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogidmark?logid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'APIKey')),[`Content-type`]: 'application/json' })).setEncoding('utf8').send());
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail((String('modalScanInput Function - Error getting shipment details for logid: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' We tried this many times: ',counter].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
  }
  try {
    if (shipmentList.length == 1) {
      response = true;
      shipmentObject = shipmentList[0];
      var shipmentObjectKey_list = (Object.keys(shipmentObject));
      for (var shipmentObjectKey_index in shipmentObjectKey_list) {
        shipmentObjectKey = shipmentObjectKey_list[shipmentObjectKey_index];
        if ((getObjectProperty(shipmentObject, shipmentObjectKey)) === null) {
          shipmentObject[shipmentObjectKey] = '';
        }
      }
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['name'] = ((getObjectProperty(shipmentObject, 'To_Attn')).trim().length > 0 ? (getObjectProperty(shipmentObject, 'To_Attn')).trim() : (getObjectProperty(shipmentObject, 'To_Name')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['company'] = ((getObjectProperty(shipmentObject, 'To_Attn')).trim().length > 0 ? (getObjectProperty(shipmentObject, 'To_Name')).trim() : ' ');
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['address1'] = ((getObjectProperty(shipmentObject, 'To_Address')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['address2'] = ' ';
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['city'] = ((getObjectProperty(shipmentObject, 'To_City')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['state'] = ((getObjectProperty(shipmentObject, 'To_State')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['zip'] = ((getObjectProperty(shipmentObject, 'To_Zip')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['country'] = 'US';
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['phone'] = ((getObjectProperty(shipmentObject, 'To_Phone')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['email'] = ((getObjectProperty(shipmentObject, 'To_Email')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['company'] = ((getObjectProperty(shipmentObject, 'From_Name')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['address1'] = ((getObjectProperty(shipmentObject, 'From_Address')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['city'] = ((getObjectProperty(shipmentObject, 'From_City')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['state'] = ((getObjectProperty(shipmentObject, 'From_State')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['zip'] = ((getObjectProperty(shipmentObject, 'From_Zip')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['country'] = 'US';
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['phone'] = ((getObjectProperty(shipmentObject, 'From_Phone')).trim().length > 0 ? (getObjectProperty(shipmentObject, 'From_Phone')).trim() : '800-886-7895');
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['companyId'] = ((getObjectProperty(shipmentObject, 'CompanyID')).trim());
      shippingCompany = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingCompaniesList')), async (item) => {


       return ((getObjectProperty(shipmentObject, 'CompanyID')) == (getObjectProperty(item, 'CompanyId')));
      }));
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['email'] = (shippingCompany.length == 1 ? (getObjectProperty((shippingCompany[0]), 'Email')) : '');
      (getObjectProperty(___arguments.context.pageData, 'parcel'))['metadata'] = ((getObjectProperty(shipmentObject, 'Ref1')).trim());
      (getObjectProperty(___arguments.context.pageData, 'shipment'))['companyId'] = ((getObjectProperty(shipmentObject, 'CompanyID')).trim());
    }

  } catch (error) {
    response = false;
    await Backendless.Messaging.sendEmail((String('modalScanInput Function - getAddress - Error getting address for logid: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (String('This was the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  return response
}


  stopSetTimeout('modalScanInput');

  ;(function() {
    const callback = async () => {
        changedValue = ___arguments.value;
    if (changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'startCharacter')) + 1 > 0 && changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'endCharacter')) + 1 > 0) {
      changedValue = String(changedValue.slice(0, (changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'startCharacter')) + 1) - 1)) + String(changedValue.slice(((changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'endCharacter')) + 1 + 1) - 1), changedValue.length));
    }
    (getObjectProperty(___arguments.context.pageData, 'shipment'))['logId'] = (changedValue == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'endCharacter')) ? '' : changedValue);
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')).length == 8) {
      ___arguments.context.pageData['shipmentStartTime'] = ((new Date()).valueOf());
      ___arguments.context.pageData['addressToOriginalSpinnerVisible'] = true;
      (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = false;
      (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = true;
      retrievedAddress = false;
      retrievedAddress = await getShipmetnDetails2();
      if (retrievedAddress) {
        await BackendlessUI.Functions.Custom['fn_af325e4a22a2b4daac665665a4a282f4'](___arguments.context.pageData, 'scan');
      } else {
        (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = false;
        ___arguments.context.pageData['error'] = 'No address available from Mark\'s system.';
        (getObjectProperty(___arguments.context.pageData, 'shipment'))['logId'] = '';
        (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = true;
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));
        ___arguments.context.pageData['addressToOriginalSpinnerVisible'] = false;
        return ;
      }
      ___arguments.context.pageData['addressToOriginalSpinnerVisible'] = false;
      await BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'](___arguments.context.pageData);
      console.log(String('modalScanInput elapsed time: ') + String(((new Date()).valueOf()) - (getObjectProperty(___arguments.context.pageData, 'shipmentStartTime'))));
    }

    };

    const timerId = 'modalScanInput';
    const timerDelay = 350;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/34da05f5c44d48e783c36d543a119bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    classesList = ['modal'];
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalBox')) {
      addItemToList(classesList, 'open');
    }
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageReady')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalBox')) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/a9019758a63e7bb185afc29a017b17b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/c197795353e8d9be6952dd33592c2ae5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/5665a5c6cb8553e9710c7485b747c93c/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'name'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/cf9f4524a423b72281be149be225b6f7/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'company')).length > 0) {
    return2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'company'));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'name')).length > 0) {
    return2 = '';
  }

  return return2

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/3b27b1b67f97335766a5c43979810eb9/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'address1'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/17cfb8d557413c3d44d4569403ecb986/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'address2'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/336524c1816a0168af2fdc9994eaf6b7/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'city'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/e0a58092ad7a799f4b85cd266eeddbec/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'state'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/aedbeeb16092c4e3ea741de58d04ad11/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'zip'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/2ddcfcb9fa63a101c065d69578058175/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'phone'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/30224bf6e9a674bf16b27d810c9ba096/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'name'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'name', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  async ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com' ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/1473e9b262aa6aa5997a55e46e86eed5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'company'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'company', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  async ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com' ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/9c1a5b75005a44621dffd60ecb5ee8c4/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address1'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'address1', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  async ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com' ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/21192cb69015f5c7e353f8ad32df8199/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address2'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'address2', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  async ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com' ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/7a07298552d4fc14a3c75dec6de97eea/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'city'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'city', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  async ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com' ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/fe95a961b0b383033e3dbc8fb479264e/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'state'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'state', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  async ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com' ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/50c7d1db7768a655c0f1644e976b8589/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'zip'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'zip', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  async ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com' ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/363fbf42a13e7d33e0b3b45cb69764ca/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'phone'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'phone', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/855c5518ba0fe0ac0b76973b3272a666/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/check.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/1099cd12ccb514e6a819bc7a84c2d75d/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/delete.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid')) === 'boolean') {
    isVisible = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid')) ? false : true;
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/297162822a82cab1e787f59d24f56e4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressMessage'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain/components/0d8c80f6c5474f52a34d75dcdaa2e72f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressMessage'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/shippingMain/components/2f7806665be4e7b1f8e39a13634249be/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'email'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressTo', 'email', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/804c3a83606236727446a7c62d09f528/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  async ['onValueAssignment'](___arguments) {
    var alertText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'overweightAlert')) != true) {
    stopSetTimeout('weight');

    ;(function() {
      const callback = async () => {
          if ((Number((getObjectProperty(___arguments.context.pageData, 'scaleWeight')))) > 50) {
        (getObjectProperty(___arguments.context.pageData, 'shipment'))['overweightAlert'] = true;
        await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Overweight Package','text': 'This package is over 50lbs!','icon': 'info','confirmButtonText': 'Close','showCancelButton': false }), null);
      } else if ((Number((getObjectProperty(___arguments.context.pageData, 'scaleWeight')))) == 0) {
        (getObjectProperty(___arguments.context.pageData, 'shipment'))['overweightAlert'] = '';
      }

      };

      const timerId = 'weight';
      const timerDelay = 1000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  return (getObjectProperty(___arguments.context.pageData, 'scaleWeight'))

  },
  /* handler:onValueAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Weight (lbs) - ') + String(getObjectProperty(___arguments.context.pageData, 'scaleName')))

  },
  /* handler:onLabelAssignment */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'testMode')) ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'testMode')) {
    ___arguments.context.pageData['scaleWeight'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/7262c0a719eae6ad32b3bd995f5950f2/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'boxLabel'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'shipment', 'combinedDimensions', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'](___arguments.context.pageData);

  },
  /* handler:onBlur */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'testMode')) ? false : true)

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/0e71e48fd3c55f7c6a61c9d386131ad9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['modalBoxInput'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/e949e2c7a08432af4a14fbc2e8e34085/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressToOriginal')), 'email'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/shippingMain/components/c0e7009c1b38d5cdd225554e91170ad6/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'name'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'name', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/fd47ea9c16a7f8d6a5fc5277365ea2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'company'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'company', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/9c7fd6a3d5c4386cfd33ab27d47de466/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'address1'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'address1', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/38c6b92191a3e7abd6b109a782a3a584/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'address2'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'address2', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/c19f01aa1bef9ba56263cc45b8295c85/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'city'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'name', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/4d8e1b91ecb7a0772caccc42724e4a2d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'state'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'state', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/99d4e906fa7e9c6e0dc29e7d04586fc5/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'zip'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'name', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/ff7581b8760b96d7ba7e9c18383d10f6/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'phone'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'phone', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/040a745b32bd1fa2d466942383445bbe/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressFrom')), 'email'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_24dd5a91f97590ae7c08510703b68cc4'](___arguments.value, 'addressFrom', 'email', ___arguments.context.pageData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain/components/ba09447c2723a434982bd07153cb4145/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'rates'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/shippingMain/components/9a493a829d7bf042627dc3fc8dd4a1eb/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.dataModel, 'objectId'))

  },
  /* handler:onValueAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'carrier')),' ',(getObjectProperty(___arguments.context.dataModel, 'service')),' ',(getObjectProperty(___arguments.context.dataModel, 'speed')),' days',' - $',(getObjectProperty(___arguments.context.dataModel, 'amount'))].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'selectedRate'))

  },
  /* handler:onCheckedValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'shipment'))['selectedRate'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'reviewBeforeTransaction')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/0aed12149f2719bf490c6044382d1283/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_ede16f295a85a3ad700cdb4100b1a097'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'shipmentCreated')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/20c413281abdf5467aa70cbe7078617e/bundle.js', [], () => ({
  /* content */
  /* handler:contentLogic */
  ['contentLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'error'))

  },
  /* handler:contentLogic */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'error')).length > 0)

  },
  /* handler:onDisplayAssignment */
  /* handler:titleLogic */
  ['titleLogic'](___arguments) {
      return 'There was an Error!'

  },
  /* handler:titleLogic */
  /* handler:onClose */
  ['onClose'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['error'] = '';
  (getObjectProperty(pageData, 'modalVisible'))['modalProcessing'] = false;

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/shippingMain/components/c4bbb288b24e131efb48ba49b556b123/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var addressSourceProperty;


  await BackendlessUI.Functions.Custom['fn_498e95b477d71882ffbc8bde233ec06c'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressChecked')) == !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/71f45cc570ba6dcf44b85d6d6cfb4074/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressChecked'))) {
    isVisible = true;
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address1')).length == 0) {
      isVisible = false;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'city')).length == 0) {
      isVisible = false;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'state')).length == 0) {
      isVisible = false;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'zip')).length == 0) {
      isVisible = false;
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_af325e4a22a2b4daac665665a4a282f4'](___arguments.context.pageData, 'button');
  await BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/c40b7c8321a1655b3fddd68f85da6ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Current User: ') + String(getObjectProperty(___arguments.context.pageData, 'loggedInUser')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain/components/22141edd0992874265be19383eae1a8f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'addressToOriginalSpinnerVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/f12a3eef7119e54ea7287bd4b3b814f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'testMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/16a7e1a95bfb281a0236c4b502cabe16/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/question.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyIsResidential')).length == 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/def1bbf69fb285c344598cb9310fe1b9/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/check.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyIsResidential')) == true ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/bcfe0dcf5b039193bf7d74690b4f500c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/warning-yellow.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyIsResidential')) === 'boolean') {
    isVisible = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyIsResidential')) ? false : true;
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/9abc9523288191727422f9e437bd0293/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid')).length == 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/question.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/shippingMain/components/0836c4dc6dd127a707a414d680f11751/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    if ((getObjectProperty(___arguments.context.pageData, 'error')).length == 0) {
      isVisible = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalProcessing'));
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    classesList = ['modal'];
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalProcessing')) {
      addItemToList(classesList, 'open');
    }
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/shippingMain/components/53df73a66f06dbb59db3ee87a251f786/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'pageReady'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/3c88030892f8b9538a3cef1600e14c76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var alertText, stat, statsList, list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c88030892f8b9538a3cef1600e14c76')), 'button-loading');
  statsList = (await Backendless.Request.get(`${Backendless.appPath}/services/shipping/shippingdailysummary`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  if (statsList.length > 0) {
    alertText = '';
    for (var stat_index in statsList) {
      stat = statsList[stat_index];
      alertText = String(alertText) + String(['<tr>',['<td>',(getObjectProperty(stat, 'Value')),'</td>'].join(''),['<td>',(getObjectProperty(stat, 'Count')),'</td>'].join(''),'</tr>'].join(''));
    }
  } else {
    alertText = ['<tr>',['<td colspan=\'2\'>','NO RESULTS','</td>'].join(''),'</tr>'].join('');
  }
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Shipping Stats','html': ['<table style="width:100%">',['<thead>','<tr>',['<th style="width:50%">','Value','</th>'].join(''),['<th>','# of Shipments','</th>'].join(''),'</tr>','</thead>'].join(''),['<tbody>',alertText,'<tbody>'].join(''),'</table>'].join(''),'icon': 'info','confirmButtonText': 'Close','showCancelButton': false }), null);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c88030892f8b9538a3cef1600e14c76')), 'button-loading', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/1aaa552588bf62245b5f93effc5f6849/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['multipackageShipment'] = ___arguments.value;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'multipackageShipment'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/dd084eb86aa82a4158d440b6bcc83742/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'multipackageShipment'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'shipment'))['multipackageShipmentLast'] = ___arguments.value;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0e71e48fd3c55f7c6a61c9d386131ad9')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'multipackageShipmentLast'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/1aafaf13a2a95939476d8fbc69ad865a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressChecked')) == true) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid')) == false) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com') {
        isVisible = true;
      }
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'shipment'))['smartyAddressValid'] = true;
  await BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain/components/864d72bfd8bb191438cd6296da7f8fea/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['reviewBeforeTransaction'] = ___arguments.value;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewBeforeTransaction'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/daf249abf76c5f4303ce42e41df23881/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['addressValidationMatchType'] = (___arguments.value == true ? 'enhanced' : 'invalid');
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'addressValidationMatchType')) == 'enhanced' ? true : false)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain/components/ab77922dc5f77c79836561026cfccb16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'company')).length > 0 ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'company')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'name'))) + String('<br>'),(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'company')).length > 0 ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'name')) + String('<br>') : '',String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address1')) + String('<br>'),(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address2')).length > 0 ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address2')) + String('<br>') : null,[(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'city')),', ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'state')),' ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'zip'))].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain/components/090d27bb71ef7bb3cc6789de67147814/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'multipackageShipment'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain/components/c7fbf2f36c96a47c1cfe238668275d1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var alertText, label, labelList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c7fbf2f36c96a47c1cfe238668275d1c')), 'button-loading');
  labelList = (await Backendless.Request.get(`${Backendless.appPath}/services/shipping/shippinglabels`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  if (labelList.length > 0) {
    alertText = '';
    for (var label_index in labelList) {
      label = labelList[label_index];
      alertText = String(alertText) + String(['<tr>',['<td style="padding:5px; border-bottom:1px solid;">',[(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'name')),'<br>',(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'address1')),'<br>',[(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'city')),', ',(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'state')),' ',(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'zip'))].join('')].join(''),'</td>'].join(''),['<td style="padding:5px; border-bottom:1px solid;">',[['<button type="button"',' class="MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained"',' onclick="printJS(\'',(getObjectProperty(label, 'LabelURL')),'\')">'].join(''),'Print Label','</button>'].join(''),'</td>'].join(''),'</tr>'].join(''));
    }
  } else {
    alertText = ['<tr>',['<td colspan=\'2\'>','NO RESULTS','</td>'].join(''),'</tr>'].join('');
  }
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Last 5 Shipping Labels','html': ['<table style="width:100%">',['<thead>','<tr>',['<th style="width:50%;padding:5px; border-bottom:1px solid;">','Address','</th>'].join(''),['<th style="padding:5px; border-bottom:1px solid;">','Label','</th>'].join(''),'</tr>','</thead>'].join(''),['<tbody>',alertText,'<tbody>'].join(''),'</table>'].join(''),'icon': 'info','confirmButtonText': 'Close','showCancelButton': false }), null);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c7fbf2f36c96a47c1cfe238668275d1c')), 'button-loading', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var item, userCheck, packagingObject, packagingList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function testMode() {
  if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'tim@meadowfarms.com') {
    console.log('logged in at Tim test mode');
    ___arguments.context.pageData['testMode'] = true;
    (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingShippoToken'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingShippoTestToken'));
  }
}

/**
 * Describe this function...
 */
async function pageDataSettings() {
  ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['OfficeAPIBaseURL', 'CurrentSeasonDatabase', 'APIKey', 'ShippingShippoToken', 'ShippingShippoTestToken', 'SmartyAPIKey', 'ShipppingDoNotShipImage', 'ShippingServiceIgnoreList', 'ShippingRateListLimit', 'ShippingCarriers', 'ShippingRateSortBy', 'ShippingAddressMatchType', 'ShippingNoShipEmails', 'ShippingOutsideCompaniesList', 'ShippingCompaniesList'], ___arguments.context.appData));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingServiceIgnoreList'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingServiceIgnoreList')).toUpperCase().split(','));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingOutsideCompaniesList'] = (await Promise.all(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingOutsideCompaniesList')).split('|')).map(async item => {; return (JSON.parse(item));})));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['ShippingCompaniesList'] = (await Promise.all(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingCompaniesList')).split('|')).map(async item => {; return (JSON.parse(item));})));
  (getObjectProperty(___arguments.context.pageData, 'settings'))['distanceUnit'] = 'in';
  (getObjectProperty(___arguments.context.pageData, 'settings'))['massUnit'] = 'lb';
}

/**
 * Describe this function...
 */
async function pageDataObjects() {
  ___arguments.context.pageData['requireValidAddress'] = true;
  ___arguments.context.pageData['reviewBeforeTransaction'] = true;
  ___arguments.context.pageData['scaleConnected'] = false;
  ___arguments.context.pageData['testMode'] = false;
  ___arguments.context.pageData['createShipmentSpinnerVisible'] = false;
  ___arguments.context.pageData['addressToSpinnerVisible'] = true;
  ___arguments.context.pageData['createShipmentRunning'] = false;
  ___arguments.context.pageData['error'] = '';
  ___arguments.context.pageData['scaleWeight'] = '';
  ___arguments.context.pageData['scaleName'] = '';
  ___arguments.context.pageData['weightReturnZero'] = false;
  ___arguments.context.pageData['lastLabelURL'] = '';
  ___arguments.context.pageData['lastLogId'] = '';
  ___arguments.context.pageData['loggedInUser'] = (((await Backendless.UserService.getCurrentUser(false)) === null) ? '' : (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'FirstName')));
  ___arguments.context.pageData['modalVisible'] = ({ [`modalScan`]: false,[`modalScale`]: false,[`modalBox`]: false,[`modalError`]: false,[`modalProcessing`]: false });
  ___arguments.context.pageData['objectsToClear'] = ['addressToOriginal', 'addressTo', 'addressFrom', 'addressReturn', 'parcel', 'shipment'];
}

/**
 * Describe this function...
 */
async function pageDataShipmentObjects() {
  ___arguments.context.pageData['shipment'] = ({ [`selectedRate`]: '',[`rates`]: '',[`ratesAll`]: '',[`rawRatesAll`]: '',[`logId`]: '',[`labelURL`]: '',[`shipmentCreated`]: '',[`dimensionsEntered`]: '',[`boxItemNumber`]: '',[`boxLabel`]: '',[`packageBarcode`]: '',[`addressValid`]: '',[`smartyIsResidential`]: '',[`reference1`]: '',[`companyId`]: '',[`excludeUSPS`]: '',[`multipackageShipmentCount`]: '',[`multipackageShipmentLast`]: '',[`overweightAlert`]: '',[`smartyAddressChecked`]: '',[`smartyAddressMessage`]: '',[`notifyOfficeSource`]: '' });
  ___arguments.context.pageData['addressToOriginal'] = ({ [`name`]: '',[`company`]: '',[`address1`]: '',[`address2`]: '',[`city`]: '',[`state`]: '',[`zip`]: '',[`country`]: '',[`phone`]: '',[`email`]: '' });
  ___arguments.context.pageData['addressTo'] = ({ [`name`]: '',[`company`]: '',[`address1`]: '',[`address2`]: '',[`city`]: '',[`state`]: '',[`zip`]: '',[`country`]: '',[`phone`]: '',[`email`]: '' });
  ___arguments.context.pageData['addressReturn'] = ({ [`name`]: '',[`company`]: '',[`address1`]: '',[`address2`]: '',[`city`]: '',[`state`]: '',[`zip`]: '',[`country`]: '',[`phone`]: '',[`email`]: '',[`companyId`]: '' });
  ___arguments.context.pageData['addressFrom'] = ({ [`name`]: '',[`company`]: '',[`address1`]: '',[`address2`]: '',[`city`]: '',[`state`]: '',[`zip`]: '',[`country`]: '',[`phone`]: '',[`email`]: '',[`companyId`]: '' });
  ___arguments.context.pageData['parcel'] = ({ [`length`]: '',[`width`]: '',[`height`]: '',[`distance_unit`]: '',[`weight`]: '',[`mass_unit`]: '',[`metadata`]: '' });
}

/**
 * Describe this function...
 */
async function pageDataPackaging() {
  ___arguments.context.pageData['packaging'] = ({  });
  packagingList = (await Backendless.Data.of('Packaging').find(Backendless.DataQueryBuilder.create().setProperties(['Name', 'Barcode', 'Length', 'Width', 'Height']).setPageSize(100)));
  for (var packagingObject_index in packagingList) {
    packagingObject = packagingList[packagingObject_index];
    (getObjectProperty(___arguments.context.pageData, 'packaging'))[(getObjectProperty(packagingObject, 'Barcode'))] = ({ [`name`]: (getObjectProperty(packagingObject, 'Name')),[`length`]: (getObjectProperty(packagingObject, 'Length')),[`width`]: (getObjectProperty(packagingObject, 'Width')),[`height`]: (getObjectProperty(packagingObject, 'Height')) });
  }
}


  ___arguments.context.pageData['pageReady'] = false;
  await pageDataObjects();
  await pageDataShipmentObjects();
  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c']('shippingMain2'));
  if (typeof userCheck === 'undefined') {
    return ;
  }
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    await pageDataSettings();
    await pageDataPackaging();
    await testMode();
    await (async function() {
    	await BackendlessUI.requireModule('https://meadowfarms.com/tools/test/BrowserPrint-3.1.250.min.js');
    })();
    await (async function() {
    	var selected_device;
    	var devices = [];
    	function setup()
    	{
    		//Get the default device from the application as a first step. Discovery takes longer to complete.
    		BrowserPrint.getDefaultDevice("printer", function(device)
    				{
    			
    					//Add device to list of devices and to html select element
    					selected_device = device;
    					devices.push(device);
    					var html_select = document.getElementById("selected_device");
    					var option = document.createElement("option");
    					option.text = device.name;
    					html_select.add(option);
    					
    					//Discover any other devices available to the application
    					BrowserPrint.getLocalDevices(function(device_list){
    						for(var i = 0; i < device_list.length; i++)
    						{
    							//Add device to list of devices and to html select element
    							var device = device_list[i];
    							if(!selected_device || device.uid != selected_device.uid)
    							{
    								devices.push(device);
    								var option = document.createElement("option");
    								option.text = device.name;
    								option.value = device.uid;
    								html_select.add(option);
    							}
    						}
    						
    					}, function(){alert("Error getting local devices")},"printer");
    					
    				}, function(error){
    					alert(error);
    				})
    	}
    	function getConfig(){
    		BrowserPrint.getApplicationConfiguration(function(config){
    			alert(JSON.stringify(config))
    		}, function(error){
    			alert(JSON.stringify(new BrowserPrint.ApplicationConfiguration()));
    		})
    	}
    	function writeToSelectedPrinter(dataToWrite)
    	{
    		selected_device.send(dataToWrite, undefined, errorCallback);
    	}
    	var readCallback = function(readData) {
    		if(readData === undefined || readData === null || readData === "")
    		{
    			alert("No Response from Device");
    		}
    		else
    		{
    			alert(readData);
    		}
    		
    	}
    	var errorCallback = function(errorMessage){
    		alert("Error: " + errorMessage);	
    	}
    	function readFromSelectedPrinter()
    	{
    	
    		selected_device.read(readCallback, errorCallback);
    		
    	}
    	function getDeviceCallback(deviceList)
    	{
    		alert("Devices: \n" + JSON.stringify(deviceList, null, 4))
    	}
    	
    	function sendImage(imageUrl)
    	{
    		url = window.location.href.substring(0, window.location.href.lastIndexOf("/"));
    		url = url + "/" + imageUrl;
    		selected_device.convertAndSendFile(url, undefined, errorCallback)
    	}
    	function sendFile(fileUrl){
    	    //url = window.location.href.substring(0, window.location.href.lastIndexOf("/"));
    	    //url = url + "/" + fileUrl;
    		url = fileUrl;
    	    selected_device.sendFile(url, undefined, errorCallback)
    	}
    	function onDeviceSelected(selected)
    	{
    		for(var i = 0; i < devices.length; ++i){
    			if(selected.value == devices[i].uid)
    			{
    				selected_device = devices[i];
    				return;
    			}
    		}
    	}
    	
    	setup();
    	window.sendFile = sendFile;
    })();
    await (async function(pageData) {
    	/*
    	if (onScan.isAttachedTo(document) == false) {
    	     onScan.attachTo(document, {
    	       onScan: function(sCode, iQty) {
    	                //console.log('here');
    	                BackendlessUI.Functions.call('shippingScanCapture2', pageData, sCode) // the function id is: "d7dba626720f7c95a53501533f7ffcbe"

    	       }
    	    });
    	}
    	*/


    	onScan.attachTo(document, {
    	  minLength: 4,
    	  onScan: function(sCode, iQty) {
    	      //console.log('sCode '+ sCode);
    	      BackendlessUI.Functions.call('shippingScanCapture2', sCode, pageData) // the function id is: "d7dba626720f7c95a53501533f7ffcbe"
    	  },
    	  keyCodeMapper: function(oEvent) {
    		  // Look for special keycodes or other event properties specific to keyscanner
    		  if (oEvent.which == '192') {
    			  return '~';
    		  }
    		  // Fall back to the default decoder in all other cases
    		  return onScan.decodeKeyEvent(oEvent);
    	  },
    	  onScanError: function(oDebug) {
    	   console.log(oDebug);
    	  }
    	});
    })(___arguments.context.pageData);
    if ((getObjectProperty(___arguments.context.pageData, 'scaleConnected')) == false) {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Connect Scale',[`html`]: 'Click "Connect" and select PS60 or BCA-222- from list of devices',[`icon`]: 'info',[`confirmButtonText`]: 'Connect',[`showCancelButton`]: false }), (await (async function(pageData) {
      	const foo = (result) => {
      	  if (result.value) {
      		let connectedDevices = [];
      		let selectedDevice = null;
      	
      		const connectDevice = () => {
      			navigator.hid.requestDevice({filters:[]}).then(devices => {
      				if (devices.length == 0)
      				return;
      	
      			for (let device of devices)
      			  addDevice(device);
      		  });
      		};
      	
      		// Adds |device| to |connectedDevices|. Selects the device if there was no prior
      		// selection.
      		const addDevice = device => {
      		  if (connectedDevices.includes(device)) {
      			//console.log('device already in connectedDevices');
      		  } else {
      			connectedDevices.push(device);
      			//console.log('device connected: ' + device.productName);
      		  }
      		  
      		  //let scaleText = document.querySelector(".scaleText");
      		  //console.log(scaleText);
      		  if (device !== null) {
      			pageData.scaleName = device.productName;
      			pageData.scaleConnected = true;
      			device.oninputreport = handleInputReport;
      			
      			if (!device.opened) 
      			  device.open();
      		   
      		  }
      		};
      	
      		// Removes |device| from |connectedDevices|.
      		const removeDevice = device => {
      		  if (device === selectedDevice)
      			selectedDevice = null;
      		  for (let i = connectedDevices.length - 1; i >= 0; --i) {
      			if (connectedDevices[i] === device) {
      			  connectedDevices.splice(i, 1);
      			  console.log('device disconnected: ' + device.productName);
      			  updateDeviceMenu();
      			}
      		  }
      		};
      	
      		const handleInputReport = event => {
      			//const inputReportTextView = document.querySelector(".scaleValue");
      		  //if (!inputReportTextView)
      		  //	return;
      	
      		  const reportData = new Uint8Array(event.data.buffer); //** original
      	
      			//inputReportTextView.innerHTML = (reportData[3] + (256 * reportData[4])) * 0.01;
      			pageData.scaleWeight = Math.round(((reportData[3] + (256 * reportData[4])) * 0.01) * 10) / 10;
      		}
      	
      		connectDevice();
      			
      			
      	  }
      	};
      	
      	return foo;
      })(___arguments.context.pageData)));
    }
    ___arguments.context.pageData['pageReady'] = true;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sellerDashboard', undefined);
  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/shippingMain2/components/8a4366d416b762b7db4ad6caf3880bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      ___arguments.context.pageData['multipackageShipment'] = false;
  await BackendlessUI.Functions.Custom['fn_1c34361e2c6c3575779be479e68770c4'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/263de7fccddddcca5127adeb04848b76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/e843cfe3408355afcac782a42cbc42d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/e10d423ed644f62c0c79d9f6783ba031/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    classesList = ['modal'];
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalScan')) {
      addItemToList(classesList, 'open');
    }
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
      (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onVisibilityChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageReady')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalScan')) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/13d91b64ee28be62d688356a677d67ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var retrievedAddress, changedValue, element, response, error, shipmentObject, shippingCompany, item, shipmentObjectKey, shipmentList, counter, timer;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getShipmetnDetails2() {
  response = false;
  shipmentList = [];
  counter = 0;
  timer = ((new Date()).valueOf());
  for (var count = 0; count < 3; count++) {
    counter = (typeof counter == 'number' ? counter : 0) + 1;
    try {
      shipmentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogid?logid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'APIKey')) })).setEncoding('utf8').send());
      break;

    } catch (error) {
      if (counter > 1) {
        await Backendless.Messaging.sendEmail((String('modalScanInput Function - Error getting shipment details from Tim\'s shipping endpoint for logid: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,'We tried this many times so far: ',counter,'This was the path: ',[(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogid?logid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      }
      await new Promise(r => setTimeout(r, (100 * counter) || 0));

    }
  }
  if (shipmentList.length == 0) {
    counter = 0;
    for (var count2 = 0; count2 < 3; count2++) {
      try {
        counter = (typeof counter == 'number' ? counter : 0) + 1;
        shipmentList = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/shipping/getshippingdetailsbylogidmark?logid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')),'&seasondb=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'APIKey')),[`Content-type`]: 'application/json' })).setEncoding('utf8').send());
        break;

      } catch (error) {
        await Backendless.Messaging.sendEmail((String('modalScanInput Function - Error getting shipment details for logid: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' We tried this many times: ',counter].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        await new Promise(r => setTimeout(r, 100 || 0));

      }
    }
  }
  try {
    if (shipmentList.length == 1) {
      response = true;
      shipmentObject = shipmentList[0];
      var shipmentObjectKey_list = (Object.keys(shipmentObject));
      for (var shipmentObjectKey_index in shipmentObjectKey_list) {
        shipmentObjectKey = shipmentObjectKey_list[shipmentObjectKey_index];
        if ((getObjectProperty(shipmentObject, shipmentObjectKey)) === null) {
          shipmentObject[shipmentObjectKey] = '';
        }
      }
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['name'] = ((getObjectProperty(shipmentObject, 'To_Attn')).trim().length > 0 ? (getObjectProperty(shipmentObject, 'To_Attn')).trim() : (getObjectProperty(shipmentObject, 'To_Name')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['company'] = ((getObjectProperty(shipmentObject, 'To_Attn')).trim().length > 0 ? (getObjectProperty(shipmentObject, 'To_Name')).trim() : ' ');
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['address1'] = ((getObjectProperty(shipmentObject, 'To_Address')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['address2'] = ' ';
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['city'] = ((getObjectProperty(shipmentObject, 'To_City')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['state'] = ((getObjectProperty(shipmentObject, 'To_State')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['zip'] = ((getObjectProperty(shipmentObject, 'To_Zip')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['country'] = 'US';
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['phone'] = ((getObjectProperty(shipmentObject, 'To_Phone')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressToOriginal'))['email'] = ((getObjectProperty(shipmentObject, 'To_Email')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['company'] = ((getObjectProperty(shipmentObject, 'From_Name')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['address1'] = ((getObjectProperty(shipmentObject, 'From_Address')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['city'] = ((getObjectProperty(shipmentObject, 'From_City')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['state'] = ((getObjectProperty(shipmentObject, 'From_State')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['zip'] = ((getObjectProperty(shipmentObject, 'From_Zip')).trim());
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['country'] = 'US';
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['phone'] = ((getObjectProperty(shipmentObject, 'From_Phone')).trim().length > 0 ? (getObjectProperty(shipmentObject, 'From_Phone')).trim() : '800-886-7895');
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['companyId'] = ((getObjectProperty(shipmentObject, 'CompanyID')).trim());
      shippingCompany = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShippingCompaniesList')), async (item) => {


       return ((getObjectProperty(shipmentObject, 'CompanyID')) == (getObjectProperty(item, 'CompanyId')));
      }));
      (getObjectProperty(___arguments.context.pageData, 'addressFrom'))['email'] = (shippingCompany.length == 1 ? (getObjectProperty((shippingCompany[0]), 'Email')) : '');
      (getObjectProperty(___arguments.context.pageData, 'parcel'))['metadata'] = ((getObjectProperty(shipmentObject, 'Ref1')).trim());
      (getObjectProperty(___arguments.context.pageData, 'shipment'))['companyId'] = ((getObjectProperty(shipmentObject, 'CompanyID')).trim());
    }

  } catch (error) {
    response = false;
    await Backendless.Messaging.sendEmail((String('modalScanInput Function - getAddress - Error getting address for logid: ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId'))), new Backendless.Bodyparts({ textmessage: (String('This was the error: ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  return response
}


  stopSetTimeout('modalScanInput');

  ;(function() {
    const callback = async () => {
        changedValue = ___arguments.value;
    if (changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'startCharacter')) + 1 > 0 && changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'endCharacter')) + 1 > 0) {
      changedValue = String(changedValue.slice(0, (changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'startCharacter')) + 1) - 1)) + String(changedValue.slice(((changedValue.indexOf(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'endCharacter')) + 1 + 1) - 1), changedValue.length));
    }
    (getObjectProperty(___arguments.context.pageData, 'shipment'))['logId'] = (changedValue == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'endCharacter')) ? '' : changedValue);
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'logId')).length == 8) {
      ___arguments.context.pageData['shipmentStartTime'] = ((new Date()).valueOf());
      ___arguments.context.pageData['addressToOriginalSpinnerVisible'] = true;
      (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = false;
      (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = true;
      retrievedAddress = false;
      retrievedAddress = await getShipmetnDetails2();
      if (retrievedAddress) {
        await BackendlessUI.Functions.Custom['fn_af325e4a22a2b4daac665665a4a282f4'](___arguments.context.pageData, 'scan');
      } else {
        (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = false;
        ___arguments.context.pageData['error'] = 'No address available from Mark\'s system.';
        (getObjectProperty(___arguments.context.pageData, 'shipment'))['logId'] = '';
        (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalScan'] = true;
        (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));
        ___arguments.context.pageData['addressToOriginalSpinnerVisible'] = false;
        return ;
      }
      ___arguments.context.pageData['addressToOriginalSpinnerVisible'] = false;
      await BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'](___arguments.context.pageData);
      console.log(String('modalScanInput elapsed time: ') + String(((new Date()).valueOf()) - (getObjectProperty(___arguments.context.pageData, 'shipmentStartTime'))));
    }

    };

    const timerId = 'modalScanInput';
    const timerDelay = 350;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain2/components/34da05f5c44d48e783c36d543a119bb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    classesList = ['modal'];
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalBox')) {
      addItemToList(classesList, 'open');
    }
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageReady')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalBox')) : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/a9019758a63e7bb185afc29a017b17b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/c197795353e8d9be6952dd33592c2ae5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'modalVisible'))['modalBox'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/855c5518ba0fe0ac0b76973b3272a666/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/check.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'addressValid'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/1099cd12ccb514e6a819bc7a84c2d75d/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/delete.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'addressValid')) === 'boolean') {
    isVisible = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'addressValid')) ? false : true;
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/0e71e48fd3c55f7c6a61c9d386131ad9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['modalBoxInput'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain2/components/ba09447c2723a434982bd07153cb4145/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'rates'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/9a493a829d7bf042627dc3fc8dd4a1eb/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.dataModel, 'objectId'))

  },
  /* handler:onValueAssignment */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.dataModel, 'carrier')),' ',(getObjectProperty(___arguments.context.dataModel, 'service')),' ',(getObjectProperty(___arguments.context.dataModel, 'speed')),' days',' - $',(getObjectProperty(___arguments.context.dataModel, 'amount'))].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'selectedRate'))

  },
  /* handler:onCheckedValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'shipment'))['selectedRate'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'reviewBeforeTransaction')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/0aed12149f2719bf490c6044382d1283/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_1a06d341212e70cfc5fa381bd1711dba'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'shipmentCreated')) ? false : true)

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/c4bbb288b24e131efb48ba49b556b123/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var addressSourceProperty;


  await BackendlessUI.Functions.Custom['fn_498e95b477d71882ffbc8bde233ec06c'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressChecked')) == !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/c40b7c8321a1655b3fddd68f85da6ee5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('Current User: ') + String(getObjectProperty(___arguments.context.pageData, 'loggedInUser')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/f12a3eef7119e54ea7287bd4b3b814f1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'testMode'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/9abc9523288191727422f9e437bd0293/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'addressValid'))) == 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return (String('https://cdn.meadowfarms.com/images/icons/question.png') + String('?w=30'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/0836c4dc6dd127a707a414d680f11751/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    if ((getObjectProperty(___arguments.context.pageData, 'error')).length == 0) {
      isVisible = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalProcessing'));
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'pageReady')) {
    classesList = ['modal'];
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalVisible')), 'modalProcessing')) {
      addItemToList(classesList, 'open');
    }
  }

  return classesList

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/53df73a66f06dbb59db3ee87a251f786/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'pageReady'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/3c88030892f8b9538a3cef1600e14c76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var alertText, stat, statsList, list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c88030892f8b9538a3cef1600e14c76')), 'button-loading');
  statsList = (await Backendless.Request.get(`${Backendless.appPath}/services/shipping/shippingdailysummary`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  if (statsList.length > 0) {
    alertText = '';
    for (var stat_index in statsList) {
      stat = statsList[stat_index];
      alertText = String(alertText) + String(['<tr>',['<td>',(getObjectProperty(stat, 'Value')),'</td>'].join(''),['<td>',(getObjectProperty(stat, 'Count')),'</td>'].join(''),'</tr>'].join(''));
    }
  } else {
    alertText = ['<tr>',['<td colspan=\'2\'>','NO RESULTS','</td>'].join(''),'</tr>'].join('');
  }
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Shipping Stats','html': ['<table style="width:100%">',['<thead>','<tr>',['<th style="width:50%">','Value','</th>'].join(''),['<th>','# of Shipments','</th>'].join(''),'</tr>','</thead>'].join(''),['<tbody>',alertText,'<tbody>'].join(''),'</table>'].join(''),'icon': 'info','confirmButtonText': 'Close','showCancelButton': false }), null);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3c88030892f8b9538a3cef1600e14c76')), 'button-loading', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/1aaa552588bf62245b5f93effc5f6849/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['multipackageShipment'] = ___arguments.value;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'multipackageShipment'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/dd084eb86aa82a4158d440b6bcc83742/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'multipackageShipment'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'shipment'))['multipackageShipmentLast'] = ___arguments.value;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0e71e48fd3c55f7c6a61c9d386131ad9')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'multipackageShipmentLast'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/1aafaf13a2a95939476d8fbc69ad865a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var isVisible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressChecked')) == true) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'smartyAddressValid')) == false) {
      if ((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'email')) == 'karen@meadowfarms.com') {
        isVisible = true;
      }
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'shipment'))['smartyAddressValid'] = true;
  await BackendlessUI.Functions.Custom['fn_d72658826cb28ac7b8c3a149ec378a78'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/864d72bfd8bb191438cd6296da7f8fea/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['reviewBeforeTransaction'] = ___arguments.value;
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'reviewBeforeTransaction'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/daf249abf76c5f4303ce42e41df23881/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['addressValidationMatchType'] = (___arguments.value == true ? 'enhanced' : 'invalid');
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('13d91b64ee28be62d688356a677d67ae')));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'addressValidationMatchType')) == 'enhanced' ? true : false)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/ab77922dc5f77c79836561026cfccb16/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'company')).length > 0 ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'company')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'name'))) + String('<br>'),(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'company')).length > 0 ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'name')) + String('<br>') : '',String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address1')) + String('<br>'),(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address2')).length > 0 ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'address2')) + String('<br>') : null,[(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'city')),', ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'state')),' ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'addressTo')), 'zip'))].join('')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/090d27bb71ef7bb3cc6789de67147814/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'multipackageShipment'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/c7fbf2f36c96a47c1cfe238668275d1c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var alertText, label, labelList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c7fbf2f36c96a47c1cfe238668275d1c')), 'button-loading');
  labelList = (await Backendless.Request.get(`${Backendless.appPath}/services/shipping/shippinglabels`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  if (labelList.length > 0) {
    alertText = '';
    for (var label_index in labelList) {
      label = labelList[label_index];
      alertText = String(alertText) + String(['<tr>',['<td style="padding:5px; border-bottom:1px solid;">',[(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'name')),'<br>',(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'address1')),'<br>',[(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'city')),', ',(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'state')),' ',(getObjectProperty((getObjectProperty(label, 'AddressTo')), 'zip'))].join('')].join(''),'</td>'].join(''),['<td style="padding:5px; border-bottom:1px solid;">',[['<button type="button"',' class="MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained"',' onclick="sendFile(\'',(getObjectProperty(label, 'LabelURL')),'\')">'].join(''),'Print Label','</button>'].join(''),'</td>'].join(''),'</tr>'].join(''));
    }
  } else {
    alertText = ['<tr>',['<td colspan=\'2\'>','NO RESULTS','</td>'].join(''),'</tr>'].join('');
  }
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Last 5 Shipping Labels',[`html`]: ['<table style="width:100%">',['<thead>','<tr>',['<th style="width:50%;padding:5px; border-bottom:1px solid;">','Address','</th>'].join(''),['<th style="padding:5px; border-bottom:1px solid;">','Label','</th>'].join(''),'</tr>','</thead>'].join(''),['<tbody>',alertText,'<tbody>'].join(''),'</table>'].join(''),[`icon`]: 'info',[`confirmButtonText`]: 'Close',[`showCancelButton`]: false }), null);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c7fbf2f36c96a47c1cfe238668275d1c')), 'button-loading', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/a45283cca3120527a5176ef43a3fef78/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  return2 = 'Waiting for address scan....';
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'addressTo.name'))) > 0) {
    return2 = [(getObjectProperty(___arguments.context.pageData, 'addressTo.name')),getValueLength((getObjectProperty(___arguments.context.pageData, 'addressTo.company'))) > 0 ? String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressTo.company')) : '',String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressTo.address1')),getValueLength((getObjectProperty(___arguments.context.pageData, 'addressTo.address2'))) > 0 ? String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressTo.address2')) : '',[String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressTo.city')),', ',(getObjectProperty(___arguments.context.pageData, 'addressTo.state')),' ',(getObjectProperty(___arguments.context.pageData, 'addressTo.zip'))].join(''),String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressTo.phone')),String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressTo.email'))].join('');
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/93a9ae1fa59f1de86c293cba58930b22/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var return2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  return2 = 'Waiting for address scan....';
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'addressReturn.address1'))) > 0) {
    return2 = [(getObjectProperty(___arguments.context.pageData, 'addressReturn.name')),getValueLength((getObjectProperty(___arguments.context.pageData, 'addressReturn.company'))) > 0 ? String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressReturn.company')) : '',String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressReturn.address1')),getValueLength((getObjectProperty(___arguments.context.pageData, 'addressReturn.address2'))) > 0 ? String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressReturn.address2')) : '',[String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressReturn.city')),', ',(getObjectProperty(___arguments.context.pageData, 'addressReturn.state')),' ',(getObjectProperty(___arguments.context.pageData, 'addressReturn.zip'))].join(''),String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressReturn.phone')),String('<br>') + String(getObjectProperty(___arguments.context.pageData, 'addressReturn.email'))].join('');
  }

  return return2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/53af4fdfac020d95c144055942f7263b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'overweightAlert')) != true) {
    if ((Number((getObjectProperty(___arguments.context.pageData, 'scaleWeight')))) == 0) {
      ___arguments.context.pageData['weightReturnZero'] = true;
    }
    stopSetTimeout('weight');

    ;(function() {
      const callback = async () => {
          if ((Number((getObjectProperty(___arguments.context.pageData, 'scaleWeight')))) > 50) {
        (getObjectProperty(___arguments.context.pageData, 'shipment'))['overweightAlert'] = true;
        await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Overweight Package',[`text`]: 'This package is over 50lbs!',[`icon`]: 'error',[`confirmButtonText`]: 'Close',[`showCancelButton`]: false }), null);
      } else if ((Number((getObjectProperty(___arguments.context.pageData, 'scaleWeight')))) == 0) {
        (getObjectProperty(___arguments.context.pageData, 'shipment'))['overweightAlert'] = '';
      } else {
        await BackendlessUI.Functions.Custom['fn_65f8914503da6a18a29e96f6c91d8511'](___arguments.context.pageData, null);
      }

      };

      const timerId = 'weight';
      const timerDelay = 1000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  return ([String('<b>Weight:</b>') + String(getObjectProperty(___arguments.context.pageData, 'scaleWeight')),'<br><br>',String('<b>Box:</b>') + String(getValueLength((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'boxLabel'))) > 0 ? [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'shipment')), 'boxLabel')),' ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'parcel')), 'length')),' X ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'parcel')), 'width')),' X ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'parcel')), 'height'))].join('') : 'Waiting for box scan....')].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/9928e8a5397be7cda2183f1d03be87e6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['reviewBeforeTransaction'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/shippingMain2/components/879d95a444e5319e14fafc4363668441/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}



  return (getValueLength((getObjectProperty(___arguments.context.pageData, 'addressTo.address1'))) > 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/shippingMain2/components/ebdc9f531f3dbe3be72ebd2b90962ede/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var class2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  class2 = 'class="swal2-input"';
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Edit Address',[`html`]: ['<p style=\'text-align:left;\'>',[['<input id="address1"',[' value="',(getObjectProperty(___arguments.context.pageData, 'addressTo.address1')),'" '].join(''),class2,' >'].join(''),['<input id="address2"',[' value="',(getObjectProperty(___arguments.context.pageData, 'addressTo.address2')),'" '].join(''),class2,' >'].join(''),['<input id="city"',[' value="',(getObjectProperty(___arguments.context.pageData, 'addressTo.city')),'" '].join(''),class2,' >'].join(''),['<input id="state"',[' value="',(getObjectProperty(___arguments.context.pageData, 'addressTo.state')),'" '].join(''),class2,' >'].join(''),['<input id="zip"',[' value="',(getObjectProperty(___arguments.context.pageData, 'addressTo.zip')),'" '].join(''),class2,' >'].join('')].join(''),'</p>'].join(''),[`icon`]: 'question',[`confirmButtonText`]: 'Save',[`showDenyButton`]: true,[`denyButtonText`]: 'Cancel',[`timer`]: 45000 }), (await (async function(pageData) {
  	const foo = (result) => {

  	  if (result.isConfirmed) {
  	    pageData.addressTo.address1 = document.getElementById("address1").value;
  	    pageData.addressTo.address2 = document.getElementById("address2").value;
  	    pageData.addressTo.city = document.getElementById("city").value;
  	    pageData.addressTo.state = document.getElementById("state").value;
  	    pageData.addressTo.zip = document.getElementById("zip").value;
  	    pageData.shipment.shipmentCreated = false;
  	    //BackendlessUI.Functions.call('shippingCreateShipment3', pageData) // the function id is: "65f8914503da6a18a29e96f6c91d8511"
  	    BackendlessUI.Functions.call('shippingCreateShipment3', pageData, 'addressEditButton') // the function id is: "65f8914503da6a18a29e96f6c91d8511"
  	  }
  	};

  	return foo;
  })(___arguments.context.pageData)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/shippingMain2/components/57b5fc5d6e9e78034cb1cb76f639fc37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var class2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  class2 = 'class="swal2-input"';
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'LogId',[`html`]: ['<p style=\'text-align:left;\'>',['<input id="logid"',[' value="',(getObjectProperty(___arguments.context.pageData, 'shipment.logId')),'" '].join(''),class2,' >'].join(''),'</p>'].join(''),[`icon`]: 'question',[`confirmButtonText`]: 'Save',[`showDenyButton`]: true,[`denyButtonText`]: 'Cancel',[`timer`]: 45000 }), (await (async function(pageData) {
  	const foo = (result) => {

  	  if (result.isConfirmed) {
  	    //pageData.shipment.logId = document.getElementById("logid").value;
  	    //BackendlessUI.Functions.call('shippingCreateShipment3', pageData) // the function id is: "65f8914503da6a18a29e96f6c91d8511"
  	    var scanString = document.getElementById("logid").value + '\n';

  	    BackendlessUI.Functions.call('shippingScanCapture2', scanString.trim(), pageData, 'logIdTypeInAlert') // the function id is: "4435afc15c0863b196012c7dd9f85b62"
  	  }
  	};

  	return foo;
  })(___arguments.context.pageData)));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var settingKeys, organizationData, userCheck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setModalEdit() {
  ___arguments.context.pageData['isOpenModalEdit'] = false;
  ___arguments.context.pageData['formFundraiserId'] = '';
  ___arguments.context.pageData['formPhoto'] = '';
  ___arguments.context.pageData['formMessage'] = '';
  ___arguments.context.pageData['formMessageError'] = false;
  ___arguments.context.pageData['isDisabledModalEditSubmitButton'] = false;
}

/**
 * Describe this function...
 */
async function setModalOrders() {
  ___arguments.context.pageData['isOpenModalOrders'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersPrintButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersPDFButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersCSVButton'] = false;
}

/**
 * Describe this function...
 */
async function setModalRaffle() {
  ___arguments.context.pageData['isDisabledModalRaffleGenerateButton'] = false;
}


  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Sponsor', ___arguments.context.appData))) {
    ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['SponsorDashboardPageSize', 'StoreBaseURL', 'cdnURL', 'OrganizationAvatarDefault', 'ShareSuccessEmailMessage', 'ShareSuccessTextMessage', 'CurrentSeasonDatabase'], ___arguments.context.appData));
    ___arguments.context.pageData['organizationData'] = null;
    ___arguments.context.pageData['currentFundraiserId'] = '';
    ___arguments.context.pageData['currentFundraiserName'] = '';
    ___arguments.context.pageData['currentFundraiserDates'] = '';
    ___arguments.context.pageData['isNoresults'] = false;
    ___arguments.context.pageData['isLoader'] = true;
    await setModalOrders();
    await setModalEdit();
    await setModalRaffle();
    await (async function() {
    	await BackendlessUI.requireModule('https://cdn.crop.guide/loader/l.js?c=NHKLMH');
    })();
    await (async function() {
    	await BackendlessUI.requireModule('https://printjs-4de6.kxcdn.com/print.min.js');
    })();
    if (getObjectProperty(___arguments.context.pageData, 'message')) {
      if ((getObjectProperty(___arguments.context.pageData, 'message')) == 'email') {
        ___arguments.context.pageData['isRuMessageShow'] = true;
        ___arguments.context.pageData['ruMessageText'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSuccessEmailMessage'));
      }
      if ((getObjectProperty(___arguments.context.pageData, 'message')) == 'text') {
        ___arguments.context.pageData['isRuMessageShow'] = true;
        ___arguments.context.pageData['ruMessageText'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSuccessTextMessage'));
      }
    }
    if (!(getObjectProperty(___arguments.context.appData, 'organizationDataList')) || !(getObjectProperty(___arguments.context.appData, 'organizationDataList')).length) {
      ___arguments.context.appData['organizationDataList'] = [(await Backendless.Request.get(`${Backendless.appPath}/services/organization/getfundraisers`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send())];
    }
    organizationData = (getObjectProperty(___arguments.context.appData, 'organizationDataList'))[0];
    ___arguments.context.pageData['pageCount'] = (getObjectProperty(organizationData, 'pageCount'));
    ___arguments.context.pageData['currentPage'] = (getObjectProperty(organizationData, 'currentPage'));
    ___arguments.context.pageData['isLoader'] = false;
    ___arguments.context.pageData['isPagination'] = true;
    if (!(getObjectProperty(organizationData, 'fundraiserList')).length) {
      ___arguments.context.pageData['isNoresults'] = true;
      ___arguments.context.pageData['organizationData'] = [];
    } else {
      ___arguments.context.pageData['organizationData'] = (getObjectProperty(organizationData, 'fundraiserList'));
    }
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sponsorDashboard/components/c81d636bf6f6b1b9d26bb5cc67ccc153/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__noresults'];
  if (getObjectProperty(___arguments.context.pageData, 'isNoresults')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/6f72b42171cb5983c9144d4290f533e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__loader'];
  if (getObjectProperty(___arguments.context.pageData, 'isLoader')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/3081b931e9788beef78dfa199dcd230d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalOrders'] = false;
  ___arguments.context.pageData['currentFundraiserId'] = '';
  ___arguments.context.pageData['currentFundraiserName'] = '';
  ___arguments.context.pageData['currentFundraiserDates'] = '';
  ___arguments.context.pageData['currentSellers'] = ({  });
  delete ___arguments.context.pageData['sortByStudentName'];
  delete ___arguments.context.pageData['sortByTeacherName'];
  delete ___arguments.context.pageData['sortByItemCount'];
  delete ___arguments.context.pageData['sortBySalesTotal'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/c16dd853efea649b1c2408357b7ab83d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalOrders'] = false;
  ___arguments.context.pageData['currentFundraiserId'] = '';
  ___arguments.context.pageData['currentFundraiserName'] = '';
  ___arguments.context.pageData['currentFundraiserDates'] = '';
  ___arguments.context.pageData['currentSellers'] = ({  });
  delete ___arguments.context.pageData['sortByStudentName'];
  delete ___arguments.context.pageData['sortByTeacherName'];
  delete ___arguments.context.pageData['sortByItemCount'];
  delete ___arguments.context.pageData['sortBySalesTotal'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/623a0ef1f525858cf7bbc82650bed98d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__modal-orders'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModalOrders')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/29d2c9eecee1c944e1eb554afaceb8df/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')) {
    content2 = (getObjectProperty(___arguments.context.pageData, 'currentFundraiserName'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/e8ff3fa58e06aab13cd5db374d22baee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (getObjectProperty(___arguments.context.pageData, 'currentFundraiserStartDate')) {
    content2 = ['Fundraising dates: ',(getObjectProperty(___arguments.context.pageData, 'currentFundraiserStartDate')),' - ',(getObjectProperty(___arguments.context.pageData, 'currentFundraiserEndDate'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/d8521e4e32f517dbb9f5f75397047867/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalEdit'] = false;
  ___arguments.context.pageData['formFundraiserId'] = '';
  ___arguments.context.pageData['formPhoto'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['formMessage'] = '';
  ___arguments.context.pageData['formMessageError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/8cead4b11ffe743478d544fd8c065614/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalEdit'] = false;
  ___arguments.context.pageData['formFundraiserId'] = '';
  ___arguments.context.pageData['formPhoto'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['formMessage'] = '';
  ___arguments.context.pageData['formMessageError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/cdd49e2e3fefb7dafcf1b2a5cee40b7b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.pageData['isOpenModalEdit'] = false;
  if (getObjectProperty(___arguments.context.pageData, 'uploadedFile')) {
    await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.pageData, 'uploadedFile'))));
  }
  ___arguments.context.pageData['formFundraiserId'] = '';
  ___arguments.context.pageData['formPhoto'] = '';
  ___arguments.context.pageData['photoChanged'] = '';
  ___arguments.context.pageData['uploadedFile'] = '';
  ___arguments.context.pageData['formMessage'] = '';
  ___arguments.context.pageData['formMessageError'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/c6980a96051e5e65f61da76d7073f353/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__modal-edit'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModalEdit')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/5ea7a0738fdb41213cb6bbe5a26aa1ae/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['formMessageError'] = false;
  ___arguments.context.pageData['formMessage'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formMessage'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/ffbebb77a1b1ba8e9ab321cb6802742d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, saveResult, dataObject, update;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledModalEditSubmitButton'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ffbebb77a1b1ba8e9ab321cb6802742d')), 'button-loading');
  if ((getObjectProperty(___arguments.context.pageData, 'formMessage')) == '' || (getObjectProperty(___arguments.context.pageData, 'formMessage')) == null) {
    ___arguments.context.pageData['formMessageError'] = true;
  } else {
    update = false;
    dataObject = ({ 'orgObjectId': (getObjectProperty(___arguments.context.pageData, 'formOrganizationId')) });
    if ((getObjectProperty(___arguments.context.pageData, 'formMessage')).length > 0) {
      update = true;
      dataObject['message'] = (getObjectProperty(___arguments.context.pageData, 'formMessage'));
    }
    if (getObjectProperty(___arguments.context.pageData, 'photoChanged')) {
      update = true;
      dataObject['formPhoto'] = (getObjectProperty(___arguments.context.pageData, 'formPhoto'));
    }
    if (update) {
      saveResult = (await Backendless.Request.put(`${Backendless.appPath}/services/organization/update_fundraiser`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'fundraiserId': (getObjectProperty(___arguments.context.pageData, 'formFundraiserId')),'data': dataObject }));
    }
    if (saveResult) {
      ___arguments.context.pageData['organizationData'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'organizationData')).map(async item => {  if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'formFundraiserId'))) {
          item['AppealMessage'] = (getObjectProperty(___arguments.context.pageData, 'formMessage'));
          item['OrgProfileImage'] = (getObjectProperty(___arguments.context.pageData, 'formPhoto'));
        }
      ; return item;})));
      ___arguments.context.appData['organizationDataList'] = (await Promise.all((getObjectProperty(___arguments.context.appData, 'organizationDataList')).map(async item => {  if ((getObjectProperty(item, 'currentPage')) == (getObjectProperty(___arguments.context.pageData, 'currentPage'))) {
          item['fundraiserList'] = (getObjectProperty(___arguments.context.pageData, 'organizationData'));
        }
      ; return item;})));
      ___arguments.context.pageData['isOpenModalEdit'] = false;
      ___arguments.context.pageData['formFundraiserId'] = '';
      ___arguments.context.pageData['formPhoto'] = '';
      ___arguments.context.pageData['photoChanged'] = '';
      ___arguments.context.pageData['uploadedFile'] = '';
      ___arguments.context.pageData['formMessage'] = '';
      ___arguments.context.pageData['formMessageError'] = false;
    }
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ffbebb77a1b1ba8e9ab321cb6802742d')), 'button-loading', '');
  ___arguments.context.pageData['isDisabledModalEditSubmitButton'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledModalEditSubmitButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/081163aae2e86547765f49f28d9fcec7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__modal-edit__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'formMessageError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/021b8dee797612a7c6714739d2ad9864/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/fc0e26feef73a1e21c8748fe1495ae2b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/edfc8c13233d357367989781bb279386/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgProfileImage')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgProfileImage')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OrganizationAvatarDefault')))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/b9ef484e31889054984b97553bf3e018/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgProfileImage')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgProfileImage')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OrganizationAvatarDefault')))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/1e8b75ad404d9fd7c93bc58ab8567704/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgMicrostorePath')))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgMicrostorePath'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/6653fec571b11642a248d64d99b139c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(toCopy) {
  	navigator.clipboard.writeText(toCopy);
  })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgMicrostorePath'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/6e726373baebab995d42305e5849d2f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sponsorShare', ({ 'type': 'email','fundraiserObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'objectId')),'currentPage': (getObjectProperty(___arguments.context.pageData, 'currentPage')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/424322549a1ad08632e4de17b61dc46d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sponsorShare', ({ 'type': 'cell','fundraiserObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'objectId')),'currentPage': (getObjectProperty(___arguments.context.pageData, 'currentPage')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/574bc5fcc8849d2f349e971fd1869061/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sponsorShare', ({ 'type': 'soc','fundraiserObjectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'objectId')),'currentPage': (getObjectProperty(___arguments.context.pageData, 'currentPage')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/112d8a3b845dc3e36f34197932548e89/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2StartDate')),' to ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2EndDate'))].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/81de6c59d24d0479b5ddfbf9310b521f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'AppealMessage')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'AppealMessage')) : ' ')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/2fc5a394c3c8f05515118a52e16afae1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('$') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrderGoal')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/45120d73ac22189efc5a0306b3e455e4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('$') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrderTotal')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/f73b3b969ce53b8f7d266be1d9030a62/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'FundraiserStats')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/25521682655c1a19a6bab6d575734462/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb88daa63cf28b4893c196eb0614c3e5'), 'value'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/eb83afa7d5dd1597465a5231fa4acea6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('eb88daa63cf28b4893c196eb0614c3e5'), 'label'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/b405c01180dd92d5a682bddf483310c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModalEdit'] = true;
  ___arguments.context.pageData['formFundraiserId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'objectId'));
  ___arguments.context.pageData['formOrganizationId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgObjectId'));
  ___arguments.context.pageData['formPhoto'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgProfileImage'));
  ___arguments.context.pageData['formMessage'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'AppealMessage'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/f95bdfebc2ebe1f7fd41b35ef6e8651e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/sponsorDashboard/components/439f62b363aa4efa196616f9df877b2b/bundle.js', [], () => ({
  /* content */
  /* handler:onPageChange */
  async ['onPageChange'](___arguments) {
    var fundraiserList, organizationData, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'organizationData')) && (getObjectProperty(___arguments.context.pageData, 'currentPage')) == ___arguments['currentPage'] || !(getObjectProperty(___arguments.context.pageData, 'currentPage')) || !((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('17b7db83aafe9391d70be71fcab6279b'))) {
    return ;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17b7db83aafe9391d70be71fcab6279b'))['display'] = 'none';
    ___arguments.context.pageData['isLoader'] = true;
    ___arguments.context.pageData['isPagination'] = false;
    organizationData = (getObjectProperty(___arguments.context.appData, 'organizationDataList')) ? (!!(getObjectProperty(___arguments.context.appData, 'organizationDataList')).length ? (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'organizationDataList')), async (item) => {


     return ((getObjectProperty(item, 'currentPage')) == ___arguments['currentPage']);
    }))[0] : null) : null;
    if (!organizationData) {
      organizationData = (await Backendless.Request.get(`${Backendless.appPath}/services/organization/getfundraisers`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageOffset': (___arguments['currentPage'] - 1) }).send());
      ___arguments.context.appData['organizationDataList'] = (addItemToList((getObjectProperty(___arguments.context.appData, 'organizationDataList')), organizationData));
    }
    ___arguments.context.pageData['isLoader'] = false;
    ___arguments.context.pageData['isPagination'] = true;
    ___arguments.context.pageData['currentPage'] = (getObjectProperty(organizationData, 'currentPage'));
    fundraiserList = (getObjectProperty(organizationData, 'fundraiserList'));
    if (fundraiserList) {
      ___arguments.context.pageData['organizationData'] = fundraiserList;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('17b7db83aafe9391d70be71fcab6279b'))['display'] = 'flex';
    } else {
      ___arguments.context.pageData['isNoresults'] = true;
      ___arguments.context.pageData['organizationData'] = [];
    }
  }

  },
  /* handler:onPageChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isPagination')) && (getObjectProperty(___arguments.context.pageData, 'pageCount')) > 1)

  },
  /* handler:onDisplayAssignment */
  /* handler:onGoNext */
  async ['onGoNext'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goNextPage() })('439f62b363aa4efa196616f9df877b2b');

  },
  /* handler:onGoNext */
  /* handler:onGoBack */
  async ['onGoBack'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goPreviousPage() })('439f62b363aa4efa196616f9df877b2b');

  },
  /* handler:onGoBack */
  /* handler:onGoFirst */
  async ['onGoFirst'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goFirstPage() })('439f62b363aa4efa196616f9df877b2b');

  },
  /* handler:onGoFirst */
  /* handler:onGoLast */
  async ['onGoLast'](___arguments) {
      await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).goLastPage() })('439f62b363aa4efa196616f9df877b2b');

  },
  /* handler:onGoLast */
  /* content */
}))

define('./pages/sponsorDashboard/components/fcc1dec8917c87e8ff7daf7b878ecdff/bundle.js', [], () => ({
  /* content */
  /* handler:labelsLogic */
  ['labelsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'chartData')), 'labels'))

  },
  /* handler:labelsLogic */
  /* handler:datasetsLogic */
  ['datasetsLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return [({ 'data': (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'chartData')), 'orderSum')),'borderColor': '#183F97','backgroundColor': 'rgba(0,174,239,0.7)' })]

  },
  /* handler:datasetsLogic */
  /* content */
}))

define('./pages/sponsorDashboard/components/cce1063150acdf183b85e7953b65f6d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__modal-edit__form-col'];
  if (getObjectProperty(___arguments.context.pageData, 'formMessageError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/857e0623756c3867adeb984ba5c96f2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisableUploadButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/d7b2626c3767212cb0cff9dc547588ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__modal-edit__form-croppie-wrap'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenCrop')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/e1477c0f7029890596bbc7a873e9a2bf/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__modal-edit__form-field-photo-wrap'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenCrop')) {
    addItemToList(classes, 'hide');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/5667f7892521808569b2d107dd0260e4/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUpload */
  ['onBeforeUpload'](___arguments) {
      ___arguments.context.pageData['isDisabledModalEditSubmitButton'] = true;
  ___arguments.context.pageData['formPhoto'] = 'https://cdn.meadowfarms.com/images/icons/loading-2.gif';

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var sirvAvatarURL, response, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('5667f7892521808569b2d107dd0260e4');
  sirvAvatarURL = '';
  response = (await Backendless.Request.get(`${Backendless.appPath}/services/utils/utils/upload_sirv_image`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'fileUrl': JSON.stringify(___arguments.uploadedFiles),'fileName': JSON.stringify((___arguments.uploadedFiles.split('/').slice(-1)[0])),'filePath': JSON.stringify((['/images/groups/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase')),'/'].join(''))) }).send());
  if (getObjectProperty(response, 'status')) {
    sirvAvatarURL = getValueLength((getObjectProperty(response, 'filePath'))) > 0 ? String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'cdnURL')) + String(getObjectProperty(response, 'filePath')) : '';
  }
  if (getValueLength(sirvAvatarURL) == 0) {
    ___arguments.context.pageData['uploadedFile'] = ___arguments.uploadedFiles;
    ___arguments.context.pageData['formPhoto'] = ___arguments.uploadedFiles;
    ___arguments.context.pageData['photoChanged'] = false;
  } else {
    await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));
    ___arguments.context.pageData['uploadedFile'] = sirvAvatarURL;
    ___arguments.context.pageData['formPhoto'] = sirvAvatarURL;
    ___arguments.context.pageData['photoChanged'] = true;
  }
  ___arguments.context.pageData['isDisableUploadButton'] = false;
  ___arguments.context.pageData['isDisabledModalEditSubmitButton'] = false;

  },
  /* handler:onUploadSuccess */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('5667f7892521808569b2d107dd0260e4');
  ___arguments.context.pageData['isDisabledModalEditSubmitButton'] = false;
  ___arguments.context.pageData['formPhoto'] = '';

  },
  /* handler:onUploadFail */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    var styles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  styles = ({  });
  if ((getObjectProperty(___arguments.context.pageData, 'formPhoto')) != '' && !((getObjectProperty(___arguments.context.pageData, 'formPhoto')) === null)) {
    styles['backgroundImage'] = (['url("',(getObjectProperty(___arguments.context.pageData, 'formPhoto')),'?w=200','")'].join(''));
  } else {
    styles['backgroundImage'] = (['url("','https://cdn.meadowfarms.com/images/icons/upload_photo.png','?w=200','")'].join(''));
  }

  return styles

  },
  /* handler:onStyleAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    var fileExtension;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  fileExtension = (getObjectProperty(___arguments.file, 'name')).split('.').slice(-1)[0];

  return ([((new Date()).valueOf()),'_',mathRandomInt(1, 1000),'.',fileExtension].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onSelectFiles */
  ['onSelectFiles'](___arguments) {
    
  },
  /* handler:onSelectFiles */
  /* content */
}))

define('./pages/sponsorDashboard/components/464e79fb23dd40e2efff143dea792a52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentSellers, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['isOpenModalOrders'] = true;
  ___arguments.context.pageData['currentFundraiserId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'objectId'));
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgName')) {
    ___arguments.context.pageData['currentFundraiserName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgName'));
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2StartDate')) {
    ___arguments.context.pageData['currentFundraiserStartDate'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2StartDate'));
    ___arguments.context.pageData['currentFundraiserEndDate'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2EndDate'));
  }
  currentSellers = (getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')) ? (!!(getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')).length ? (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')), async (item) => {


   return ((getObjectProperty(item, 'OfficeOrganizationId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId')));
  }))[0] : null) : null;
  if (!currentSellers) {
    currentSellers = ({ 'Sellers': (await Backendless.Request.get(`${Backendless.appPath}/services/organization/getsellers`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'officeOrganizationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId')) }).send()),'OfficeOrganizationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId')) });
    ___arguments.context.appData['SellersByOfficeOrganizationIdList'] = ((getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')) ? (addItemToList((getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')), currentSellers)) : [currentSellers]);
  }
  ___arguments.context.pageData['currentSellers'] = currentSellers;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/f63346decd2611b528c97264ab78ca94/bundle.js', [], () => ({
  /* content */
  /* handler:rowsDataLogic */
  ['rowsDataLogic'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentSellers')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'Sellers')) : [])

  },
  /* handler:rowsDataLogic */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
    var forSellers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  forSellers = [({ 'headerName': 'Student','field': 'studentName','flex': 1,'filter': false,'sortable': true }), ({ 'headerName': 'Teacher','field': 'teacherName','flex': 1,'filter': false,'sortable': true }), ({ 'headerName': 'Items','field': 'itemCount','flex': 1,'filter': false,'sortable': true }), ({ 'headerName': 'Retail','field': 'salesTotal','flex': 1,'filter': false,'sortable': true })];

  return ((getObjectProperty(___arguments.context.pageData, 'currentSellers')) ? forSellers : [])

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/sponsorDashboard/components/9c88664f7c63fe068898601fae09157f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'sortByStudentName'))) {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdAsc(colId) })('f63346decd2611b528c97264ab78ca94', 'studentName');
    ___arguments.context.pageData['sortByStudentName'] = 'asc';
  } else if ((getObjectProperty(___arguments.context.pageData, 'sortByStudentName')) == 'asc') {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdDesc(colId) })('f63346decd2611b528c97264ab78ca94', 'studentName');
    ___arguments.context.pageData['sortByStudentName'] = 'desc';
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).clearSort() })('f63346decd2611b528c97264ab78ca94');
    delete ___arguments.context.pageData['sortByStudentName'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/9d8d4bea2f0fd87ed26530e5839b828d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'sortByTeacherName'))) {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdAsc(colId) })('f63346decd2611b528c97264ab78ca94', 'teacherName');
    ___arguments.context.pageData['sortByTeacherName'] = 'asc';
  } else if ((getObjectProperty(___arguments.context.pageData, 'sortByTeacherName')) == 'asc') {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdDesc(colId) })('f63346decd2611b528c97264ab78ca94', 'teacherName');
    ___arguments.context.pageData['sortByTeacherName'] = 'desc';
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).clearSort() })('f63346decd2611b528c97264ab78ca94');
    delete ___arguments.context.pageData['sortByTeacherName'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/23cd69a9e5583322a7372c7eab3e715d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'sortByItemCount'))) {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdAsc(colId) })('f63346decd2611b528c97264ab78ca94', 'itemCount');
    ___arguments.context.pageData['sortByItemCount'] = 'asc';
  } else if ((getObjectProperty(___arguments.context.pageData, 'sortByItemCount')) == 'asc') {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdDesc(colId) })('f63346decd2611b528c97264ab78ca94', 'itemCount');
    ___arguments.context.pageData['sortByItemCount'] = 'desc';
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).clearSort() })('f63346decd2611b528c97264ab78ca94');
    delete ___arguments.context.pageData['sortByItemCount'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/a653c0ab536fab8149cb7f411b5870c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'sortBySalesTotal'))) {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdAsc(colId) })('f63346decd2611b528c97264ab78ca94', 'salesTotal');
    ___arguments.context.pageData['sortBySalesTotal'] = 'asc';
  } else if ((getObjectProperty(___arguments.context.pageData, 'sortBySalesTotal')) == 'asc') {
    await ( async function (componentUid, colId) {  ___arguments.context.getComponentByUid(componentUid).sortByColIdDesc(colId) })('f63346decd2611b528c97264ab78ca94', 'salesTotal');
    ___arguments.context.pageData['sortBySalesTotal'] = 'desc';
  } else {
    await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).clearSort() })('f63346decd2611b528c97264ab78ca94');
    delete ___arguments.context.pageData['sortBySalesTotal'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/3ad6a9a947c4615524a66c160122d943/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsordashboard__modal-raffle'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModalRaffle')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/bace962b61691822ee6102714f810d76/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentSellers, item, isProcess, buttton;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['isOpenModalRaffle'] = true;
  ___arguments.context.pageData['currentFundraiserName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgName'));
  ___arguments.context.pageData['currentFundraiserStartDate'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2StartDate'));
  ___arguments.context.pageData['currentFundraiserEndDate'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2EndDate'));
  ___arguments.context.pageData['currentOfficeOrganizationId'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId'));
  currentSellers = (getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')) ? (!!(getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')).length ? (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')), async (item) => {


   return ((getObjectProperty(item, 'OfficeOrganizationId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId')));
  }))[0] : null) : null;
  if (!currentSellers) {
    currentSellers = ({ 'Sellers': (await Backendless.Request.get(`${Backendless.appPath}/services/organization/getsellers`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'officeOrganizationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId')) }).send()),'OfficeOrganizationId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OfficeOrganizationId')) });
    ___arguments.context.appData['SellersByOfficeOrganizationIdList'] = ((getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')) ? (addItemToList((getObjectProperty(___arguments.context.appData, 'SellersByOfficeOrganizationIdList')), currentSellers)) : [currentSellers]);
  }
  ___arguments.context.pageData['currentSellers'] = currentSellers;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aafcc7329309fb08e852d721c4fc0d', ({ 'raffleType': 'items','numberOfTickets': 1,'numberOfItemsDefault': 1,'numberOfItems': 1,'numberOfDollarsDefault': 9,'numberOfDollars': 9,'calculationType': 'every','instantWinnerCount': 0,'currentFundraiserName': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'OrgName')),'currentFundraiserStartDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2StartDate')),'currentFundraiserEndDate': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6fb19ca0241faf36515c85399ec9ed8'), 'Formatted2EndDate')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/5231584582659ab5b3ab63ca481f80d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalRaffle'] = false;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aafcc7329309fb08e852d721c4fc0d', ({ 'raffleType': 'items','numberOfTickets': 1,'numberOfItemsDefault': 1,'numberOfItems': 1,'numberOfDollarsDefault': 9,'numberOfDollars': 9,'calculationType': 'every','instantWinnerCount': 0 }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/bc1c0bce790d80f2402a3e6cb5bd123b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d')['raffleType'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sponsorDashboard/components/a414e9713d84e05968a838ec0c58bacf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModalRaffle'] = false;
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b6aafcc7329309fb08e852d721c4fc0d', ({ 'raffleType': 'items','numberOfTickets': 1,'numberOfItemsDefault': 1,'numberOfItems': 1,'numberOfDollarsDefault': 9,'numberOfDollars': 9,'calculationType': 'every','instantWinnerCount': 0 }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorDashboard/components/2cd7d87d3c7184e7c5dbf9215f313849/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledModalRaffleGenerateButton'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2cd7d87d3c7184e7c5dbf9215f313849')), 'button-loading');
  response = (await Backendless.Request.post(`${Backendless.appPath}/services/organization/createraffletickets`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'sellersList': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'Sellers')),'configuration': ({ 'raffleType': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')),'calculationType': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'calculationType')),'numberofTickets': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfTickets')),'numberofItemsDollars': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')) == 'items' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfItems')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfDollars')),'numberofInstantWinners': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'instantWinnerCount')),'organizationName': (getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')),'organizationOfficeId': (getObjectProperty(___arguments.context.pageData, 'currentOfficeOrganizationId')) }) }));
  if ((getObjectProperty(response, 'errorCode')) == 0) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(response, 'pdfURL')), true, undefined);
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2cd7d87d3c7184e7c5dbf9215f313849')), 'button-loading', '');
  ___arguments.context.pageData['isDisabledModalRaffleGenerateButton'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledModalRaffleGenerateButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/522dcc2a6dd973e944135b8471a2ddbd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d')['numberOfTickets'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sponsorDashboard/components/9ac50da37838224a94df8902260e98da/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')) == 'items') {
    ___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d')['numberOfItems'] = ___arguments.value;
  } else {
    ___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d')['numberOfDollars'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var optionList, i;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  optionList = [];
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')) == 'items') {
    var i_start = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfItemsDefault'));
    var i_inc = 1;
    if (i_start > 20) {
      i_inc = -i_inc;
    }
    for (i = i_start; i_inc >= 0 ? i <= 20 : i >= 20; i += i_inc) {
      addItemToList(optionList, ({ 'label': String(i) + String(i == 1 ? ' item' : ' items'),'value': i }));
    }
  } else {
    var i_start2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfDollarsDefault'));
    var i_inc2 = 1;
    if (i_start2 > 20) {
      i_inc2 = -i_inc2;
    }
    for (i = i_start2; i_inc2 >= 0 ? i <= 20 : i >= 20; i += i_inc2) {
      addItemToList(optionList, ({ 'label': ['$',i,' dollars'].join(''),'value': i }));
    }
    for (i = 30; i <= 100; i += 10) {
      addItemToList(optionList, ({ 'label': ['$',i,' dollars'].join(''),'value': i }));
    }
  }

  return optionList

  },
  /* handler:onOptionsAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')) == 'items' ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfItems')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfDollars')))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/5b943e4d88bf2489dca58ae591ffb161/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d')['instantWinnerCount'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sponsorDashboard/components/0f76e814a4de53b92fdf596625a2a986/bundle.js', [], () => ({
  /* content */
  /* handler:optionsLogic */
  ['optionsLogic'](___arguments) {
    var label2, label1, instantWinners, ticketLabel;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ticketLabel = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfTickets')) == 1 ? 'ticket' : 'tickets';
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'instantWinnerCount')) == 0) {
    instantWinners = 'with no instant winners.';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'instantWinnerCount')) == 1) {
    instantWinners = ['with ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'instantWinnerCount')),' instant winner.'].join('');
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'instantWinnerCount')) > 1) {
    instantWinners = ['with ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'instantWinnerCount')),' instant winners.'].join('');
  }
  label1 = ['Each Seller gets ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfTickets')),' raffle ',ticketLabel,' FOR EVERY ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')) == 'items' ? String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfItems')) + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfItems')) == 1 ? ' item sold ' : ' items sold ') : ['$',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfDollars')),' dollars sold '].join(''),instantWinners].join('');
  label2 = ['Each Seller gets ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfTickets')),' raffle ',ticketLabel,' if they have sold AT LEAST ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')) == 'items' ? String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfItems')) + String((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfItems')) == 1 ? ' item ' : ' items ') : ['$',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'numberOfDollars')),' dollars '].join(''),instantWinners].join('');

  return [({ 'label': label1,'value': 'every' }), ({ 'label': label2,'value': 'atLeast' })]

  },
  /* handler:optionsLogic */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d')['calculationType'] = ___arguments['value'];

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/sponsorDashboard/components/f41c14626ffafe3ac78c52e889afc8fc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6aafcc7329309fb08e852d721c4fc0d'), 'raffleType')) == 'items' ? 'Number of items sold' : 'Dollars sold')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/b5590e21d9b26888ba4386dbe2088d98/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')) ? (getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')) : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/c4687235aef6b9fd9feebf132cfce4d3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentFundraiserStartDate')) ? ['Fundraising dates: ',(getObjectProperty(___arguments.context.pageData, 'currentFundraiserStartDate')),' - ',(getObjectProperty(___arguments.context.pageData, 'currentFundraiserEndDate'))].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/ae337e5670ed598dced8037cc9d9a95b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response, dateNow;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledModalOrdersPrintButton'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ae337e5670ed598dced8037cc9d9a95b')), 'button-loading');
  ___arguments.context.pageData['isDisabledModalOrdersPDFButton'] = true;
  ___arguments.context.pageData['isDisabledModalOrdersCSVButton'] = true;
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerPDFURL')) === 'undefined') {
    dateNow = (new Intl.DateTimeFormat(undefined, ({ [`timeZone`]: 'America/New_York',[`timeStyle`]: 'long',[`dateStyle`]: 'short' })).format((new Date())));
    response = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/generatepdf`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'inputList': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'Sellers')),'configuration': ({ [`title`]: (getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')),[`subtitle`]: String('Online sellers as of: ') + String(dateNow.slice(0, dateNow.length - 3)),[`headerList`]: ['Student', 'Teacher', 'Items', 'Retail'],[`dataSource`]: 'sponsorDashboardSellers',[`folder`]: 'sponsorsellerpdfs',[`fileName`]: [((getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')).replace((new RegExp('[^A-Za-z0-9 ]+', 'g')), '')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'OfficeOrganizationId')),'-',[(new Date(dateNow).getMonth() + 1),'-',(new Date(dateNow).getDate()),'-',(new Date(dateNow).getFullYear()),'-',(new Date(dateNow).getHours()),'-',(new Date(dateNow).getMinutes()),'-',String(new Date(dateNow).getSeconds()).length == 1 ? String('0') + String(new Date(dateNow).getSeconds()) : (new Date(dateNow).getSeconds())].join(''),'.pdf'].join(''),[`fileTitle`]: String(getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')) + String(' - Online Sellers') }) }));
    if ((getObjectProperty(response, 'errorCode')) == 0) {
      (getObjectProperty(___arguments.context.pageData, 'currentSellers'))['SellerPDFURL'] = (getObjectProperty(response, 'pdfURL'));
    }
  }
  if (!(typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerPDFURL')) === 'undefined')) {
    await (async function(fileURL, fileType) {
    	printJS(fileURL, fileType);
    })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerPDFURL')), 'pdf');
    await new Promise(r => setTimeout(r, 400 || 0));
  }
  ___arguments.context.pageData['isDisabledModalOrdersPrintButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersPDFButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersCSVButton'] = false;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ae337e5670ed598dced8037cc9d9a95b')), 'button-loading', '');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledModalOrdersPrintButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/90019e6101db8fdd3a4808f1de9b836b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response, dateNow;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledModalOrdersPDFButton'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('90019e6101db8fdd3a4808f1de9b836b')), 'button-loading');
  ___arguments.context.pageData['isDisabledModalOrdersPrintButton'] = true;
  ___arguments.context.pageData['isDisabledModalOrdersCSVButton'] = true;
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerPDFURL')) === 'undefined') {
    dateNow = (new Intl.DateTimeFormat(undefined, ({ [`timeZone`]: 'America/New_York',[`timeStyle`]: 'long',[`dateStyle`]: 'short' })).format((new Date())));
    response = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/generatepdf`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'inputList': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'Sellers')),'configuration': ({ [`title`]: (getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')),[`subtitle`]: String('Online sellers as of: ') + String(dateNow.slice(0, dateNow.length - 3)),[`headerList`]: ['Student', 'Teacher', 'Items', 'Retail'],[`dataSource`]: 'sponsorDashboardSellers',[`folder`]: 'sponsorsellerpdfs',[`fileName`]: [((((getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')).replace((new RegExp('[^A-Za-z0-9 ]+', 'g')), '')).replace((new RegExp('\\s\\s+', 'g')), ' ')).replace((new RegExp(' ', 'g')), '-')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'OfficeOrganizationId')),'-',[(new Date(dateNow).getMonth() + 1),'-',(new Date(dateNow).getDate()),'-',(new Date(dateNow).getFullYear()),'-',(new Date(dateNow).getHours()),'-',(new Date(dateNow).getMinutes()),'-',String(new Date(dateNow).getSeconds()).length == 1 ? String('0') + String(new Date(dateNow).getSeconds()) : (new Date(dateNow).getSeconds())].join(''),'.pdf'].join(''),[`fileTitle`]: String(getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')) + String(' - Online Sellers') }) }));
    if ((getObjectProperty(response, 'errorCode')) == 0) {
      (getObjectProperty(___arguments.context.pageData, 'currentSellers'))['SellerPDFURL'] = (getObjectProperty(response, 'pdfURL'));
    }
  }
  if (!(typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerPDFURL')) === 'undefined')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerPDFURL')), true, undefined);
  }
  ___arguments.context.pageData['isDisabledModalOrdersPDFButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersPrintButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersCSVButton'] = false;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('90019e6101db8fdd3a4808f1de9b836b')), 'button-loading', '');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledModalOrdersPDFButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/b0df5d1434bf93beeaaf88ab599f25c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var dateNow, csvURL, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledModalOrdersCSVButton'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b0df5d1434bf93beeaaf88ab599f25c8')), 'button-loader');
  ___arguments.context.pageData['isDisabledModalOrdersPrintButton'] = true;
  ___arguments.context.pageData['isDisabledModalOrdersPDFButton'] = true;
  dateNow = (new Date());
  if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerPDFURL')) === 'undefined') {
    csvURL = '';
    csvURL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['sponsorsellercsvs',['/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase')),'/'].join(''),[((getObjectProperty(___arguments.context.pageData, 'currentFundraiserName')).replace((new RegExp(' ', 'g')), '-')),'-',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'OfficeOrganizationId')),'-',[(new Date(dateNow).getMonth() + 1),'-',(new Date(dateNow).getDate()),'-',(new Date(dateNow).getFullYear()),'-',String(new Date(dateNow).getHours()).length == 1 ? String('0') + String(new Date(dateNow).getHours()) : (new Date(dateNow).getHours()),'-',String(new Date(dateNow).getMinutes()).length == 1 ? String('0') + String(new Date(dateNow).getMinutes()) : (new Date(dateNow).getMinutes()),'-',String(new Date(dateNow).getSeconds()).length == 1 ? String('0') + String(new Date(dateNow).getSeconds()) : (new Date(dateNow).getSeconds())].join(''),'.csv'].join('')].join('')),'data': (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'Sellers')).map(async item => {; return ({ 'Student': (getObjectProperty(item, 'studentName')),'Teacher': (getObjectProperty(item, 'teacherName')),'Items': (getObjectProperty(item, 'itemCount')),'Retail': (getObjectProperty(item, 'salesTotal')) });}))),'csvOptions': ({ 'header': true }) }));
    if (csvURL.length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'currentSellers'))['SellerCSVURL'] = csvURL;
    }
  }
  if (!(typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerCSVURL')) === 'undefined')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentSellers')), 'SellerCSVURL')), true, undefined);
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b0df5d1434bf93beeaaf88ab599f25c8')), 'button-loader', '');
  ___arguments.context.pageData['isDisabledModalOrdersCSVButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersPrintButton'] = false;
  ___arguments.context.pageData['isDisabledModalOrdersPDFButton'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledModalOrdersCSVButton'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sponsorDashboard/components/876e790362168abbdb8a96a899c9e61f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['Store message to family and friends (',(getObjectProperty(___arguments.context.pageData, 'formMessage')) ? (getObjectProperty(___arguments.context.pageData, 'formMessage')).length : '0',' of 250)'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var settings, organizationData, loadPage, fundraiserListFilter, item, organizationDataListPage, organizationDataList, typesList, sponsorSocLink, baseUrl, settingKeys;

/**
 * Describe this function...
 */
async function fieldsError() {
  ___arguments.context.pageData['formEmailToError'] = false;
  ___arguments.context.pageData['formEmailSubjectError'] = false;
  ___arguments.context.pageData['formEmailMessageError'] = false;
  ___arguments.context.pageData['formCellToError'] = false;
  ___arguments.context.pageData['formCellMessageError'] = false;
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function fieldsDefault() {
  ___arguments.context.pageData['fieldEmailsSubmit'] = false;
  ___arguments.context.pageData['fieldPhonesSubmit'] = false;
  ___arguments.context.pageData['fieldEmails'] = '';
  ___arguments.context.pageData['fieldPhones'] = '';
  ___arguments.context.pageData['formEmailTo'] = [];
  ___arguments.context.pageData['formEmailSubject'] = '';
  ___arguments.context.pageData['formEmailMessage'] = '';
  ___arguments.context.pageData['formEmailReminders'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'AutoReminderEmails'));
  ___arguments.context.pageData['formCellTo'] = [];
  ___arguments.context.pageData['formCellMessage'] = '';
  ___arguments.context.pageData['formCellReminders'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'AutoReminderTexts'));
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function setTypes() {
  ___arguments.context.pageData['activeType'] = ((getObjectProperty(___arguments.context.pageData, 'type')) && (['email', 'cell', 'soc'].includes((getObjectProperty(___arguments.context.pageData, 'type')))) ? (getObjectProperty(___arguments.context.pageData, 'type')) : 'email');
  typesList = [({ [`label`]: 'Email',[`id`]: 'email' }), ({ [`label`]: 'Text',[`id`]: 'cell' }), ({ [`label`]: 'Social Media',[`id`]: 'soc' })];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c1ef98f4bcd945820f9e49b57a522fa3', typesList);
}

/**
 * Describe this function...
 */
async function setMessagesByType() {
  baseUrl = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorRegisterURL')),'?groupid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OfficeOrganizationId'))].join('');
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'email') {
    ___arguments.context.pageData['formEmailSubject'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorEmailSubject')), '$OrganizationName', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName'))));
    ___arguments.context.pageData['formEmailMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorEmailBody')), ['$OrganizationName', '$baseURL'], [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName')), baseUrl]));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'cell') {
    ___arguments.context.pageData['formCellMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorTextBody')), ['$OrganizationName', '$baseURL'], [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName')), baseUrl]));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'soc') {
    sponsorSocLink = baseUrl;
    ___arguments.context.pageData['sponsorSocLink'] = sponsorSocLink;
    await BackendlessUI.Functions.Custom['fn_af316a0c15474f44858a3f62b2b7292d']('.sponsorshare_soc-form_fb-button', sponsorSocLink);
    await BackendlessUI.Functions.Custom['fn_feffbd2bb679b69a498a1696230cdfc9'](({ [`image`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgProfileImage')),[`name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName')),[`OfficeOrganizationId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OfficeOrganizationId')),[`endDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'EndDate')),[`text`]: '' }), (await settingSalesImages()), 'https://meadowfarms.sirv.com/organizations/noimage.png');
  }
}

/**
 * Describe this function...
 */
async function settingSalesImages() {
  return [(await BackendlessUI.Functions.Custom['fn_8a75c255e1b93999c602fe2677f6c2bd']('ShareSponsorImage1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorImage1')), 'sponsorshare_soc-form_sales-1_image', 'sponsorshare_soc-form_sales-1_download')), (await BackendlessUI.Functions.Custom['fn_8a75c255e1b93999c602fe2677f6c2bd']('ShareSponsorImage2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorImage2')), 'sponsorshare_soc-form_sales-2_image', 'sponsorshare_soc-form_sales-2_download')), (await BackendlessUI.Functions.Custom['fn_8a75c255e1b93999c602fe2677f6c2bd']('ShareSponsorImage3', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorImage3')), 'sponsorshare_soc-form_sales-3_image', 'sponsorshare_soc-form_sales-3_download'))]
}


  loadPage = true;
  ___arguments.context.pageData['isLoading'] = true;
  ___arguments.context.pageData['noResults'] = false;
  if (!(await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null))) {
    loadPage = false;
  }
  if (!(await BackendlessUI.Functions.Custom['fn_8cec55bfe1cb2271228cc6a79473903e']())) {
    loadPage = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'fundraiserObjectId'))) {
    loadPage = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'fundraiserObjectId')) == '') {
    loadPage = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'currentPage'))) {
    loadPage = false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'currentPage')) == '') {
    loadPage = false;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'organizationDataList'))) {
    loadPage = false;
  } else if (!(getObjectProperty(___arguments.context.appData, 'organizationDataList')).length) {
    loadPage = false;
  }
  if (loadPage) {
    organizationDataList = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'organizationDataList')), async (item) => {


     return ((getObjectProperty(item, 'currentPage')) == (getObjectProperty(___arguments.context.pageData, 'currentPage')));
    }));
    if (organizationDataList.length == 0) {
      loadPage = false;
    } else {
      organizationDataListPage = organizationDataList[0];
      fundraiserListFilter = (await asyncListFilter((getObjectProperty(organizationDataListPage, 'fundraiserList')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'fundraiserObjectId')));
      }));
      if (fundraiserListFilter.length == 0) {
        loadPage = false;
      } else {
        ___arguments.context.pageData['organization'] = (fundraiserListFilter[0]);
      }
    }
  }
  if (loadPage) {
    settings = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['TinyMCEAPIKey', 'ShareSponsorEmailSubject', 'ShareSponsorEmailBody', 'ShareSponsorTextBody', 'ShareSponsorImage1', 'ShareSponsorImage2', 'ShareSponsorImage3', 'ShareSponsorRegisterURL', 'cdnURL'], ___arguments.context.appData));
    ___arguments.context.pageData['settings'] = settings;
    ___arguments.context.pageData['isLoading'] = false;
    await setTypes();
    await fieldsDefault();
    await fieldsError();
    ___arguments.context.pageData['contacts'] = (await Backendless.Request.get(`${Backendless.appPath}/services/organization/get_contacts`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'fundraiserId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'objectId'))),'organizationId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgObjectId'))) }).send());
    await (async function() {
    	const emailField = document.querySelector('.sponsorshare_email-form_to_field textarea:first-child');
    	const cellField = document.querySelector('.sponsorshare_cell-form_to_field textarea:first-child');

    	emailField.addEventListener("keypress", function onEvent(event) {
    	    if (event.key === "Enter") {
    	      ___arguments.context.pageData['fieldEmailsSubmit'] = true;
    	    }
    	});
    	emailField.addEventListener("blur", function onEvent(event) {
    	    ___arguments.context.pageData['fieldEmailsSubmit'] = true;
    	});
    	cellField.addEventListener("keypress", function onEvent(event) {
    	    if (event.key === "Enter") {
    	      ___arguments.context.pageData['fieldPhonesSubmit'] = true;
    	    }
    	});
    	cellField.addEventListener("blur", function onEvent(event) {
    	    ___arguments.context.pageData['fieldPhonesSubmit'] = true;
    	});
    })();
    await setMessagesByType();
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sponsorDashboard', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/sponsorShare/components/78d84ff45a4c7b88faa75827a8cbf2e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var sponsorSocLink, baseUrl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function setMessagesByType() {
  baseUrl = [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorRegisterURL')),'?groupid=',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OfficeOrganizationId'))].join('');
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'email') {
    if ((getObjectProperty(___arguments.context.pageData, 'formEmailSubject')) == '') {
      ___arguments.context.pageData['formEmailSubject'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorEmailSubject')), '$OrganizationName', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName'))));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'formEmailMessage')) == '') {
      ___arguments.context.pageData['formEmailMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorEmailBody')), ['$OrganizationName', '$baseURL'], [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName')), baseUrl]));
      await (async function(message) {
      	tinymce.activeEditor.setContent(message);
      })((getObjectProperty(___arguments.context.pageData, 'formEmailMessage')));
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'cell') {
    if ((getObjectProperty(___arguments.context.pageData, 'formCellMessage')) == '') {
      ___arguments.context.pageData['formCellMessage'] = (await BackendlessUI.Functions.Custom['fn_e23ea808a57e516b1a8f2ae45d7c20e3']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorTextBody')), ['$OrganizationName', '$baseURL'], [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName')), baseUrl]));
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'soc') {
    sponsorSocLink = baseUrl;
    ___arguments.context.pageData['sponsorSocLink'] = sponsorSocLink;
    await BackendlessUI.Functions.Custom['fn_af316a0c15474f44858a3f62b2b7292d']('.sponsorshare_soc-form_fb-button', sponsorSocLink);
    await BackendlessUI.Functions.Custom['fn_feffbd2bb679b69a498a1696230cdfc9'](({ 'image': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgProfileImage')),'name': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgName')),'startDate': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'StartDate')),'OfficeOrganizationId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OfficeOrganizationId')),'endDate': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'EndDate')),'text': '' }), (await settingSalesImages()), 'https://meadowfarms.sirv.com/organizations/noimage.png');
  }
}

/**
 * Describe this function...
 */
async function settingSalesImages() {
  return [(await BackendlessUI.Functions.Custom['fn_8a75c255e1b93999c602fe2677f6c2bd']('ShareSponsorImage1', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorImage1')), 'sponsorshare_soc-form_sales-1_image', 'sponsorshare_soc-form_sales-1_download')), (await BackendlessUI.Functions.Custom['fn_8a75c255e1b93999c602fe2677f6c2bd']('ShareSponsorImage2', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorImage2')), 'sponsorshare_soc-form_sales-2_image', 'sponsorshare_soc-form_sales-2_download')), (await BackendlessUI.Functions.Custom['fn_8a75c255e1b93999c602fe2677f6c2bd']('ShareSponsorImage3', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'ShareSponsorImage3')), 'sponsorshare_soc-form_sales-3_image', 'sponsorshare_soc-form_sales-3_download'))]
}


  ___arguments.context.pageData['activeType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'id'));
  await setMessagesByType();

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'label'))

  },
  /* handler:onLabelAssignment */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'id'))

  },
  /* handler:onValueAssignment */
  /* handler:onCheckedValueAssignment */
  onCheckedValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'activeType'))

  },
  /* handler:onCheckedValueAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ['sponsorshare_type-radio', (getObjectProperty(___arguments.context.getComponentDataStoreByUid('928c3b6bf8ebc08f0d896575b8cc684f'), 'id'))]

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/b8823b3710199eb9e1e3804b2cf622c4/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sponsorSocLink'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/50cdd0717c59e988b42e1ac90ea8de9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await (async function() {
  	
  	const button = ___arguments.event.target;
  	const input = button.parentElement.parentElement.querySelector('input');
  	input.select();
  	document.execCommand("copy");
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorShare/components/7b414c72d0be277e55fd443d0b216daf/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'NoSellers')) || (getObjectProperty(___arguments.context.pageData, 'isDisableSendEmail')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var apiResult, formData, field, validation, contactsReturn, formEmailItem, formEmailTo, contactItem, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function rules() {
  return [({ [`field`]: 'formEmailTo',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formEmailTo')),[`rules`]: ['requiredArray'] }), ({ [`field`]: 'formEmailSubject',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formEmailSubject')),[`rules`]: ['required'] }), ({ [`field`]: 'formEmailMessage',[`value`]: (getObjectProperty(___arguments.context.pageData, 'formEmailMessage')),[`rules`]: ['required'] })]
}

/**
 * Describe this function...
 */
async function cleanForm() {
  ___arguments.context.pageData['formEmailTo'] = [];
  ___arguments.context.pageData['formEmailSubject'] = '';
  ___arguments.context.pageData['formEmailMessage'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', []);
  ___arguments.context.pageData['contacts'] = (await Backendless.Request.get(`${Backendless.appPath}/services/organization/get_contacts`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'fundraiserId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'objectId'))),'organizationId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgObjectId'))) }).send());
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function parseContacts() {
  contactsReturn = [];
  formEmailTo = (getObjectProperty(___arguments.context.pageData, 'formEmailTo'));
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'emails')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'emails')).length > 0) {
    var contactItem_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'emails'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      if (formEmailTo.includes((getObjectProperty(contactItem, 'value')))) {
        addItemToList(contactsReturn, contactItem);
        formEmailTo = (await asyncListFilter(formEmailTo, async (item) => {


         return (item != (getObjectProperty(contactItem, 'value')));
        }));
      }
    }
  }
  if (formEmailTo.length > 0) {
    for (var formEmailItem_index in formEmailTo) {
      formEmailItem = formEmailTo[formEmailItem_index];
      addItemToList(contactsReturn, ({ [`id`]: '',[`value`]: formEmailItem }));
    }
  }
  return contactsReturn
}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf')), 'button-loading');
  ___arguments.context.pageData['formEmailMessageError'] = false;
  validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
  if (validation.length > 0) {
    for (var field_index in validation) {
      field = validation[field_index];
      ___arguments.context.pageData[(String(field) + String('Error'))] = true;
    }
  } else {
    ___arguments.context.pageData['isDisableSendEmail'] = true;
    formData = ({ [`to`]: await parseContacts(),[`subject`]: (getObjectProperty(___arguments.context.pageData, 'formEmailSubject')),[`message`]: (await (async function(htmlString) {
    	const updatedHtmlString = htmlString.replace(/style="([^"]*)"/g, (match, p1) => {
    	  return `style="${p1}; margin: 0;"`;
    	});

    	return updatedHtmlString;
    })((getObjectProperty(___arguments.context.pageData, 'formEmailMessage')))),[`reminders`]: (getObjectProperty(___arguments.context.pageData, 'formEmailReminders')),[`type`]: 'Email' });
    apiResult = (await Backendless.Request.post(`${Backendless.appPath}/services/messages/set_sponsor_messages`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': formData,'organizationId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgObjectId')),'fundraiserId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'objectId')) }));
    if (getObjectProperty(apiResult, 'status')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sponsorDashboard', ({ [`message`]: 'email' }));
    }
    ___arguments.context.pageData['isDisableSendEmail'] = false;
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf')), 'button-loading', '');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'isSuccessSendEmail')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf')), 'success');
  }

  return ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b414c72d0be277e55fd443d0b216daf'))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/1e3885a63981a42496d68fee1a399f29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isDisableSendCell')) || (getObjectProperty(___arguments.context.pageData, 'NoSellers')))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var apiResult, formData, field, validation, contactsReturn, formCellItem, formCellTo, contactItem, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function rules() {
  return [({ 'field': 'formCellTo','value': (getObjectProperty(___arguments.context.pageData, 'formCellTo')),'rules': ['requiredArray'] }), ({ 'field': 'formCellMessage','value': (getObjectProperty(___arguments.context.pageData, 'formCellMessage')),'rules': ['required'] })]
}

/**
 * Describe this function...
 */
async function cleanForm() {
  ___arguments.context.pageData['formCellTo'] = [];
  ___arguments.context.pageData['formCellMessage'] = '';
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', []);
  ___arguments.context.pageData['contacts'] = (await Backendless.Request.get(`${Backendless.appPath}/services/organization/get_contacts`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'fundraiserId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'objectId'))),'organizationId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgObjectId'))) }).send());
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function parseContacts() {
  contactsReturn = [];
  formCellTo = (getObjectProperty(___arguments.context.pageData, 'formCellTo'));
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'phones')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'phones')).length > 0) {
    var contactItem_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'phones'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      if (formCellTo.includes((getObjectProperty(contactItem, 'value')))) {
        addItemToList(contactsReturn, contactItem);
        formCellTo = (await asyncListFilter(formCellTo, async (item) => {


         return (item != (getObjectProperty(contactItem, 'value')));
        }));
      }
    }
  }
  if (formCellTo.length > 0) {
    for (var formCellItem_index in formCellTo) {
      formCellItem = formCellTo[formCellItem_index];
      addItemToList(contactsReturn, ({ 'id': '','value': formCellItem }));
    }
  }
  return contactsReturn
}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29')), 'button-loading');
  validation = (await BackendlessUI.Functions.Custom['fn_6153cc06151d02ccfc05fce1b6855a44']((await rules())));
  if (validation.length > 0) {
    for (var field_index in validation) {
      field = validation[field_index];
      ___arguments.context.pageData[(String(field) + String('Error'))] = true;
    }
  } else {
    ___arguments.context.pageData['isDisableSendCell'] = true;
    formData = ({ 'to': await parseContacts(),'message': (getObjectProperty(___arguments.context.pageData, 'formCellMessage')),'reminders': (getObjectProperty(___arguments.context.pageData, 'formCellReminders')),'type': 'Text' });
    apiResult = (await Backendless.Request.post(`${Backendless.appPath}/services/messages/set_sponsor_messages`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'data': formData,'organizationId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'OrgObjectId')),'fundraiserId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'organization')), 'objectId')) }));
    if (getObjectProperty(apiResult, 'status')) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('sponsorDashboard', ({ 'message': 'text' }));
    }
    ___arguments.context.pageData['isDisableSendCell'] = false;
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29')), 'button-loading', '');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'isSuccessSendCell')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29')), 'success');
  }

  return ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e3885a63981a42496d68fee1a399f29'))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/0b88cd89868c429f28f6e0ea8515824f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (getObjectProperty(___arguments.context.pageData, 'contacts')) {
    isDisabled = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'emails')).length == 0;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var formEmailTo, contactItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formEmailToError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'emails')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'emails')).length > 0) {
    formEmailTo = (getObjectProperty(___arguments.context.pageData, 'formEmailTo'));
    var contactItem_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'emails'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      formEmailTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formEmailTo, (getObjectProperty(contactItem, 'value'))));
    }
    ___arguments.context.pageData['formEmailTo'] = formEmailTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', formEmailTo);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorShare/components/87ab5762a9ef9ff3f59b3adb584a7c52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (getObjectProperty(___arguments.context.pageData, 'contacts')) {
    isDisabled = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'phones')).length == 0;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var formCellTo, contactItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formCellToError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'phones')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'phones')).length > 0) {
    formCellTo = (getObjectProperty(___arguments.context.pageData, 'formCellTo'));
    var contactItem_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'all')), 'phones'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      formCellTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formCellTo, (getObjectProperty(contactItem, 'value'))));
    }
    ___arguments.context.pageData['formCellTo'] = formCellTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', formCellTo);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorShare/components/531f645354216075b4592a2d5189a3f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_email-form_to'];
  if (getObjectProperty(___arguments.context.pageData, 'formEmailToError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/332420aaa1238f2b3ada5928d9125a0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_email-form_subject'];
  if (getObjectProperty(___arguments.context.pageData, 'formEmailSubjectError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/12798471e42e79c646a54532c3e84a69/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_email-form_message'];
  if (getObjectProperty(___arguments.context.pageData, 'formEmailMessageError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/7fe431477239782e68c1ea63edeef882/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_cell-form_to'];
  if (getObjectProperty(___arguments.context.pageData, 'formCellToError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/f0ac94f445d537f49c4a2fe770b7ab2d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_cell-form_message'];
  if (getObjectProperty(___arguments.context.pageData, 'formCellMessageError')) {
    addItemToList(classes, 'error');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/e65a9542500b007f1e44661174e4fc44/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var fieldValue;


  ___arguments.context.pageData['formEmailToError'] = false;
  ___arguments.context.pageData['fieldEmails'] = ___arguments.value;
  if (___arguments.value != '' && ((___arguments.value.indexOf(',') !== -1) || (___arguments.value.indexOf(' ') !== -1))) {
    ___arguments.context.pageData['fieldEmailsSubmit'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'fieldEmails'))

  },
  /* handler:onValueAssignment */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var formEmailTo, valueItem, valuesList, value, fieldEmails;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'fieldEmailsSubmit')) {
    ___arguments.context.pageData['fieldEmailsSubmit'] = false;
    valuesList = [];
    formEmailTo = (getObjectProperty(___arguments.context.pageData, 'formEmailTo'));
    fieldEmails = (getObjectProperty(___arguments.context.pageData, 'fieldEmails'));
    value = fieldEmails.trim();
    valuesList = ((value.split(',')).concat((value.split(' '))));
    if (valuesList.length > 0) {
      for (var valueItem_index in valuesList) {
        valueItem = valuesList[valueItem_index];
        if (await BackendlessUI.Functions.Custom['fn_e89aa51663f454786e1bc72788d3fc54'](valueItem)) {
          formEmailTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formEmailTo, valueItem));
        }
      }
      ___arguments.context.pageData['fieldEmails'] = '';
    }
    ___arguments.context.pageData['formEmailTo'] = formEmailTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', formEmailTo);
  }

  return ['sponsorshare_email-form_to_field']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/7d777ffcd77bd1a70c7e426bd645b97e/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return ___arguments.context.dataModel

  },
  /* handler:onLabelAssignment */
  /* handler:onDelete */
  async onDelete(___arguments) {
    var formEmailTo, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  formEmailTo = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formEmailTo')), async (item) => {


   return (item != ___arguments.context.dataModel);
  }));
  ___arguments.context.pageData['formEmailTo'] = formEmailTo;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', formEmailTo);

  },
  /* handler:onDelete */
  /* content */
}))

define('./pages/sponsorShare/components/5952aac50b11b501f254982addee25c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDelete */
  async onDelete(___arguments) {
    var formCellTo, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  formCellTo = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'formCellTo')), async (item) => {


   return (item != ___arguments.context.dataModel);
  }));
  ___arguments.context.pageData['formCellTo'] = formCellTo;
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', formCellTo);

  },
  /* handler:onDelete */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      return ___arguments.context.dataModel

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/cb59721e3f41c58f8f96fc44b32b9c9e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var newFormCellTo, fieldValue, valueItem, valueList, value;


  ___arguments.context.pageData['formCellToError'] = false;
  ___arguments.context.pageData['fieldPhones'] = ___arguments.value;
  if (___arguments.value != '' && ((___arguments.value.endsWith(',')) || (___arguments.value.endsWith(' ')))) {
    ___arguments.context.pageData['fieldPhonesSubmit'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'fieldPhones'))

  },
  /* handler:onValueAssignment */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var formCellTo, formatPhone, valueItem, valueList, value, fieldPhones;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'fieldPhonesSubmit')) {
    ___arguments.context.pageData['fieldPhonesSubmit'] = false;
    valueList = [];
    formCellTo = (getObjectProperty(___arguments.context.pageData, 'formCellTo'));
    fieldPhones = (getObjectProperty(___arguments.context.pageData, 'fieldPhones'));
    value = fieldPhones.trim();
    valueList = ((value.split(',')).concat((value.split(' '))));
    if (valueList.length > 0) {
      for (var valueItem_index in valueList) {
        valueItem = valueList[valueItem_index];
        formatPhone = (await BackendlessUI.Functions.Custom['fn_f30620e2042fe4e4cc73ad02ed3f3336'](valueItem));
        if (formatPhone != '') {
          formCellTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formCellTo, formatPhone));
        }
      }
      ___arguments.context.pageData['fieldPhones'] = '';
    }
    ___arguments.context.pageData['formCellTo'] = formCellTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', formCellTo);
  }

  return ['sponsorshare_cell-form_to_field']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/a1ef9cae3bbf6a6adfcd989f0f21c3ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formCellMessageError'] = false;
  ___arguments.context.pageData['formCellMessage'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formCellMessage'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/8bfd450fb1c84d17098fcb83bb1ca542/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formEmailReminders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formEmailReminders'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/d9e71c933aeb4396cce6bc6bc79b8c14/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formEmailSubjectError'] = false;
  ___arguments.context.pageData['formEmailSubject'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    var formEmailSubject, lastSellerName, list, sellerItem, sellerNamesList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formEmailSubject'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/e04e1a0b87f176b104a67a553a7aee2a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['formCellReminders'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  onCheckedStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'formCellReminders'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/7c850a43d3bfa15fc361b06293f7a86f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_cell-form'];
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'cell') {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/ae4a96f3ad35d86ed758eedaf047c3ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_soc-form'];
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'soc') {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/414ef23553419e2dbfb56544c7e222cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isLoading')) == false && (getObjectProperty(___arguments.context.pageData, 'noResults')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/3e7bb84931c1e7c4bd4fa79369b3e00f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_noresults'];
  if (getObjectProperty(___arguments.context.pageData, 'noResults')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/93e7b8e68bd792726c4b2aa26b734bd3/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_loading'];
  if (getObjectProperty(___arguments.context.pageData, 'isLoading')) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/3b136d8b154b27b17a4a7e82dd98a4d6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (getObjectProperty(___arguments.context.pageData, 'contacts')) {
    isDisabled = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'emails')).length == 0;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var formEmailTo, contactItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formEmailToError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'emails')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'emails')).length > 0) {
    formEmailTo = (getObjectProperty(___arguments.context.pageData, 'formEmailTo'));
    var contactItem_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'emails'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      formEmailTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formEmailTo, (getObjectProperty(contactItem, 'value'))));
    }
    ___arguments.context.pageData['formEmailTo'] = formEmailTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('94848f2c472d156ed6a41c8f54eb78d9', formEmailTo);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorShare/components/048bb0240e8f449b93d7b328b62e60dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var formCellTo, contactItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['formCellToError'] = false;
  if ((getObjectProperty(___arguments.context.pageData, 'contacts')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'phones')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'phones')).length > 0) {
    formCellTo = (getObjectProperty(___arguments.context.pageData, 'formCellTo'));
    var contactItem_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'phones'));
    for (var contactItem_index in contactItem_list) {
      contactItem = contactItem_list[contactItem_index];
      formCellTo = (await BackendlessUI.Functions.Custom['fn_9d167b3f52282c0dbef5bcaf729374cd'](formCellTo, (getObjectProperty(contactItem, 'value'))));
    }
    ___arguments.context.pageData['formCellTo'] = formCellTo;
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('52778041bb6d594ec7db470148c412bd', formCellTo);
  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    var isDisabled;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isDisabled = true;
  if (getObjectProperty(___arguments.context.pageData, 'contacts')) {
    isDisabled = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'contacts')), 'current')), 'phones')).length == 0;
  }

  return isDisabled

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/e90e6095d254d7d9806d79bdbec1a2f9/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sponsorSocLink'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/863d2cae177d8986406c1e6c845a1269/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await (async function() {
  	
  	const button = ___arguments.event.target;
  	const input = button.parentElement.parentElement.querySelector('input');
  	input.select();
  	document.execCommand("copy");
  })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/sponsorShare/components/4593ab1d341398fc79046bd9b4cd5cb3/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['sponsorshare_email-form'];
  if ((getObjectProperty(___arguments.context.pageData, 'activeType')) == 'email') {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/sponsorShare/components/b0fbbf67c5871bfec86d92fbc7e1b7df/bundle.js', [], () => ({
  /* content */
  /* handler:onTextChange */
  ['onTextChange'](___arguments) {
      ___arguments.context.pageData['formEmailMessageError'] = false;

  },
  /* handler:onTextChange */
  /* content */
}))

define('./pages/staffFundraisers/components/3c2c0edf83819498ace3b9e378581f67/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  onWhereClauseAssignment(___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  where = 'objectId = \'\'';
  if (getObjectProperty(___arguments.context.pageData, 'CurrentSeasonObjectId')) {
    where = ['SeasonObjectId = \'',(getObjectProperty(___arguments.context.pageData, 'CurrentSeasonObjectId')),'\''].join('');
  }

  return where

  },
  /* handler:onWhereClauseAssignment */
  /* handler:onRecordSelect */
  async onRecordSelect(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModal'] = true;
  ___arguments.context.pageData['modalTitle'] = (getObjectProperty(___arguments.selectedRecord, 'Name'));
  ___arguments.context.pageData['modalSubtitle'] = ([(await BackendlessUI.Functions.Custom['fn_20217ef49bece0b76c85d32fa0f1d4a7']((getObjectProperty(___arguments.selectedRecord, 'StartDate')))),' - ',(await BackendlessUI.Functions.Custom['fn_20217ef49bece0b76c85d32fa0f1d4a7']((getObjectProperty(___arguments.selectedRecord, 'EndDate'))))].join(''));
  ___arguments.context.pageData['modalObjectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/staffFundraisers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var settings, userCheck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['CurrentSeasonObjectId'], ___arguments.context.appData));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);
  }
  ___arguments.context.pageData['CurrentSeasonObjectId'] = (getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonObjectId'));
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['modalTitle'] = '';
  ___arguments.context.pageData['modalSubtitle'] = '';
  ___arguments.context.pageData['modalObjectId'] = '';

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/staffFundraisers/components/f7c35c4ab31d7e4b47b1f1eea9efea3b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['modalTitle'] = '';
  ___arguments.context.pageData['modalSubtitle'] = '';
  ___arguments.context.pageData['modalObjectId'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffFundraisers/components/e4de59995e2f74218bcd781d1b69c12a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['modalTitle'] = '';
  ___arguments.context.pageData['modalSubtitle'] = '';
  ___arguments.context.pageData['modalObjectId'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffFundraisers/components/759d10fa456b3a2f4a0e41d45893de9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['stafffundraisers__modal-orders'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/staffFundraisers/components/9cb2c0d277fbadee761b3597fb56aeaa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (getObjectProperty(___arguments.context.pageData, 'modalTitle')) {
    content2 = (getObjectProperty(___arguments.context.pageData, 'modalTitle'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffFundraisers/components/5bdee889f3d411c8f8b27f8bedec265f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (getObjectProperty(___arguments.context.pageData, 'modalSubtitle')) {
    content2 = (getObjectProperty(___arguments.context.pageData, 'modalSubtitle'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffFundraisers/components/c7fd77df5339b09d732b3db3b4696296/bundle.js', [], () => ({
  /* content */
  /* handler:onWhereClauseAssignment */
  onWhereClauseAssignment(___arguments) {
    var where;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  where = 'objectId = \'\'';
  if (getObjectProperty(___arguments.context.pageData, 'modalObjectId')) {
    where = ['Fundraisers[Orders].objectId = \'',(getObjectProperty(___arguments.context.pageData, 'modalObjectId')),'\''].join('');
  }

  return where

  },
  /* handler:onWhereClauseAssignment */
  /* content */
}))

define('./pages/staffGAImport/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var pageReady, userCheck, response;

/**
 * Describe this function...
 */
async function setPageData() {
  ___arguments.context.pageData['itemNumberMapObject'] = '';
  ___arguments.context.pageData['fileContentList'] = [];
  ___arguments.context.pageData['importedFileList'] = [];
  ___arguments.context.pageData['processButtonDisabled'] = true;
  ___arguments.context.pageData['orderNumberPrefix'] = 80;
  ___arguments.context.pageData['gaCatalogItems'] = '';
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function itemNumberMap() {
  response = (await Backendless.Request.get(`${Backendless.appPath}/services/utils/gaitemmap`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  ___arguments.context.pageData['itemNumberMapObject'] = (getObjectProperty(response, 'itemNumberMapObject'));
  ___arguments.context.pageData['catalogId'] = (getObjectProperty(response, 'catalogId'));
}


  pageReady = false;
  await setPageData();
  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['StoreBaseURL', 'OfficeAPIBaseURL', 'APIKey', 'EasycronAPIKey', 'CurrentSeasonDatabase'], ___arguments.context.appData));
    pageReady = true;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);
  }
  if (pageReady) {
    await itemNumberMap();
    ___arguments.context.pageData['importedFileList'] = (await Backendless.Data.of('GAOrders').find(Backendless.DataQueryBuilder.create().setProperties(['FileName', 'FileRows', 'CreatedFormatted']).excludeProperties(['objectId']).setSortBy('created DESC').setPageSize(25).setDistinct(true)));
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/staffGAImport/components/bc173039586a9c0e10ba4a361b91278f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var startTime, itemCountEmailBody, itemCountObject, j, insertList, error, apiOutput, errorList, fileRow, i, transactionResults, transaction, settings, counter, insertOrderObject, lastOrderId, fileContentList, uniqueCampaignList, item, fundraiserObject, creditCode, orderNumber;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function errorHandler() {
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Uh oh!',[`html`]: errorList.join('<br>'),[`icon`]: 'error',[`confirmButtonText`]: 'Close',[`showCancelButton`]: false }), null);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bc173039586a9c0e10ba4a361b91278f')), 'button-loading', '');
  ___arguments.context.pageData['processButtonDisabled'] = true;
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).resetFileList() })('61484356d9cf2617aa71556cb8bb800c');
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function createInsertOrderObject() {
  orderNumber = (Number((String(getObjectProperty(___arguments.context.pageData, 'orderNumberPrefix')) + String(subsequenceFromStartLast((getObjectProperty(fileRow, 'Order Id')), 3)))));
  creditCode = (Number((getObjectProperty(fileRow, 'Campaign Id'))));
  return { [`OrderNumbers`]: [(getObjectProperty(fileRow, 'Order Id'))],[`OrderNumber`]: orderNumber,[`Order`]: ({ [`CustomerOrderNumber`]: orderNumber,[`idOrder`]: orderNumber,[`orderDate`]: ((getObjectProperty(fileRow, 'Order Timestamp')) === null) ? '' : (getObjectProperty(fileRow, 'Order Timestamp')),[`SubTotal`]: 0,[`Shipping`]: 0,[`Phone`]: ((getObjectProperty(fileRow, 'Recipient Phone')) === null) ? '' : ((String(getObjectProperty(fileRow, 'Recipient Phone'))).replace((new RegExp('\\D', 'g')), '')),[`Email`]: (getObjectProperty(fileRow, 'Recipient Email')).trim(),[`LastName`]: subsequenceFromStartLast((getObjectProperty(fileRow, 'Recipient Name')), (((getObjectProperty(fileRow, 'Recipient Name')).trim().lastIndexOf(' ') + 1) - 1)).trim(),[`FirstName`]: (getObjectProperty(fileRow, 'Recipient Name')).slice(0, (getObjectProperty(fileRow, 'Recipient Name')).trim().lastIndexOf(' ') + 1).trim(),[`Address`]: [(getObjectProperty(fileRow, 'Address 1')).trim(),' ',((getObjectProperty(fileRow, 'Address 2')) === null) ? '' : (getObjectProperty(fileRow, 'Address 2')).trim()].join('').trim(),[`City`]: ((getObjectProperty(fileRow, 'City')) === null) ? '' : (getObjectProperty(fileRow, 'City')).trim(),[`State`]: ((getObjectProperty(fileRow, 'State')) === null) ? '' : (getObjectProperty(fileRow, 'State')).trim(),[`Zip`]: ((getObjectProperty(fileRow, 'Zip code')) === null) ? '' : (getObjectProperty(fileRow, 'Zip Code')).trim(),[`PartID`]: creditCode,[`creditCode`]: creditCode,[`shipSchool`]: 'N',[`Discount`]: 0,[`SalesTax`]: 0 }),[`Items`]: [],[`Seller`]: ({ [`PartID`]: creditCode,[`FirstName`]: (getObjectProperty((getObjectProperty(fundraiserObject, creditCode)), 'School')),[`LastName`]: '',[`Email`]: '',[`Teacher`]: '',[`Grade`]: '',[`SchoolID`]: (Number((getObjectProperty((getObjectProperty(fundraiserObject, creditCode)), 'SchoolId')))),[`CreditCode`]: creditCode,[`Address1`]: '',[`Address2`]: '',[`City`]: '',[`State`]: '',[`PostalCode`]: '',[`Phone`]: '' }),[`RawData`]: [],[`FileName`]: (getObjectProperty(___arguments.context.pageData, 'fileObject.name')),[`FileRows`]: (getObjectProperty(___arguments.context.pageData, 'fileContentList')).length,[`Processed`]: false }
}


  startTime = ((new Date()).valueOf());
  errorList = [];
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bc173039586a9c0e10ba4a361b91278f')), 'button-loading');
  try {
    if ((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'importedFileList')), async (item) => {


     return ((getObjectProperty(item, 'FileName')) == (getObjectProperty(___arguments.context.pageData, 'fileObject.name')));
    })) !== null && !Array.isArray((await asyncListFind((getObjectProperty(___arguments.context.pageData, 'importedFileList')), async (item) => {


     return ((getObjectProperty(item, 'FileName')) == (getObjectProperty(___arguments.context.pageData, 'fileObject.name')));
    }))) && (typeof (await asyncListFind((getObjectProperty(___arguments.context.pageData, 'importedFileList')), async (item) => {


     return ((getObjectProperty(item, 'FileName')) == (getObjectProperty(___arguments.context.pageData, 'fileObject.name')));
    })) === 'object')) {
      addItemToList(errorList, (['The file \'',(getObjectProperty(___arguments.context.pageData, 'fileObject.name')),'\' has already been imported.'].join('')));
      await errorHandler();
      return ;
    }
    await (async function(pageData) {
    	readXlsxFile(pageData.fileObject).then(function (data) {
    	  
    	    const headers = data[0];
    	    const jsonData = [];
    	    for (let i = 1; i < data.length; i++) {
    	        const temp = {};
    	        for (let j = 0; j < headers.length; j++) {
    	            temp[headers[j]] = data[i][j];
    	        }
    	        jsonData.push(temp);
    	    }
    	    
    	  pageData.fileContentList = jsonData;
    	
    	/*
    	    pageData.fileContentList = JSON.stringify(
    	        jsonData,
    	        null,
    	        2
    	    );
    	*/
    	    
    	    //console.log(typeof(pageData.fileContentList));
    	
    	});
    })(___arguments.context.pageData);

    ;(function() {
      const callback = async () => {
          if ((getObjectProperty(___arguments.context.pageData, 'fileContentList')).length > 0) {
        stopSetTimeout('listReady');
      }

      };

      const timerId = 'listReady';
      const timerDelay = 200;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    await new Promise(r => setTimeout(r, 1000 || 0));
    fileContentList = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'fileContentList')), 1, async (item) => {


     return (getObjectProperty(item, 'Order Id'));
    }));
    counter = 0;
    lastOrderId = 0;
    insertList = [];
    itemCountObject = ({  });
    uniqueCampaignList = (await (async function(orders) {
    	const uniqueOrders = Array.from(new Set(orders.map(order => `${order['Campaign Id']}|${order['Campaign Name']}`)))
    	  .map(orderKey => {
    	    const [campaignId, campaignName] = orderKey.split('|');
    	    return { 'Campaign Id': campaignId, 'Campaign Name': campaignName };
    	  });

    	return uniqueOrders;
    })(fileContentList));
    counter = 0;
    for (var count = 0; count < 2; count++) {
      counter = (typeof counter == 'number' ? counter : 0) + 1;
      try {
        fundraiserObject = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/fundraiser/bygacampaignid',String('?seasondb=') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase')),String('&campaignIds=') + String((uniqueCampaignList.map(item => item['Campaign Id'])).join(','))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'APIKey')) })).setEncoding('utf8').send());
        break;

      } catch (error) {
        if ((getObjectProperty(error, 'message')).toUpperCase().indexOf('network error'.toUpperCase()) + 1 > 0) {
          addItemToList(errorList, 'Network Error - Make sure CORs extension is on.');
          await errorHandler();
          return ;
        } else if (counter == 2) {
          await Backendless.Messaging.sendEmail('staffGAImport Page - Error getting fundraisers by GA campaign Id', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' These are the campaign Ids: ',(JSON.stringify(uniqueCampaignList)),' This is the file: ',(getObjectProperty(___arguments.context.pageData, 'fileObject.name'))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
        }

      }
    }
    if ((Object.keys(fundraiserObject)).length != uniqueCampaignList.length) {
      addItemToList(errorList, (String('Campaign(s) in the import file were not found in Mark\'s system (checks payable field): <br>') + String((await Promise.all((await asyncListFilter(uniqueCampaignList, async (item) => {


       return (!((Object.keys(fundraiserObject)).includes((getObjectProperty(item, 'Campaign Id')))));
      })).map(async item => {; return ([(getObjectProperty(item, 'Campaign Name')),' (campaign id: ',(getObjectProperty(item, 'Campaign Id')),')'].join(''));}))).join('<br>'))));
      await errorHandler();
      return ;
    }
    if (!((getObjectProperty(___arguments.context.pageData, 'gaCatalogItemObject')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'gaCatalogItemObject'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'gaCatalogItemObject')) === 'object'))) {
      for (var count2 = 0; count2 < 2; count2++) {
        try {
          ___arguments.context.pageData['gaCatalogItemObject'] = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OfficeAPIBaseURL')),'/inventory/inventoryByCatalog',String('?seasondb=') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'CurrentSeasonDatabase')),String('&catalogIds=') + String(getObjectProperty(___arguments.context.pageData, 'catalogId'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'APIKey')) })).setEncoding('utf8').send());
          break;

        } catch (error) {
          await Backendless.Messaging.sendEmail('staffGAImport Page - Error getting items by catalog id', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' These are the campaign Ids: ',(JSON.stringify(uniqueCampaignList)),' This is the file: ',(getObjectProperty(___arguments.context.pageData, 'fileObject.name'))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

        }
      }
    }
    if (!((getObjectProperty(___arguments.context.pageData, 'gaCatalogItemObject')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'gaCatalogItemObject'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'gaCatalogItemObject')) === 'object'))) {
      addItemToList(errorList, 'Items for the GA catalog were not retrieved from Mark\'s system.');
      await errorHandler();
      return ;
    }
    counter = 0;
    for (var fileRow_index in fileContentList) {
      fileRow = fileContentList[fileRow_index];
      counter = (typeof counter == 'number' ? counter : 0) + 1;
      if ((getObjectProperty(fileRow, 'Order Id')) != lastOrderId) {
        if (counter != 1) {
          addItemToList(insertList, insertOrderObject);
        }
        insertOrderObject = await createInsertOrderObject();
      }
      lastOrderId = (getObjectProperty(fileRow, 'Order Id'));
      if (!(typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'itemNumberMapObject')), (getObjectProperty(fileRow, 'Product Sku')))) === 'undefined')) {
        var j_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'itemNumberMapObject')), (getObjectProperty(fileRow, 'Product Sku'))));
        for (var j_index in j_list) {
          j = j_list[j_index];
          addItemToList((getObjectProperty(insertOrderObject, 'Items')), ({ [`idCartRow`]: 0,[`idOrder`]: (getObjectProperty(insertOrderObject, 'OrderNumber')),[`sku`]: (getObjectProperty(j, 'itemNumber')),[`quantity`]: (getObjectProperty(fileRow, 'Product Quantity')) * (getObjectProperty(j, 'quantity')),[`unitPrice`]: 0,[`description`]: (getObjectProperty(j, 'description')) }));
          itemCountObject[(getObjectProperty(j, 'itemNumber'))] = ((getObjectProperty(fileRow, 'Product Quantity')) * (getObjectProperty(j, 'quantity')) + ((typeof (getObjectProperty(itemCountObject, (getObjectProperty(j, 'itemNumber')))) === 'undefined') ? 0 : (getObjectProperty(itemCountObject, (getObjectProperty(j, 'itemNumber'))))));
        }
      } else {
        if (typeof (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'gaCatalogItemObject')), (getObjectProperty(fileRow, 'Product Sku')))) === 'undefined') {
          addItemToList(errorList, (['GA item number ',(getObjectProperty(fileRow, 'Product Sku')),' is unknown.'].join('')));
          continue;
        }
        addItemToList((getObjectProperty(insertOrderObject, 'Items')), ({ [`idCartRow`]: 0,[`idOrder`]: (getObjectProperty(insertOrderObject, 'OrderNumber')),[`sku`]: [(getObjectProperty(___arguments.context.pageData, 'catalogId')),'-',(getObjectProperty(fileRow, 'Product Sku'))].join(''),[`quantity`]: (getObjectProperty(fileRow, 'Product Quantity')),[`unitPrice`]: 0,[`description`]: (getObjectProperty(fileRow, 'Product Name')) }));
        itemCountObject[(getObjectProperty(fileRow, 'Product Sku'))] = ((getObjectProperty(fileRow, 'Product Quantity')) + ((typeof (getObjectProperty(itemCountObject, (getObjectProperty(fileRow, 'Product Sku')))) === 'undefined') ? 0 : (getObjectProperty(itemCountObject, (getObjectProperty(fileRow, 'Product Sku'))))));
      }
      addItemToList((getObjectProperty(insertOrderObject, 'RawData')), fileRow);
    }
    addItemToList(insertList, insertOrderObject);
    if (errorList.length > 0) {
      errorList = (await (async function(errorList) {
      	const uniqueStrings = [...new Set(errorList)];

      	return uniqueStrings;
      })(errorList));
      await errorHandler();
      return ;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'fileContentList')).length != counter) {
      addItemToList(errorList, (['Import file ',(getObjectProperty(___arguments.context.pageData, 'fileObject.name')),' contained ',(getObjectProperty(___arguments.context.pageData, 'fileContentList')).length,' rows but only ',counter,' rows were processed.  These numbers should match.'].join('')));
      await errorHandler();
      return ;
    }
    try {
      var i_end = insertList.length;
      var i_inc = 100;
      if (1 > i_end) {
        i_inc = -i_inc;
      }
      for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
        await Backendless.Data.of('GAOrders').bulkCreate( (insertList.slice((i - 1), i + 99 >= insertList.length ? insertList.length : i + 99)) );
      }

    } catch (error) {
      await Backendless.Messaging.sendEmail('staffGAImport - Bulk Create Error', new Backendless.Bodyparts({ textmessage: (['There was an error with the bulk create statement on the staffGAImport page.  This is the error: ',error,' This is what we were trying to insert: ',insertList.join(',')].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
      await Backendless.Data.of('GAOrders').bulkDelete( (['FileName =\'',(getObjectProperty(___arguments.context.pageData, 'fileObject.name')),'\''].join('')) );
      addItemToList(errorList, 'There was a problem adding these orders to the database.  An email has been sent to IT.');
      await errorHandler();
      return ;

    }
    ___arguments.context.pageData['importedFileList'] = ([({ [`___class`]: 'GAOrders',[`FileName`]: (getObjectProperty(___arguments.context.pageData, 'fileObject.name')),[`FileRows`]: (getObjectProperty(___arguments.context.pageData, 'fileContentList')).length,[`CreatedFormatted`]: [(new Date((new Date())).getMonth() + 1),'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear())].join('') })].concat((getObjectProperty(___arguments.context.pageData, 'importedFileList'))));

  } catch (error) {
    await Backendless.Messaging.sendEmail('staffGAImport - General processing error', new Backendless.Bodyparts({ textmessage: (['This is the error ',error,' File: ',(getObjectProperty(___arguments.context.pageData, 'fileObject.name')),' This is the fileRow that errored: ',(JSON.stringify(fileRow))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);
    addItemToList(errorList, 'There was an unknown error - Sorry!');
    await errorHandler();
    return ;

  }
  try {
    for (var count3 = 0; count3 < 2; count3++) {
      apiOutput = (await Backendless.Request['patch']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})('https://api.easycron.com/v1/cron-jobs/8002033')).set(({ [`Content-Type`]: 'application/json',[`X-API-Key`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'EasycronAPIKey')) })).setEncoding('utf8').send(({ [`status`]: 1 })));
      break;
    }

  } catch (error) {
    await Backendless.Messaging.sendEmail('staffGAImport - Error enabling cron job', new Backendless.Bodyparts({ textmessage: (String('Orders will not import until this is resolved.  This is the error ') + String(error)) }), ensureArray('tim@meadowfarms.com'), undefined);

  }
  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).resetFileList() })('61484356d9cf2617aa71556cb8bb800c');
  await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Success',[`html`]: ['The file ',(getObjectProperty(___arguments.context.pageData, 'fileObject.name')),' has been successfully processed for importing.','  ',insertList.length,'   orders will be available for import in Web Admin soon.'].join(''),[`icon`]: 'success',[`confirmButtonText`]: 'Close',[`showCancelButton`]: false }), null);
  if (false) {
    itemCountEmailBody = '';
    var j_list2 = (Object.keys(itemCountObject));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      itemCountEmailBody = String(itemCountEmailBody) + String([j,': ',(getObjectProperty(itemCountObject, j)),'<br>'].join(''));
    }
    await Backendless.Messaging.sendEmail((String('GA Import Item Summary - ') + String(getObjectProperty(___arguments.context.pageData, 'fileObject.name'))), new Backendless.Bodyparts({ htmlmessage: itemCountEmailBody }), ensureArray('tim@meadowfarms.com'), undefined);
  }
  ___arguments.context.pageData['fileObject'] = ({  });
  ___arguments.context.pageData['fileContentList'] = [];
  ___arguments.context.pageData['processButtonDisabled'] = true;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bc173039586a9c0e10ba4a361b91278f')), 'button-loading', '');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'processButtonDisabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/staffGAImport/components/61484356d9cf2617aa71556cb8bb800c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item, fileExt, fileExtList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['fileObject'] = (getObjectProperty((___arguments['filesList'][0]), 'file'));
  fileExtList = ['xls', 'xlsx'];
  fileExt = (getObjectProperty((___arguments['filesList'][0]), 'name')).split('.').slice(-1)[0];
  if ((await asyncListFilter(fileExtList, async (item) => {


   return (fileExt == item);
  })).length == 1) {
    ___arguments.context.pageData['processButtonDisabled'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/staffGAImport/components/421e1c82e11561bb33ec420294348d2a/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`headerName`]: 'GA Item',[`field`]: 'GAItemNumber',[`flex`]: 1,[`filter`]: false,[`sortable`]: true }), ({ [`headerName`]: 'MF Item(s)',[`field`]: 'MFItemNumber',[`flex`]: 1,[`filter`]: false,[`sortable`]: true })]

  },
  /* handler:columnDefsLogic */
  /* handler:rowsDataLogic */
  async ['rowsDataLogic'](___arguments) {
    var return2, mfItemNumbers, item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  return2 = [];
  if ((getObjectProperty(___arguments.context.pageData, 'itemNumberMapObject')) !== null && !Array.isArray((getObjectProperty(___arguments.context.pageData, 'itemNumberMapObject'))) && (typeof (getObjectProperty(___arguments.context.pageData, 'itemNumberMapObject')) === 'object')) {
    return2 = (await Promise.all((Object.keys((getObjectProperty(___arguments.context.pageData, 'itemNumberMapObject')))).map(async item => {  mfItemNumbers = '';
      var j_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'itemNumberMapObject')), item));
      for (var j_index in j_list) {
        j = j_list[j_index];
        mfItemNumbers = String(mfItemNumbers) + String(getValueLength(mfItemNumbers) > 0 ? '\n' : '');
        mfItemNumbers = String(mfItemNumbers) + String([(getObjectProperty(j, 'quantity')),' x ',(getObjectProperty(j, 'itemNumber')),' ',(getObjectProperty(j, 'description'))].join(''));
      }
    ; return ({ [`GAItemNumber`]: item,[`MFItemNumber`]: mfItemNumbers });})));
  }

  return return2

  },
  /* handler:rowsDataLogic */
  /* content */
}))

define('./pages/staffGAImport/components/465d83dd24279add94418121146201fd/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`headerName`]: 'File',[`field`]: 'FileName',[`flex`]: 1,[`filter`]: false,[`sortable`]: true }), ({ [`headerName`]: 'Rows',[`field`]: 'FileRows',[`flex`]: 1,[`filter`]: false,[`sortable`]: true }), ({ [`headerName`]: 'Date',[`field`]: 'CreatedFormatted',[`flex`]: 1,[`filter`]: false,[`sortable`]: true })]

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/staffGAImport/components/77caa44b085ddc44870c339b6b9234b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function textToTitleCase(str) {
 return str.replace(/\S+/g, function(txt) {
   return txt[0].toUpperCase() + txt.substring(1).toLowerCase()
 })
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase')) === 'undefined') ? 'Upload Order Import File' : ['Upload Order Import File (',textToTitleCase(getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase')),')'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var optionList, userCheck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function pageVariables() {
  ___arguments.context.pageData['searchBtnDisabled'] = true;
  ___arguments.context.pageData['buildBtnDisabled'] = true;
  ___arguments.context.pageData['schoolId'] = '';
  ___arguments.context.pageData['fundraiserObject'] = ({  });
  ___arguments.context.pageData['parentLetterObject'] = ({ [`imageURL`]: 'Not found',[`pdfURL`]: 'Not found' });
}


  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c']('staffParentLetter'));
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['OrdersAPIBaseURL', 'StoreBaseURL', 'OfficeAPIBaseURL', 'APIKey', 'CurrentSeasonDatabase', 'cdnURL'], ___arguments.context.appData));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', ({ [`redirect`]: 'staffParentLetter' }));
  }
  optionList = [({ [`label`]: 'Fall 25',[`value`]: 'fall25' }), ({ [`label`]: 'Spring 25',[`value`]: 'spring25' }), ({ [`label`]: 'Fall 24',[`value`]: 'fall24' }), ({ [`label`]: 'Spring 24',[`value`]: 'spring24' }), ({ [`label`]: 'Fall 23',[`value`]: 'fall23' })];
  (function (componentUid, options) { ___arguments.context.getComponentByUid(componentUid).options = options })('ed7f4e21b3c73705aa6c5294175a40d3', optionList);
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('ed7f4e21b3c73705aa6c5294175a40d3', (getObjectProperty((optionList[0]), 'value')));
  await pageVariables();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/staffParentLetter/components/a442ff1c6b990e09e9fce5e735b85ef2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'searchBtnDisabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response, error, parentLetterList, additionalText, contactText, fundraiserResponse, fundraiserList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function ensureArray(items) {
  return Array.isArray(items) ? items : [items]
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a442ff1c6b990e09e9fce5e735b85ef2')), 'button-loading');
  ___arguments.context.pageData['parentLetterObject'] = ({ [`imageURL`]: 'Not found',[`pdfURL`]: 'Not found' });
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'schoolId'))) == 7) {
    fundraiserResponse = (await Backendless.Request.get(`${Backendless.appPath}/services/organization/getfundraiserbyid`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'schoolId': (getObjectProperty(___arguments.context.pageData, 'schoolId')),'seasonDb': JSON.stringify(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ed7f4e21b3c73705aa6c5294175a40d3'))) }).send());
    if (fundraiserResponse !== null && !Array.isArray(fundraiserResponse) && (typeof fundraiserResponse === 'object')) {
      ___arguments.context.pageData['fundraiserObject'] = fundraiserResponse;
      additionalText = '';
      if ((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.FundraiserType')) != 'online' && (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.FundraiserType')) != 'hybrid') {
        if (getValueLength((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.chkPayableTo'))) > 0) {
          additionalText = String(additionalText) + String(String('Checks Payable: ') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.chkPayableTo')));
        }
      }
      contactText = '';
      if ((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLSponsorName')) == '1' && (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SPONSER'))) {
        contactText = String(contactText) + String((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SPONSER')).trim());
      }
      if ((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLSponsorPhone')) == '1' && (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Telephone'))) {
        contactText = String(contactText) + String(getValueLength(contactText) > 0 ? ' | ' : '');
        contactText = String(contactText) + String((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Telephone')).trim());
      }
      if ((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLSponsorEmail')) == '1' && (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SpEmail'))) {
        contactText = String(contactText) + String(getValueLength(contactText) > 0 ? ' | ' : '');
        contactText = String(contactText) + String((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SpEmail')).trim());
      }
      if (getValueLength(contactText) > 0) {
        additionalText = String(additionalText) + String(getValueLength(additionalText) > 0 ? '\n' : '');
        additionalText = String(additionalText) + String(String('Contact: ') + String(contactText));
      }
      if ((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLType')) == 'C') {
        additionalText = String(additionalText) + String(getValueLength(additionalText) > 0 ? '\n' : '');
        additionalText = String(additionalText) + String('**SEE REVERSE SIDE FOR IMPORTANT INFORMATION FROM YOUR GROUP**');
      }
      (getObjectProperty(___arguments.context.pageData, 'fundraiserObject'))['additionalText'] = additionalText;
      ___arguments.context.pageData['schoolId'] = '';
      ___arguments.context.pageData['searchBtnDisabled'] = true;
      ___arguments.context.pageData['buildBtnDisabled'] = false;
      parentLetterList = (await Backendless.Data.of('ParentLetters').find(Backendless.DataQueryBuilder.create().setWhereClause(([String('OfficeOrganizationId = ') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SchoolId')),' AND ',['Season = \'',((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ed7f4e21b3c73705aa6c5294175a40d3')),'\''].join('')].join(''))).setSortBy(['created DESC']).setPageSize(10)));
      if (parentLetterList.length > 0) {
        ___arguments.context.pageData['parentLetterObject'] = ({ [`imageURL`]: (getObjectProperty((parentLetterList[0]), 'ImageURL')),[`pdfURL`]: (getObjectProperty((parentLetterList[0]), 'PDFURL')) });
      } else {
        try {
          response = (await Backendless.Request['get']((function(url){ if( !url ) { throw new Error('Url must be specified.')} if( !url.startsWith('http://') && !url.startsWith('https://')) { return 'https://' + url } return url})(([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'OrdersAPIBaseURL')),'?route=parentletter/getImage',String('&schoolid=') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SchoolId')),String('&season=') + String(getObjectProperty(___arguments.context.pageData, 'seasonDb'))].join('')))).set(({ [`ApiKey`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'APIKey')) })).setEncoding('utf8').send());

        } catch (error) {
          await Backendless.Messaging.sendEmail('staffParentLetter Page - Error trying to find a file system parent letter', new Backendless.Bodyparts({ textmessage: (['This was the error: ',error,' These were the search variables: ',String('&schoolid=') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SchoolId')),String('&season=') + String(getObjectProperty(___arguments.context.pageData, 'seasonDb'))].join('')) }), ensureArray('tim@meadowfarms.com'), undefined);

        }
        if (response && getValueLength((getObjectProperty(response, 'fileURL'))) > 0) {
          ___arguments.context.pageData['parentLetterObject'] = ({ [`imageURL`]: (getObjectProperty(response, 'fileURL')),[`pdfURL`]: 'Not Found' });
        }
      }
    } else {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'No Results',[`html`]: 'No fundraiser found for the supplied School ID',[`icon`]: 'error',[`confirmButtonText`]: 'Close',[`showCancelButton`]: false }), null);
    }
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a442ff1c6b990e09e9fce5e735b85ef2')), 'button-loading', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffParentLetter/components/bfaf1b35f722062ac7822fc92a9b0859/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var inputInt;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  inputInt = (await (async function(str) {
  	const extractNumbers = str => {
  	  // Use a regular expression to match all numeric values
  	  const numbers = str.match(/\d+/g);

  	  // Join the array of numbers into a single string with no spaces
  	  return numbers ? numbers.join('') : '';
  	};

  	return extractNumbers(str);
  })(___arguments.value));
  if (getValueLength(inputInt) == 7) {
    ___arguments.context.pageData['searchBtnDisabled'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/staffParentLetter/components/ed7f4e21b3c73705aa6c5294175a40d3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['seasonDb'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/staffParentLetter/components/cb3a4f4c755575a877aba696ed0acfb4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.School'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/f46a9e2bf43b01aa4beeb7a3742baf2f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>End Date:</b> ') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Sale_End2')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/1eb6a6cf52f21cf3b7144f1834b237b8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Checks Payable:</b> ') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.chkPayableTo')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/2779aa77fe6fbb5651f3641b4bd2ad77/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Reason:</b> ') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Reason')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/ae1301ff87d4f45a97bf72ae27a27977/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Show Name:</b> ') + String((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLSponsorName')) == '1' ? ['YES (',(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SPONSER')),')'].join('') : 'NO'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/0935788bdf177bc9fb2f2a72d1754a8e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Show Email:</b> ') + String((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLSponsorEmail')) == '1' ? ['YES (',(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SpEmail')),')'].join('') : 'NO'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/a267cddb6b91412c0e0da30d8b31fba9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Show Phone:</b> ') + String((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLSponsorPhone')) == '1' ? ['YES (',(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SpPhone_Cell')),')'].join('') : 'NO'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/46450b5897b25624e29650454f829c24/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Goal:</b> ') + String(((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Goal')) === null) ? 'N/A' : String('$') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Goal'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/a7ed3f012859075a570c6d78e0c9e946/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>School Id:</b> ') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SchoolId')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/5fe61963df987b6a4d817f81357a7a5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Bilingual:</b> ') + String((getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLBiLingual')) == '1' ? 'YES' : 'NO'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/b51837c6c1a1c2db57dc8b5caba64527/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Image:</b> ') + String(((new RegExp('https', '')).test((getObjectProperty(___arguments.context.pageData, 'parentLetterObject.imageURL')))) ? ['<a href="',(getObjectProperty(___arguments.context.pageData, 'parentLetterObject.imageURL')),'" target="_blank" >',(getObjectProperty(___arguments.context.pageData, 'parentLetterObject.imageURL')),'</a>'].join('') : 'Not found'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/9e079382d4d584ffefcc90e1e1027dcc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>Group Members:</b> ') + String(getObjectProperty(___arguments.context.pageData, 'fundraiserObject.TotalStudentNumber')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/043963c892416d34693ddc96e5dc2618/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var response;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('043963c892416d34693ddc96e5dc2618')), 'button-loading');
  response = (await Backendless.Request.post(`${Backendless.appPath}/services/utils/createparentletter2`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`buildObject`]: ({ [`accountName`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.School')),[`schoolId`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.SchoolId')),[`endDate`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Sale_End2')),[`reason`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.Reason')),[`additionalText`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.additionalText')),[`buildImage`]: true,[`buildPDF`]: true,[`bilingual`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.PLBiLingual')) == '1' ? true : false,[`fundraiserType`]: (getObjectProperty(___arguments.context.pageData, 'fundraiserObject.FundraiserType')),[`logToDB`]: true }),[`settings`]: (getObjectProperty(___arguments.context.pageData, 'settings')),[`season`]: ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).value })('ed7f4e21b3c73705aa6c5294175a40d3')) }))));
  if (getValueLength((getObjectProperty(response, 'errorMessage'))) == 0) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((getObjectProperty(response, 'pdfURL')), true, undefined);
    ___arguments.context.pageData['parentLetterObject'] = ({ [`imageURL`]: (getObjectProperty(response, 'imageURL')),[`pdfURL`]: (getObjectProperty(response, 'pdfURL')) });
  } else {
    await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Error',[`html`]: (getObjectProperty(response, 'errorMessage')),[`icon`]: 'error',[`confirmButtonText`]: 'Close',[`showCancelButton`]: false }), null);
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('043963c892416d34693ddc96e5dc2618')), 'button-loading', '');

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'buildBtnDisabled'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/staffParentLetter/components/f19b165b1c7848b49e36f08e6383c041/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('<b>PDF:</b> ') + String(((new RegExp('https', '')).test((getObjectProperty(___arguments.context.pageData, 'parentLetterObject.pdfURL')))) ? ['<a href="',(getObjectProperty(___arguments.context.pageData, 'parentLetterObject.pdfURL')),'" target="_blank" >',(getObjectProperty(___arguments.context.pageData, 'parentLetterObject.pdfURL')),'</a>'].join('') : 'Not found'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffSellers/components/3c2c0edf83819498ace3b9e378581f67/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isOpenModal'] = true;
  ___arguments.context.pageData['sellerFullName'] = (getObjectProperty(___arguments.selectedRecord, 'FullName'));
  ___arguments.context.pageData['sellerMicrostoreId'] = (getObjectProperty(___arguments.selectedRecord, 'MicrostoreID'));
  ___arguments.context.pageData['sellerMicrostorePath'] = (getObjectProperty(___arguments.selectedRecord, 'MicrostorePath'));
  ___arguments.context.pageData['sellerEmail'] = (getObjectProperty(___arguments.selectedRecord, 'email'));
  ___arguments.context.pageData['sellerObjectId'] = (getObjectProperty(___arguments.selectedRecord, 'objectId'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/staffSellers/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var userCheck, settingKeys;

/**
 * Describe this function...
 */
async function setPageData() {
  ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['sellerFullName'] = '';
  ___arguments.context.pageData['sellerEmail'] = '';
  ___arguments.context.pageData['sellerMicrostoreId'] = '';
  ___arguments.context.pageData['sellerMicrostorePath'] = '';
  ___arguments.context.pageData['sellerObjectId'] = '';
  ___arguments.context.pageData['sellerSigninLink'] = '';
  ___arguments.context.pageData['isDisabledSigninLinkBtn'] = false;
}


  await setPageData();
  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['StoreBaseURL'], ___arguments.context.appData));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/staffSellers/components/add90473a43941818083e84347363726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['sellerFullName'] = '';
  ___arguments.context.pageData['sellerMicrostoreId'] = '';
  ___arguments.context.pageData['sellerMicrostorePath'] = '';
  ___arguments.context.pageData['sellerObjectId'] = '';
  ___arguments.context.pageData['sellerEmail'] = '';
  ___arguments.context.pageData['sellerSigninLink'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffSellers/components/eb2f70adecfbc98a86f1c6cc26569456/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenModal'] = false;
  ___arguments.context.pageData['sellerFullName'] = '';
  ___arguments.context.pageData['sellerMicrostoreId'] = '';
  ___arguments.context.pageData['sellerMicrostorePath'] = '';
  ___arguments.context.pageData['sellerObjectId'] = '';
  ___arguments.context.pageData['sellerEmail'] = '';
  ___arguments.context.pageData['sellerSigninLink'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffSellers/components/fbb24d09a0e5f8d3777193217774464c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['staffsellers__modal-orders'];
  if (getObjectProperty(___arguments.context.pageData, 'isOpenModal')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/staffSellers/components/2e0f8d7ebe2a8ee3fe6ee65a33eea172/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (getObjectProperty(___arguments.context.pageData, 'sellerFullName')) {
    content2 = (getObjectProperty(___arguments.context.pageData, 'sellerFullName'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffSellers/components/406701b88003ddce79780a42f50f151a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (getObjectProperty(___arguments.context.pageData, 'sellerMicrostoreId')) {
    content2 = String('ShopID: ') + String(getObjectProperty(___arguments.context.pageData, 'sellerMicrostoreId'));
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/staffSellers/components/b68517a4de58b3bf78560a5768f3c0e9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var content2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  content2 = '';
  if (getObjectProperty(___arguments.context.pageData, 'sellerMicrostorePath')) {
    content2 = ['Store Link: ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')),(getObjectProperty(___arguments.context.pageData, 'sellerMicrostorePath'))].join('');
  }

  return content2

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.pageData, 'sellerMicrostorePath'))), true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffSellers/components/1541d18c16a9c8c6c43594351b02e8ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(toCopy) {
  	navigator.clipboard.writeText(toCopy);
  })((String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'settings')), 'StoreBaseURL')) + String(getObjectProperty(___arguments.context.pageData, 'sellerMicrostorePath'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffSellers/components/2439fa19d5869dbc763dc693c4d6daf6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var signinLink;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledSigninLinkBtn'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2439fa19d5869dbc763dc693c4d6daf6')), 'button-loading');
  signinLink = (await Backendless.Request.get(`${Backendless.appPath}/services/magicLink/MagicLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'baseUrl': JSON.stringify(((function () { return window.location.href })())),'email': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'sellerEmail'))) }).send());
  if (signinLink) {
    ___arguments.context.pageData['sellerSigninLink'] = signinLink;
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2439fa19d5869dbc763dc693c4d6daf6')), 'button-loading', '');
  ___arguments.context.pageData['isDisabledSigninLinkBtn'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledSigninLinkBtn'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/staffSellers/components/3616cde94c0a1d611728bbe63673e639/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sellerSigninLink'))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sellerSigninLink'))

  },
  /* handler:onTextAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'sellerSigninLink')).length > 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/staffSellers/components/b8ba4a5a8476a8262ede0f9890fe5f2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'sellerSigninLink')).length > 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/staffSellers/components/567ca496727c859f6b714d372642238f/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a83202278a4c2568aa2947d88bcde872');
  ___arguments.context.pageData['userEmail'] = (getObjectProperty(___arguments.selectedRecord, 'email'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/staffSellers/components/ea7d0d4d24582503442af03e430e6e12/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var signinLink;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['isDisabledSigninLinkBtn'] = true;
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ea7d0d4d24582503442af03e430e6e12')), 'button-loading');
  if ((getObjectProperty(___arguments.context.pageData, 'userEmail')).length > 0) {
    signinLink = (await Backendless.Request.get(`${Backendless.appPath}/services/magicLink/MagicLink`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'baseUrl': JSON.stringify(((function () { return window.location.href })())),'email': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'userEmail'))) }).send());
  }
  if (signinLink) {
    ___arguments.context.pageData['sellerSigninLink'] = signinLink;
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ea7d0d4d24582503442af03e430e6e12')), 'button-loading', '');
  ___arguments.context.pageData['isDisabledSigninLinkBtn'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isDisabledSigninLinkBtn'))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/staffSellers/components/04666144e67f98031372e98528475d0e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'sellerSigninLink')).length > 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/staffSellers/components/111b436a4c141d3ab201d79796d1a411/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'sellerSigninLink')).length > 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sellerSigninLink'))

  },
  /* handler:onTargetPathAssignment */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'sellerSigninLink'))

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/staffSellers/components/a83202278a4c2568aa2947d88bcde872/bundle.js', [], () => ({
  /* content */
  /* handler:onClose */
  ['onClose'](___arguments) {
      ___arguments.context.pageData['sellerSigninLink'] = '';
  ___arguments.context.pageData['userEmail'] = '';

  },
  /* handler:onClose */
  /* content */
}))

define('./pages/staffSellers/components/7432173dc66d47314fad4b05adb62806/bundle.js', [], () => ({
  /* content */
  /* handler:onRecordSelect */
  async ['onRecordSelect'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (componentUid) {  ___arguments.context.getComponentByUid(componentUid).openModal() })('a83202278a4c2568aa2947d88bcde872');
  ___arguments.context.pageData['userEmail'] = (getObjectProperty(___arguments.selectedRecord, 'email'));

  },
  /* handler:onRecordSelect */
  /* content */
}))

define('./pages/staffYoY/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var changeObject, counter, currentSeasonAlpha, currnetSeasonNumeric, fundraiserList, fundraiserObject, item, j, key, loopNormalizedAddressZip, lostAccounts, masterFundraiserObject, masterTotalObject, pageReady, repList, repObject, seasonFundraiserList, seasonList, seasonList1, seasonName, seasonObject, selectedSeasons, userCheck;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function setPageData() {
  ___arguments.context.pageData['searchFilterObject'] = ({ [`accountName`]: '',[`repAbbr`]: '',[`repList`]: [],[`lastSeason`]: '',[`lastSeasonFilter`]: false });
  ___arguments.context.pageData['dlConsolidate'] = false;
  seasonList = (await Backendless.Data.of('Seasons').find(Backendless.DataQueryBuilder.create().setProperties(['Name AS name', 'OfficeDatabaseName AS dbName', 'StartDate', 'EndDate']).setSortBy('StartDate DESC').setPageSize(10)));
  ___arguments.context.pageData['seasonList'] = seasonList;
  ___arguments.context.pageData['seasonListFall'] = (await asyncListFilter(seasonList, async (item) => {


   return ((getObjectProperty(item, 'dbName')).indexOf('fall') + 1 > 0);
  }));
  ___arguments.context.pageData['seasonListSpring'] = (await asyncListFilter(seasonList, async (item) => {


   return ((getObjectProperty(item, 'dbName')).indexOf('spring') + 1 > 0);
  }));
  currentSeasonAlpha = ((getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase')).replace((new RegExp('\\d', 'g')), ''));
  currnetSeasonNumeric = (Number(((getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase')).replace((new RegExp('\\D', 'g')), ''))));
  selectedSeasons = [(getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase'))];
  for (var count = 0; count < 2; count++) {
    currnetSeasonNumeric = (typeof currnetSeasonNumeric == 'number' ? currnetSeasonNumeric : 0) + -1;
    addItemToList(selectedSeasons, (String(currentSeasonAlpha) + String(currnetSeasonNumeric)));
  }
  ___arguments.context.pageData['selectedSeasons'] = selectedSeasons;
}


  pageReady = false;
  userCheck = (await BackendlessUI.Functions.Custom['fn_53345af7489572bf06e8f84a5a147b5c'](null));
  if (userCheck && (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    ___arguments.context.pageData['settings'] = (await BackendlessUI.Functions.Custom['fn_b6a716fc8f5c1d1f5dc8ae32543a46df'](['YoYComparisonSeasons', 'CurrentSeasonDatabase'], ___arguments.context.appData));
    pageReady = true;
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogin', undefined);
  }
  if (pageReady) {
    await setPageData();
    await BackendlessUI.Functions.Custom['fn_e7989e3f9e3c18d25b5875b25ad82a76'](___arguments.context.pageData);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/staffYoY/components/e431d0bbd143167c7379891bc9224a53/bundle.js', [], () => ({
  /* content */
  /* handler:columnDefsLogic */
  ['columnDefsLogic'](___arguments) {
      return [({ [`headerName`]: 'Account',[`field`]: 'AccountName',[`flex`]: 1,[`minWidth`]: '275',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'City',[`field`]: 'City',[`flex`]: 1,[`minWidth`]: '125',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'State',[`field`]: 'State',[`flex`]: 1,[`minWidth`]: '60',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Season',[`field`]: 'Season',[`flex`]: 1,[`maxWidth`]: '85',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Retail',[`field`]: 'TotalRetail',[`flex`]: 1,[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Web Retail',[`field`]: 'WebRetail',[`flex`]: 1,[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Paper Retail',[`field`]: 'PaperRetail',[`flex`]: 1,[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Enrollment',[`field`]: 'Enrollment',[`flex`]: 1,[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Sellers',[`field`]: 'TotalSellers',[`flex`]: 1,[`maxWidth`]: '85',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Web Sell',[`field`]: 'WebSellers',[`flex`]: 1,[`maxWidth`]: '115',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Paper Sell',[`field`]: 'PaperSellers',[`flex`]: 1,[`maxWidth`]: '115',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Type',[`field`]: 'SaleType',[`flex`]: 1,[`maxWidth`]: '100',[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Rep',[`field`]: 'Rep',[`flex`]: 1,[`filter`]: false,[`sortable`]: false }), ({ [`headerName`]: 'Catalogs',[`field`]: 'Catalogs',[`flex`]: 1,[`filter`]: false,[`sortable`]: false })]

  },
  /* handler:columnDefsLogic */
  /* content */
}))

define('./pages/staffYoY/components/14d25e046a9544e11dcafef9e7e266ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'searchFilterObject'))['accountName'] = ___arguments.value;
  ___arguments.context.pageData['filteredFundraiserList'] = (await BackendlessUI.Functions.Custom['fn_70ad3f85585d0f344c6cf1fd74ff4a91'](___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'fundraiserList'))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/staffYoY/components/21d35f6a00ec62619ee4c2c7289d162b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'searchFilterObject'))['repAbbr'] = ___arguments.value;
  console.log(___arguments.value);
  ___arguments.context.pageData['filteredFundraiserList'] = (await BackendlessUI.Functions.Custom['fn_70ad3f85585d0f344c6cf1fd74ff4a91'](___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'fundraiserList'))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/staffYoY/components/925fd89d1a991f8ae649240616853fad/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'searchFilterObject'))['lastSeasonFilter'] = ___arguments.value;
  ___arguments.context.pageData['filteredFundraiserList'] = (await BackendlessUI.Functions.Custom['fn_70ad3f85585d0f344c6cf1fd74ff4a91'](___arguments.context.pageData, (getObjectProperty(___arguments.context.pageData, 'fundraiserList'))));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/staffYoY/components/f14d90c4972ebad89c1cb5a78084cc75/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    if (!((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')).includes((getObjectProperty(___arguments.context.dataModel, 'dbName'))))) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')), (getObjectProperty(___arguments.context.dataModel, 'dbName')));
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')), (getObjectProperty(___arguments.context.dataModel, 'dbName')), '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.dataModel, 'dbName')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'selectedSeasons')) === 'undefined') ? false : ((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')).includes((getObjectProperty(___arguments.context.dataModel, 'dbName')))))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/staffYoY/components/d1ee2941955ab5c3bc3bd52badd114be/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    if (!((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')).includes((getObjectProperty(___arguments.context.dataModel, 'dbName'))))) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')), (getObjectProperty(___arguments.context.dataModel, 'dbName')));
    }
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')), (getObjectProperty(___arguments.context.dataModel, 'dbName')), '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.dataModel, 'dbName')) === 'undefined') || (typeof (getObjectProperty(___arguments.context.pageData, 'selectedSeasons')) === 'undefined') ? false : ((getObjectProperty(___arguments.context.pageData, 'selectedSeasons')).includes((getObjectProperty(___arguments.context.dataModel, 'dbName')))))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/staffYoY/components/b2fd017571180f5cefa61d18ef1e52ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b2fd017571180f5cefa61d18ef1e52ca')), 'button-loading');
  ___arguments.context.pageData['dlConsolidate'] = false;
  (getObjectProperty(___arguments.context.pageData, 'searchFilterObject'))['lastSeasonFilter'] = false;
  ___arguments.context.pageData['fundraiserList'] = [];
  ___arguments.context.pageData['filteredFundraiserList'] = [];
  await BackendlessUI.Functions.Custom['fn_e7989e3f9e3c18d25b5875b25ad82a76'](___arguments.context.pageData);
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b2fd017571180f5cefa61d18ef1e52ca')), 'button-loading', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffYoY/components/3af1fd29ab52491391a2a07c16c3c5ce/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var csvURL, thisList;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3af1fd29ab52491391a2a07c16c3c5ce')), 'button-loading');
  if (getObjectProperty(___arguments.context.pageData, 'dlConsolidate')) {
    thisList = (await (async function(data) {
    	const grouped = data.reduce((acc, item) => {
    	    if (!acc[item.Id]) {
    	        acc[item.Id] = [];
    	    }
    	    acc[item.Id].push(item);
    	    return acc;
    	}, {});

    	const consolidated = Object.values(grouped).map(group => {
    	    const accountRow = group[0];
    	    const lastSeasonRow = group[group.length - 1];

    	    Object.keys(lastSeasonRow).forEach(key => {
    	        if (key !== "Id" && key !== "AccountName" && key !== "Address" && key !== "City" && key !== "State" && key !== "Zipcode") {
    	            accountRow[key] = lastSeasonRow[key];
    	        }
    	    });

    	    // Remove the Id property
    	    delete accountRow.Id;

    	    return accountRow;
    	});

    	return consolidated;
    })((getObjectProperty(___arguments.context.pageData, 'filteredFundraiserList'))));
  } else {
    thisList = (getObjectProperty(___arguments.context.pageData, 'filteredFundraiserList'));
  }
  thisList = (await (async function(thisList) {
  	thisList.map(obj => {
  	  delete obj.Id;
  	});

  	return thisList;
  })(thisList));
  csvURL = (await Backendless.Request.post(`${Backendless.appPath}/services/CSVAdapter/list2csv`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'filePath': (['staffYoY\\',(getObjectProperty(___arguments.context.pageData, 'settings.CurrentSeasonDatabase')),'\\AccountList-',(new Date((new Date())).getMonth() + 1),'-',(new Date((new Date())).getDate()),'-',(new Date((new Date())).getFullYear()),'-',(new Date((new Date())).getHours()),(new Date((new Date())).getMinutes()),(new Date((new Date())).getSeconds()),'.csv'].join('')),'data': thisList,'csvOptions': ({ [`header`]: true }) }));
  if (getValueLength(csvURL) > 0) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })(csvURL, true, undefined);
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3af1fd29ab52491391a2a07c16c3c5ce')), 'button-loading', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/staffYoY/components/b116f2dcad8decb16d394225f6c298d3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['dlConsolidate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/testSweetAlert/components/268c2b2b6f25411adb85df1de3f728dd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9']((await (async function(fullName, firstName) {
  	return ({
  	  title: "Whoops!",
  		html: `You have already registered ${fullName} <br><br>You can edit ${firstName}'s details from your dashboard.  Go there now?`,
  		type: "info",
  		confirmButtonText: "Yes",
  		showCancelButton: true
  	});
  })('Jane Seller', 'Jane')), (await (async function() {
  	const foo = (result) => {
  	  if (result.value) {
  			window.location = 'https://backendeless.com';
  	  }
  	};

  	return foo;
  })()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testSweetAlert/components/f5efd2bd7361d2f487666aeb8dfa40bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9']((await (async function() {
  	return ({
  	  title: 'Are you sure?',
  	  text: "You won't be able to revert this!",
  	  icon: 'warning',
  	  showCancelButton: true,
  	  confirmButtonColor: '#3085d6',
  	  cancelButtonColor: '#d33',
  	  confirmButtonText: 'Yes, delete it!'
  	});
  })()), (await (async function() {
  	const foo = (result) => {
  	  if (result.isConfirmed) {
  	    Swal.fire(
  	      'Deleted!',
  	      'Your file has been deleted.',
  	      'success'
  	    )
  	  }
  	};

  	return foo;
  })()));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testSweetAlert/components/a358bab993c54775af48f7c1e9725f17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ 'title': 'Whoops!','html': 'You have already registered Jane Seller <br><br>You can edit Jane\'s details from your dashboard.  Go there now?','type': 'info','confirmButtonText': 'Yes','showCancelButton': true }), null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testSweetAlert/components/b68d59199af58011350cc7b90b0eaeb4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_d3332f2d035fe3de875748be5828e2a9'](({ [`title`]: 'Whoops!',[`html`]: ['You have already registered ','Jane Seller','<br><br>You can edit ','Jane','\'s details from your dashboard.  Go there now?'].join(''),[`type`]: 'info',[`confirmationButtonText`]: 'Yes',[`showCancelButton`]: true }), (await (async function() {
  	const foo = (result) => {
  	  if (result.value) {
  		let connectedDevices = [];
  		let selectedDevice = null;
  	
  		const connectDevice = () => {
  			navigator.hid.requestDevice({filters:[]}).then(devices => {
  				if (devices.length == 0)
  				return;
  	
  			for (let device of devices)
  			  addDevice(device);
  		  });
  		};
  	
  		// Adds |device| to |connectedDevices|. Selects the device if there was no prior
  		// selection.
  		const addDevice = device => {
  		  if (connectedDevices.includes(device)) {
  			//console.log('device already in connectedDevices');
  		  } else {
  			connectedDevices.push(device);
  			//console.log('device connected: ' + device.productName);
  		  }
  		  
  		  //let scaleText = document.querySelector(".scaleText");
  		  //console.log(scaleText);
  		  if (device !== null) {
  			pageData.scaleName = device.productName;
  			device.oninputreport = handleInputReport;
  			
  			if (!device.opened) 
  			  device.open();
  		   
  		  }
  		};
  	
  		// Removes |device| from |connectedDevices|.
  		const removeDevice = device => {
  		  if (device === selectedDevice)
  			selectedDevice = null;
  		  for (let i = connectedDevices.length - 1; i >= 0; --i) {
  			if (connectedDevices[i] === device) {
  			  connectedDevices.splice(i, 1);
  			  console.log('device disconnected: ' + device.productName);
  			  updateDeviceMenu();
  			}
  		  }
  		};
  	
  		const handleInputReport = event => {
  			//const inputReportTextView = document.querySelector(".scaleValue");
  		  //if (!inputReportTextView)
  		  //	return;
  	
  		  const reportData = new Uint8Array(event.data.buffer); //** original
  	
  			//inputReportTextView.innerHTML = (reportData[3] + (256 * reportData[4])) * 0.01;
  			pageData.scaleWeight = Math.round(((reportData[3] + (256 * reportData[4])) * 0.01) * 10) / 10;
  		}
  	
  		connectDevice();
  			
  			
  	  }
  	};
  	
  	return foo;
  })()));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_8b75618feeb41f448f09e3e118b23c25/logic/8f4bb1e6e7eaab95588c43c5c1f17e64/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['rumessage__modal'];
  if (getObjectProperty(___arguments.context.pageData, 'isRuMessageShow')) {
    addItemToList(classes, 'open');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_8b75618feeb41f448f09e3e118b23c25/logic/b8a1e5583b4d91850feb43ab653ce84b/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'message')) && (getObjectProperty(___arguments.context.pageData, 'ruMessageText'))) {
    ___arguments.context.pageData['isRuMessageShow'] = true;
  }

  },
  /* handler:onMounted */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (getObjectProperty(___arguments.context.pageData, 'isRuMessageShow')) {

    ;(function() {
      const callback = async () => {
          ___arguments.context.pageData['isRuMessageShow'] = false;

      };

      const timerId = '';
      const timerDelay = 3000;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_8b75618feeb41f448f09e3e118b23c25/logic/47012392292cb958ab0cd6526e5cc258/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var ruMessageText;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ruMessageText = 'No Message';
  if (getObjectProperty(___arguments.context.pageData, 'ruMessageText')) {
    ruMessageText = (getObjectProperty(___arguments.context.pageData, 'ruMessageText'));
  }

  return ruMessageText

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/bbf8486f3fcf78f60dee7ff98d729c4b/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var showChat, itemMenu, returnList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function menuList() {
  returnList = [];
  if ((await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Seller', ___arguments.context.appData)) && !(await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Rep', ___arguments.context.appData))) {
    addItemToList(returnList, ({ [`isVisible`]: '',[`label`]: '',[`page`]: 'sellerDashboard',[`subPages`]: [] }));
    addItemToList(returnList, ({ [`isVisible`]: '',[`label`]: 'Add Seller',[`page`]: 'sellerAdd',[`subPages`]: [] }));
    addItemToList(returnList, ({ [`isVisible`]: '',[`label`]: 'Share',[`page`]: 'sellerShare',[`subPages`]: [] }));
    addItemToList(returnList, ({ [`isVisible`]: '',[`label`]: 'FAQ',[`page`]: 'sellersFaq',[`subPages`]: [] }));
    showChat = true;
  }
  if ((await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Sponsor', ___arguments.context.appData))) {
    showChat = true;
    addItemToList(returnList, (await getSponsorSubmenu()));
  }
  if ((await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Rep', ___arguments.context.appData))) {
    showChat = false;
  }
  if ((await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Staff', ___arguments.context.appData))) {
    showChat = false;
    addItemToList(returnList, (await getStaffSubmenu()));
  }
  addItemToList(returnList, ({ [`isVisible`]: '',[`label`]: '',[`page`]: 'sellersSettings',[`subPages`]: [] }));
  addItemToList(returnList, ({ [`isVisible`]: '',[`label`]: 'Logout',[`page`]: 'logout',[`subPages`]: [] }));
  return returnList
}

/**
 * Describe this function...
 */
async function getSponsorSubmenu() {
  return { [`isVisible`]: 'headerIsSponsor',[`label`]: (await BackendlessUI.Functions.Custom['fn_7fecd3653238e53fd8441d77fd1f02cb']('Rep', ___arguments.context.appData)) ? 'Accounts' : 'Sponsor',[`page`]: 'sponsor',[`subPages`]: [({ [`label`]: 'Dashboard',[`page`]: 'sponsorDashboard' }), ({ [`label`]: 'Tools & FAQ',[`page`]: 'sponsorFaq' })] }
}

/**
 * Describe this function...
 */
async function getStaffSubmenu() {
  return { [`isVisible`]: 'headerIsStaff',[`label`]: 'Staff',[`page`]: 'staff',[`subPages`]: [({ [`label`]: 'Sellers',[`page`]: 'staffSellers' }), ({ [`label`]: 'Groups',[`page`]: 'staffFundraisers' }), ({ [`label`]: 'Parent Letter',[`page`]: 'staffParentLetter' }), ({ [`label`]: 'Year Over Year',[`page`]: 'staffYoY' }), ({ [`label`]: 'GA Import',[`page`]: 'staffGAImport' })] }
}


  showChat = false;
  ___arguments.context.pageData['headerCurrentPage'] = (await (async function(currentUrl) {
  	const url = new URL(currentUrl);
  	return url.searchParams.get("page");
  })(((function () { return window.location.href })())));
  ___arguments.context.pageData['headerSubmenuVisible'] = ({  });
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9abc22c23887682cca233cf78e360a3d')) {
    var itemMenu_list = await menuList();
    for (var itemMenu_index in itemMenu_list) {
      itemMenu = itemMenu_list[itemMenu_index];
      if ((getObjectProperty(itemMenu, 'subPages')).length > 0) {
        (getObjectProperty(___arguments.context.pageData, 'headerSubmenuVisible'))[(getObjectProperty(itemMenu, 'page'))] = false;
      }
    }
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('9abc22c23887682cca233cf78e360a3d', (await menuList()));
  }
  if (showChat == true) {
    await (async function() {
    	    window.__lc = window.__lc || {};
    	    window.__lc.license = 12578445;
    	    ;(function(n,t,c){function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}var e={_q:[],_h:null,_v:"2.0",on:function(){i(["on",c.call(arguments)])},once:function(){i(["once",c.call(arguments)])},off:function(){i(["off",c.call(arguments)])},get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},call:function(){i(["call",c.call(arguments)])},init:function(){var n=t.createElement("script");n.async=!0,n.type="text/javascript",n.src="https://cdn.livechatinc.com/tracking.js",t.head.appendChild(n)}};!n.__lc.asyncInit&&e.init(),n.LiveChatWidget=n.LiveChatWidget||e}(window,document,[].slice))

    })();
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/cb8fb05fc9e6a9038f9b25467f9df8ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes, subPageItem, isVisilble;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['ruheader_menu-item'];
  if ((getObjectProperty(___arguments.context.dataModel, 'subPages')).length > 0) {
    var subPageItem_list = (getObjectProperty(___arguments.context.dataModel, 'subPages'));
    for (var subPageItem_index in subPageItem_list) {
      subPageItem = subPageItem_list[subPageItem_index];
      if ((getObjectProperty(subPageItem, 'page')) == (getObjectProperty(___arguments.context.pageData, 'headerCurrentPage'))) {
        addItemToList(classes, 'active');
      }
    }
  } else {
    if ((getObjectProperty(___arguments.context.dataModel, 'page')) == (getObjectProperty(___arguments.context.pageData, 'headerCurrentPage'))) {
      addItemToList(classes, 'active');
    }
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'page')) == 'sellerDashboard') {
    addItemToList(classes, 'home');
  }
  if ((getObjectProperty(___arguments.context.dataModel, 'page')) == 'sellersSettings') {
    addItemToList(classes, 'settings');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.dataModel, 'subPages')).length > 0) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c4480aca696220ba937ec90edb82af25', (getObjectProperty(___arguments.context.dataModel, 'subPages')));
  }

  },
  /* handler:onMounted */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var key, obj;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function deleteProperties(obj) {
  var key_list = (Object.keys(obj));
  for (var key_index in key_list) {
    key = key_list[key_index];
    delete obj[key];
  }
}


  if ((getObjectProperty(___arguments.context.dataModel, 'subPages')).length > 0) {
    (getObjectProperty(___arguments.context.pageData, 'headerSubmenuVisible'))[(getObjectProperty(___arguments.context.dataModel, 'page'))] = (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'headerSubmenuVisible')), (getObjectProperty(___arguments.context.dataModel, 'page')))));
  } else if ((getObjectProperty(___arguments.context.dataModel, 'page')) == 'logout') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('authLogout', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.dataModel, 'page')), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/5cd5b65980dbdaaf5e3934a879ee7fac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8fb05fc9e6a9038f9b25467f9df8ff'), 'label'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/c4480aca696220ba937ec90edb82af25/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['ruheader_menu-submenu'];
  if ((getObjectProperty(___arguments.context.pageData, 'headerSubmenuVisible')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'headerSubmenuVisible')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8fb05fc9e6a9038f9b25467f9df8ff'), 'page')))) == true) {
    addItemToList(classes, 'show');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/cc32547ee50a1cd3cb5f7ef29654bcf2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.dataModel, 'page')), undefined);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var classes;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  classes = ['ruheader_menu-submenu-item'];
  if ((getObjectProperty(___arguments.context.dataModel, 'page')) == (getObjectProperty(___arguments.context.pageData, 'headerCurrentPage'))) {
    addItemToList(classes, 'active');
  }

  return classes

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/34ff95bef8579f4419e22a2466dcda51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cc32547ee50a1cd3cb5f7ef29654bcf2'), 'label'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/8c98a72c7eb274eb1b9bdb850b9d9a02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var isVisilble;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisilble = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8fb05fc9e6a9038f9b25467f9df8ff'), 'page')) == 'sellerDashboard') {
    isVisilble = false;
  }

  return isVisilble

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_d624496ccd65bf27f81b50a12536a3ae/logic/2853c3b770423312f534a6c877b8a837/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var isVisilble;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisilble = false;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cb8fb05fc9e6a9038f9b25467f9df8ff'), 'page')) == 'sellersSettings') {
    isVisilble = false;
  }

  return isVisilble

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

